import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string | number; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `JSON` scalar type represents JSON values */
  JSON: { input: any; output: any; }
};

export type AusCourseContent = {
  __typename?: 'AUSCourseContent';
  categories: Scalars['String']['output'];
  comingSoonAt: Scalars['String']['output'];
  comingSoonLabelPosition: Scalars['String']['output'];
  coverImage: Scalars['String']['output'];
  gradeLevel: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isComingSoon: Scalars['Boolean']['output'];
  isNew: Scalars['Boolean']['output'];
  isNewCover: Scalars['Boolean']['output'];
  isOpReel: Scalars['Boolean']['output'];
  isUpdated: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  newLabelPosition: Scalars['String']['output'];
  number: Scalars['Int']['output'];
  progress: Scalars['Float']['output'];
  subHeading: Scalars['String']['output'];
  suggestedDuration: Scalars['String']['output'];
  suggestedLessonCount: Scalars['Int']['output'];
  type: CourseContentType;
  updatedLabelPosition: Scalars['String']['output'];
};

export type AusProgram = {
  __typename?: 'AUSProgram';
  country?: Maybe<Scalars['String']['output']>;
  courseContents?: Maybe<Array<AusCourseContent>>;
  coverVideo?: Maybe<Scalars['String']['output']>;
  created: Scalars['String']['output'];
  createdBy: User;
  description?: Maybe<Scalars['String']['output']>;
  favorite?: Maybe<Scalars['Boolean']['output']>;
  grade?: Maybe<Grade>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isCustomized?: Maybe<Scalars['Boolean']['output']>;
  isParentCourse?: Maybe<Scalars['Boolean']['output']>;
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  isTest?: Maybe<Scalars['Boolean']['output']>;
  lastUsed?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  updated: Scalars['String']['output'];
};

export type AwsKeys = {
  __typename?: 'AWSKeys';
  AccessKeyId: Scalars['String']['output'];
  Expiration: Scalars['String']['output'];
  SecretKey: Scalars['String']['output'];
  SessionToken: Scalars['String']['output'];
};

export type AbsentStudentLesson = {
  __typename?: 'AbsentStudentLesson';
  createdBy: Scalars['String']['output'];
  expireAt: Scalars['String']['output'];
  generatedAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isSLL: Scalars['Boolean']['output'];
  lessonId: Scalars['String']['output'];
  link: Scalars['String']['output'];
  studentsCount: Scalars['Int']['output'];
};

export type AbsentStudentLessonByLinkInput = {
  link: Scalars['String']['input'];
};

export type AbsentStudentLessonInput = {
  className?: InputMaybe<Scalars['String']['input']>;
  expiryMinutes: Scalars['Int']['input'];
  formData?: InputMaybe<Scalars['String']['input']>;
  grade: Scalars['String']['input'];
  isSLL: Scalars['Boolean']['input'];
  lessonId: Scalars['String']['input'];
  lessonName?: InputMaybe<Scalars['String']['input']>;
  programId?: InputMaybe<Scalars['String']['input']>;
  programName?: InputMaybe<Scalars['String']['input']>;
  studentsCount: Scalars['Int']['input'];
  unitId?: InputMaybe<Scalars['String']['input']>;
  unitName?: InputMaybe<Scalars['String']['input']>;
};

export type AccountInfo = {
  __typename?: 'AccountInfo';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AccountSchool = {
  __typename?: 'AccountSchool';
  dataCollections?: Maybe<Array<Maybe<SurveyType>>>;
  groups?: Maybe<Array<Maybe<ProgramType>>>;
  schools?: Maybe<Array<Maybe<School>>>;
};

export type AddAccountInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  courses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dataCollections?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disabledPwLogin?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  trial?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AddGroupInput = {
  name: Scalars['String']['input'];
};

export type AddMcToProgramInput = {
  mcInfo?: InputMaybe<Array<McInfo>>;
  programId: Scalars['String']['input'];
};

export type AddSchoolInput = {
  accountId: Scalars['String']['input'];
  country: Scalars['String']['input'];
  dataCollections?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  grades?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: Scalars['String']['input'];
  programs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AdminUser = {
  __typename?: 'AdminUser';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AdminUsers = {
  __typename?: 'AdminUsers';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  school: Scalars['String']['output'];
};

export type AdminUsers2 = {
  __typename?: 'AdminUsers2';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AdminUsersArrayType = {
  __typename?: 'AdminUsersArrayType';
  id?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Array<Maybe<AdminUsers2>>>;
};

export type AiLessonChatInput = {
  asSchoolId?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Scalars['String']['input']>;
  history?: InputMaybe<Array<AiLessonChatTurnInput>>;
  query: Scalars['String']['input'];
  sendAccess?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiLessonChatResult = {
  __typename?: 'AiLessonChatResult';
  answer: Scalars['String']['output'];
  lessons: Array<Maybe<AiSearchLesson>>;
  sources: Array<AiLessonChatSource>;
};

export enum AiLessonChatRole {
  ASSISTANT = 'assistant',
  USER = 'user'
}

export type AiLessonChatSource = {
  __typename?: 'AiLessonChatSource';
  name: Scalars['String']['output'];
  namespace: Scalars['String']['output'];
};

export type AiLessonChatTurnInput = {
  content: Scalars['String']['input'];
  role: AiLessonChatRole;
};

export type AiLessonLibrarySearchInput = {
  asSchoolId?: InputMaybe<Scalars['String']['input']>;
  competency?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  grades?: InputMaybe<Array<Scalars['String']['input']>>;
  lessonType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mood?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  query: Scalars['String']['input'];
  sendAccess?: InputMaybe<Scalars['Boolean']['input']>;
  skill?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tier?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AiSearchLesson = {
  __typename?: 'AiSearchLesson';
  grades: Array<Scalars['String']['output']>;
  lesson: LessonForLessonLibrary;
  mCollectionId: Scalars['String']['output'];
  mCollectionName: Scalars['String']['output'];
};

export type AllContent = {
  __typename?: 'AllContent';
  default: Content;
  groups?: Maybe<Array<GroupContent>>;
};

export type AnalyticsInput = {
  ageGroups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  fromDate: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  schoolIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  toDate: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type BulkUserInviteInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type CalendarEventType = {
  __typename?: 'CalendarEventType';
  isInMeeting: Scalars['Boolean']['output'];
  timeLeftInSec: Scalars['Int']['output'];
};

export type CaptionUploadResult = {
  __typename?: 'CaptionUploadResult';
  captionJob: EnglishCaptionJob;
  muxAssetId: Scalars['String']['output'];
  muxPlaybackId: Scalars['String']['output'];
  videoUrl: Scalars['String']['output'];
};

export type CleverLoginInput = {
  code: Scalars['String']['input'];
  redirect_uri: Scalars['String']['input'];
};

export type CleverUser = {
  __typename?: 'CleverUser';
  accessToken: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type Collection = {
  __typename?: 'Collection';
  addlMatBox?: Maybe<Scalars['String']['output']>;
  addlMatHeading?: Maybe<Scalars['String']['output']>;
  bannerImage?: Maybe<Scalars['String']['output']>;
  bannerVideo?: Maybe<Scalars['String']['output']>;
  collectionType?: Maybe<CollectionType>;
  country?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isSensitive?: Maybe<Scalars['Int']['output']>;
  isSubHeading?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  pacing?: Maybe<Scalars['String']['output']>;
  requirements?: Maybe<Scalars['String']['output']>;
  sllLessons?: Maybe<Array<Maybe<SllLesson>>>;
  subHeading?: Maybe<Scalars['String']['output']>;
  subHeadingHighlight?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Scalars['String']['output']>;
  unitOvwBox1?: Maybe<Scalars['String']['output']>;
  unitOvwBox2?: Maybe<Scalars['String']['output']>;
  unitOvwHeading1?: Maybe<Scalars['String']['output']>;
  unitOvwHeading2?: Maybe<Scalars['String']['output']>;
};

export enum CollectionType {
  COLLECTION_IMAGE = 'Collection_Image',
  INDIVIDUAL_LESSON_IMAGE = 'Individual_Lesson_Image',
  THEME = 'Theme'
}

export type CompetencyRating = {
  __typename?: 'CompetencyRating';
  relationshipSkills?: Maybe<Scalars['Int']['output']>;
  responsibleDecisionMaking?: Maybe<Scalars['Int']['output']>;
  selfAwareness?: Maybe<Scalars['Int']['output']>;
  selfManagement?: Maybe<Scalars['Int']['output']>;
  socialAwareness?: Maybe<Scalars['Int']['output']>;
};

export type ConfirmEmailInput = {
  id: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type Content = {
  __typename?: 'Content';
  additionalAfter?: Maybe<Scalars['Boolean']['output']>;
  created: Scalars['String']['output'];
  createdBy?: Maybe<User>;
  data?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  formData?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  lastInGroup?: Maybe<Scalars['Boolean']['output']>;
  lastInLesson?: Maybe<Scalars['Boolean']['output']>;
  meta?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  parent?: Maybe<Content>;
  pauseHere?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  type: ContentType;
  updated: Scalars['String']['output'];
};

export enum ContentType {
  AUDIO = 'Audio',
  FORM = 'Form',
  GOOGLESLIDE = 'GoogleSlide',
  PDF = 'PDF',
  PARENT = 'Parent',
  REVEALSLIDE = 'RevealSlide',
  SKILL = 'Skill',
  SLIDE = 'Slide',
  VIDEO = 'Video',
  ZIPSLIDE = 'ZIPSlide'
}

export type CourseContent = {
  __typename?: 'CourseContent';
  additional?: Maybe<Array<Unit>>;
  primary?: Maybe<Array<Unit>>;
};

export enum CourseContentType {
  LESSON = 'Lesson',
  UNIT = 'Unit'
}

export type CourseLesson = {
  __typename?: 'CourseLesson';
  completedLessons?: Maybe<Scalars['Int']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<LessonDetails>>>;
  schoolName?: Maybe<Scalars['String']['output']>;
  teacherName?: Maybe<Scalars['String']['output']>;
};

export type CreateCollectionInput = {
  addlMatBox?: InputMaybe<Scalars['String']['input']>;
  addlMatHeading?: InputMaybe<Scalars['String']['input']>;
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  bannerVideo?: InputMaybe<Scalars['String']['input']>;
  collectionType?: InputMaybe<CollectionType>;
  country?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Scalars['String']['input']>;
  isSensitive?: InputMaybe<Scalars['Boolean']['input']>;
  isSubHeading?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  pacing?: InputMaybe<Scalars['String']['input']>;
  requirements?: InputMaybe<Scalars['String']['input']>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  subHeadingHighlight?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['String']['input']>;
  unitOvwBox1?: InputMaybe<Scalars['String']['input']>;
  unitOvwBox2?: InputMaybe<Scalars['String']['input']>;
  unitOvwHeading1?: InputMaybe<Scalars['String']['input']>;
  unitOvwHeading2?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContentInput = {
  lessonId: Scalars['String']['input'];
  lessonType?: InputMaybe<LessonType>;
  position?: InputMaybe<Scalars['Int']['input']>;
  sectionId?: InputMaybe<Scalars['String']['input']>;
  type: ContentType;
};

export type CreateMultiCollectionInput = {
  country: Scalars['String']['input'];
  description: Scalars['String']['input'];
  grade: Scalars['String']['input'];
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  isScopeAndSeq?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  scopeAndSeqId?: InputMaybe<Scalars['String']['input']>;
  type: MultiCollectionType;
};

export type CreateNewGroupContentInput = {
  group: Scalars['String']['input'];
  groupName: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type CreateQuizInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  darkColor?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  unitId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSectionInput = {
  lessonId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateSharedUnitInput = {
  expiryMinutes: Scalars['Int']['input'];
  unitId: Scalars['String']['input'];
};

export type CreateTranslationJobInput = {
  assetId?: InputMaybe<Scalars['String']['input']>;
  playbackId?: InputMaybe<Scalars['String']['input']>;
  targetLanguages: Array<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUnitInput = {
  box1?: InputMaybe<Scalars['String']['input']>;
  box2?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Scalars['String']['input']>;
  comingSoonAt?: InputMaybe<Scalars['String']['input']>;
  comingSoonLabelPosition?: InputMaybe<Scalars['String']['input']>;
  competency?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  courseId?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<Scalars['String']['input']>;
  default: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  helpfulHeading?: InputMaybe<Scalars['String']['input']>;
  isComingSoon?: InputMaybe<Scalars['Boolean']['input']>;
  isEducatorCaregiverLessonLayout?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  isNewCover?: InputMaybe<Scalars['Boolean']['input']>;
  isPreProgramQuiz?: InputMaybe<Scalars['Boolean']['input']>;
  isQuizCreated?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdated?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  newLabelPosition?: InputMaybe<Scalars['String']['input']>;
  pace?: InputMaybe<Scalars['String']['input']>;
  popupCover?: InputMaybe<Scalars['String']['input']>;
  sensitive?: InputMaybe<Scalars['Boolean']['input']>;
  sensitiveTooltip?: InputMaybe<Scalars['String']['input']>;
  skill: Scalars['String']['input'];
  skillsHeading?: InputMaybe<Scalars['String']['input']>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  suggestedDuration?: InputMaybe<Scalars['String']['input']>;
  suggestedLessonCount?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Scalars['String']['input']>;
  teacherBox?: InputMaybe<Scalars['String']['input']>;
  teacherImage?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  uniqueName?: InputMaybe<Scalars['String']['input']>;
  unitStudyBox?: InputMaybe<Scalars['String']['input']>;
  unitStudyHeading?: InputMaybe<Scalars['String']['input']>;
  updatedLabelPosition?: InputMaybe<Scalars['String']['input']>;
};

export type CreateVideoSubtitleInput = {
  languageCode: Scalars['String']['input'];
  name: Scalars['String']['input'];
  playbackId?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type CreateVideoTranslationJobInput = {
  assetId?: InputMaybe<Scalars['String']['input']>;
  generateEnglishSubtitles?: InputMaybe<Scalars['Boolean']['input']>;
  playbackId?: InputMaybe<Scalars['String']['input']>;
  targetLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreateVideoWithTranslationInput = {
  generateEnglishSubtitles?: InputMaybe<Scalars['Boolean']['input']>;
  targetLanguages: Array<Scalars['String']['input']>;
  uploadId: Scalars['String']['input'];
};

export type Customer = {
  __typename?: 'Customer';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  disabledPwLogin?: Maybe<Scalars['Boolean']['output']>;
  expiry?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  trial?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomizeCoursesForSchoolInput = {
  customizedPrograms?: InputMaybe<Array<InputMaybe<CustomizedProgramInput>>>;
  defaultPrograms?: InputMaybe<Array<DefaultProgramInput>>;
  schoolId: Scalars['String']['input'];
};

export type CustomizedProgram = {
  __typename?: 'CustomizedProgram';
  additional?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  primary?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  programId: Scalars['ID']['output'];
};

export type CustomizedProgramInput = {
  additional?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  courseContents?: InputMaybe<Array<InputMaybe<SchoolCourseContentInput>>>;
  primary?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  programId: Scalars['String']['input'];
};

export type DataCollectionsSimplified = {
  __typename?: 'DataCollectionsSimplified';
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type DefaultProgramInput = {
  id: Scalars['String']['input'];
  isCustomizing: Scalars['Boolean']['input'];
  newId?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteGroupModuleInput = {
  group: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type DistrictAdminBulkInviteUserInput = {
  admin: Scalars['Boolean']['input'];
  adminId?: InputMaybe<Scalars['String']['input']>;
  adminName?: InputMaybe<Scalars['String']['input']>;
  customer: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  school: Scalars['String']['input'];
  schoolName?: InputMaybe<Scalars['String']['input']>;
};

export type DuplicateCourseInput = {
  newCourseName: Scalars['String']['input'];
  originalCourseId: Scalars['String']['input'];
};

export type EditAccountInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  courses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dataCollections?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disabledPwLogin?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  trial?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EditGroupInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type EditSchoolInput = {
  accountId: Scalars['String']['input'];
  country: Scalars['String']['input'];
  courses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dataCollections?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disabledPwLogin?: InputMaybe<Scalars['Boolean']['input']>;
  exitTicketCC?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  grades?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  preProgramQuizCC?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  programs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type EditUnitInput = {
  box1?: InputMaybe<Scalars['String']['input']>;
  box2?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Scalars['String']['input']>;
  comingSoonAt?: InputMaybe<Scalars['String']['input']>;
  comingSoonLabelPosition?: InputMaybe<Scalars['String']['input']>;
  competency?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  courseId?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<Scalars['String']['input']>;
  default: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  helpfulHeading?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isComingSoon?: InputMaybe<Scalars['Boolean']['input']>;
  isEducatorCaregiverLessonLayout?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  isNewCover?: InputMaybe<Scalars['Boolean']['input']>;
  isPreProgramQuiz?: InputMaybe<Scalars['Boolean']['input']>;
  isQuizCreated?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdated?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  newLabelPosition?: InputMaybe<Scalars['String']['input']>;
  pace?: InputMaybe<Scalars['String']['input']>;
  popupCover?: InputMaybe<Scalars['String']['input']>;
  sensitive?: InputMaybe<Scalars['Boolean']['input']>;
  sensitiveTooltip?: InputMaybe<Scalars['String']['input']>;
  skill: Scalars['String']['input'];
  skillsHeading?: InputMaybe<Scalars['String']['input']>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  suggestedDuration?: InputMaybe<Scalars['String']['input']>;
  suggestedLessonCount?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Scalars['String']['input']>;
  teacherBox?: InputMaybe<Scalars['String']['input']>;
  teacherImage?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  uniqueName?: InputMaybe<Scalars['String']['input']>;
  unitStudyBox?: InputMaybe<Scalars['String']['input']>;
  unitStudyHeading?: InputMaybe<Scalars['String']['input']>;
  updatedLabelPosition?: InputMaybe<Scalars['String']['input']>;
};

export type EducatorLessonItem = {
  __typename?: 'EducatorLessonItem';
  completedAt?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  lessonId?: Maybe<Scalars['String']['output']>;
  lessonName?: Maybe<Scalars['String']['output']>;
  lessonPosition?: Maybe<Scalars['Int']['output']>;
  lessonType?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unitName?: Maybe<Scalars['String']['output']>;
};

export type EducatorWellBeingByLessonsType = {
  __typename?: 'EducatorWellBeingByLessonsType';
  lessonId?: Maybe<Scalars['String']['output']>;
  lessonName?: Maybe<Scalars['String']['output']>;
  lessons?: Maybe<Array<Maybe<WellBeingLesson>>>;
  lessonsCompleted?: Maybe<Scalars['Int']['output']>;
  progress?: Maybe<Scalars['Int']['output']>;
};

export type EmailInput = {
  email: Scalars['String']['input'];
};

export type EnglishCaptionJob = {
  __typename?: 'EnglishCaptionJob';
  completedAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  progressPercentage: Scalars['Int']['output'];
  status: EnglishCaptionStatus;
  subtitleUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  videoUrl: Scalars['String']['output'];
};

export enum EnglishCaptionStatus {
  COMPLETED = 'completed',
  FAILED = 'failed',
  PENDING = 'pending',
  PROCESSING = 'processing'
}

export type EntityTrackingResponse = {
  __typename?: 'EntityTrackingResponse';
  entityId?: Maybe<Scalars['String']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<EntityType>;
  isTracked: Scalars['Boolean']['output'];
  trackingLevel?: Maybe<TrackingLevel>;
};

export enum EntityType {
  ACCOUNT = 'account',
  SCHOOL = 'school',
  USER = 'user'
}

export type ExtendedCustomer = {
  __typename?: 'ExtendedCustomer';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  dataCollections?: Maybe<Array<Maybe<DataCollectionsSimplified>>>;
  disabledPwLogin?: Maybe<Scalars['Boolean']['output']>;
  expiry?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  trial?: Maybe<Scalars['Boolean']['output']>;
};

export type FailedReport = {
  __typename?: 'FailedReport';
  className?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  dataIntact?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  email_attempts?: Maybe<Scalars['Int']['output']>;
  email_error?: Maybe<Scalars['String']['output']>;
  email_status?: Maybe<Scalars['String']['output']>;
  expirationAt: Scalars['String']['output'];
  feedbackFormCount?: Maybe<Scalars['Int']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  last_email_attempt?: Maybe<Scalars['String']['output']>;
  lessonName?: Maybe<Scalars['String']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  schoolName?: Maybe<Scalars['String']['output']>;
  type: Scalars['Int']['output'];
  unitName?: Maybe<Scalars['String']['output']>;
};

export type FeedbackFormAnswerForAbsentInput = {
  formData: Scalars['String']['input'];
  link: Scalars['String']['input'];
};

export type FeedbackFormContent = {
  __typename?: 'FeedbackFormContent';
  className?: Maybe<Scalars['String']['output']>;
  collectionId?: Maybe<Scalars['String']['output']>;
  collectionName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<User>;
  exitTicketCount?: Maybe<Scalars['Int']['output']>;
  expirationAt?: Maybe<Scalars['String']['output']>;
  formData?: Maybe<Scalars['String']['output']>;
  grade: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isCancelled?: Maybe<Scalars['Boolean']['output']>;
  lessonName?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  mcId?: Maybe<Scalars['String']['output']>;
  mcName?: Maybe<Scalars['String']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
  unitName?: Maybe<Scalars['String']['output']>;
};

export type FeedbackFormContentAnswer = {
  __typename?: 'FeedbackFormContentAnswer';
  createdAt?: Maybe<Scalars['String']['output']>;
  formData?: Maybe<Scalars['String']['output']>;
  formId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

export type FeedbackFormContentAnswerInput = {
  formData: Scalars['String']['input'];
  formId: Scalars['String']['input'];
};

export type FeedbackFormContentInput = {
  className?: InputMaybe<Scalars['String']['input']>;
  collectionId?: InputMaybe<Scalars['String']['input']>;
  collectionName?: InputMaybe<Scalars['String']['input']>;
  exitTicketCount?: InputMaybe<Scalars['Int']['input']>;
  expiryMinutes?: InputMaybe<Scalars['Int']['input']>;
  formData?: InputMaybe<Scalars['String']['input']>;
  grade: Scalars['String']['input'];
  isSLL?: InputMaybe<Scalars['Boolean']['input']>;
  lessonId?: InputMaybe<Scalars['String']['input']>;
  lessonName?: InputMaybe<Scalars['String']['input']>;
  mcId?: InputMaybe<Scalars['String']['input']>;
  mcName?: InputMaybe<Scalars['String']['input']>;
  programId?: InputMaybe<Scalars['String']['input']>;
  programName?: InputMaybe<Scalars['String']['input']>;
  unitId?: InputMaybe<Scalars['String']['input']>;
  unitName?: InputMaybe<Scalars['String']['input']>;
};

export type FeedbackLinkInput = {
  link: Scalars['String']['input'];
};

export type GenerateCaptionsForUploadInput = {
  uploadId: Scalars['String']['input'];
};

export type GenerateEnglishCaptionsInput = {
  assetId?: InputMaybe<Scalars['String']['input']>;
  playbackId?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateSchoolReportInput = {
  endDate: Scalars['String']['input'];
  name: Scalars['String']['input'];
  schoolIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate: Scalars['String']['input'];
  surveyId: Scalars['String']['input'];
};

export type GetAllCollectionsInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  programId?: InputMaybe<Scalars['String']['input']>;
};

export type GetAllMultiCollectionsInput = {
  subType?: InputMaybe<MultiCollectionSubType>;
  type: MultiCollectionType;
};

export type GetAllUnitsInput = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};

export type GetFailedReportsInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  excludeZeroResponses?: InputMaybe<Scalars['Boolean']['input']>;
  schoolIds?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
  surveyType?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type GetReportsInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  excludeZeroResponses?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  schoolIds?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
  surveyType?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type GetSchoolReportDownloadUrlInput = {
  key: Scalars['String']['input'];
};

export type GetSharedUnitInfoByLinkInput = {
  link: Scalars['String']['input'];
};

export type GetSurveysInput = {
  account?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  excludeZeroResponses?: InputMaybe<Scalars['Boolean']['input']>;
  includeSent?: InputMaybe<Scalars['Boolean']['input']>;
  school?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  surveyType: Scalars['Int']['input'];
};

export type Grade = {
  __typename?: 'Grade';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
};

export type Group = {
  __typename?: 'Group';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type GroupContent = {
  __typename?: 'GroupContent';
  contentId: Scalars['ID']['output'];
  data?: Maybe<Scalars['String']['output']>;
  formData?: Maybe<Scalars['String']['output']>;
  groupId: Scalars['String']['output'];
  groupName?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Scalars['String']['output']>;
};

export type HeaCheckRegisterTokenInput = {
  token: Scalars['String']['input'];
};

export type HeaCheckUserStatusInput = {
  email: Scalars['String']['input'];
};

export type HeaConfirmLessonInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  lessonId: Scalars['String']['input'];
  studyplanId: Scalars['String']['input'];
};

export type HeaCreateFeedbackFormAnswerInput = {
  answerData: Scalars['String']['input'];
  lessonId?: InputMaybe<Scalars['String']['input']>;
  lessonName?: InputMaybe<Scalars['String']['input']>;
  moduleId: Scalars['String']['input'];
  moduleName?: InputMaybe<Scalars['String']['input']>;
  studyplanId: Scalars['String']['input'];
  surveyType: Scalars['Int']['input'];
  unitId?: InputMaybe<Scalars['String']['input']>;
  unitName?: InputMaybe<Scalars['String']['input']>;
};

export type HeaCreateGroupModuleInput = {
  groupId: Scalars['String']['input'];
  groupName: Scalars['String']['input'];
  moduleId: Scalars['String']['input'];
};

export type HeaCreateModuleInput = {
  position?: InputMaybe<Scalars['Int']['input']>;
  type: ContentType;
  unitId: Scalars['String']['input'];
};

export type HeaCreateStudyPlanInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  darkColor?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  unitId?: InputMaybe<Scalars['String']['input']>;
};

export type HeaCreateUnitInput = {
  ageGroup?: InputMaybe<Scalars['String']['input']>;
  box1?: InputMaybe<Scalars['String']['input']>;
  box2?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  helpfulHeading?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  originalUnitId: Scalars['String']['input'];
  pace?: InputMaybe<Scalars['String']['input']>;
  parentBox?: InputMaybe<Scalars['String']['input']>;
  parentImage?: InputMaybe<Scalars['String']['input']>;
  popupCover?: InputMaybe<Scalars['String']['input']>;
  sensitive?: InputMaybe<Scalars['Boolean']['input']>;
  sensitiveTooltip?: InputMaybe<Scalars['String']['input']>;
  skillsHeading?: InputMaybe<Scalars['String']['input']>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['String']['input']>;
  topics?: InputMaybe<Scalars['String']['input']>;
};

export type HeaDeleteGroupModuleInput = {
  groupId: Scalars['String']['input'];
  moduleId: Scalars['String']['input'];
};

export type HeaFeedbackFormAnswer = {
  __typename?: 'HEAFeedbackFormAnswer';
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['ID']['output'];
  formData: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lessonId?: Maybe<Scalars['String']['output']>;
  lessonName?: Maybe<Scalars['String']['output']>;
  moduleId: Scalars['ID']['output'];
  moduleName?: Maybe<Scalars['String']['output']>;
  parentEmail: Scalars['String']['output'];
  parentId: Scalars['ID']['output'];
  studyplanId: Scalars['ID']['output'];
  surveyType: Scalars['Int']['output'];
  unitId?: Maybe<Scalars['String']['output']>;
  unitName?: Maybe<Scalars['String']['output']>;
};

export type HeaGetLessonStatusInput = {
  studyplanId: Scalars['String']['input'];
  unitId: Scalars['String']['input'];
};

export type HeaGroupModule = {
  __typename?: 'HEAGroupModule';
  data?: Maybe<Scalars['String']['output']>;
  formData?: Maybe<Scalars['String']['output']>;
  groupId: Scalars['String']['output'];
  groupName?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Scalars['String']['output']>;
  moduleId: Scalars['ID']['output'];
};

export type HeaInviteUserInput = {
  association?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  expireAt?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type HeaLesson = {
  __typename?: 'HEALesson';
  description?: Maybe<Scalars['String']['output']>;
  descriptionAnswers?: Maybe<Scalars['String']['output']>;
  descriptionHeading?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  modules?: Maybe<Array<HeaPresentationModule>>;
  name: Scalars['String']['output'];
  number?: Maybe<Scalars['Int']['output']>;
  originalLessonId: Scalars['ID']['output'];
  prerequisite?: Maybe<Scalars['Boolean']['output']>;
  sensitive?: Maybe<Scalars['Boolean']['output']>;
  sensitiveTooltip?: Maybe<Scalars['String']['output']>;
};

export type HeaLessonStatus = {
  __typename?: 'HEALessonStatus';
  incomplete?: Maybe<Scalars['Boolean']['output']>;
  lessonId: Scalars['ID']['output'];
  status: Scalars['String']['output'];
};

export type HeaLoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type HeaLoginResponse = {
  __typename?: 'HEALoginResponse';
  token: Scalars['String']['output'];
  user?: Maybe<HeaUser>;
};

export type HeaModule = {
  __typename?: 'HEAModule';
  data?: Maybe<Scalars['String']['output']>;
  formData?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  meta?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  originalModuleId?: Maybe<Scalars['ID']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  type: ContentType;
};

export type HeaMoveModuleInput = {
  moduleId: Scalars['String']['input'];
  newPosition: ModulePositionInput;
  oldPosition: ModulePositionInput;
};

export type HeaPresentationModule = {
  __typename?: 'HEAPresentationModule';
  created: Scalars['String']['output'];
  createdBy?: Maybe<User>;
  data?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  formData?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastInGroup?: Maybe<Scalars['Boolean']['output']>;
  lastInLesson?: Maybe<Scalars['Boolean']['output']>;
  meta?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pauseHere?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  type: ContentType;
  updated: Scalars['String']['output'];
  useDefault?: Maybe<Scalars['Boolean']['output']>;
};

export type HeaRegisterInput = {
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type HeaResetPasswordInput = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type HeaSendResetPasswordLinkInput = {
  email: Scalars['String']['input'];
};

export type HeaSetPasswordAfterLoginInput = {
  enablePasscode?: InputMaybe<Scalars['Boolean']['input']>;
  passcode?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  studyplanId?: InputMaybe<Scalars['String']['input']>;
};

export type HeaSetPasswordInput = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type HeaUnit = {
  __typename?: 'HEAUnit';
  ageGroup?: Maybe<Scalars['String']['output']>;
  box1?: Maybe<Scalars['String']['output']>;
  box2?: Maybe<Scalars['String']['output']>;
  classPresentation?: Maybe<Array<HeaLesson>>;
  coverImage?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  helpfulHeading?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  originalUnitId: Scalars['ID']['output'];
  pace?: Maybe<Scalars['String']['output']>;
  parentBox?: Maybe<Scalars['String']['output']>;
  parentImage?: Maybe<Scalars['String']['output']>;
  parentPreparation?: Maybe<Array<HeaModule>>;
  popupCover?: Maybe<Scalars['String']['output']>;
  sensitive?: Maybe<Scalars['Boolean']['output']>;
  sensitiveTooltip?: Maybe<Scalars['String']['output']>;
  skillsHeading?: Maybe<Scalars['String']['output']>;
  subHeading?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Scalars['String']['output']>;
  topics?: Maybe<Scalars['String']['output']>;
};

export type HeaUnlockAccountInput = {
  passcode: Scalars['String']['input'];
};

export type HeaUpdateGroupModuleInput = {
  data: Scalars['String']['input'];
  formData?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['String']['input'];
  moduleId: Scalars['String']['input'];
};

export type HeaUpdateLessonInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionAnswers?: InputMaybe<Scalars['String']['input']>;
  descriptionHeading?: InputMaybe<Scalars['String']['input']>;
  duration: Scalars['Int']['input'];
  group?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  image?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  prerequisite?: InputMaybe<Scalars['Boolean']['input']>;
  sensitive?: InputMaybe<Scalars['Boolean']['input']>;
  sensitiveTooltip?: InputMaybe<Scalars['String']['input']>;
};

export type HeaUpdateLessonStatusInput = {
  lessonId: Scalars['String']['input'];
  lessonName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  studyPlanName?: InputMaybe<Scalars['String']['input']>;
  studyplanId: Scalars['String']['input'];
  unitId: Scalars['String']['input'];
  unitName?: InputMaybe<Scalars['String']['input']>;
};

export type HeaUpdateMeInput = {
  enableFaith?: InputMaybe<Scalars['Boolean']['input']>;
  enablePasscode?: InputMaybe<Scalars['Boolean']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  passcode?: InputMaybe<Scalars['String']['input']>;
};

export type HeaUpdateModuleInput = {
  data?: InputMaybe<Scalars['String']['input']>;
  formData?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  lessonId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type?: InputMaybe<ContentType>;
  unitId: Scalars['String']['input'];
  useDefault?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HeaUpdateStudyPlanInput = {
  id: Scalars['String']['input'];
  unitIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type HeaUpdateStudyPlanNameInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type HeaUpdateUnitInput = {
  ageGroup?: InputMaybe<Scalars['String']['input']>;
  box1?: InputMaybe<Scalars['String']['input']>;
  box2?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  helpfulHeading?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  pace?: InputMaybe<Scalars['String']['input']>;
  parentBox?: InputMaybe<Scalars['String']['input']>;
  parentImage?: InputMaybe<Scalars['String']['input']>;
  popupCover?: InputMaybe<Scalars['String']['input']>;
  sensitive?: InputMaybe<Scalars['Boolean']['input']>;
  sensitiveTooltip?: InputMaybe<Scalars['String']['input']>;
  skillsHeading?: InputMaybe<Scalars['String']['input']>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['String']['input']>;
  topics?: InputMaybe<Scalars['String']['input']>;
};

export type HeaUpdateUserInput = {
  email: Scalars['String']['input'];
  expireAt?: InputMaybe<Scalars['String']['input']>;
  expired?: InputMaybe<Scalars['Boolean']['input']>;
  firstName: Scalars['String']['input'];
  id: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type HeaUser = {
  __typename?: 'HEAUser';
  association?: Maybe<Scalars['String']['output']>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  email: Scalars['String']['output'];
  enableFaith?: Maybe<Scalars['Boolean']['output']>;
  enablePasscode?: Maybe<Scalars['Boolean']['output']>;
  expireAt?: Maybe<Scalars['String']['output']>;
  expired?: Maybe<Scalars['Boolean']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isTypeformShown?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  locked?: Maybe<Scalars['Boolean']['output']>;
  registeredAt?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  studyplanCount?: Maybe<Scalars['Int']['output']>;
  studyplanId?: Maybe<Scalars['String']['output']>;
  studyplanName?: Maybe<Scalars['String']['output']>;
};

export type HeaVerifyEmailTokenInput = {
  token: Scalars['String']['input'];
};

export type HeCreateTokenInput = {
  association?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  expireAt?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type HeDeleteTokenInput = {
  token: Scalars['String']['input'];
};

export type HeExitTicketResultInput = {
  moduleId: Scalars['String']['input'];
  studyPlanId: Scalars['String']['input'];
};

export type HeFeedbackAnswerResult = {
  __typename?: 'HEFeedbackAnswerResult';
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['ID']['output'];
  formData: Scalars['String']['output'];
  lessonName?: Maybe<Scalars['String']['output']>;
  moduleName?: Maybe<Scalars['String']['output']>;
  parentEmail: Scalars['String']['output'];
  studyPlanName?: Maybe<Scalars['String']['output']>;
  surveyType: Scalars['Int']['output'];
  unitName?: Maybe<Scalars['String']['output']>;
};

export type HeToken = {
  __typename?: 'HEToken';
  association?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  expireAt?: Maybe<Scalars['String']['output']>;
  expired?: Maybe<Scalars['Boolean']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  generatedAt?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  signups?: Maybe<Scalars['Int']['output']>;
  token: Scalars['ID']['output'];
};

export type HeUpdateTokenInput = {
  association?: InputMaybe<Scalars['String']['input']>;
  blockAll?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  expireAt?: InputMaybe<Scalars['String']['input']>;
  expired?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

export type IdInput = {
  id: Scalars['String']['input'];
};

export type IDsInput = {
  ids: Array<Scalars['String']['input']>;
};

export type LastVisitedLesson = {
  __typename?: 'LastVisitedLesson';
  lastVisitedAt: Scalars['String']['output'];
  lessonId: Scalars['ID']['output'];
  moduleId: Scalars['ID']['output'];
  pageNumber?: Maybe<Scalars['Int']['output']>;
  sectionId?: Maybe<Scalars['ID']['output']>;
  status: Scalars['String']['output'];
  unitId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

export type LastVisitedLessonInput = {
  lessonId: Scalars['String']['input'];
  moduleId: Scalars['String']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  previousModuleId?: InputMaybe<Scalars['String']['input']>;
  sectionId?: InputMaybe<Scalars['String']['input']>;
  unitId: Scalars['String']['input'];
};

export type LastVisitedUnitStudyReview = {
  __typename?: 'LastVisitedUnitStudyReview';
  lastVisitedAt: Scalars['String']['output'];
  moduleId: Scalars['ID']['output'];
  pageNumber?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  unitId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

export type LastVisitedUnitStudyReviewInput = {
  moduleId: Scalars['String']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  previousModuleId?: InputMaybe<Scalars['String']['input']>;
  unitId: Scalars['String']['input'];
};

export type Lesson = {
  __typename?: 'Lesson';
  alternativeActivated?: Maybe<Scalars['Boolean']['output']>;
  created: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionAnswers?: Maybe<Scalars['String']['output']>;
  descriptionHeading?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isAlternative?: Maybe<Scalars['Boolean']['output']>;
  lastVisitedAt?: Maybe<Scalars['String']['output']>;
  master?: Maybe<Scalars['Boolean']['output']>;
  materials?: Maybe<Array<Content>>;
  modules?: Maybe<Array<Content>>;
  name: Scalars['String']['output'];
  number?: Maybe<Scalars['Int']['output']>;
  prerequisite?: Maybe<Scalars['Boolean']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  sections?: Maybe<Array<Section>>;
  sensitive?: Maybe<Scalars['Boolean']['output']>;
  sensitiveTooltip?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  uniqueName?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['String']['output']>;
};

export type LessonByCourse = {
  __typename?: 'LessonByCourse';
  grade?: Maybe<Scalars['String']['output']>;
  lessons?: Maybe<Array<Maybe<CourseLesson>>>;
  lessonsCompleted?: Maybe<Scalars['Int']['output']>;
  progress?: Maybe<Scalars['Int']['output']>;
};

export type LessonCompleted = {
  __typename?: 'LessonCompleted';
  activeSessions: Scalars['Int']['output'];
  completedLessons: Scalars['Int']['output'];
  engagement: Scalars['Int']['output'];
  items?: Maybe<Array<Maybe<EducatorLessonItem>>>;
  lastActiveAt: Scalars['String']['output'];
  lastSessionAt: Scalars['String']['output'];
  schoolName: Scalars['String']['output'];
  teacherName: Scalars['String']['output'];
  timeSpent?: Maybe<Scalars['Int']['output']>;
  totalLogins: Scalars['Int']['output'];
  totalSessions: Scalars['Int']['output'];
};

export type LessonDetails = {
  __typename?: 'LessonDetails';
  completedAt: Scalars['String']['output'];
  lessonId?: Maybe<Scalars['String']['output']>;
  lessonName?: Maybe<Scalars['String']['output']>;
  lessonPosition?: Maybe<Scalars['String']['output']>;
  lessonType?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unitId?: Maybe<Scalars['String']['output']>;
  unitName?: Maybe<Scalars['String']['output']>;
};

export type LessonForLessonLibrary = {
  __typename?: 'LessonForLessonLibrary';
  categories: Scalars['String']['output'];
  competency: Scalars['String']['output'];
  coverImage: Scalars['String']['output'];
  duration: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isExtensionAvailable?: Maybe<Scalars['Boolean']['output']>;
  lessonType: Scalars['String']['output'];
  mainTopics: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type LessonInProgress = {
  __typename?: 'LessonInProgress';
  completionCount?: Maybe<Scalars['Int']['output']>;
  gradeName?: Maybe<Scalars['String']['output']>;
  lastCompletedAt?: Maybe<Scalars['String']['output']>;
  lessonId: Scalars['ID']['output'];
  lessonName: Scalars['String']['output'];
  progress?: Maybe<Scalars['Float']['output']>;
  status: Scalars['String']['output'];
  unitId?: Maybe<Scalars['ID']['output']>;
  unitName?: Maybe<Scalars['String']['output']>;
};

export type LessonLibrarySearchInput = {
  competency?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lessonType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mood?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  searchText?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  skill?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tier?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LessonLibrarySearchResult = {
  __typename?: 'LessonLibrarySearchResult';
  content: Array<Maybe<LessonForLessonLibrary>>;
  mCollectionId: Scalars['String']['output'];
  mCollectionName: Scalars['String']['output'];
  mIsScopeandSeq?: Maybe<Scalars['String']['output']>;
  mScopeAndSeqId?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
};

export type LessonProgress = {
  __typename?: 'LessonProgress';
  progress: Scalars['Float']['output'];
  sllLessonId: Scalars['String']['output'];
};

export type LessonToConfirm = {
  __typename?: 'LessonToConfirm';
  incomplete?: Maybe<Scalars['Boolean']['output']>;
  lesson?: Maybe<HeaLesson>;
  studyplanId: Scalars['ID']['output'];
  studyplanName: Scalars['String']['output'];
  unitId: Scalars['ID']['output'];
};

export enum LessonType {
  ALTERNATE = 'alternate',
  LESSONMATERIAL = 'lessonMaterial',
  PREPARATION = 'preparation',
  PRESENTATION = 'presentation',
  STUDENTQUIZ = 'studentQuiz',
  STUDYGUIDE = 'studyGuide',
  STUDYGUIDEMATERIAL = 'studyGuideMaterial'
}

export type LessonUpdateInput = {
  alternativeActivated?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionAnswers?: InputMaybe<Scalars['String']['input']>;
  descriptionHeading?: InputMaybe<Scalars['String']['input']>;
  duration: Scalars['Int']['input'];
  group?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  image?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  prerequisite?: InputMaybe<Scalars['Boolean']['input']>;
  sensitive?: InputMaybe<Scalars['Boolean']['input']>;
  sensitiveTooltip?: InputMaybe<Scalars['String']['input']>;
  uniqueName?: InputMaybe<Scalars['String']['input']>;
};

export type LessonsByCompetency = {
  __typename?: 'LessonsByCompetency';
  relationshipSkills?: Maybe<Scalars['Int']['output']>;
  responsibleDecisionMaking?: Maybe<Scalars['Int']['output']>;
  selfAwareness?: Maybe<Scalars['Int']['output']>;
  selfManagement?: Maybe<Scalars['Int']['output']>;
  socialAwareness?: Maybe<Scalars['Int']['output']>;
};

export type LessonsByGrade = {
  __typename?: 'LessonsByGrade';
  byCompetency?: Maybe<LessonsByCompetency>;
  byGrade?: Maybe<PaginationLessonByCourse>;
  summary?: Maybe<SummaryMetaData>;
};

export type ListNormalMultiCollectionsInput = {
  ageGroup?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export type LoginAnalyticsData = {
  __typename?: 'LoginAnalyticsData';
  total: TotalLoginAnalyticsData;
  unique: TotalLoginAnalyticsData;
};

export type LoginDataByUser = {
  __typename?: 'LoginDataByUser';
  count: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type LoginInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  sid?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  uri?: Maybe<Scalars['String']['output']>;
  verified?: Maybe<Scalars['String']['output']>;
};

export type McInfo = {
  mcId: Scalars['String']['input'];
  position: Scalars['Int']['input'];
};

export type ManuallyTriggerReportInput = {
  formId: Scalars['String']['input'];
  previewMode?: InputMaybe<Scalars['Boolean']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MarkSchoolNewYearModalShownInput = {
  schoolNewYearInfo: Scalars['String']['input'];
};

export type ModulePositionInput = {
  lessonId?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
  sectionId?: InputMaybe<Scalars['String']['input']>;
  unitId: Scalars['String']['input'];
};

export type MoveCourseContentInput = {
  courseId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  newPosition: Scalars['Int']['input'];
  oldPosition: Scalars['Int']['input'];
  type: CourseContentType;
};

export type MoveLessonInput = {
  lessonId: Scalars['String']['input'];
  newPosition: Scalars['Int']['input'];
  oldPosition: Scalars['Int']['input'];
  unitId: Scalars['String']['input'];
};

export type MoveModuleInput = {
  alternate?: InputMaybe<Scalars['Boolean']['input']>;
  lessonMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  moduleId: Scalars['String']['input'];
  newPosition: ModulePositionInput;
  oldPosition: ModulePositionInput;
};

export type MoveUnitInput = {
  courseId: Scalars['String']['input'];
  newPosition: Scalars['Int']['input'];
  oldPosition: Scalars['Int']['input'];
  primary: Scalars['Boolean']['input'];
  unitId: Scalars['String']['input'];
};

export type MultiCollection = {
  __typename?: 'MultiCollection';
  collections?: Maybe<Array<Maybe<Collection>>>;
  country: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  grade: Scalars['String']['output'];
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  isScopeAndSeq?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  scopeAndSeqId?: Maybe<Scalars['String']['output']>;
  type: MultiCollectionType;
};

export type MultiCollectionContent = {
  __typename?: 'MultiCollectionContent';
  ageGroup?: Maybe<Scalars['String']['output']>;
  bannerImage?: Maybe<Scalars['String']['output']>;
  bannerVideo?: Maybe<Scalars['String']['output']>;
  categories?: Maybe<Scalars['String']['output']>;
  collectionType?: Maybe<CollectionType>;
  comingSoonAt?: Maybe<Scalars['String']['output']>;
  comingSoonLabelPosition?: Maybe<Scalars['String']['output']>;
  competency?: Maybe<Scalars['String']['output']>;
  coverImage?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  gradeLevel?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isComingSoon?: Maybe<Scalars['Boolean']['output']>;
  isNew?: Maybe<Scalars['Boolean']['output']>;
  isNewCover?: Maybe<Scalars['Boolean']['output']>;
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  lessonDetails?: Maybe<Scalars['String']['output']>;
  lessonType?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  newLabelPosition?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  progress?: Maybe<Scalars['Float']['output']>;
  subHeading?: Maybe<Scalars['String']['output']>;
  suggestedDuration?: Maybe<Scalars['String']['output']>;
  suggestedLessonCount?: Maybe<Scalars['Int']['output']>;
  type: MultiCollectionContentType;
  updatedLabelPosition?: Maybe<Scalars['String']['output']>;
};

export enum MultiCollectionContentType {
  COLLECTION = 'Collection',
  LESSON = 'Lesson'
}

export enum MultiCollectionSubType {
  BRAINBREAK = 'BrainBreak',
  SKILLBUILDER = 'SkillBuilder'
}

export enum MultiCollectionType {
  BRAINBREAK = 'BrainBreak',
  NORMAL = 'Normal',
  STUDENTINTRODUCTION = 'StudentIntroduction',
  TRANSITION = 'Transition'
}

export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['String']['output']>;
  addAccount?: Maybe<Scalars['Boolean']['output']>;
  addGroup: Group;
  addMCToProgram: Scalars['Boolean']['output'];
  addSchool?: Maybe<School>;
  addSentryTracking: SentryTracking;
  addUrlToAirtable: Scalars['Boolean']['output'];
  aiLessonChat: AiLessonChatResult;
  bulkInviteUsersAsEducator?: Maybe<Array<Maybe<User>>>;
  cancelAbsentStudentLesson?: Maybe<Scalars['Boolean']['output']>;
  cancelFeedbackForm?: Maybe<Scalars['Boolean']['output']>;
  cancelTranslationJob: Scalars['Boolean']['output'];
  cancelVideoTranslationJob: Scalars['Boolean']['output'];
  clearTranslationCache: Scalars['Boolean']['output'];
  cleverSSOLogin?: Maybe<LoginResponse>;
  convertTextToAudio: Scalars['String']['output'];
  copyPasswordLink: Scalars['String']['output'];
  createAbsentStudentLesson: AbsentStudentLesson;
  createAlternateLesson?: Maybe<Array<Section>>;
  createCollection?: Maybe<Collection>;
  createContent?: Maybe<Content>;
  createFeedbackForm?: Maybe<FeedbackFormContent>;
  createFeedbackFormAnswer?: Maybe<FeedbackFormContentAnswer>;
  createLesson?: Maybe<Lesson>;
  createMultiCollection?: Maybe<MultiCollection>;
  createNewGroupContent?: Maybe<GroupContent>;
  createProgram?: Maybe<Scalars['String']['output']>;
  createQuiz: Scalars['String']['output'];
  createQuizFeedbackForm?: Maybe<FeedbackFormContent>;
  createSection?: Maybe<Section>;
  createTranslationJob: TranslationJob;
  createUnit: Unit;
  createVideoSubtitle?: Maybe<VideoSubtitle>;
  createVideoTranslationJob: VideoTranslationJob;
  createVideoWithTranslation: VideoWithTranslationResult;
  customizeCoursesForSchool?: Maybe<Scalars['Boolean']['output']>;
  deleteAccount?: Maybe<Scalars['Boolean']['output']>;
  deleteAlternateLesson: Scalars['Boolean']['output'];
  deleteCollection?: Maybe<Scalars['Boolean']['output']>;
  deleteGroupContent?: Maybe<Scalars['Boolean']['output']>;
  deleteGroupModuleData?: Maybe<Scalars['Boolean']['output']>;
  deleteLesson: Scalars['Boolean']['output'];
  deleteModuleData?: Maybe<Scalars['Boolean']['output']>;
  deleteMultiCollection: Scalars['Boolean']['output'];
  deleteProgram?: Maybe<Scalars['Boolean']['output']>;
  deleteQuiz: Scalars['Boolean']['output'];
  deleteSchool?: Maybe<Scalars['Boolean']['output']>;
  deleteSchoolReport: Scalars['Boolean']['output'];
  deleteSection: Scalars['Boolean']['output'];
  deleteUnit: Scalars['Boolean']['output'];
  deleteVideoSubtitle?: Maybe<Scalars['ID']['output']>;
  districtAdminInviteUsers?: Maybe<Array<Maybe<User>>>;
  duplicateCourse: Scalars['String']['output'];
  editAccount?: Maybe<Scalars['Boolean']['output']>;
  editGroup: Group;
  editSchool?: Maybe<School>;
  editUnit: Unit;
  emailPasswordLink: Scalars['Boolean']['output'];
  finishStudyPlan: HeaUser;
  generateAWSKeys: AwsKeys;
  generateAccess: Scalars['String']['output'];
  generateCaptionsForUpload: CaptionUploadResult;
  generateDashboardLink: Scalars['String']['output'];
  generateEnglishCaptions: EnglishCaptionJob;
  generateParentLinkForUser: ParentLinkOutput;
  generateSchoolReport?: Maybe<SchoolReport>;
  getCleverUser?: Maybe<CleverUser>;
  heCreateToken: Scalars['Boolean']['output'];
  heDeleteToken: Scalars['Boolean']['output'];
  heUpdateToken: Scalars['Boolean']['output'];
  heaCheckRegisterToken: Scalars['Boolean']['output'];
  heaCheckUserStatus: Scalars['String']['output'];
  heaConfirmLesson: Scalars['Boolean']['output'];
  heaCreateFeedbackFormAnswer?: Maybe<HeaFeedbackFormAnswer>;
  heaCreateGroupModule?: Maybe<HeaGroupModule>;
  heaCreateModule?: Maybe<HeaModule>;
  heaCreateStudyPlan: Scalars['String']['output'];
  heaCreateUnit: HeaUnit;
  heaDeleteAccount?: Maybe<Scalars['Boolean']['output']>;
  heaDeleteGroupModule?: Maybe<Scalars['Boolean']['output']>;
  heaDeleteModule?: Maybe<Scalars['Boolean']['output']>;
  heaDeleteStudyPlan: Scalars['Boolean']['output'];
  heaDeleteUnit: Scalars['Boolean']['output'];
  heaDeleteUser: Scalars['Boolean']['output'];
  heaEnableFaith?: Maybe<Scalars['Boolean']['output']>;
  heaInviteUser: Scalars['Boolean']['output'];
  heaLockAccount?: Maybe<Scalars['Boolean']['output']>;
  heaLogin: HeaLoginResponse;
  heaMoveModule: Scalars['Boolean']['output'];
  heaRegister: HeaRegisterResponse;
  heaResetPassword: Scalars['String']['output'];
  heaSendResetPasswordLink: Scalars['Boolean']['output'];
  heaSetPassword: Scalars['String']['output'];
  heaSetPasswordAfterLogin?: Maybe<Scalars['Boolean']['output']>;
  heaSetTypeformShown: Scalars['Boolean']['output'];
  heaUnlockAccount?: Maybe<Scalars['Boolean']['output']>;
  heaUpdateGroupModule?: Maybe<HeaGroupModule>;
  heaUpdateLesson?: Maybe<HeaLesson>;
  heaUpdateLessonStatus: Scalars['Boolean']['output'];
  heaUpdateMe: HeaUser;
  heaUpdateModule?: Maybe<Scalars['Boolean']['output']>;
  heaUpdateStudyPlan: Scalars['Boolean']['output'];
  heaUpdateStudyPlanName: Scalars['Boolean']['output'];
  heaUpdateUnit: HeaUnit;
  heaUpdateUser: Scalars['Boolean']['output'];
  heaVerifyEmailToken: Scalars['String']['output'];
  inviteUserAsEducator?: Maybe<User>;
  inviteUserAsEducatorEdit?: Maybe<User>;
  login?: Maybe<LoginResponse>;
  manuallyTriggerReport: Scalars['Boolean']['output'];
  markSchoolNewYearModalShown: Scalars['Boolean']['output'];
  moveCourseContent?: Maybe<Scalars['Boolean']['output']>;
  moveLesson: Scalars['Boolean']['output'];
  moveModule: Scalars['Boolean']['output'];
  moveUnit?: Maybe<Scalars['Boolean']['output']>;
  registerParent?: Maybe<ParentRegisterOutput>;
  registration: UserRegistrationResponse;
  removeContent?: Maybe<Scalars['Boolean']['output']>;
  removeMCFromProgram: Scalars['Boolean']['output'];
  removeSentryTracking: Scalars['Boolean']['output'];
  resendEmailCode?: Maybe<Scalars['Boolean']['output']>;
  resetAllLessonProgress: Scalars['Boolean']['output'];
  resetEmail?: Maybe<Scalars['Boolean']['output']>;
  resetEmailConfirmation?: Maybe<Scalars['Boolean']['output']>;
  resetLessonProgress: Scalars['Boolean']['output'];
  retryFailedLanguageJob: VideoTranslationLanguageJob;
  revalidateToken?: Maybe<RevalidateTokenResponse>;
  saveCollectionLessons?: Maybe<Scalars['Boolean']['output']>;
  saveMultiCollections?: Maybe<Scalars['Boolean']['output']>;
  saveProgramUnits?: Maybe<Scalars['Boolean']['output']>;
  saveReel?: Maybe<Scalars['Boolean']['output']>;
  sendReplyWithUrl: Scalars['Boolean']['output'];
  sllAddLessonExclusion: Scalars['Boolean']['output'];
  sllCreateCourse: Scalars['String']['output'];
  sllCreateGroupModule?: Maybe<SllGroupModule>;
  sllCreateLesson?: Maybe<SllLesson>;
  sllCreateModule?: Maybe<SllModule>;
  sllCreateProgram: SllProgram;
  sllCreateSection?: Maybe<SllSection>;
  sllDeleteCourse: Scalars['Boolean']['output'];
  sllDeleteGroupModule: Scalars['Boolean']['output'];
  sllDeleteGroupModuleContent: Scalars['Boolean']['output'];
  sllDeleteLesson: Scalars['Boolean']['output'];
  sllDeleteModule: Scalars['Boolean']['output'];
  sllDeleteModuleContent: Scalars['Boolean']['output'];
  sllDeleteProgram: Scalars['Boolean']['output'];
  sllDeleteSection: Scalars['Boolean']['output'];
  sllMoveModule: Scalars['Boolean']['output'];
  sllRemoveLessonExclusion: Scalars['Boolean']['output'];
  sllUpdateCourse: Scalars['Boolean']['output'];
  sllUpdateCourseName: Scalars['Boolean']['output'];
  sllUpdateGroupModule?: Maybe<SllGroupModule>;
  sllUpdateLastVisitedModule: Scalars['Boolean']['output'];
  sllUpdateLesson?: Maybe<SllLesson>;
  sllUpdateLessonCompleteStatus: Scalars['Boolean']['output'];
  sllUpdateModule?: Maybe<SllModule>;
  sllUpdateProgram: SllProgram;
  sllUpdateSection: Scalars['Boolean']['output'];
  sllUpdateVideoGroupModule?: Maybe<SllGroupModule>;
  sllUpdateVideoModule?: Maybe<SllModule>;
  socialLogin?: Maybe<LoginResponse>;
  sslCreatePreProgramFeedbackForm: FeedbackFormContent;
  submitFeedbackFormAnswerForAbsent?: Maybe<FeedbackFormContentAnswer>;
  superAdminInviteUser?: Maybe<User>;
  superAdminInviteUserEdit?: Maybe<User>;
  superAdminInviteUsers?: Maybe<Array<Maybe<User>>>;
  superAdminRemoveUser?: Maybe<Scalars['Boolean']['output']>;
  switchLessonFlow: Scalars['Boolean']['output'];
  trackAnalytics?: Maybe<Scalars['Boolean']['output']>;
  translateText: TranslationResult;
  translateTexts: TranslationBatchResult;
  unsubscribe?: Maybe<Scalars['Boolean']['output']>;
  updateCollection?: Maybe<Collection>;
  updateContent?: Maybe<Content>;
  updateFormContentJson?: Maybe<Scalars['Boolean']['output']>;
  updateGroupContent?: Maybe<GroupContent>;
  updateLanguageJob: VideoTranslationLanguageJob;
  updateLastVisitedLesson?: Maybe<LastVisitedLesson>;
  updateLastVisitedUnitStudyReview?: Maybe<LastVisitedUnitStudyReview>;
  updateLesson?: Maybe<Lesson>;
  updateLessonCompleteStatus: Scalars['Boolean']['output'];
  updateMe: Scalars['String']['output'];
  updateMultiCollection?: Maybe<MultiCollection>;
  updateProgram?: Maybe<Program>;
  updateProgramLastUsed?: Maybe<ProgramLastUsed>;
  updateQuiz: Scalars['Boolean']['output'];
  updateQuizName: Scalars['Boolean']['output'];
  updateSchoolReport: Scalars['Boolean']['output'];
  updateSection: Scalars['Boolean']['output'];
  updateSectionCompleteStatus: Scalars['Boolean']['output'];
  updateSentryTracking: SentryTracking;
  updateSpecialProgram?: Maybe<SpecialProgram>;
  updateTranslationJob: TranslationJob;
  updateUnitStudyReviewStatus?: Maybe<Scalars['Boolean']['output']>;
  updateUserFlags?: Maybe<UserFlags>;
  updateVideoContent?: Maybe<Content>;
  updateVideoGroupContent?: Maybe<GroupContent>;
  updateVideoTranslationJob: VideoTranslationJob;
  uploadZIPSlide: Scalars['Boolean']['output'];
  userTimeSpent?: Maybe<Scalars['Boolean']['output']>;
  verifyCode: Scalars['String']['output'];
  verifyEmailCode: Scalars['String']['output'];
};


export type MutationAddAccountArgs = {
  input: AddAccountInput;
};


export type MutationAddGroupArgs = {
  input: AddGroupInput;
};


export type MutationAddMcToProgramArgs = {
  input: AddMcToProgramInput;
};


export type MutationAddSchoolArgs = {
  input: AddSchoolInput;
};


export type MutationAddSentryTrackingArgs = {
  input: SentryTrackingInput;
};


export type MutationAddUrlToAirtableArgs = {
  urls: Array<Scalars['String']['input']>;
};


export type MutationAiLessonChatArgs = {
  input: AiLessonChatInput;
};


export type MutationBulkInviteUsersAsEducatorArgs = {
  input?: InputMaybe<Array<InputMaybe<BulkUserInviteInput>>>;
};


export type MutationCancelAbsentStudentLessonArgs = {
  input: IdInput;
};


export type MutationCancelFeedbackFormArgs = {
  input: IdInput;
};


export type MutationCancelTranslationJobArgs = {
  jobId: Scalars['String']['input'];
};


export type MutationCancelVideoTranslationJobArgs = {
  jobId: Scalars['String']['input'];
};


export type MutationCleverSsoLoginArgs = {
  input: CleverLoginInput;
};


export type MutationConvertTextToAudioArgs = {
  isAU?: InputMaybe<Scalars['Boolean']['input']>;
  text: Scalars['String']['input'];
};


export type MutationCopyPasswordLinkArgs = {
  input: EmailInput;
};


export type MutationCreateAbsentStudentLessonArgs = {
  input: AbsentStudentLessonInput;
};


export type MutationCreateAlternateLessonArgs = {
  input: IdInput;
};


export type MutationCreateCollectionArgs = {
  input: CreateCollectionInput;
};


export type MutationCreateContentArgs = {
  input: CreateContentInput;
};


export type MutationCreateFeedbackFormArgs = {
  input: FeedbackFormContentInput;
};


export type MutationCreateFeedbackFormAnswerArgs = {
  input: FeedbackFormContentAnswerInput;
};


export type MutationCreateLessonArgs = {
  input: IdInput;
};


export type MutationCreateMultiCollectionArgs = {
  input: CreateMultiCollectionInput;
};


export type MutationCreateNewGroupContentArgs = {
  input: CreateNewGroupContentInput;
};


export type MutationCreateProgramArgs = {
  input?: InputMaybe<ProgramEditInput>;
};


export type MutationCreateQuizArgs = {
  input: CreateQuizInput;
};


export type MutationCreateQuizFeedbackFormArgs = {
  input: QuizFeedbackFormInput;
};


export type MutationCreateSectionArgs = {
  input: CreateSectionInput;
};


export type MutationCreateTranslationJobArgs = {
  input: CreateTranslationJobInput;
};


export type MutationCreateUnitArgs = {
  input: CreateUnitInput;
};


export type MutationCreateVideoSubtitleArgs = {
  input: CreateVideoSubtitleInput;
};


export type MutationCreateVideoTranslationJobArgs = {
  input: CreateVideoTranslationJobInput;
};


export type MutationCreateVideoWithTranslationArgs = {
  input: CreateVideoWithTranslationInput;
};


export type MutationCustomizeCoursesForSchoolArgs = {
  input: CustomizeCoursesForSchoolInput;
};


export type MutationDeleteAccountArgs = {
  input: UserIdInput;
};


export type MutationDeleteAlternateLessonArgs = {
  input: IdInput;
};


export type MutationDeleteCollectionArgs = {
  input: IdInput;
};


export type MutationDeleteGroupContentArgs = {
  input: DeleteGroupModuleInput;
};


export type MutationDeleteGroupModuleDataArgs = {
  input: DeleteGroupModuleInput;
};


export type MutationDeleteLessonArgs = {
  input: IdInput;
};


export type MutationDeleteModuleDataArgs = {
  input: IdInput;
};


export type MutationDeleteMultiCollectionArgs = {
  input: IdInput;
};


export type MutationDeleteProgramArgs = {
  input: IdInput;
};


export type MutationDeleteQuizArgs = {
  input: IdInput;
};


export type MutationDeleteSchoolArgs = {
  input: UserIdInput;
};


export type MutationDeleteSchoolReportArgs = {
  input: IdInput;
};


export type MutationDeleteSectionArgs = {
  input: IdInput;
};


export type MutationDeleteUnitArgs = {
  input: IdInput;
};


export type MutationDeleteVideoSubtitleArgs = {
  assetId?: InputMaybe<Scalars['ID']['input']>;
  playbackId?: InputMaybe<Scalars['ID']['input']>;
  trackId: Scalars['ID']['input'];
};


export type MutationDistrictAdminInviteUsersArgs = {
  input?: InputMaybe<Array<InputMaybe<DistrictAdminBulkInviteUserInput>>>;
};


export type MutationDuplicateCourseArgs = {
  input: DuplicateCourseInput;
};


export type MutationEditAccountArgs = {
  input: EditAccountInput;
};


export type MutationEditGroupArgs = {
  input: EditGroupInput;
};


export type MutationEditSchoolArgs = {
  input: EditSchoolInput;
};


export type MutationEditUnitArgs = {
  input: EditUnitInput;
};


export type MutationEmailPasswordLinkArgs = {
  input: EmailInput;
};


export type MutationGenerateAccessArgs = {
  input: IdInput;
};


export type MutationGenerateCaptionsForUploadArgs = {
  input: GenerateCaptionsForUploadInput;
};


export type MutationGenerateDashboardLinkArgs = {
  input: UserIdInput;
};


export type MutationGenerateEnglishCaptionsArgs = {
  input: GenerateEnglishCaptionsInput;
};


export type MutationGenerateParentLinkForUserArgs = {
  input?: InputMaybe<ParentLinkInput>;
};


export type MutationGenerateSchoolReportArgs = {
  input: GenerateSchoolReportInput;
};


export type MutationGetCleverUserArgs = {
  input: CleverLoginInput;
};


export type MutationHeCreateTokenArgs = {
  input: HeCreateTokenInput;
};


export type MutationHeDeleteTokenArgs = {
  input: HeDeleteTokenInput;
};


export type MutationHeUpdateTokenArgs = {
  input: HeUpdateTokenInput;
};


export type MutationHeaCheckRegisterTokenArgs = {
  input: HeaCheckRegisterTokenInput;
};


export type MutationHeaCheckUserStatusArgs = {
  input: HeaCheckUserStatusInput;
};


export type MutationHeaConfirmLessonArgs = {
  input: HeaConfirmLessonInput;
};


export type MutationHeaCreateFeedbackFormAnswerArgs = {
  input: HeaCreateFeedbackFormAnswerInput;
};


export type MutationHeaCreateGroupModuleArgs = {
  input: HeaCreateGroupModuleInput;
};


export type MutationHeaCreateModuleArgs = {
  input: HeaCreateModuleInput;
};


export type MutationHeaCreateStudyPlanArgs = {
  input: HeaCreateStudyPlanInput;
};


export type MutationHeaCreateUnitArgs = {
  input: HeaCreateUnitInput;
};


export type MutationHeaDeleteGroupModuleArgs = {
  input: HeaDeleteGroupModuleInput;
};


export type MutationHeaDeleteModuleArgs = {
  input: IdInput;
};


export type MutationHeaDeleteStudyPlanArgs = {
  input: IdInput;
};


export type MutationHeaDeleteUnitArgs = {
  input: IdInput;
};


export type MutationHeaDeleteUserArgs = {
  input: IdInput;
};


export type MutationHeaEnableFaithArgs = {
  disable?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationHeaInviteUserArgs = {
  input: HeaInviteUserInput;
};


export type MutationHeaLockAccountArgs = {
  input: IdInput;
};


export type MutationHeaLoginArgs = {
  input: HeaLoginInput;
};


export type MutationHeaMoveModuleArgs = {
  input: HeaMoveModuleInput;
};


export type MutationHeaRegisterArgs = {
  input: HeaRegisterInput;
};


export type MutationHeaResetPasswordArgs = {
  input: HeaResetPasswordInput;
};


export type MutationHeaSendResetPasswordLinkArgs = {
  input: HeaSendResetPasswordLinkInput;
};


export type MutationHeaSetPasswordArgs = {
  input: HeaSetPasswordInput;
};


export type MutationHeaSetPasswordAfterLoginArgs = {
  input: HeaSetPasswordAfterLoginInput;
};


export type MutationHeaUnlockAccountArgs = {
  input: HeaUnlockAccountInput;
};


export type MutationHeaUpdateGroupModuleArgs = {
  input: HeaUpdateGroupModuleInput;
};


export type MutationHeaUpdateLessonArgs = {
  input: HeaUpdateLessonInput;
};


export type MutationHeaUpdateLessonStatusArgs = {
  input: HeaUpdateLessonStatusInput;
};


export type MutationHeaUpdateMeArgs = {
  input: HeaUpdateMeInput;
};


export type MutationHeaUpdateModuleArgs = {
  input: HeaUpdateModuleInput;
};


export type MutationHeaUpdateStudyPlanArgs = {
  input: HeaUpdateStudyPlanInput;
};


export type MutationHeaUpdateStudyPlanNameArgs = {
  input: HeaUpdateStudyPlanNameInput;
};


export type MutationHeaUpdateUnitArgs = {
  input: HeaUpdateUnitInput;
};


export type MutationHeaUpdateUserArgs = {
  input: HeaUpdateUserInput;
};


export type MutationHeaVerifyEmailTokenArgs = {
  input: HeaVerifyEmailTokenInput;
};


export type MutationInviteUserAsEducatorArgs = {
  input?: InputMaybe<UserInviteInput>;
};


export type MutationInviteUserAsEducatorEditArgs = {
  input?: InputMaybe<UserInviteEditInput>;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationManuallyTriggerReportArgs = {
  input: ManuallyTriggerReportInput;
};


export type MutationMarkSchoolNewYearModalShownArgs = {
  input: MarkSchoolNewYearModalShownInput;
};


export type MutationMoveCourseContentArgs = {
  input: MoveCourseContentInput;
};


export type MutationMoveLessonArgs = {
  input: MoveLessonInput;
};


export type MutationMoveModuleArgs = {
  input: MoveModuleInput;
};


export type MutationMoveUnitArgs = {
  input: MoveUnitInput;
};


export type MutationRegisterParentArgs = {
  input: ParentRegisterInput;
};


export type MutationRegistrationArgs = {
  input?: InputMaybe<UserRegistrationInput>;
};


export type MutationRemoveContentArgs = {
  input: IdInput;
};


export type MutationRemoveMcFromProgramArgs = {
  input: RemoveMcFromProgramInput;
};


export type MutationRemoveSentryTrackingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResendEmailCodeArgs = {
  input: EmailInput;
};


export type MutationResetEmailArgs = {
  input: EmailInput;
};


export type MutationResetEmailConfirmationArgs = {
  input: ResetConfirmationInput;
};


export type MutationResetLessonProgressArgs = {
  input: ResetLessonProgressInput;
};


export type MutationRetryFailedLanguageJobArgs = {
  languageJobId: Scalars['String']['input'];
};


export type MutationRevalidateTokenArgs = {
  input: RevalidateTokenInput;
};


export type MutationSaveCollectionLessonsArgs = {
  input: SaveCollectionLessonsInput;
};


export type MutationSaveMultiCollectionsArgs = {
  input: Array<SaveMultiCollectionsInput>;
};


export type MutationSaveProgramUnitsArgs = {
  input: SaveProgramUnitsInput;
};


export type MutationSaveReelArgs = {
  input: Array<SaveReelInput>;
};


export type MutationSendReplyWithUrlArgs = {
  input: UploadZipSlideInput;
};


export type MutationSllAddLessonExclusionArgs = {
  input: SllLessonExclusionInput;
};


export type MutationSllCreateCourseArgs = {
  input: SllCreateCourseInput;
};


export type MutationSllCreateGroupModuleArgs = {
  input: SllCreateGroupModuleInput;
};


export type MutationSllCreateLessonArgs = {
  input: SllCreateLessonInput;
};


export type MutationSllCreateModuleArgs = {
  input: SllCreateModuleInput;
};


export type MutationSllCreateProgramArgs = {
  input: SllCreateProgramInput;
};


export type MutationSllCreateSectionArgs = {
  input: IdInput;
};


export type MutationSllDeleteCourseArgs = {
  input: IdInput;
};


export type MutationSllDeleteGroupModuleArgs = {
  input: SllDeleteGroupModuleInput;
};


export type MutationSllDeleteGroupModuleContentArgs = {
  input: SllDeleteGroupModuleInput;
};


export type MutationSllDeleteLessonArgs = {
  input: IdInput;
};


export type MutationSllDeleteModuleArgs = {
  input: IdInput;
};


export type MutationSllDeleteModuleContentArgs = {
  input: IdInput;
};


export type MutationSllDeleteProgramArgs = {
  input: IdInput;
};


export type MutationSllDeleteSectionArgs = {
  input: IdInput;
};


export type MutationSllMoveModuleArgs = {
  input: SllMoveModuleInput;
};


export type MutationSllRemoveLessonExclusionArgs = {
  input: SllLessonExclusionInput;
};


export type MutationSllUpdateCourseArgs = {
  input: SllUpdateCourseInput;
};


export type MutationSllUpdateCourseNameArgs = {
  input: SllUpdateSectionInput;
};


export type MutationSllUpdateGroupModuleArgs = {
  input: SllUpdateGroupModuleInput;
};


export type MutationSllUpdateLastVisitedModuleArgs = {
  input: SllUpdateLastVisitedModuleInput;
};


export type MutationSllUpdateLessonArgs = {
  input: SllUpdateLessonInput;
};


export type MutationSllUpdateLessonCompleteStatusArgs = {
  input: SllUpdateLessonCompleteStatusInput;
};


export type MutationSllUpdateModuleArgs = {
  input: SllUpdateModuleInput;
};


export type MutationSllUpdateProgramArgs = {
  input: SllUpdateProgramInput;
};


export type MutationSllUpdateSectionArgs = {
  input: SllUpdateSectionInput;
};


export type MutationSllUpdateVideoGroupModuleArgs = {
  input: SllUpdateVideoGroupModuleInput;
};


export type MutationSllUpdateVideoModuleArgs = {
  input: SllUpdateVideoModuleInput;
};


export type MutationSocialLoginArgs = {
  input: SocialLoginInput;
};


export type MutationSslCreatePreProgramFeedbackFormArgs = {
  input: SllPreProgramQuizInput;
};


export type MutationSubmitFeedbackFormAnswerForAbsentArgs = {
  input: FeedbackFormAnswerForAbsentInput;
};


export type MutationSuperAdminInviteUserArgs = {
  input?: InputMaybe<SuperAdminInviteUserInput>;
};


export type MutationSuperAdminInviteUserEditArgs = {
  input?: InputMaybe<SuperAdminInviteUserInput>;
};


export type MutationSuperAdminInviteUsersArgs = {
  input?: InputMaybe<Array<InputMaybe<SuperAdminBulkInviteUserInput>>>;
};


export type MutationSuperAdminRemoveUserArgs = {
  input: UserIdInput;
};


export type MutationSwitchLessonFlowArgs = {
  input: SwitchLessonFlowInput;
};


export type MutationTrackAnalyticsArgs = {
  input: TrackDataInput;
};


export type MutationTranslateTextArgs = {
  input: TranslateTextInput;
};


export type MutationTranslateTextsArgs = {
  input: TranslateTextsInput;
};


export type MutationUnsubscribeArgs = {
  input: UserIdInput;
};


export type MutationUpdateCollectionArgs = {
  input: UpdateCollectionInput;
};


export type MutationUpdateContentArgs = {
  input: UpdateContentInput;
};


export type MutationUpdateFormContentJsonArgs = {
  input: UpdateFormContentJsonInput;
};


export type MutationUpdateGroupContentArgs = {
  input: UpdateGroupContentInput;
};


export type MutationUpdateLanguageJobArgs = {
  input: UpdateLanguageJobInput;
};


export type MutationUpdateLastVisitedLessonArgs = {
  input?: InputMaybe<LastVisitedLessonInput>;
};


export type MutationUpdateLastVisitedUnitStudyReviewArgs = {
  input?: InputMaybe<LastVisitedUnitStudyReviewInput>;
};


export type MutationUpdateLessonArgs = {
  input?: InputMaybe<LessonUpdateInput>;
};


export type MutationUpdateLessonCompleteStatusArgs = {
  input: UpdateLessonCompleteStatusInput;
};


export type MutationUpdateMeArgs = {
  userInput: UserUpdateInput;
};


export type MutationUpdateMultiCollectionArgs = {
  input: UpdateMultiCollectionInput;
};


export type MutationUpdateProgramArgs = {
  input?: InputMaybe<ProgramEditInput>;
};


export type MutationUpdateProgramLastUsedArgs = {
  input: IdInput;
};


export type MutationUpdateQuizArgs = {
  input: UpdateQuizInput;
};


export type MutationUpdateQuizNameArgs = {
  input: UpdateQuizNameInput;
};


export type MutationUpdateSchoolReportArgs = {
  input: UpdateSchoolReportInput;
};


export type MutationUpdateSectionArgs = {
  input: UpdateSectionInput;
};


export type MutationUpdateSectionCompleteStatusArgs = {
  input: UpdateSectionCompleteStatusInput;
};


export type MutationUpdateSentryTrackingArgs = {
  input: UpdateSentryTrackingInput;
};


export type MutationUpdateSpecialProgramArgs = {
  input: SpecialProgramEditInput;
};


export type MutationUpdateTranslationJobArgs = {
  input: UpdateTranslationJobInput;
};


export type MutationUpdateUnitStudyReviewStatusArgs = {
  input: UpdateUnitStudyReviewStatusInput;
};


export type MutationUpdateUserFlagsArgs = {
  flags?: InputMaybe<UserFlagsInput>;
};


export type MutationUpdateVideoContentArgs = {
  input: UpdateVideoContentInput;
};


export type MutationUpdateVideoGroupContentArgs = {
  input: UpdateVideoGroupContentInput;
};


export type MutationUpdateVideoTranslationJobArgs = {
  input: UpdateVideoTranslationJobInput;
};


export type MutationUploadZipSlideArgs = {
  input: UploadZipSlideInput;
};


export type MutationUserTimeSpentArgs = {
  input: TimeSpentInput;
};


export type MutationVerifyCodeArgs = {
  input: VerifyCodeInput;
};


export type MutationVerifyEmailCodeArgs = {
  input: VerifyCodeInput;
};

export type MuxAssetData = {
  __typename?: 'MuxAssetData';
  aspect_ratio?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  input_info?: Maybe<Array<Maybe<MuxInputInfo>>>;
  master_access?: Maybe<Scalars['String']['output']>;
  max_stored_frame_rate?: Maybe<Scalars['Int']['output']>;
  max_stored_resolution?: Maybe<Scalars['String']['output']>;
  mp4_support?: Maybe<Scalars['String']['output']>;
  non_standard_input_reasons?: Maybe<MuxNonStandardReasons>;
  playback_ids?: Maybe<Array<Maybe<MuxPlaybackId>>>;
  status?: Maybe<Scalars['String']['output']>;
  tracks?: Maybe<Array<Maybe<MuxTrack>>>;
  upload_id?: Maybe<Scalars['String']['output']>;
};

export type MuxInputInfo = {
  __typename?: 'MuxInputInfo';
  settings?: Maybe<MuxInputSettings>;
  tracks?: Maybe<Array<Maybe<MuxInputTrack>>>;
};

export type MuxInputSettings = {
  __typename?: 'MuxInputSettings';
  audio_codec?: Maybe<Scalars['String']['output']>;
  video_codec?: Maybe<Scalars['String']['output']>;
};

export type MuxInputTrack = {
  __typename?: 'MuxInputTrack';
  duration?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type MuxNonStandardReasons = {
  __typename?: 'MuxNonStandardReasons';
  video_resolution?: Maybe<Scalars['String']['output']>;
};

export type MuxPlaybackId = {
  __typename?: 'MuxPlaybackId';
  id?: Maybe<Scalars['String']['output']>;
  policy?: Maybe<Scalars['String']['output']>;
};

export type MuxTrack = {
  __typename?: 'MuxTrack';
  duration?: Maybe<Scalars['Float']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  language_code?: Maybe<Scalars['String']['output']>;
  max_channel_layout?: Maybe<Scalars['String']['output']>;
  max_channels?: Maybe<Scalars['Int']['output']>;
  max_frame_rate?: Maybe<Scalars['Float']['output']>;
  max_height?: Maybe<Scalars['Int']['output']>;
  max_width?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  primary?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  text_source?: Maybe<Scalars['String']['output']>;
  text_type?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type NormalMultiCollection = {
  __typename?: 'NormalMultiCollection';
  content?: Maybe<Array<Maybe<MultiCollectionContent>>>;
  country: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  grade: Scalars['String']['output'];
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  isScopeAndSeq?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  scopeAndSeqId?: Maybe<Scalars['String']['output']>;
};

export type OfficeHourEvents = {
  __typename?: 'OfficeHourEvents';
  clinical: CalendarEventType;
  onboarding: CalendarEventType;
};

export type PaginationLessonByCourse = {
  __typename?: 'PaginationLessonByCourse';
  data?: Maybe<Array<Maybe<LessonByCourse>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PaginationLessonCompleted = {
  __typename?: 'PaginationLessonCompleted';
  data?: Maybe<Array<Maybe<LessonCompleted>>>;
  total?: Maybe<Scalars['Int']['output']>;
  totalTimeSpent?: Maybe<Scalars['Int']['output']>;
};

export type ParentLinkInput = {
  uniqueName?: InputMaybe<Scalars['String']['input']>;
};

export type ParentLinkOutput = {
  __typename?: 'ParentLinkOutput';
  id: Scalars['String']['output'];
  resource?: Maybe<Scalars['String']['output']>;
};

export type ParentRegisterInput = {
  accessId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

export type ParentRegisterOutput = {
  __typename?: 'ParentRegisterOutput';
  parentId?: Maybe<Scalars['String']['output']>;
  schoolId?: Maybe<Scalars['String']['output']>;
  schoolName?: Maybe<Scalars['String']['output']>;
  specialCourseId?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
};

export type Position = {
  __typename?: 'Position';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Program = {
  __typename?: 'Program';
  additional?: Maybe<Array<Unit>>;
  country?: Maybe<Scalars['String']['output']>;
  coverVideo?: Maybe<Scalars['String']['output']>;
  created: Scalars['String']['output'];
  createdBy: User;
  description?: Maybe<Scalars['String']['output']>;
  favorite?: Maybe<Scalars['Boolean']['output']>;
  grade?: Maybe<Grade>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isCustomized?: Maybe<Scalars['Boolean']['output']>;
  isParentCourse?: Maybe<Scalars['Boolean']['output']>;
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  isTest?: Maybe<Scalars['Boolean']['output']>;
  lastUsed?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  primary?: Maybe<Array<Unit>>;
  primarySllLessons?: Maybe<Array<SllLesson>>;
  progress?: Maybe<Scalars['Float']['output']>;
  updated: Scalars['String']['output'];
};

export type ProgramEditInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  coverVideo?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  grade?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  isParentCourse?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type ProgramLastUsed = {
  __typename?: 'ProgramLastUsed';
  lastUsed: Scalars['String']['output'];
  programId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

export type ProgramNames = {
  __typename?: 'ProgramNames';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ProgramType = {
  __typename?: 'ProgramType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ProgramUnits = {
  __typename?: 'ProgramUnits';
  additional?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  primary?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  primarySllLessons?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['String']['output']>;
  account?: Maybe<Array<Maybe<School>>>;
  accountSchools?: Maybe<AccountSchool>;
  accountUsers?: Maybe<Array<Maybe<User>>>;
  adminUsers?: Maybe<Array<Maybe<AdminUser>>>;
  adminUsersByBulk?: Maybe<Array<Maybe<AdminUsersArrayType>>>;
  aiSearchLessonLibrary?: Maybe<Array<Maybe<LessonLibrarySearchResult>>>;
  allCoverVideos?: Maybe<Array<Video>>;
  allCustomers?: Maybe<Array<Maybe<ExtendedCustomer>>>;
  allPrograms?: Maybe<Array<Maybe<Program>>>;
  allProgramsForSuperAdmin?: Maybe<Array<Maybe<Program>>>;
  allSpecialPrograms?: Maybe<Array<Maybe<SpecialProgram>>>;
  allVideos?: Maybe<Array<Video>>;
  calendarEvents?: Maybe<OfficeHourEvents>;
  checkAccess: Scalars['Boolean']['output'];
  checkEntityTracking?: Maybe<EntityTrackingResponse>;
  confirmEmail: Scalars['String']['output'];
  contentGroups?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  customers?: Maybe<Array<Maybe<Customer>>>;
  districtCompetencyRating?: Maybe<CompetencyRating>;
  educatorResilientClassroomByLessons?: Maybe<Array<Maybe<EducatorWellBeingByLessonsType>>>;
  educatorWellBeingByLessons?: Maybe<Array<Maybe<EducatorWellBeingByLessonsType>>>;
  englishCaptionJob?: Maybe<EnglishCaptionJob>;
  feedbackForm?: Maybe<FeedbackFormContent>;
  getAUSCourse: AusProgram;
  getAUSCourseContents?: Maybe<Array<AusCourseContent>>;
  getAbsentStudentLesson?: Maybe<AbsentStudentLesson>;
  getAllCollections?: Maybe<Array<Maybe<Collection>>>;
  getAllMultiCollections?: Maybe<Array<Maybe<MultiCollection>>>;
  getAllUnits: Array<UnitsByProgram>;
  getAllUnitsAndSLLLessons: UnitAndSllLesson;
  getAllUnitsWithQuiz: Array<UnitsByProgram>;
  getCollection?: Maybe<Collection>;
  getContentAllGroups?: Maybe<AllContent>;
  getCourse: Program;
  getCourseContents: CourseContent;
  getFailedReports?: Maybe<Array<FailedReport>>;
  getFeedbackFormByLink?: Maybe<FeedbackFormContent>;
  getLessonInfoByLink: Lesson;
  getMultiCollection?: Maybe<NormalMultiCollection>;
  getMultiCollections?: Maybe<Array<Maybe<NormalMultiCollection>>>;
  getPostProgramQuizUnit: Unit;
  getPreProgramQuizUnit: Unit;
  getProgram?: Maybe<SllProgram>;
  getProgramUnits: ProgramUnits;
  getPrograms?: Maybe<Array<SllProgram>>;
  getQuiz: QuizContent;
  getReports: ReportsPage;
  getSchoolCourses?: Maybe<SchoolPrograms>;
  getSchoolReportDownloadURL: Scalars['String']['output'];
  getSchoolReports?: Maybe<Array<SchoolReport>>;
  getSllLessonInfoByLink: SllLesson;
  getSpecialProgram?: Maybe<SpecialProgram>;
  getSurveys: SurveyReport;
  getUnitInfo: Unit;
  getUnitInfoByUniqueName: Unit;
  getUnitInfoForSuperAdmin: Unit;
  getVideoUrl?: Maybe<VideoData>;
  getZIPSlideUrl: Scalars['String']['output'];
  grades?: Maybe<Array<Maybe<Grade>>>;
  heExitTicketResult?: Maybe<HeFeedbackAnswerResult>;
  heTokens?: Maybe<Array<HeToken>>;
  heaGetLessonStatus?: Maybe<Array<HeaLessonStatus>>;
  heaGetModuleAllGroups?: Maybe<Array<Maybe<HeaGroupModule>>>;
  heaGetStudyPlansByUnit?: Maybe<Array<StudyPlan>>;
  heaGetUnitInfo: HeaUnit;
  heaGetUnitInfoForSuperAdmin: HeaUnit;
  heaLessonsToConfirm?: Maybe<Array<LessonToConfirm>>;
  heaListStudyPlans?: Maybe<Array<StudyPlan>>;
  heaMe?: Maybe<HeaUser>;
  heaUnits?: Maybe<Array<HeaUnit>>;
  heaUnitsByAgeGroup?: Maybe<Array<HeaUnit>>;
  heaUsers?: Maybe<Array<HeaUser>>;
  health: Scalars['String']['output'];
  intercomIdentity?: Maybe<Scalars['String']['output']>;
  invitedUser?: Maybe<User>;
  isValidLessonUniqueName: Scalars['Boolean']['output'];
  isValidSLLUniqueName: Scalars['Boolean']['output'];
  isValidUnitUniqueName: Scalars['Boolean']['output'];
  lastVisitedLesson?: Maybe<Array<Maybe<LastVisitedLesson>>>;
  lastVisitedUnitStudyReview?: Maybe<Array<Maybe<LastVisitedUnitStudyReview>>>;
  lessonsByGrade?: Maybe<LessonsByGrade>;
  lessonsByTeacher?: Maybe<PaginationLessonCompleted>;
  listGroups?: Maybe<Array<Maybe<Group>>>;
  listLessonsInProgress?: Maybe<Array<LessonInProgress>>;
  listNormalMultiCollections?: Maybe<Array<Maybe<MultiCollection>>>;
  listSchoolReports?: Maybe<Array<SchoolReport>>;
  loginAnalytics: LoginAnalyticsData;
  me?: Maybe<User>;
  myQuizzes?: Maybe<Array<Quiz>>;
  nonParentSpecialPrograms?: Maybe<Array<Maybe<SpecialProgram>>>;
  parentPrograms?: Maybe<Array<Maybe<Program>>>;
  parentSpecialPrograms?: Maybe<Array<Maybe<SpecialProgram>>>;
  positions?: Maybe<Array<Maybe<Position>>>;
  programTypes?: Maybe<Array<Maybe<ProgramType>>>;
  programs?: Maybe<Array<Maybe<Program>>>;
  registeredUsers: SummaryMetaData;
  retryEligibleLanguageJobs: Array<VideoTranslationLanguageJob>;
  roles?: Maybe<Array<Maybe<Role>>>;
  school?: Maybe<Scalars['Boolean']['output']>;
  schoolProgramNames?: Maybe<Array<Maybe<ProgramNames>>>;
  schoolUsers?: Maybe<Array<Maybe<SchoolUser>>>;
  schools?: Maybe<Array<Maybe<School>>>;
  searchLessonLibrary?: Maybe<Array<Maybe<LessonLibrarySearchResult>>>;
  sentryTrackingByEntity?: Maybe<SentryTrackingByEntityResponse>;
  sentryTrackingConfigurations: Array<SentryTracking>;
  skills?: Maybe<Array<Maybe<Skill>>>;
  sllGetBrainBreakLessons?: Maybe<Array<SllLesson>>;
  sllGetCaregiverLessons?: Maybe<Array<SllLesson>>;
  sllGetCourses?: Maybe<Array<SllCourse>>;
  sllGetGettingStartedLessons?: Maybe<Array<SllLesson>>;
  sllGetGroupModules?: Maybe<SllExtendedModule>;
  sllGetLastVisitedModule?: Maybe<SllLastVisitedModule>;
  sllGetLessonExclusions?: Maybe<Array<SllLessonExclusion>>;
  sllGetLessonInfo: SllLesson;
  sllGetLessonInfoByUniqueName: SllLesson;
  sllGetLessonInfoForSA: SllLesson;
  sllGetLessons?: Maybe<Array<SllLesson>>;
  sllGetLessonsForSA?: Maybe<SllGetLessonsForSaResponse>;
  sllGetLessonsProgress?: Maybe<Array<LessonProgress>>;
  sllGetPopularLessons: Array<Maybe<SllLesson>>;
  sllGetPreProgramInfo: SllLesson;
  sllPreProgramQuiz?: Maybe<Array<Content>>;
  supportedLanguages: Array<Scalars['String']['output']>;
  surveySubmitted?: Maybe<SurveySubmitted>;
  surveyTypes?: Maybe<Array<Maybe<SurveyType>>>;
  translationCacheStats: TranslationCacheStats;
  translationJob?: Maybe<TranslationJob>;
  translationJobs: TranslationJobsResponse;
  translationServiceInfo: TranslationServiceInfo;
  units?: Maybe<Array<Unit>>;
  userFlags?: Maybe<UserFlags>;
  users?: Maybe<Array<Maybe<User>>>;
  usersInvitedByMe?: Maybe<Array<Maybe<User>>>;
  videoSubtitles?: Maybe<Array<Maybe<VideoSubtitle>>>;
  videoTranslationJob?: Maybe<VideoTranslationJob>;
  videoTranslationJobs: VideoTranslationJobsResponse;
  videoTranslationLanguageJob?: Maybe<VideoTranslationLanguageJob>;
  videoUpload?: Maybe<VideoUpload>;
};


export type QueryAccountArgs = {
  input: UserIdInput;
};


export type QueryAccountSchoolsArgs = {
  input: UserIdInput;
};


export type QueryAdminUsersArgs = {
  input: UserIdInput;
};


export type QueryAdminUsersByBulkArgs = {
  schoolIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryAiSearchLessonLibraryArgs = {
  input: AiLessonLibrarySearchInput;
};


export type QueryCheckAccessArgs = {
  input: UserIdInput;
};


export type QueryCheckEntityTrackingArgs = {
  userId: Scalars['String']['input'];
};


export type QueryConfirmEmailArgs = {
  input: ConfirmEmailInput;
};


export type QueryContentGroupsArgs = {
  input: IdInput;
};


export type QueryDistrictCompetencyRatingArgs = {
  input: AnalyticsInput;
};


export type QueryEducatorResilientClassroomByLessonsArgs = {
  input: AnalyticsInput;
};


export type QueryEducatorWellBeingByLessonsArgs = {
  input: AnalyticsInput;
};


export type QueryEnglishCaptionJobArgs = {
  id: Scalars['String']['input'];
};


export type QueryFeedbackFormArgs = {
  input: IdInput;
};


export type QueryGetAusCourseArgs = {
  input: IdInput;
};


export type QueryGetAusCourseContentsArgs = {
  input: IdInput;
};


export type QueryGetAbsentStudentLessonArgs = {
  input: IdInput;
};


export type QueryGetAllCollectionsArgs = {
  input: GetAllCollectionsInput;
};


export type QueryGetAllMultiCollectionsArgs = {
  input: GetAllMultiCollectionsInput;
};


export type QueryGetAllUnitsArgs = {
  input: GetAllUnitsInput;
};


export type QueryGetCollectionArgs = {
  input: IdInput;
};


export type QueryGetContentAllGroupsArgs = {
  input: IdInput;
};


export type QueryGetCourseArgs = {
  input: IdInput;
};


export type QueryGetCourseContentsArgs = {
  input: IdInput;
};


export type QueryGetFailedReportsArgs = {
  input: GetFailedReportsInput;
};


export type QueryGetFeedbackFormByLinkArgs = {
  input: FeedbackLinkInput;
};


export type QueryGetLessonInfoByLinkArgs = {
  input: AbsentStudentLessonByLinkInput;
};


export type QueryGetMultiCollectionArgs = {
  input: IdInput;
};


export type QueryGetMultiCollectionsArgs = {
  input: IDsInput;
};


export type QueryGetProgramArgs = {
  input: IdInput;
};


export type QueryGetProgramUnitsArgs = {
  input: IdInput;
};


export type QueryGetQuizArgs = {
  input: IdInput;
};


export type QueryGetReportsArgs = {
  input: GetReportsInput;
};


export type QueryGetSchoolCoursesArgs = {
  input: UserIdInput;
};


export type QueryGetSchoolReportDownloadUrlArgs = {
  input: GetSchoolReportDownloadUrlInput;
};


export type QueryGetSchoolReportsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryGetSllLessonInfoByLinkArgs = {
  input: AbsentStudentLessonByLinkInput;
};


export type QueryGetSpecialProgramArgs = {
  input: IdInput;
};


export type QueryGetSurveysArgs = {
  input: GetSurveysInput;
};


export type QueryGetUnitInfoArgs = {
  input: IdInput;
};


export type QueryGetUnitInfoByUniqueNameArgs = {
  input: UniqueNameInput;
};


export type QueryGetUnitInfoForSuperAdminArgs = {
  input: IdInput;
};


export type QueryGetVideoUrlArgs = {
  uploadId: Scalars['String']['input'];
};


export type QueryGetZipSlideUrlArgs = {
  groupId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  isCourse?: InputMaybe<Scalars['Boolean']['input']>;
  isHomeEd?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryHeExitTicketResultArgs = {
  input: HeExitTicketResultInput;
};


export type QueryHeaGetLessonStatusArgs = {
  input: HeaGetLessonStatusInput;
};


export type QueryHeaGetModuleAllGroupsArgs = {
  input: IdInput;
};


export type QueryHeaGetStudyPlansByUnitArgs = {
  input: IdInput;
};


export type QueryHeaGetUnitInfoArgs = {
  input: IdInput;
};


export type QueryHeaGetUnitInfoForSuperAdminArgs = {
  input: IdInput;
};


export type QueryInvitedUserArgs = {
  input: UserIdInput;
};


export type QueryIsValidLessonUniqueNameArgs = {
  input: UniqueNameInput;
};


export type QueryIsValidSllUniqueNameArgs = {
  input: UniqueNameInput;
};


export type QueryIsValidUnitUniqueNameArgs = {
  input: UniqueNameInput;
};


export type QueryLastVisitedLessonArgs = {
  input: IdInput;
};


export type QueryLastVisitedUnitStudyReviewArgs = {
  input: IdInput;
};


export type QueryLessonsByGradeArgs = {
  input: AnalyticsInput;
};


export type QueryLessonsByTeacherArgs = {
  input: AnalyticsInput;
};


export type QueryListNormalMultiCollectionsArgs = {
  input: ListNormalMultiCollectionsInput;
};


export type QueryLoginAnalyticsArgs = {
  input: AnalyticsInput;
};


export type QueryRegisteredUsersArgs = {
  input: AnalyticsInput;
};


export type QuerySchoolArgs = {
  input: UserIdInput;
};


export type QuerySchoolProgramNamesArgs = {
  input: UserIdInput;
};


export type QuerySearchLessonLibraryArgs = {
  input: LessonLibrarySearchInput;
};


export type QuerySentryTrackingByEntityArgs = {
  entityId: Scalars['String']['input'];
  entityType: EntityType;
};


export type QuerySllGetGroupModulesArgs = {
  input: IdInput;
};


export type QuerySllGetLastVisitedModuleArgs = {
  input: IdInput;
};


export type QuerySllGetLessonExclusionsArgs = {
  input: IdInput;
};


export type QuerySllGetLessonInfoArgs = {
  input: IdInput;
};


export type QuerySllGetLessonInfoByUniqueNameArgs = {
  input: UniqueNameInput;
};


export type QuerySllGetLessonInfoForSaArgs = {
  input: IdInput;
};


export type QuerySllGetLessonsArgs = {
  input: SllGetLessonsInput;
};


export type QuerySllGetLessonsForSaArgs = {
  input: SllGetLessonsForSaInput;
};


export type QuerySllGetPopularLessonsArgs = {
  input?: InputMaybe<SllGetPopularLessonsInput>;
};


export type QuerySllPreProgramQuizArgs = {
  input: IdInput;
};


export type QuerySurveySubmittedArgs = {
  input: AnalyticsInput;
};


export type QueryTranslationJobArgs = {
  id: Scalars['String']['input'];
};


export type QueryTranslationJobsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<TranslationStatus>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUsersArgs = {
  input: SearchUsersInput;
};


export type QueryVideoSubtitlesArgs = {
  assetId?: InputMaybe<Scalars['String']['input']>;
  playbackId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVideoTranslationJobArgs = {
  id: Scalars['String']['input'];
};


export type QueryVideoTranslationJobsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<VideoTranslationStatus>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVideoTranslationLanguageJobArgs = {
  id: Scalars['String']['input'];
};


export type QueryVideoUploadArgs = {
  input: VideoUploadInput;
};

export type Quiz = {
  __typename?: 'Quiz';
  color?: Maybe<Scalars['String']['output']>;
  darkColor?: Maybe<Scalars['String']['output']>;
  feedbackForm?: Maybe<FeedbackFormContent>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  unitIds?: Maybe<Array<Scalars['ID']['output']>>;
};

export type QuizContent = {
  __typename?: 'QuizContent';
  color?: Maybe<Scalars['String']['output']>;
  contents?: Maybe<Array<Content>>;
  darkColor?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type QuizFeedbackFormInput = {
  className: Scalars['String']['input'];
  collectionId?: InputMaybe<Scalars['String']['input']>;
  collectionName?: InputMaybe<Scalars['String']['input']>;
  exitTicketCount: Scalars['Int']['input'];
  expiryMinutes: Scalars['Int']['input'];
  grade: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  mcId?: InputMaybe<Scalars['String']['input']>;
  mcName?: InputMaybe<Scalars['String']['input']>;
  programId?: InputMaybe<Scalars['String']['input']>;
  programName?: InputMaybe<Scalars['String']['input']>;
};

export type QuizForm = {
  __typename?: 'QuizForm';
  form: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type RemoveMcFromProgramInput = {
  mcId: Scalars['String']['input'];
  programId: Scalars['String']['input'];
};

export type ReportsPage = {
  __typename?: 'ReportsPage';
  hasMore: Scalars['Boolean']['output'];
  reports: Array<SurveyFormReport>;
  totalCount: Scalars['Int']['output'];
};

export type ResetConfirmationInput = {
  password: Scalars['String']['input'];
  region: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type ResetLessonProgressInput = {
  lessonId: Scalars['String']['input'];
  unitId?: InputMaybe<Scalars['String']['input']>;
};

export type RevalidateTokenInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type RevalidateTokenResponse = {
  __typename?: 'RevalidateTokenResponse';
  clientId: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type Role = {
  __typename?: 'Role';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SllCourse = {
  __typename?: 'SLLCourse';
  color?: Maybe<Scalars['String']['output']>;
  darkColor?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lessonIds?: Maybe<Array<Scalars['ID']['output']>>;
  name: Scalars['String']['output'];
};

export type SllCreateCourseInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  darkColor?: InputMaybe<Scalars['String']['input']>;
  lessonId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type SllCreateGroupModuleInput = {
  groupId: Scalars['String']['input'];
  groupName: Scalars['String']['input'];
  moduleId: Scalars['String']['input'];
};

export type SllCreateLessonInput = {
  ageGroup?: InputMaybe<Scalars['String']['input']>;
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Scalars['String']['input']>;
  comingSoonAt?: InputMaybe<Scalars['String']['input']>;
  comingSoonLabelPosition?: InputMaybe<Scalars['String']['input']>;
  competency?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  coverImage?: InputMaybe<Scalars['String']['input']>;
  coverVideo?: InputMaybe<Scalars['String']['input']>;
  duration: Scalars['Int']['input'];
  gradeLabelPosition?: InputMaybe<Scalars['String']['input']>;
  gradeLevel?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isComingSoon?: InputMaybe<Scalars['Boolean']['input']>;
  isEducatorCaregiverLessonLayout?: InputMaybe<Scalars['Boolean']['input']>;
  isExtensionAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  isNewCover?: InputMaybe<Scalars['Boolean']['input']>;
  isOpReel?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdated?: InputMaybe<Scalars['Boolean']['input']>;
  lessonDetails?: InputMaybe<Scalars['String']['input']>;
  lessonMaterialAnswers?: InputMaybe<Scalars['String']['input']>;
  lessonMaterialHeading?: InputMaybe<Scalars['String']['input']>;
  lessonMaterialsNotice?: InputMaybe<Scalars['String']['input']>;
  lessonType?: InputMaybe<Scalars['String']['input']>;
  mainTopics?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  newLabelPosition?: InputMaybe<Scalars['String']['input']>;
  overviewAnswers1?: InputMaybe<Scalars['String']['input']>;
  overviewAnswers2?: InputMaybe<Scalars['String']['input']>;
  overviewHeading1?: InputMaybe<Scalars['String']['input']>;
  overviewHeading2?: InputMaybe<Scalars['String']['input']>;
  recommendedNext?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  recommendedPrior?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showLessonMaterialsNotice?: InputMaybe<Scalars['Boolean']['input']>;
  skill?: InputMaybe<Scalars['String']['input']>;
  sllType?: InputMaybe<SllLessonType>;
  subTopics?: InputMaybe<Scalars['String']['input']>;
  suggestedDuration?: InputMaybe<Scalars['String']['input']>;
  uniqueName?: InputMaybe<Scalars['String']['input']>;
  updatedLabelPosition?: InputMaybe<Scalars['String']['input']>;
};

export type SllCreateModuleInput = {
  lessonId: Scalars['String']['input'];
  lessonType?: InputMaybe<LessonType>;
  position?: InputMaybe<Scalars['Int']['input']>;
  sectionId?: InputMaybe<Scalars['String']['input']>;
  type: ContentType;
};

export type SllCreateProgramInput = {
  avgDuration?: InputMaybe<Scalars['String']['input']>;
  bannerDesc?: InputMaybe<Scalars['String']['input']>;
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Scalars['String']['input']>;
  hoverText?: InputMaybe<Scalars['String']['input']>;
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  isShown: Scalars['Boolean']['input'];
  labels?: InputMaybe<Scalars['String']['input']>;
  learnMoreDesc?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  numberOfLessons?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  tier?: InputMaybe<Scalars['String']['input']>;
};

export type SllDeleteGroupModuleInput = {
  groupId: Scalars['String']['input'];
  moduleId: Scalars['String']['input'];
};

export type SllExtendedModule = {
  __typename?: 'SLLExtendedModule';
  default: SllModule;
  groups?: Maybe<Array<SllGroupModule>>;
};

export type SllGetLessonsForSaInput = {
  ageGroup?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};

export type SllGetLessonsForSaResponse = {
  __typename?: 'SLLGetLessonsForSAResponse';
  data?: Maybe<Array<SllLesson>>;
  totals: Scalars['Int']['output'];
};

export type SllGetLessonsInput = {
  ageGroup?: InputMaybe<Array<Scalars['String']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  mainTopic?: InputMaybe<Array<Scalars['String']['input']>>;
  skill?: InputMaybe<Array<Scalars['String']['input']>>;
  subTopic?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SllGroupModule = {
  __typename?: 'SLLGroupModule';
  data?: Maybe<Scalars['String']['output']>;
  formData?: Maybe<Scalars['String']['output']>;
  groupId: Scalars['String']['output'];
  groupName?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Scalars['String']['output']>;
  moduleId: Scalars['ID']['output'];
};

export type SllLastVisitedModule = {
  __typename?: 'SLLLastVisitedModule';
  lastVisitedAt: Scalars['String']['output'];
  lessonId: Scalars['ID']['output'];
  moduleId: Scalars['ID']['output'];
  pageNumber?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
};

export type SllLesson = {
  __typename?: 'SLLLesson';
  ageGroup?: Maybe<Scalars['String']['output']>;
  bannerImage?: Maybe<Scalars['String']['output']>;
  categories?: Maybe<Scalars['String']['output']>;
  collections?: Maybe<Array<Maybe<SllLessonCollection>>>;
  comingSoonAt?: Maybe<Scalars['String']['output']>;
  comingSoonLabelPosition?: Maybe<Scalars['String']['output']>;
  competency?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  coverImage?: Maybe<Scalars['String']['output']>;
  coverVideo?: Maybe<Scalars['String']['output']>;
  duration: Scalars['Int']['output'];
  gradeLabelPosition?: Maybe<Scalars['String']['output']>;
  gradeLevel?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isComingSoon?: Maybe<Scalars['Boolean']['output']>;
  isEducatorCaregiverLessonLayout?: Maybe<Scalars['Boolean']['output']>;
  isExtensionAvailable?: Maybe<Scalars['Boolean']['output']>;
  isNew?: Maybe<Scalars['Boolean']['output']>;
  isNewCover?: Maybe<Scalars['Boolean']['output']>;
  isOpReel?: Maybe<Scalars['Boolean']['output']>;
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  lastVisitedAt?: Maybe<Scalars['String']['output']>;
  lessonDetails?: Maybe<Scalars['String']['output']>;
  lessonMaterialAnswers?: Maybe<Scalars['String']['output']>;
  lessonMaterialHeading?: Maybe<Scalars['String']['output']>;
  lessonMaterialsNotice?: Maybe<Scalars['String']['output']>;
  lessonType?: Maybe<Scalars['String']['output']>;
  mainTopics?: Maybe<Scalars['String']['output']>;
  materials?: Maybe<Array<Maybe<SllModule>>>;
  meta?: Maybe<Scalars['String']['output']>;
  multiCollections?: Maybe<Array<Maybe<SllLessonMultiCollection>>>;
  name: Scalars['String']['output'];
  newLabelPosition?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  overviewAnswers1?: Maybe<Scalars['String']['output']>;
  overviewAnswers2?: Maybe<Scalars['String']['output']>;
  overviewHeading1?: Maybe<Scalars['String']['output']>;
  overviewHeading2?: Maybe<Scalars['String']['output']>;
  presentation?: Maybe<Array<Maybe<SllModule>>>;
  progress?: Maybe<Scalars['Float']['output']>;
  recommendedNext?: Maybe<Scalars['String']['output']>;
  recommendedPrior?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<Maybe<SllSection>>>;
  showLessonMaterialsNotice?: Maybe<Scalars['Boolean']['output']>;
  skill?: Maybe<Scalars['String']['output']>;
  sllType?: Maybe<SllLessonType>;
  status?: Maybe<Scalars['String']['output']>;
  subTopics?: Maybe<Scalars['String']['output']>;
  suggestedDuration?: Maybe<Scalars['String']['output']>;
  uniqueName?: Maybe<Scalars['String']['output']>;
  updatedLabelPosition?: Maybe<Scalars['String']['output']>;
};

export type SllLessonCollection = {
  __typename?: 'SLLLessonCollection';
  collectionType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SllLessonExclusion = {
  __typename?: 'SLLLessonExclusion';
  groupId: Scalars['String']['output'];
  groupName?: Maybe<Scalars['String']['output']>;
  lessonId: Scalars['String']['output'];
};

export type SllLessonExclusionInput = {
  groupId: Scalars['String']['input'];
  lessonId: Scalars['String']['input'];
};

export type SllLessonMultiCollection = {
  __typename?: 'SLLLessonMultiCollection';
  grade: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  programType?: Maybe<Scalars['String']['output']>;
};

export enum SllLessonType {
  EXERCISE = 'Exercise',
  LESSON = 'Lesson'
}

export type SllModule = {
  __typename?: 'SLLModule';
  additionalAfter?: Maybe<Scalars['Boolean']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  formData?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  lastInGroup?: Maybe<Scalars['Boolean']['output']>;
  lastInLesson?: Maybe<Scalars['Boolean']['output']>;
  meta?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pauseHere?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  type: ContentType;
};

export type SllModulePositionInput = {
  position: Scalars['Int']['input'];
  sectionId?: InputMaybe<Scalars['String']['input']>;
};

export enum SllModuleType {
  MATERIAL = 'material',
  PRESENTATION = 'presentation',
  SECTION = 'section'
}

export type SllMoveModuleInput = {
  id: Scalars['String']['input'];
  lessonId: Scalars['String']['input'];
  newPosition: SllModulePositionInput;
  oldPosition: SllModulePositionInput;
  type: SllModuleType;
};

export type SllPreProgramQuizInput = {
  className: Scalars['String']['input'];
  collectionId?: InputMaybe<Scalars['String']['input']>;
  collectionName?: InputMaybe<Scalars['String']['input']>;
  exitTicketCount: Scalars['Int']['input'];
  expiryMinutes: Scalars['Int']['input'];
  grade: Scalars['String']['input'];
  mcId?: InputMaybe<Scalars['String']['input']>;
  mcName?: InputMaybe<Scalars['String']['input']>;
  programId: Scalars['String']['input'];
  programName: Scalars['String']['input'];
};

export type SllProgram = {
  __typename?: 'SLLProgram';
  avgDuration?: Maybe<Scalars['String']['output']>;
  bannerDesc?: Maybe<Scalars['String']['output']>;
  bannerImage?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  hoverText?: Maybe<Scalars['String']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isShown: Scalars['Boolean']['output'];
  labels?: Maybe<Scalars['String']['output']>;
  learnMoreDesc?: Maybe<Scalars['String']['output']>;
  mcs?: Maybe<Array<Maybe<MultiCollection>>>;
  name: Scalars['String']['output'];
  numberOfLessons?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  tier?: Maybe<Scalars['String']['output']>;
};

export type SllSection = {
  __typename?: 'SLLSection';
  id: Scalars['ID']['output'];
  modules?: Maybe<Array<Maybe<SllModule>>>;
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
};

export type SllUpdateCourseInput = {
  id: Scalars['String']['input'];
  lessonIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SllUpdateGroupModuleInput = {
  data?: InputMaybe<Scalars['String']['input']>;
  formData?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['String']['input'];
  moduleId: Scalars['String']['input'];
};

export type SllUpdateLastVisitedModuleInput = {
  lessonId: Scalars['String']['input'];
  moduleId: Scalars['String']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  previousModuleId?: InputMaybe<Scalars['String']['input']>;
};

export type SllUpdateLessonCompleteStatusInput = {
  lessonId: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type SllUpdateLessonInput = {
  ageGroup?: InputMaybe<Scalars['String']['input']>;
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Scalars['String']['input']>;
  comingSoonAt?: InputMaybe<Scalars['String']['input']>;
  comingSoonLabelPosition?: InputMaybe<Scalars['String']['input']>;
  competency?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  coverImage?: InputMaybe<Scalars['String']['input']>;
  coverVideo?: InputMaybe<Scalars['String']['input']>;
  duration: Scalars['Int']['input'];
  gradeLabelPosition?: InputMaybe<Scalars['String']['input']>;
  gradeLevel?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isComingSoon?: InputMaybe<Scalars['Boolean']['input']>;
  isEducatorCaregiverLessonLayout?: InputMaybe<Scalars['Boolean']['input']>;
  isExtensionAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  isNewCover?: InputMaybe<Scalars['Boolean']['input']>;
  isOpReel?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdated?: InputMaybe<Scalars['Boolean']['input']>;
  lessonDetails?: InputMaybe<Scalars['String']['input']>;
  lessonMaterialAnswers?: InputMaybe<Scalars['String']['input']>;
  lessonMaterialHeading?: InputMaybe<Scalars['String']['input']>;
  lessonMaterialsNotice?: InputMaybe<Scalars['String']['input']>;
  lessonType?: InputMaybe<Scalars['String']['input']>;
  mainTopics?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  newLabelPosition?: InputMaybe<Scalars['String']['input']>;
  overviewAnswers1?: InputMaybe<Scalars['String']['input']>;
  overviewAnswers2?: InputMaybe<Scalars['String']['input']>;
  overviewHeading1?: InputMaybe<Scalars['String']['input']>;
  overviewHeading2?: InputMaybe<Scalars['String']['input']>;
  recommendedNext?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  recommendedPrior?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showLessonMaterialsNotice?: InputMaybe<Scalars['Boolean']['input']>;
  skill?: InputMaybe<Scalars['String']['input']>;
  sllType?: InputMaybe<SllLessonType>;
  subTopics?: InputMaybe<Scalars['String']['input']>;
  suggestedDuration?: InputMaybe<Scalars['String']['input']>;
  uniqueName?: InputMaybe<Scalars['String']['input']>;
  updatedLabelPosition?: InputMaybe<Scalars['String']['input']>;
};

export type SllUpdateModuleInput = {
  additionalAfter?: InputMaybe<Scalars['Boolean']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
  formData?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  lastInGroup?: InputMaybe<Scalars['Boolean']['input']>;
  lastInLesson?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  pauseHere?: InputMaybe<Scalars['Boolean']['input']>;
  type: ContentType;
};

export type SllUpdateProgramInput = {
  avgDuration?: InputMaybe<Scalars['String']['input']>;
  bannerDesc?: InputMaybe<Scalars['String']['input']>;
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Scalars['String']['input']>;
  hoverText?: InputMaybe<Scalars['String']['input']>;
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isShown: Scalars['Boolean']['input'];
  labels?: InputMaybe<Scalars['String']['input']>;
  learnMoreDesc?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  numberOfLessons?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  tier?: InputMaybe<Scalars['String']['input']>;
};

export type SllUpdateSectionInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type SllUpdateVideoGroupModuleInput = {
  data?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['String']['input'];
  moduleId: Scalars['String']['input'];
  uploadId?: InputMaybe<Scalars['String']['input']>;
};

export type SllUpdateVideoModuleInput = {
  data?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  lastInLesson?: InputMaybe<Scalars['Boolean']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pauseHere?: InputMaybe<Scalars['Boolean']['input']>;
  type: ContentType;
  uploadId?: InputMaybe<Scalars['String']['input']>;
};

export type SaveCollectionLessonsInput = {
  collectionId: Scalars['String']['input'];
  sllLessons?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SaveMultiCollectionsInput = {
  id: Scalars['String']['input'];
  multiCollectionId: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  type: MultiCollectionContentType;
};

export type SaveProgramUnitsInput = {
  additional?: InputMaybe<Array<Scalars['String']['input']>>;
  primary?: InputMaybe<Array<Scalars['String']['input']>>;
  programId: Scalars['String']['input'];
};

export type SaveReelInput = {
  id: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  programId: Scalars['String']['input'];
  type: CourseContentType;
};

export type School = {
  __typename?: 'School';
  courses?: Maybe<Array<Maybe<Program>>>;
  dataCollections?: Maybe<Array<Maybe<SurveyType>>>;
  disabledPwLogin?: Maybe<Scalars['Boolean']['output']>;
  exitTicketCC?: Maybe<Scalars['String']['output']>;
  grades?: Maybe<Scalars['String']['output']>;
  groupIds?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Maybe<ProgramType>>>;
  id: Scalars['ID']['output'];
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  preProgramQuizCC?: Maybe<Scalars['String']['output']>;
  programs?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type SchoolCourseContentInput = {
  id: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  type: CourseContentType;
};

export type SchoolInfo = {
  __typename?: 'SchoolInfo';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SchoolProgramId = {
  __typename?: 'SchoolProgramID';
  access?: Maybe<Scalars['Boolean']['output']>;
  customized?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  newId?: Maybe<Scalars['ID']['output']>;
};

export type SchoolProgramIdInput = {
  access?: InputMaybe<Scalars['Boolean']['input']>;
  customized?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  newId?: InputMaybe<Scalars['String']['input']>;
};

export type SchoolPrograms = {
  __typename?: 'SchoolPrograms';
  customizedPrograms?: Maybe<Array<CustomizedProgram>>;
  programIds?: Maybe<Array<SchoolProgramId>>;
};

export type SchoolReport = {
  __typename?: 'SchoolReport';
  endDate: Scalars['String']['output'];
  generatedAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  schoolIds: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
  surveyId: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type SchoolUser = {
  __typename?: 'SchoolUser';
  admin?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Customer>;
  districtSchools?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  expiry?: Maybe<Scalars['String']['output']>;
  firstLoginFormFilled?: Maybe<Scalars['Boolean']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastLoginAt?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  position?: Maybe<Position>;
  role: Scalars['String']['output'];
  roleDesc?: Maybe<Scalars['String']['output']>;
  schools?: Maybe<Array<Maybe<School>>>;
  status: Scalars['String']['output'];
  subject?: Maybe<Scalars['String']['output']>;
  totalLogins: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  usages?: Maybe<Scalars['String']['output']>;
};

export type SearchUsersInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  noAccount?: InputMaybe<Scalars['Boolean']['input']>;
  noAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  noSchool?: InputMaybe<Scalars['Boolean']['input']>;
  pending?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  schoolId?: InputMaybe<Scalars['String']['input']>;
  trial?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Section = {
  __typename?: 'Section';
  id: Scalars['ID']['output'];
  modules?: Maybe<Array<Content>>;
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type SentryTracking = {
  __typename?: 'SentryTracking';
  accountId?: Maybe<Scalars['String']['output']>;
  accountName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  entityEmail?: Maybe<Scalars['String']['output']>;
  entityId: Scalars['String']['output'];
  entityName?: Maybe<Scalars['String']['output']>;
  entityRole?: Maybe<Scalars['String']['output']>;
  entityType: EntityType;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  schoolId?: Maybe<Scalars['String']['output']>;
  schoolName?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['String']['output'];
  trackingLevel: TrackingLevel;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type SentryTrackingByEntityResponse = {
  __typename?: 'SentryTrackingByEntityResponse';
  accountId?: Maybe<Scalars['String']['output']>;
  accountName?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  entityEmail?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  entityRole?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<EntityType>;
  id?: Maybe<Scalars['ID']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  schoolId?: Maybe<Scalars['String']['output']>;
  schoolName?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  trackingLevel?: Maybe<TrackingLevel>;
};

export type SentryTrackingInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['String']['input'];
  entityType: EntityType;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['String']['input'];
  trackingLevel: TrackingLevel;
};

export type SharedUnit = {
  __typename?: 'SharedUnit';
  createdBy: Scalars['ID']['output'];
  expireAt: Scalars['String']['output'];
  generatedAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  link: Scalars['String']['output'];
  unit?: Maybe<Unit>;
  unitId: Scalars['ID']['output'];
};

export type Skill = {
  __typename?: 'Skill';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SocialLoginInput = {
  accessToken: Scalars['String']['input'];
  clientId?: InputMaybe<Scalars['String']['input']>;
  provider: SocialProvider;
};

export enum SocialProvider {
  GOOGLE = 'Google',
  MICROSOFT = 'Microsoft'
}

export type SpecialProgram = {
  __typename?: 'SpecialProgram';
  adminOnly?: Maybe<Scalars['Boolean']['output']>;
  iconType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  program: Program;
};

export type SpecialProgramEditInput = {
  adminOnly?: InputMaybe<Scalars['Boolean']['input']>;
  customers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iconType: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type StudyPlan = {
  __typename?: 'StudyPlan';
  color?: Maybe<Scalars['String']['output']>;
  darkColor?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  unitIds?: Maybe<Array<Scalars['ID']['output']>>;
};

export type SummaryMetaData = {
  __typename?: 'SummaryMetaData';
  items?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  result?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SuperAdminBulkInviteUserInput = {
  admin: Scalars['Boolean']['input'];
  adminId?: InputMaybe<Scalars['String']['input']>;
  adminName?: InputMaybe<Scalars['String']['input']>;
  customer: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  resendInvite?: InputMaybe<Scalars['Boolean']['input']>;
  school: Scalars['String']['input'];
  schoolName?: InputMaybe<Scalars['String']['input']>;
  superAdmin: Scalars['Boolean']['input'];
};

export type SuperAdminInviteUserInput = {
  admin: Scalars['Boolean']['input'];
  adminId?: InputMaybe<Scalars['String']['input']>;
  contentAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  customer: Scalars['String']['input'];
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  districtAdmin: Scalars['Boolean']['input'];
  districtSchools?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  resendInvite?: InputMaybe<Scalars['Boolean']['input']>;
  school: Scalars['String']['input'];
  superAdmin: Scalars['Boolean']['input'];
};

export type SurveyFormReport = {
  __typename?: 'SurveyFormReport';
  className?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  dataIntact?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  email_attempts?: Maybe<Scalars['Int']['output']>;
  email_error?: Maybe<Scalars['String']['output']>;
  email_status?: Maybe<Scalars['String']['output']>;
  expirationAt: Scalars['String']['output'];
  feedbackFormCount?: Maybe<Scalars['Int']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isCancelled?: Maybe<Scalars['Int']['output']>;
  isSent?: Maybe<Scalars['Int']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  last_email_attempt?: Maybe<Scalars['String']['output']>;
  lessonName?: Maybe<Scalars['String']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  schoolName?: Maybe<Scalars['String']['output']>;
  type: Scalars['Int']['output'];
  unitName?: Maybe<Scalars['String']['output']>;
};

export type SurveyReport = {
  __typename?: 'SurveyReport';
  csvData?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SurveySubmitted = {
  __typename?: 'SurveySubmitted';
  exitTicket?: Maybe<SurveySummaryData>;
  preProgramQuiz?: Maybe<SurveySummaryData>;
};

export type SurveySummaryData = {
  __typename?: 'SurveySummaryData';
  items?: Maybe<Array<Maybe<SurveySummaryDetail>>>;
  result?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SurveySummaryDetail = {
  __typename?: 'SurveySummaryDetail';
  dateCompleted?: Maybe<Scalars['String']['output']>;
  educator?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  lessonName?: Maybe<Scalars['String']['output']>;
  responses?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
};

export type SurveyType = {
  __typename?: 'SurveyType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SwitchLessonFlowInput = {
  isAlternative?: InputMaybe<Scalars['Boolean']['input']>;
  lessonId: Scalars['String']['input'];
  unitId: Scalars['String']['input'];
};

export type TimeSpentInput = {
  timeSpent?: InputMaybe<Scalars['Int']['input']>;
};

export type TotalLoginAnalyticsData = {
  __typename?: 'TotalLoginAnalyticsData';
  count?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Array<Maybe<LoginDataByUser>>>;
  items?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type TrackDataInput = {
  data: Scalars['String']['input'];
  event: Scalars['String']['input'];
  isHE?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum TrackingLevel {
  BASIC = 'basic',
  DETAILED = 'detailed',
  FULL = 'full'
}

export type TranslateTextInput = {
  isVTT?: InputMaybe<Scalars['Boolean']['input']>;
  targetLanguage: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type TranslateTextsInput = {
  targetLanguage: Scalars['String']['input'];
  texts: Array<Scalars['String']['input']>;
};

export type TranslationBatchResult = {
  __typename?: 'TranslationBatchResult';
  targetLanguage: Scalars['String']['output'];
  translatedTexts: Array<Scalars['String']['output']>;
};

export type TranslationCacheStats = {
  __typename?: 'TranslationCacheStats';
  averageAccessCount: Scalars['Float']['output'];
  entriesByLanguage: Scalars['JSON']['output'];
  newestEntry?: Maybe<Scalars['String']['output']>;
  oldestEntry?: Maybe<Scalars['String']['output']>;
  totalEntries: Scalars['Int']['output'];
};

export type TranslationJob = {
  __typename?: 'TranslationJob';
  completedAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  englishSubtitleUrl?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  externalJobId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  languageJobs?: Maybe<Array<TranslationLanguageJob>>;
  progressPercentage: Scalars['Int']['output'];
  status: TranslationStatus;
  targetLanguages: Array<Scalars['String']['output']>;
  translationResults?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  videoUrl: Scalars['String']['output'];
};

export type TranslationJobsResponse = {
  __typename?: 'TranslationJobsResponse';
  hasMore: Scalars['Boolean']['output'];
  jobs: Array<TranslationJob>;
  totalCount: Scalars['Int']['output'];
};

export type TranslationLanguageJob = {
  __typename?: 'TranslationLanguageJob';
  completedAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  languageCode: Scalars['String']['output'];
  maxRetries: Scalars['Int']['output'];
  parentJobId: Scalars['String']['output'];
  retryCount: Scalars['Int']['output'];
  status: TranslationLanguageStatus;
  subtitleUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export enum TranslationLanguageStatus {
  COMPLETED = 'completed',
  FAILED = 'failed',
  PENDING = 'pending',
  PROCESSING = 'processing'
}

export type TranslationResult = {
  __typename?: 'TranslationResult';
  sourceLanguage?: Maybe<Scalars['String']['output']>;
  targetLanguage: Scalars['String']['output'];
  translatedText: Scalars['String']['output'];
};

export type TranslationServiceInfo = {
  __typename?: 'TranslationServiceInfo';
  azureApiVersion: Scalars['String']['output'];
  azureDeploymentName: Scalars['String']['output'];
  defaultService: Scalars['String']['output'];
  useAzureForAll: Scalars['Boolean']['output'];
};

export enum TranslationStatus {
  CANCELLED = 'cancelled',
  COMPLETED = 'completed',
  FAILED = 'failed',
  GENERATING_ENGLISH = 'generating_english',
  PARTIAL = 'partial',
  PENDING = 'pending',
  PROCESSING = 'processing'
}

export type UiStatus = {
  __typename?: 'UIStatus';
  isBBDescriptionHidden?: Maybe<Scalars['Boolean']['output']>;
  isCCDescriptionHidden?: Maybe<Scalars['Boolean']['output']>;
  isLLDescriptionHidden?: Maybe<Scalars['Boolean']['output']>;
  isSBDescriptionHidden?: Maybe<Scalars['Boolean']['output']>;
  isSIDescriptionHidden?: Maybe<Scalars['Boolean']['output']>;
  isSVDescriptionHidden?: Maybe<Scalars['Boolean']['output']>;
  isTDescriptionHidden?: Maybe<Scalars['Boolean']['output']>;
};

export type UiStatusInput = {
  isBBDescriptionHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isCCDescriptionHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isLLDescriptionHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isSBDescriptionHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isSIDescriptionHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isSVDescriptionHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isTDescriptionHidden?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UniqueNameInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  uniqueName: Scalars['String']['input'];
};

export type Unit = {
  __typename?: 'Unit';
  alternateMaterials?: Maybe<Array<Maybe<Content>>>;
  alternateMaterialsCount?: Maybe<Scalars['Int']['output']>;
  box1?: Maybe<Scalars['String']['output']>;
  box2?: Maybe<Scalars['String']['output']>;
  categories?: Maybe<Scalars['String']['output']>;
  classPresentation?: Maybe<Array<Maybe<Lesson>>>;
  classPresentationCount?: Maybe<Scalars['Int']['output']>;
  comingSoonAt?: Maybe<Scalars['String']['output']>;
  comingSoonLabelPosition?: Maybe<Scalars['String']['output']>;
  competency?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  courseId?: Maybe<Scalars['String']['output']>;
  coverImage?: Maybe<Scalars['String']['output']>;
  default: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  hea?: Maybe<Scalars['Boolean']['output']>;
  helpfulHeading?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isComingSoon?: Maybe<Scalars['Boolean']['output']>;
  isEducatorCaregiverLessonLayout?: Maybe<Scalars['Boolean']['output']>;
  isNew?: Maybe<Scalars['Boolean']['output']>;
  isNewCover?: Maybe<Scalars['Boolean']['output']>;
  isPreProgramQuiz?: Maybe<Scalars['Boolean']['output']>;
  isQuizCreated?: Maybe<Scalars['Boolean']['output']>;
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  meta?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  newLabelPosition?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  pace?: Maybe<Scalars['String']['output']>;
  popupCover?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  sensitive?: Maybe<Scalars['Boolean']['output']>;
  sensitiveTooltip?: Maybe<Scalars['String']['output']>;
  skill: Scalars['String']['output'];
  skillsHeading?: Maybe<Scalars['String']['output']>;
  studentQuizzes?: Maybe<Array<Maybe<Content>>>;
  studentQuizzesCount?: Maybe<Scalars['Int']['output']>;
  studyGuideMaterials?: Maybe<Array<Maybe<Content>>>;
  studyGuides?: Maybe<Array<Maybe<Content>>>;
  studyGuidesCount?: Maybe<Scalars['Int']['output']>;
  subHeading?: Maybe<Scalars['String']['output']>;
  suggestedDuration?: Maybe<Scalars['String']['output']>;
  suggestedLessonCount?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Scalars['String']['output']>;
  teacherBox?: Maybe<Scalars['String']['output']>;
  teacherImage?: Maybe<Scalars['String']['output']>;
  teacherPreparation?: Maybe<Array<Maybe<Content>>>;
  teacherPreparationCount?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
  uniqueName?: Maybe<Scalars['String']['output']>;
  unitStudyBox?: Maybe<Scalars['String']['output']>;
  unitStudyHeading?: Maybe<Scalars['String']['output']>;
  unitStudyReview?: Maybe<UnitStudyReview>;
  updatedLabelPosition?: Maybe<Scalars['String']['output']>;
};

export type UnitAndSllLesson = {
  __typename?: 'UnitAndSLLLesson';
  sllLessons?: Maybe<Array<Maybe<SllLesson>>>;
  units?: Maybe<Array<Maybe<Unit>>>;
};

export type UnitStudyReview = {
  __typename?: 'UnitStudyReview';
  status: Scalars['String']['output'];
};

export type UnitsByProgram = {
  __typename?: 'UnitsByProgram';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  units?: Maybe<Array<Unit>>;
};

export type UpdateCollectionInput = {
  addlMatBox?: InputMaybe<Scalars['String']['input']>;
  addlMatHeading?: InputMaybe<Scalars['String']['input']>;
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  bannerVideo?: InputMaybe<Scalars['String']['input']>;
  collectionType?: InputMaybe<CollectionType>;
  country?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isSensitive?: InputMaybe<Scalars['Boolean']['input']>;
  isSubHeading?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pacing?: InputMaybe<Scalars['String']['input']>;
  requirements?: InputMaybe<Scalars['String']['input']>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  subHeadingHighlight?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['String']['input']>;
  unitOvwBox1?: InputMaybe<Scalars['String']['input']>;
  unitOvwBox2?: InputMaybe<Scalars['String']['input']>;
  unitOvwHeading1?: InputMaybe<Scalars['String']['input']>;
  unitOvwHeading2?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContentInput = {
  additionalAfter?: InputMaybe<Scalars['Boolean']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  formData?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  lastInLesson?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  pauseHere?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  type: ContentType;
};

export type UpdateFormContentJsonInput = {
  formData: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type UpdateGroupContentInput = {
  data: Scalars['String']['input'];
  formData?: InputMaybe<Scalars['String']['input']>;
  group: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type UpdateLanguageJobInput = {
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  languageJobId: Scalars['String']['input'];
  status: VideoTranslationLanguageStatus;
  subtitleUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLessonCompleteStatusInput = {
  lessonId: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  unitId: Scalars['String']['input'];
};

export type UpdateMultiCollectionInput = {
  country: Scalars['String']['input'];
  description: Scalars['String']['input'];
  grade: Scalars['String']['input'];
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  isScopeAndSeq?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  scopeAndSeqId?: InputMaybe<Scalars['String']['input']>;
  type: MultiCollectionType;
};

export type UpdateQuizInput = {
  id: Scalars['String']['input'];
  unitIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateQuizNameInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateSchoolReportInput = {
  cdnUrl: Scalars['String']['input'];
  key: Scalars['String']['input'];
  region: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
};

export type UpdateSectionCompleteStatusInput = {
  lessonId: Scalars['String']['input'];
  sectionId: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  unitId: Scalars['String']['input'];
};

export type UpdateSectionInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateSentryTrackingInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  trackingLevel?: InputMaybe<TrackingLevel>;
};

export type UpdateTranslationJobInput = {
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  jobId: Scalars['String']['input'];
  languageCode: Scalars['String']['input'];
  status: TranslationLanguageStatus;
  subtitleUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUnitStudyReviewStatusInput = {
  status?: InputMaybe<Scalars['String']['input']>;
  unitId: Scalars['String']['input'];
};

export type UpdateVideoContentInput = {
  data?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  lastInLesson?: InputMaybe<Scalars['Boolean']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pauseHere?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  type: ContentType;
  uploadId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVideoGroupContentInput = {
  data?: InputMaybe<Scalars['String']['input']>;
  group: Scalars['String']['input'];
  id: Scalars['String']['input'];
  uploadId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVideoTranslationJobInput = {
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  jobId: Scalars['String']['input'];
  status?: InputMaybe<VideoTranslationStatus>;
  translationResults?: InputMaybe<Scalars['JSON']['input']>;
};

export type UploadZipSlideInput = {
  groupId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  isCourse?: InputMaybe<Scalars['Boolean']['input']>;
  isHomeEd?: InputMaybe<Scalars['Boolean']['input']>;
  url: Scalars['String']['input'];
};

export type User = {
  __typename?: 'User';
  admin?: Maybe<Scalars['ID']['output']>;
  autoLogoutEnabled?: Maybe<Scalars['Boolean']['output']>;
  completedLessonCount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  currentLoginAt?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Customer>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  disabledPwLogin?: Maybe<Scalars['Boolean']['output']>;
  districtSchools?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  expiry?: Maybe<Scalars['String']['output']>;
  firstLoginFormFilled?: Maybe<Scalars['Boolean']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isShownLessonProgress?: Maybe<Scalars['Boolean']['output']>;
  lastLoginAt?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  position?: Maybe<Position>;
  previousLoginAt?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  roleDesc?: Maybe<Scalars['String']['output']>;
  schoolNewYearInfo?: Maybe<Scalars['String']['output']>;
  schools?: Maybe<Array<Maybe<School>>>;
  status: Scalars['String']['output'];
  subject?: Maybe<Scalars['String']['output']>;
  uiStatus?: Maybe<UiStatus>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  usages?: Maybe<Scalars['String']['output']>;
};

export type UserFlags = {
  __typename?: 'UserFlags';
  firstLoginFormFilled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
};

export type UserFlagsInput = {
  firstLoginFormFilled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserIdInput = {
  id: Scalars['String']['input'];
};

export type UserInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type UserInviteEditInput = {
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  adminId?: InputMaybe<Scalars['String']['input']>;
  customer?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  resendInvite: Scalars['Boolean']['input'];
  school?: InputMaybe<Scalars['String']['input']>;
};

export type UserInviteInput = {
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  adminId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  school?: InputMaybe<Scalars['String']['input']>;
};

export type UserRegistrationInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  id: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  roleDesc?: InputMaybe<Scalars['String']['input']>;
  school?: InputMaybe<Scalars['String']['input']>;
  usages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UserRegistrationResponse = {
  __typename?: 'UserRegistrationResponse';
  token: Scalars['String']['output'];
  user?: Maybe<User>;
};

export enum UserStatus {
  ACCEPTED = 'Accepted',
  PENDING = 'Pending'
}

export type UserUpdateInput = {
  autoLogoutEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isShownLessonProgress?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  roleDesc?: InputMaybe<Scalars['String']['input']>;
  uiStatus?: InputMaybe<UiStatusInput>;
  usages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type VerifyCodeInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  disable: Scalars['Boolean']['input'];
  email: Scalars['String']['input'];
};

export type Video = {
  __typename?: 'Video';
  created: Scalars['String']['output'];
  data: Scalars['String']['output'];
  meta?: Maybe<Scalars['String']['output']>;
  muxAsset?: Maybe<MuxAssetData>;
  name: Scalars['String']['output'];
};

export type VideoData = {
  __typename?: 'VideoData';
  meta?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type VideoSubtitle = {
  __typename?: 'VideoSubtitle';
  id?: Maybe<Scalars['String']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type VideoTranslationJob = {
  __typename?: 'VideoTranslationJob';
  completedAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  externalJobId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  languageJobs?: Maybe<Array<VideoTranslationLanguageJob>>;
  progressPercentage: Scalars['Int']['output'];
  status: VideoTranslationStatus;
  targetLanguages: Array<Scalars['String']['output']>;
  translationResults?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  videoUrl: Scalars['String']['output'];
};

export type VideoTranslationJobsResponse = {
  __typename?: 'VideoTranslationJobsResponse';
  hasMore: Scalars['Boolean']['output'];
  jobs: Array<VideoTranslationJob>;
  totalCount: Scalars['Int']['output'];
};

export type VideoTranslationLanguageJob = {
  __typename?: 'VideoTranslationLanguageJob';
  completedAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  languageCode: Scalars['String']['output'];
  maxRetries: Scalars['Int']['output'];
  parentJobId: Scalars['String']['output'];
  retryCount: Scalars['Int']['output'];
  status: VideoTranslationLanguageStatus;
  subtitleUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export enum VideoTranslationLanguageStatus {
  COMPLETED = 'completed',
  FAILED = 'failed',
  PENDING = 'pending',
  PROCESSING = 'processing'
}

export enum VideoTranslationStatus {
  COMPLETED = 'completed',
  FAILED = 'failed',
  PARTIAL = 'partial',
  PENDING = 'pending',
  PROCESSING = 'processing'
}

export type VideoUpload = {
  __typename?: 'VideoUpload';
  uploadId?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type VideoUploadInput = {
  metadata?: InputMaybe<Scalars['String']['input']>;
};

export type VideoWithTranslationResult = {
  __typename?: 'VideoWithTranslationResult';
  muxAssetId: Scalars['String']['output'];
  muxPlaybackId: Scalars['String']['output'];
  videoTranslationJob: VideoTranslationJob;
  videoUrl: Scalars['String']['output'];
};

export type WellBeingLesson = {
  __typename?: 'WellBeingLesson';
  completedAt: Scalars['String']['output'];
  schoolId?: Maybe<Scalars['String']['output']>;
  schoolName?: Maybe<Scalars['String']['output']>;
  teacherId?: Maybe<Scalars['String']['output']>;
  teacherName?: Maybe<Scalars['String']['output']>;
};

export type HeaRegisterResponse = {
  __typename?: 'heaRegisterResponse';
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  registeredAt: Scalars['String']['output'];
};

export type SllGetPopularLessonsInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  gradeLevel?: InputMaybe<Scalars['String']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdated?: InputMaybe<Scalars['Boolean']['input']>;
  mCollectionId?: InputMaybe<Scalars['String']['input']>;
};

export type SurveyFormReportFragment = { __typename?: 'SurveyFormReport', id: string, type: number, createdBy: string, createdAt: string, expirationAt: string, programName?: string | null, lessonName?: string | null, unitName?: string | null, className?: string | null, isSent?: number | null, isCancelled?: number | null, email_status?: string | null, email_error?: string | null, email_attempts?: number | null, last_email_attempt?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, schoolName?: string | null, feedbackFormCount?: number | null, dataIntact?: boolean | null };

export type GetReportsQueryVariables = Exact<{
  input: GetReportsInput;
}>;


export type GetReportsQuery = { __typename?: 'Query', getReports: { __typename?: 'ReportsPage', totalCount: number, hasMore: boolean, reports: Array<{ __typename?: 'SurveyFormReport', id: string, type: number, createdBy: string, createdAt: string, expirationAt: string, programName?: string | null, lessonName?: string | null, unitName?: string | null, className?: string | null, isSent?: number | null, isCancelled?: number | null, email_status?: string | null, email_error?: string | null, email_attempts?: number | null, last_email_attempt?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, schoolName?: string | null, feedbackFormCount?: number | null, dataIntact?: boolean | null }> } };

export type ManuallyTriggerReportMutationVariables = Exact<{
  input: ManuallyTriggerReportInput;
}>;


export type ManuallyTriggerReportMutation = { __typename?: 'Mutation', manuallyTriggerReport: boolean };

export type UserFragment = { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, disabled?: boolean | null, role: string, status: string, updatedAt?: string | null, admin?: string | null, districtSchools?: string | null, completedLessonCount?: number | null, schoolNewYearInfo?: string | null, disabledPwLogin?: boolean | null, autoLogoutEnabled?: boolean | null, customer?: { __typename?: 'Customer', id: string, name: string, country?: string | null, trial?: boolean | null, state?: string | null } | null, schools?: Array<{ __typename?: 'School', id: string, name: string, groupIds?: string | null, isPrimary?: boolean | null, programs?: string | null, grades?: string | null } | null> | null };

export type ExtendedUserFragment = { __typename?: 'User', subject?: string | null, firstLoginFormFilled?: boolean | null, usages?: string | null, roleDesc?: string | null, createdAt?: string | null, previousLoginAt?: string | null, id: string, firstName: string, lastName: string, email: string, disabled?: boolean | null, role: string, status: string, updatedAt?: string | null, admin?: string | null, districtSchools?: string | null, completedLessonCount?: number | null, schoolNewYearInfo?: string | null, disabledPwLogin?: boolean | null, autoLogoutEnabled?: boolean | null, position?: { __typename?: 'Position', id: string, name: string } | null, uiStatus?: { __typename?: 'UIStatus', isLLDescriptionHidden?: boolean | null, isSVDescriptionHidden?: boolean | null, isTDescriptionHidden?: boolean | null, isSIDescriptionHidden?: boolean | null, isBBDescriptionHidden?: boolean | null, isSBDescriptionHidden?: boolean | null, isCCDescriptionHidden?: boolean | null } | null, customer?: { __typename?: 'Customer', id: string, name: string, country?: string | null, trial?: boolean | null, state?: string | null } | null, schools?: Array<{ __typename?: 'School', id: string, name: string, groupIds?: string | null, isPrimary?: boolean | null, programs?: string | null, grades?: string | null } | null> | null };

export type HeaUserFragment = { __typename?: 'HEAUser', id: string, email: string, firstName?: string | null, lastName?: string | null, status?: string | null, enableFaith?: boolean | null, enablePasscode?: boolean | null, locked?: boolean | null, studyplanId?: string | null, registeredAt?: string | null, studyplanName?: string | null, studyplanCount?: number | null, association?: string | null, blocked?: boolean | null, expired?: boolean | null, expireAt?: string | null, isTypeformShown?: boolean | null };

export type ContentFragment = { __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null };

export type HeaModuleFragment = { __typename?: 'HEAModule', id: string, originalModuleId?: string | null, name: string, type: ContentType, data?: string | null, position?: number | null, formData?: string | null, meta?: string | null };

export type SectionFragment = { __typename?: 'Section', id: string, name: string, position?: number | null, progress?: number | null, status?: string | null, modules?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null }> | null };

export type LessonFragment = { __typename?: 'Lesson', id: string, name: string, uniqueName?: string | null, description?: string | null, number?: number | null, master?: boolean | null, image?: string | null, duration?: number | null, descriptionHeading?: string | null, descriptionAnswers?: string | null, prerequisite?: boolean | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, status?: string | null, lastVisitedAt?: string | null, group?: string | null, progress?: number | null, alternativeActivated?: boolean | null, isAlternative?: boolean | null, modules?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null }> | null, materials?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null }> | null, sections?: Array<{ __typename?: 'Section', id: string, name: string, position?: number | null, progress?: number | null, status?: string | null, modules?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null }> | null }> | null };

export type SllModuleFragment = { __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null };

export type SllGroupModuleFragment = { __typename?: 'SLLGroupModule', moduleId: string, groupId: string, groupName?: string | null, data?: string | null, meta?: string | null, formData?: string | null };

export type SllSectionFragment = { __typename?: 'SLLSection', id: string, name: string, position?: number | null, modules?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null };

export type SllLessonContentFragment = { __typename?: 'SLLLesson', name: string, uniqueName?: string | null, coverImage?: string | null, bannerImage?: string | null, coverVideo?: string | null, country: string, ageGroup?: string | null, gradeLabelPosition?: string | null, mainTopics?: string | null, subTopics?: string | null, skill?: string | null, gradeLevel?: string | null, duration: number, lessonMaterialHeading?: string | null, lessonMaterialAnswers?: string | null, overviewHeading1?: string | null, overviewAnswers1?: string | null, overviewHeading2?: string | null, overviewAnswers2?: string | null, recommendedPrior?: string | null, recommendedNext?: string | null, isPublished?: boolean | null, isNew?: boolean | null, newLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonAt?: string | null, comingSoonLabelPosition?: string | null, groupId?: string | null, competency?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isOpReel?: boolean | null, categories?: string | null, isNewCover?: boolean | null, suggestedDuration?: string | null, sllType?: SllLessonType | null, isExtensionAvailable?: boolean | null, isEducatorCaregiverLessonLayout?: boolean | null, lessonType?: string | null, showLessonMaterialsNotice?: boolean | null, lessonDetails?: string | null };

export type CollectionFragment = { __typename?: 'Collection', id: string, name: string, grade?: string | null, country?: string | null, subHeading?: string | null, subHeadingHighlight?: string | null, collectionType?: CollectionType | null, bannerImage?: string | null, bannerVideo?: string | null, tags?: string | null, requirements?: string | null, addlMatHeading?: string | null, addlMatBox?: string | null, unitOvwHeading1?: string | null, unitOvwBox1?: string | null, unitOvwHeading2?: string | null, unitOvwBox2?: string | null, isSensitive?: number | null, pacing?: string | null, isSubHeading?: boolean | null, sllLessons?: Array<{ __typename?: 'SLLLesson', id: string, name: string, uniqueName?: string | null, coverImage?: string | null, bannerImage?: string | null, coverVideo?: string | null, country: string, gradeLabelPosition?: string | null, mainTopics?: string | null, subTopics?: string | null, skill?: string | null, gradeLevel?: string | null, duration: number, progress?: number | null, isPublished?: boolean | null, isNew?: boolean | null, newLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonAt?: string | null, comingSoonLabelPosition?: string | null, groupId?: string | null, competency?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isOpReel?: boolean | null, categories?: string | null, isNewCover?: boolean | null, suggestedDuration?: string | null, sllType?: SllLessonType | null, isExtensionAvailable?: boolean | null, lessonType?: string | null, showLessonMaterialsNotice?: boolean | null, lessonDetails?: string | null } | null> | null };

export type CollectionWithPresentationFragment = { __typename?: 'Collection', id: string, name: string, grade?: string | null, country?: string | null, subHeading?: string | null, subHeadingHighlight?: string | null, collectionType?: CollectionType | null, bannerImage?: string | null, bannerVideo?: string | null, tags?: string | null, requirements?: string | null, addlMatHeading?: string | null, addlMatBox?: string | null, unitOvwHeading1?: string | null, unitOvwBox1?: string | null, unitOvwHeading2?: string | null, unitOvwBox2?: string | null, isSensitive?: number | null, pacing?: string | null, isSubHeading?: boolean | null, sllLessons?: Array<{ __typename?: 'SLLLesson', id: string, name: string, uniqueName?: string | null, coverImage?: string | null, bannerImage?: string | null, coverVideo?: string | null, country: string, gradeLabelPosition?: string | null, mainTopics?: string | null, subTopics?: string | null, skill?: string | null, gradeLevel?: string | null, duration: number, progress?: number | null, isPublished?: boolean | null, isNew?: boolean | null, newLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonAt?: string | null, comingSoonLabelPosition?: string | null, groupId?: string | null, competency?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isOpReel?: boolean | null, categories?: string | null, isNewCover?: boolean | null, suggestedDuration?: string | null, sllType?: SllLessonType | null, isExtensionAvailable?: boolean | null, lessonType?: string | null, showLessonMaterialsNotice?: boolean | null, lessonDetails?: string | null, presentation?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null } | null> | null };

export type MultiCollectionFragment = { __typename?: 'MultiCollection', country: string, grade: string, id: string, isScopeAndSeq?: number | null, name: string, scopeAndSeqId?: string | null, type: MultiCollectionType, position?: number | null, collections?: Array<{ __typename?: 'Collection', id: string, name: string, grade?: string | null, country?: string | null, subHeading?: string | null, subHeadingHighlight?: string | null, collectionType?: CollectionType | null, bannerImage?: string | null, bannerVideo?: string | null, tags?: string | null, requirements?: string | null, addlMatHeading?: string | null, addlMatBox?: string | null, unitOvwHeading1?: string | null, unitOvwBox1?: string | null, unitOvwHeading2?: string | null, unitOvwBox2?: string | null, isSensitive?: number | null, pacing?: string | null, isSubHeading?: boolean | null, sllLessons?: Array<{ __typename?: 'SLLLesson', id: string, name: string, uniqueName?: string | null, coverImage?: string | null, bannerImage?: string | null, coverVideo?: string | null, country: string, gradeLabelPosition?: string | null, mainTopics?: string | null, subTopics?: string | null, skill?: string | null, gradeLevel?: string | null, duration: number, progress?: number | null, isPublished?: boolean | null, isNew?: boolean | null, newLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonAt?: string | null, comingSoonLabelPosition?: string | null, groupId?: string | null, competency?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isOpReel?: boolean | null, categories?: string | null, isNewCover?: boolean | null, suggestedDuration?: string | null, sllType?: SllLessonType | null, isExtensionAvailable?: boolean | null, lessonType?: string | null, showLessonMaterialsNotice?: boolean | null, lessonDetails?: string | null } | null> | null } | null> | null };

export type MultiCollectionContentFragment = { __typename?: 'MultiCollectionContent', id: string, name: string, position: number, subHeading?: string | null, isNewCover?: boolean | null, ageGroup?: string | null, bannerImage?: string | null, bannerVideo?: string | null, categories?: string | null, collectionType?: CollectionType | null, coverImage?: string | null, grade?: string | null, gradeLevel?: string | null, suggestedDuration?: string | null, suggestedLessonCount?: number | null, type: MultiCollectionContentType, duration?: string | null, competency?: string | null, progress?: number | null, lessonType?: string | null, lessonDetails?: string | null, isNew?: boolean | null, newLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonAt?: string | null, comingSoonLabelPosition?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null };

export type NormalMultiCollectionFragment = { __typename?: 'NormalMultiCollection', country: string, grade: string, id: string, isScopeAndSeq?: number | null, name: string, scopeAndSeqId?: string | null, content?: Array<{ __typename?: 'MultiCollectionContent', id: string, name: string, position: number, subHeading?: string | null, isNewCover?: boolean | null, ageGroup?: string | null, bannerImage?: string | null, bannerVideo?: string | null, categories?: string | null, collectionType?: CollectionType | null, coverImage?: string | null, grade?: string | null, gradeLevel?: string | null, suggestedDuration?: string | null, suggestedLessonCount?: number | null, type: MultiCollectionContentType, duration?: string | null, competency?: string | null, progress?: number | null, lessonType?: string | null, lessonDetails?: string | null, isNew?: boolean | null, newLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonAt?: string | null, comingSoonLabelPosition?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null } | null> | null };

export type LessonContentFragment = { __typename?: 'SLLLesson', id: string, name: string, uniqueName?: string | null, coverImage?: string | null, bannerImage?: string | null, coverVideo?: string | null, country: string, gradeLabelPosition?: string | null, mainTopics?: string | null, subTopics?: string | null, skill?: string | null, gradeLevel?: string | null, duration: number, progress?: number | null, isPublished?: boolean | null, isNew?: boolean | null, newLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonAt?: string | null, comingSoonLabelPosition?: string | null, groupId?: string | null, competency?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isOpReel?: boolean | null, categories?: string | null, isNewCover?: boolean | null, suggestedDuration?: string | null, sllType?: SllLessonType | null, isExtensionAvailable?: boolean | null, lessonType?: string | null, showLessonMaterialsNotice?: boolean | null, lessonDetails?: string | null };

export type CollectionLessonFragment = { __typename?: 'SLLLesson', id: string, name: string, progress?: number | null, competency?: string | null, categories?: string | null, coverImage?: string | null, duration: number, lessonType?: string | null };

export type DefaultCollectionFragment = { __typename?: 'Collection', id: string, name: string, bannerImage?: string | null, bannerVideo?: string | null, tags?: string | null, sllLessons?: Array<{ __typename?: 'SLLLesson', id: string, name: string, progress?: number | null, competency?: string | null, categories?: string | null, coverImage?: string | null, duration: number, lessonType?: string | null } | null> | null };

export type DefaultMultiCollectionFragment = { __typename?: 'MultiCollection', country: string, grade: string, id: string, description?: string | null, hidden?: boolean | null, isScopeAndSeq?: number | null, name: string, scopeAndSeqId?: string | null, type: MultiCollectionType, position?: number | null, collections?: Array<{ __typename?: 'Collection', id: string, name: string, bannerImage?: string | null, bannerVideo?: string | null, tags?: string | null, sllLessons?: Array<{ __typename?: 'SLLLesson', id: string, name: string, progress?: number | null, competency?: string | null, categories?: string | null, coverImage?: string | null, duration: number, lessonType?: string | null } | null> | null } | null> | null };

export type BannerContentFragment = { __typename?: 'Content', id: string, name: string, data?: string | null };

export type SllLessonCollectionFragment = { __typename?: 'SLLLessonCollection', id: string, name: string, collectionType: string };

export type SllLessonMultiCollectionFragment = { __typename?: 'SLLLessonMultiCollection', id: string, name: string, grade: string, programType?: string | null };

export type SllLessonFragment = { __typename?: 'SLLLesson', id: string, meta?: string | null, status?: string | null, progress?: number | null, name: string, uniqueName?: string | null, coverImage?: string | null, bannerImage?: string | null, coverVideo?: string | null, country: string, ageGroup?: string | null, gradeLabelPosition?: string | null, mainTopics?: string | null, subTopics?: string | null, skill?: string | null, gradeLevel?: string | null, duration: number, lessonMaterialHeading?: string | null, lessonMaterialAnswers?: string | null, overviewHeading1?: string | null, overviewAnswers1?: string | null, overviewHeading2?: string | null, overviewAnswers2?: string | null, recommendedPrior?: string | null, recommendedNext?: string | null, isPublished?: boolean | null, isNew?: boolean | null, newLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonAt?: string | null, comingSoonLabelPosition?: string | null, groupId?: string | null, competency?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isOpReel?: boolean | null, categories?: string | null, isNewCover?: boolean | null, suggestedDuration?: string | null, sllType?: SllLessonType | null, isExtensionAvailable?: boolean | null, isEducatorCaregiverLessonLayout?: boolean | null, lessonType?: string | null, showLessonMaterialsNotice?: boolean | null, lessonDetails?: string | null, materials?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null, presentation?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null, sections?: Array<{ __typename?: 'SLLSection', id: string, name: string, position?: number | null, modules?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null } | null> | null, collections?: Array<{ __typename?: 'SLLLessonCollection', id: string, name: string, collectionType: string } | null> | null, multiCollections?: Array<{ __typename?: 'SLLLessonMultiCollection', id: string, name: string, grade: string, programType?: string | null } | null> | null };

export type SllLessonForSaFragment = { __typename?: 'SLLLesson', id: string, meta?: string | null, name: string, uniqueName?: string | null, coverImage?: string | null, bannerImage?: string | null, coverVideo?: string | null, country: string, ageGroup?: string | null, gradeLabelPosition?: string | null, mainTopics?: string | null, subTopics?: string | null, skill?: string | null, gradeLevel?: string | null, duration: number, lessonMaterialHeading?: string | null, lessonMaterialAnswers?: string | null, overviewHeading1?: string | null, overviewAnswers1?: string | null, overviewHeading2?: string | null, overviewAnswers2?: string | null, recommendedPrior?: string | null, recommendedNext?: string | null, isPublished?: boolean | null, isNew?: boolean | null, newLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonAt?: string | null, comingSoonLabelPosition?: string | null, groupId?: string | null, competency?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isOpReel?: boolean | null, categories?: string | null, isNewCover?: boolean | null, suggestedDuration?: string | null, sllType?: SllLessonType | null, isExtensionAvailable?: boolean | null, isEducatorCaregiverLessonLayout?: boolean | null, lessonType?: string | null, showLessonMaterialsNotice?: boolean | null, lessonDetails?: string | null, materials?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null, presentation?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null, sections?: Array<{ __typename?: 'SLLSection', id: string, name: string, position?: number | null, modules?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null } | null> | null };

export type SllDefaultLessonForSaFragment = { __typename?: 'SLLLesson', id: string, name: string, uniqueName?: string | null, coverImage?: string | null, bannerImage?: string | null, coverVideo?: string | null, country: string, ageGroup?: string | null, gradeLabelPosition?: string | null, mainTopics?: string | null, subTopics?: string | null, skill?: string | null, gradeLevel?: string | null, duration: number, lessonMaterialHeading?: string | null, lessonMaterialAnswers?: string | null, overviewHeading1?: string | null, overviewAnswers1?: string | null, overviewHeading2?: string | null, overviewAnswers2?: string | null, recommendedPrior?: string | null, recommendedNext?: string | null, isPublished?: boolean | null, isNew?: boolean | null, newLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonAt?: string | null, comingSoonLabelPosition?: string | null, groupId?: string | null, competency?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isOpReel?: boolean | null, categories?: string | null, isNewCover?: boolean | null, suggestedDuration?: string | null, sllType?: SllLessonType | null, isExtensionAvailable?: boolean | null, isEducatorCaregiverLessonLayout?: boolean | null, lessonType?: string | null, showLessonMaterialsNotice?: boolean | null, lessonDetails?: string | null };

export type HeaLessonFragment = { __typename?: 'HEALesson', id: string, originalLessonId: string, name: string, description?: string | null, number?: number | null, image?: string | null, duration?: number | null, descriptionHeading?: string | null, descriptionAnswers?: string | null, prerequisite?: boolean | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, group?: string | null, modules?: Array<{ __typename?: 'HEAPresentationModule', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, useDefault?: boolean | null }> | null };

export type UnitContentFragment = { __typename?: 'Unit', id: string, name: string, uniqueName?: string | null, subHeading?: string | null, skill: string, coverImage?: string | null, popupCover?: string | null, type: string, country?: string | null, default: boolean, description?: string | null, courseId?: string | null, pace?: string | null, tags?: string | null, teacherBox?: string | null, teacherImage?: string | null, box1?: string | null, box2?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, progress?: number | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, isNew?: boolean | null, newLabelPosition?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonLabelPosition?: string | null, comingSoonAt?: string | null, competency?: string | null, unitStudyBox?: string | null, unitStudyHeading?: string | null, isNewCover?: boolean | null, categories?: string | null, suggestedLessonCount?: number | null, suggestedDuration?: string | null, isEducatorCaregiverLessonLayout?: boolean | null, unitStudyReview?: { __typename?: 'UnitStudyReview', status: string } | null };

export type HeaUnitContentFragment = { __typename?: 'HEAUnit', id: string, originalUnitId: string, name: string, subHeading?: string | null, coverImage?: string | null, popupCover?: string | null, pace?: string | null, topics?: string | null, tags?: string | null, box1?: string | null, box2?: string | null, description?: string | null, parentBox?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, parentImage?: string | null, ageGroup?: string | null, sensitive?: boolean | null, sensitiveTooltip?: string | null };

export type AusCourseContentFragment = { __typename?: 'AUSCourseContent', categories: string, comingSoonAt: string, coverImage: string, gradeLevel: string, id: string, isComingSoon: boolean, isNew: boolean, isNewCover: boolean, isOpReel: boolean, isUpdated: boolean, name: string, number: number, progress: number, subHeading: string, suggestedDuration: string, suggestedLessonCount: number, type: CourseContentType, comingSoonLabelPosition: string, newLabelPosition: string, updatedLabelPosition: string };

export type StudyPlanContentFragment = { __typename?: 'StudyPlan', id: string, name: string, color?: string | null, darkColor?: string | null, unitIds?: Array<string> | null };

export type ProgramFragment = { __typename?: 'Program', id: string, name: string, image?: string | null, description?: string | null, favorite?: boolean | null, lastUsed?: string | null, isTest?: boolean | null, isParentCourse?: boolean | null, isSpecial?: boolean | null, order?: number | null, country?: string | null, coverVideo?: string | null, meta?: string | null, isCustomized?: boolean | null, progress?: number | null, primary?: Array<{ __typename?: 'Unit', id: string, name: string, uniqueName?: string | null, subHeading?: string | null, skill: string, coverImage?: string | null, popupCover?: string | null, type: string, country?: string | null, default: boolean, description?: string | null, courseId?: string | null, pace?: string | null, tags?: string | null, teacherBox?: string | null, teacherImage?: string | null, box1?: string | null, box2?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, progress?: number | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, isNew?: boolean | null, newLabelPosition?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonLabelPosition?: string | null, comingSoonAt?: string | null, competency?: string | null, unitStudyBox?: string | null, unitStudyHeading?: string | null, isNewCover?: boolean | null, categories?: string | null, suggestedLessonCount?: number | null, suggestedDuration?: string | null, isEducatorCaregiverLessonLayout?: boolean | null, unitStudyReview?: { __typename?: 'UnitStudyReview', status: string } | null }> | null, additional?: Array<{ __typename?: 'Unit', id: string, name: string, uniqueName?: string | null, subHeading?: string | null, skill: string, coverImage?: string | null, popupCover?: string | null, type: string, country?: string | null, default: boolean, description?: string | null, courseId?: string | null, pace?: string | null, tags?: string | null, teacherBox?: string | null, teacherImage?: string | null, box1?: string | null, box2?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, progress?: number | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, isNew?: boolean | null, newLabelPosition?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonLabelPosition?: string | null, comingSoonAt?: string | null, competency?: string | null, unitStudyBox?: string | null, unitStudyHeading?: string | null, isNewCover?: boolean | null, categories?: string | null, suggestedLessonCount?: number | null, suggestedDuration?: string | null, isEducatorCaregiverLessonLayout?: boolean | null, unitStudyReview?: { __typename?: 'UnitStudyReview', status: string } | null }> | null, grade?: { __typename?: 'Grade', id: string, name?: string | null, position?: number | null } | null };

export type RestrictProgramFragment = { __typename?: 'Program', id: string, name: string, image?: string | null, description?: string | null, favorite?: boolean | null, lastUsed?: string | null, isTest?: boolean | null, isParentCourse?: boolean | null, isSpecial?: boolean | null, order?: number | null, country?: string | null, coverVideo?: string | null, meta?: string | null, isCustomized?: boolean | null, progress?: number | null, grade?: { __typename?: 'Grade', id: string, name?: string | null, position?: number | null } | null };

export type SpecialProgramFragment = { __typename?: 'SpecialProgram', id: string, iconType: string, name: string, adminOnly?: boolean | null, position?: number | null, program: { __typename?: 'Program', id: string, name: string, grade?: { __typename?: 'Grade', position?: number | null } | null } };

export type EditProgramFragment = { __typename?: 'Program', id: string, name: string, image?: string | null, description?: string | null, isParentCourse?: boolean | null, country?: string | null, coverVideo?: string | null, grade?: { __typename?: 'Grade', id: string } | null };

export type ExtendedUnitFragment = { __typename?: 'Unit', id: string, name: string, uniqueName?: string | null, subHeading?: string | null, skill: string, coverImage?: string | null, popupCover?: string | null, type: string, country?: string | null, default: boolean, description?: string | null, courseId?: string | null, pace?: string | null, tags?: string | null, teacherBox?: string | null, teacherImage?: string | null, box1?: string | null, box2?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, progress?: number | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, isNew?: boolean | null, newLabelPosition?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonLabelPosition?: string | null, comingSoonAt?: string | null, competency?: string | null, unitStudyBox?: string | null, unitStudyHeading?: string | null, isNewCover?: boolean | null, categories?: string | null, suggestedLessonCount?: number | null, suggestedDuration?: string | null, isEducatorCaregiverLessonLayout?: boolean | null, teacherPreparation?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null> | null, alternateMaterials?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null> | null, classPresentation?: Array<{ __typename?: 'Lesson', id: string, name: string, uniqueName?: string | null, description?: string | null, number?: number | null, master?: boolean | null, image?: string | null, duration?: number | null, descriptionHeading?: string | null, descriptionAnswers?: string | null, prerequisite?: boolean | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, status?: string | null, lastVisitedAt?: string | null, group?: string | null, progress?: number | null, alternativeActivated?: boolean | null, isAlternative?: boolean | null, modules?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null }> | null, materials?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null }> | null, sections?: Array<{ __typename?: 'Section', id: string, name: string, position?: number | null, progress?: number | null, status?: string | null, modules?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null }> | null }> | null } | null> | null, studyGuides?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null> | null, studyGuideMaterials?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null> | null, unitStudyReview?: { __typename?: 'UnitStudyReview', status: string } | null };

export type ShortenUnitFragment = { __typename?: 'Unit', id: string, name: string, uniqueName?: string | null, subHeading?: string | null, skill: string, coverImage?: string | null, popupCover?: string | null, type: string, country?: string | null, default: boolean, description?: string | null, courseId?: string | null, pace?: string | null, tags?: string | null, teacherBox?: string | null, teacherImage?: string | null, box1?: string | null, box2?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, progress?: number | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, isNew?: boolean | null, newLabelPosition?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonLabelPosition?: string | null, comingSoonAt?: string | null, competency?: string | null, unitStudyBox?: string | null, unitStudyHeading?: string | null, isNewCover?: boolean | null, categories?: string | null, suggestedLessonCount?: number | null, suggestedDuration?: string | null, isEducatorCaregiverLessonLayout?: boolean | null, teacherPreparation?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null> | null, classPresentation?: Array<{ __typename?: 'Lesson', id: string, name: string, uniqueName?: string | null, description?: string | null, number?: number | null, master?: boolean | null, image?: string | null, duration?: number | null, descriptionHeading?: string | null, descriptionAnswers?: string | null, prerequisite?: boolean | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, status?: string | null, lastVisitedAt?: string | null, group?: string | null, progress?: number | null, alternativeActivated?: boolean | null, isAlternative?: boolean | null, modules?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null }> | null, materials?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null }> | null, sections?: Array<{ __typename?: 'Section', id: string, name: string, position?: number | null, progress?: number | null, status?: string | null, modules?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null }> | null }> | null } | null> | null, studyGuides?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null> | null, studyGuideMaterials?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null> | null, unitStudyReview?: { __typename?: 'UnitStudyReview', status: string } | null };

export type ExtendedHeaUnitFragment = { __typename?: 'HEAUnit', id: string, originalUnitId: string, name: string, subHeading?: string | null, coverImage?: string | null, popupCover?: string | null, pace?: string | null, topics?: string | null, tags?: string | null, box1?: string | null, box2?: string | null, description?: string | null, parentBox?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, parentImage?: string | null, ageGroup?: string | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, parentPreparation?: Array<{ __typename?: 'HEAModule', id: string, originalModuleId?: string | null, name: string, type: ContentType, data?: string | null, position?: number | null, formData?: string | null, meta?: string | null }> | null, classPresentation?: Array<{ __typename?: 'HEALesson', id: string, originalLessonId: string, name: string, description?: string | null, number?: number | null, image?: string | null, duration?: number | null, descriptionHeading?: string | null, descriptionAnswers?: string | null, prerequisite?: boolean | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, group?: string | null, modules?: Array<{ __typename?: 'HEAPresentationModule', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, useDefault?: boolean | null }> | null }> | null };

export type ExtendedUnitWithHeaFragment = { __typename?: 'Unit', hea?: boolean | null, id: string, name: string, uniqueName?: string | null, subHeading?: string | null, skill: string, coverImage?: string | null, popupCover?: string | null, type: string, country?: string | null, default: boolean, description?: string | null, courseId?: string | null, pace?: string | null, tags?: string | null, teacherBox?: string | null, teacherImage?: string | null, box1?: string | null, box2?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, progress?: number | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, isNew?: boolean | null, newLabelPosition?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonLabelPosition?: string | null, comingSoonAt?: string | null, competency?: string | null, unitStudyBox?: string | null, unitStudyHeading?: string | null, isNewCover?: boolean | null, categories?: string | null, suggestedLessonCount?: number | null, suggestedDuration?: string | null, isEducatorCaregiverLessonLayout?: boolean | null, teacherPreparation?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null> | null, alternateMaterials?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null> | null, classPresentation?: Array<{ __typename?: 'Lesson', id: string, name: string, uniqueName?: string | null, description?: string | null, number?: number | null, master?: boolean | null, image?: string | null, duration?: number | null, descriptionHeading?: string | null, descriptionAnswers?: string | null, prerequisite?: boolean | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, status?: string | null, lastVisitedAt?: string | null, group?: string | null, progress?: number | null, alternativeActivated?: boolean | null, isAlternative?: boolean | null, modules?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null }> | null, materials?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null }> | null, sections?: Array<{ __typename?: 'Section', id: string, name: string, position?: number | null, progress?: number | null, status?: string | null, modules?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null }> | null }> | null } | null> | null, studyGuides?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null> | null, studyGuideMaterials?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null> | null, studentQuizzes?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null> | null, unitStudyReview?: { __typename?: 'UnitStudyReview', status: string } | null };

export type SchoolDataFragment = { __typename?: 'School', id: string, name: string, status?: string | null, exitTicketCC?: string | null, preProgramQuizCC?: string | null, disabledPwLogin?: boolean | null, groups?: Array<{ __typename?: 'ProgramType', id: string, name: string } | null> | null, dataCollections?: Array<{ __typename?: 'SurveyType', id: string, name: string } | null> | null, courses?: Array<{ __typename?: 'Program', id: string } | null> | null };

export type ExtendedCustomerFragment = { __typename?: 'ExtendedCustomer', id: string, name: string, trial?: boolean | null, country?: string | null, state?: string | null, city?: string | null, expiry?: string | null, disabledPwLogin?: boolean | null, dataCollections?: Array<{ __typename?: 'DataCollectionsSimplified', id: string, name?: string | null } | null> | null };

export type GroupContentFragment = { __typename?: 'GroupContent', contentId: string, groupId: string, data?: string | null, meta?: string | null, formData?: string | null };

export type HeaPresentationModuleFragment = { __typename?: 'HEAPresentationModule', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, useDefault?: boolean | null };

export type SchoolProgramIdFragment = { __typename?: 'SchoolProgramID', id: string, customized?: boolean | null, newId?: string | null };

export type CustomizedProgramFragment = { __typename?: 'CustomizedProgram', programId: string, primary?: Array<string | null> | null, additional?: Array<string | null> | null };

export type LastVisitedLessonContentFragment = { __typename?: 'LastVisitedLesson', userId: string, lessonId: string, moduleId: string, unitId: string, pageNumber?: number | null, status: string, lastVisitedAt: string, sectionId?: string | null };

export type SllLastVisitedModuleFragment = { __typename?: 'SLLLastVisitedModule', lastVisitedAt: string, lessonId: string, moduleId: string, pageNumber?: number | null, status: string };

export type LastVisitedUnitStudyReviewContentFragment = { __typename?: 'LastVisitedUnitStudyReview', lastVisitedAt: string, moduleId: string, pageNumber?: number | null, status: string, unitId: string, userId: string };

export type ProgramLastUsedContentFragment = { __typename?: 'ProgramLastUsed', userId: string, programId: string, lastUsed: string };

export type FeedbackFormContentFragment = { __typename?: 'FeedbackFormContent', id: string, programName?: string | null, unitName?: string | null, lessonName?: string | null, className?: string | null, createdAt?: string | null, exitTicketCount?: number | null, expirationAt?: string | null, formData?: string | null, isCancelled?: boolean | null, type?: number | null, link?: string | null, grade: string, mcId?: string | null, mcName?: string | null, collectionId?: string | null, collectionName?: string | null, createdBy?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, disabled?: boolean | null, role: string, status: string, updatedAt?: string | null, admin?: string | null, districtSchools?: string | null, completedLessonCount?: number | null, schoolNewYearInfo?: string | null, disabledPwLogin?: boolean | null, autoLogoutEnabled?: boolean | null, customer?: { __typename?: 'Customer', id: string, name: string, country?: string | null, trial?: boolean | null, state?: string | null } | null, schools?: Array<{ __typename?: 'School', id: string, name: string, groupIds?: string | null, isPrimary?: boolean | null, programs?: string | null, grades?: string | null } | null> | null } | null };

export type AbsentStudentLessonFragment = { __typename?: 'AbsentStudentLesson', id: string, createdBy: string, expireAt: string, generatedAt: string, isActive: boolean, isSLL: boolean, lessonId: string, link: string, studentsCount: number };

export type HeaGroupModuleFragment = { __typename?: 'HEAGroupModule', moduleId: string, groupId: string, groupName?: string | null, data?: string | null, meta?: string | null, formData?: string | null };

export type LessonToConfirmFragment = { __typename?: 'LessonToConfirm', studyplanId: string, studyplanName: string, unitId: string, incomplete?: boolean | null, lesson?: { __typename?: 'HEALesson', id: string, originalLessonId: string, name: string, description?: string | null, number?: number | null, image?: string | null, duration?: number | null, descriptionHeading?: string | null, descriptionAnswers?: string | null, prerequisite?: boolean | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, group?: string | null, modules?: Array<{ __typename?: 'HEAPresentationModule', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, useDefault?: boolean | null }> | null } | null };

export type SllCourseFragment = { __typename?: 'SLLCourse', id: string, name: string, color?: string | null, darkColor?: string | null, lessonIds?: Array<string> | null };

export type LessonInProgressFragment = { __typename?: 'LessonInProgress', completionCount?: number | null, lastCompletedAt?: string | null, lessonId: string, lessonName: string, progress?: number | null, status: string, unitId?: string | null, unitName?: string | null, gradeName?: string | null };

export type QuizFragment = { __typename?: 'Quiz', id: string, name: string, unitIds?: Array<string> | null, color?: string | null, darkColor?: string | null, feedbackForm?: { __typename?: 'FeedbackFormContent', id: string, programName?: string | null, unitName?: string | null, lessonName?: string | null, className?: string | null, createdAt?: string | null, exitTicketCount?: number | null, expirationAt?: string | null, formData?: string | null, isCancelled?: boolean | null, type?: number | null, link?: string | null } | null };

export type LessonDetailsFragment = { __typename?: 'LessonDetails', completedAt: string, lessonId?: string | null, lessonName?: string | null, lessonPosition?: string | null, unitId?: string | null, unitName?: string | null, lessonType?: string | null, type?: string | null };

export type CourseLessonFragment = { __typename?: 'CourseLesson', completedLessons?: number | null, teacherName?: string | null, schoolName?: string | null, grade?: string | null, items?: Array<{ __typename?: 'LessonDetails', completedAt: string, lessonId?: string | null, lessonName?: string | null, lessonPosition?: string | null, unitId?: string | null, unitName?: string | null, lessonType?: string | null, type?: string | null } | null> | null };

export type LessonByCourseFragment = { __typename?: 'LessonByCourse', grade?: string | null, lessonsCompleted?: number | null, progress?: number | null, lessons?: Array<{ __typename?: 'CourseLesson', completedLessons?: number | null, teacherName?: string | null, schoolName?: string | null, grade?: string | null, items?: Array<{ __typename?: 'LessonDetails', completedAt: string, lessonId?: string | null, lessonName?: string | null, lessonPosition?: string | null, unitId?: string | null, unitName?: string | null, lessonType?: string | null, type?: string | null } | null> | null } | null> | null };

export type SimpleMultiCollectionFragment = { __typename?: 'MultiCollection', country: string, grade: string, id: string, description?: string | null, hidden?: boolean | null, name: string, position?: number | null };

export type SllProgramFragment = { __typename?: 'SLLProgram', avgDuration?: string | null, bannerDesc?: string | null, bannerImage?: string | null, country: string, description?: string | null, grade?: string | null, id: string, isShown: boolean, labels?: string | null, learnMoreDesc?: string | null, name: string, numberOfLessons?: string | null, tier?: string | null, iconUrl?: string | null, hoverText?: string | null, position?: number | null, mcs?: Array<{ __typename?: 'MultiCollection', country: string, grade: string, id: string, description?: string | null, hidden?: boolean | null, name: string, position?: number | null } | null> | null };

export type SchoolUserFragment = { __typename?: 'SchoolUser', id: string, email: string, firstName: string, lastName: string, status: string, role: string, admin?: string | null, districtSchools?: string | null, lastLoginAt?: string | null, totalLogins: number, customer?: { __typename?: 'Customer', id: string, name: string, trial?: boolean | null } | null, schools?: Array<{ __typename?: 'School', id: string, name: string } | null> | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'User', subject?: string | null, firstLoginFormFilled?: boolean | null, usages?: string | null, roleDesc?: string | null, createdAt?: string | null, previousLoginAt?: string | null, id: string, firstName: string, lastName: string, email: string, disabled?: boolean | null, role: string, status: string, updatedAt?: string | null, admin?: string | null, districtSchools?: string | null, completedLessonCount?: number | null, schoolNewYearInfo?: string | null, disabledPwLogin?: boolean | null, autoLogoutEnabled?: boolean | null, position?: { __typename?: 'Position', id: string, name: string } | null, uiStatus?: { __typename?: 'UIStatus', isLLDescriptionHidden?: boolean | null, isSVDescriptionHidden?: boolean | null, isTDescriptionHidden?: boolean | null, isSIDescriptionHidden?: boolean | null, isBBDescriptionHidden?: boolean | null, isSBDescriptionHidden?: boolean | null, isCCDescriptionHidden?: boolean | null } | null, customer?: { __typename?: 'Customer', id: string, name: string, country?: string | null, trial?: boolean | null, state?: string | null } | null, schools?: Array<{ __typename?: 'School', id: string, name: string, groupIds?: string | null, isPrimary?: boolean | null, programs?: string | null, grades?: string | null } | null> | null } | null };

export type CheckAccessQueryVariables = Exact<{
  input: UserIdInput;
}>;


export type CheckAccessQuery = { __typename?: 'Query', checkAccess: boolean };

export type ParentProgramsQueryVariables = Exact<{ [key: string]: never; }>;


export type ParentProgramsQuery = { __typename?: 'Query', parentPrograms?: Array<{ __typename?: 'Program', id: string, name: string, image?: string | null, description?: string | null, favorite?: boolean | null, lastUsed?: string | null, isTest?: boolean | null, isParentCourse?: boolean | null, isSpecial?: boolean | null, order?: number | null, country?: string | null, coverVideo?: string | null, meta?: string | null, isCustomized?: boolean | null, progress?: number | null, primary?: Array<{ __typename?: 'Unit', id: string, name: string, uniqueName?: string | null, subHeading?: string | null, skill: string, coverImage?: string | null, popupCover?: string | null, type: string, country?: string | null, default: boolean, description?: string | null, courseId?: string | null, pace?: string | null, tags?: string | null, teacherBox?: string | null, teacherImage?: string | null, box1?: string | null, box2?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, progress?: number | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, isNew?: boolean | null, newLabelPosition?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonLabelPosition?: string | null, comingSoonAt?: string | null, competency?: string | null, unitStudyBox?: string | null, unitStudyHeading?: string | null, isNewCover?: boolean | null, categories?: string | null, suggestedLessonCount?: number | null, suggestedDuration?: string | null, isEducatorCaregiverLessonLayout?: boolean | null, unitStudyReview?: { __typename?: 'UnitStudyReview', status: string } | null }> | null, additional?: Array<{ __typename?: 'Unit', id: string, name: string, uniqueName?: string | null, subHeading?: string | null, skill: string, coverImage?: string | null, popupCover?: string | null, type: string, country?: string | null, default: boolean, description?: string | null, courseId?: string | null, pace?: string | null, tags?: string | null, teacherBox?: string | null, teacherImage?: string | null, box1?: string | null, box2?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, progress?: number | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, isNew?: boolean | null, newLabelPosition?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonLabelPosition?: string | null, comingSoonAt?: string | null, competency?: string | null, unitStudyBox?: string | null, unitStudyHeading?: string | null, isNewCover?: boolean | null, categories?: string | null, suggestedLessonCount?: number | null, suggestedDuration?: string | null, isEducatorCaregiverLessonLayout?: boolean | null, unitStudyReview?: { __typename?: 'UnitStudyReview', status: string } | null }> | null, grade?: { __typename?: 'Grade', id: string, name?: string | null, position?: number | null } | null } | null> | null, parentSpecialPrograms?: Array<{ __typename?: 'SpecialProgram', id: string, iconType: string, name: string, adminOnly?: boolean | null, position?: number | null, program: { __typename?: 'Program', id: string, name: string, image?: string | null, description?: string | null, favorite?: boolean | null, lastUsed?: string | null, isTest?: boolean | null, isParentCourse?: boolean | null, isSpecial?: boolean | null, order?: number | null, country?: string | null, coverVideo?: string | null, meta?: string | null, isCustomized?: boolean | null, progress?: number | null, primary?: Array<{ __typename?: 'Unit', id: string, name: string, uniqueName?: string | null, subHeading?: string | null, skill: string, coverImage?: string | null, popupCover?: string | null, type: string, country?: string | null, default: boolean, description?: string | null, courseId?: string | null, pace?: string | null, tags?: string | null, teacherBox?: string | null, teacherImage?: string | null, box1?: string | null, box2?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, progress?: number | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, isNew?: boolean | null, newLabelPosition?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonLabelPosition?: string | null, comingSoonAt?: string | null, competency?: string | null, unitStudyBox?: string | null, unitStudyHeading?: string | null, isNewCover?: boolean | null, categories?: string | null, suggestedLessonCount?: number | null, suggestedDuration?: string | null, isEducatorCaregiverLessonLayout?: boolean | null, unitStudyReview?: { __typename?: 'UnitStudyReview', status: string } | null }> | null, additional?: Array<{ __typename?: 'Unit', id: string, name: string, uniqueName?: string | null, subHeading?: string | null, skill: string, coverImage?: string | null, popupCover?: string | null, type: string, country?: string | null, default: boolean, description?: string | null, courseId?: string | null, pace?: string | null, tags?: string | null, teacherBox?: string | null, teacherImage?: string | null, box1?: string | null, box2?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, progress?: number | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, isNew?: boolean | null, newLabelPosition?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonLabelPosition?: string | null, comingSoonAt?: string | null, competency?: string | null, unitStudyBox?: string | null, unitStudyHeading?: string | null, isNewCover?: boolean | null, categories?: string | null, suggestedLessonCount?: number | null, suggestedDuration?: string | null, isEducatorCaregiverLessonLayout?: boolean | null, unitStudyReview?: { __typename?: 'UnitStudyReview', status: string } | null }> | null, grade?: { __typename?: 'Grade', id: string, name?: string | null, position?: number | null } | null } } | null> | null };

export type GetProgramByIdQueryVariables = Exact<{
  input: IdInput;
}>;


export type GetProgramByIdQuery = { __typename?: 'Query', getCourse: { __typename?: 'Program', id: string, name: string, image?: string | null, description?: string | null, isParentCourse?: boolean | null, isSpecial?: boolean | null, order?: number | null, country?: string | null, coverVideo?: string | null, meta?: string | null, primary?: Array<{ __typename?: 'Unit', id: string, name: string, uniqueName?: string | null, subHeading?: string | null, skill: string, coverImage?: string | null, popupCover?: string | null, type: string, country?: string | null, default: boolean, description?: string | null, courseId?: string | null, pace?: string | null, tags?: string | null, teacherBox?: string | null, teacherImage?: string | null, box1?: string | null, box2?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, progress?: number | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, isNew?: boolean | null, newLabelPosition?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonLabelPosition?: string | null, comingSoonAt?: string | null, competency?: string | null, unitStudyBox?: string | null, unitStudyHeading?: string | null, isNewCover?: boolean | null, categories?: string | null, suggestedLessonCount?: number | null, suggestedDuration?: string | null, isEducatorCaregiverLessonLayout?: boolean | null, unitStudyReview?: { __typename?: 'UnitStudyReview', status: string } | null }> | null, additional?: Array<{ __typename?: 'Unit', id: string, name: string, uniqueName?: string | null, subHeading?: string | null, skill: string, coverImage?: string | null, popupCover?: string | null, type: string, country?: string | null, default: boolean, description?: string | null, courseId?: string | null, pace?: string | null, tags?: string | null, teacherBox?: string | null, teacherImage?: string | null, box1?: string | null, box2?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, progress?: number | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, isNew?: boolean | null, newLabelPosition?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonLabelPosition?: string | null, comingSoonAt?: string | null, competency?: string | null, unitStudyBox?: string | null, unitStudyHeading?: string | null, isNewCover?: boolean | null, categories?: string | null, suggestedLessonCount?: number | null, suggestedDuration?: string | null, isEducatorCaregiverLessonLayout?: boolean | null, unitStudyReview?: { __typename?: 'UnitStudyReview', status: string } | null }> | null } };

export type GetLasVisitedLessonByProgramIdQueryVariables = Exact<{
  input: IdInput;
}>;


export type GetLasVisitedLessonByProgramIdQuery = { __typename?: 'Query', lastVisitedLesson?: Array<{ __typename?: 'LastVisitedLesson', userId: string, lessonId: string, moduleId: string, unitId: string, pageNumber?: number | null, status: string, lastVisitedAt: string, sectionId?: string | null } | null> | null };

export type GetCourseQueryVariables = Exact<{
  input: IdInput;
}>;


export type GetCourseQuery = { __typename?: 'Query', getCourse: { __typename?: 'Program', id: string, name: string, description?: string | null, image?: string | null, isTest?: boolean | null, isParentCourse?: boolean | null, isSpecial?: boolean | null, country?: string | null, coverVideo?: string | null, meta?: string | null, grade?: { __typename?: 'Grade', id: string, name?: string | null } | null }, getProgramUnits: { __typename?: 'ProgramUnits', primary?: Array<string | null> | null, additional?: Array<string | null> | null } };

export type SkillsQueryVariables = Exact<{ [key: string]: never; }>;


export type SkillsQuery = { __typename?: 'Query', skills?: Array<{ __typename?: 'Skill', id: string, name: string } | null> | null };

export type GetUrlQueryVariables = Exact<{
  input: VideoUploadInput;
}>;


export type GetUrlQuery = { __typename?: 'Query', videoUpload?: { __typename?: 'VideoUpload', uploadId?: string | null, url?: string | null } | null };

export type GetAllUnitsQueryVariables = Exact<{
  input: GetAllUnitsInput;
}>;


export type GetAllUnitsQuery = { __typename?: 'Query', getAllUnits: Array<{ __typename?: 'UnitsByProgram', id?: string | null, name?: string | null, units?: Array<{ __typename?: 'Unit', id: string, name: string, uniqueName?: string | null, subHeading?: string | null, skill: string, coverImage?: string | null, popupCover?: string | null, type: string, country?: string | null, default: boolean, description?: string | null, courseId?: string | null, pace?: string | null, tags?: string | null, teacherBox?: string | null, teacherImage?: string | null, box1?: string | null, box2?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, progress?: number | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, isNew?: boolean | null, newLabelPosition?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonLabelPosition?: string | null, comingSoonAt?: string | null, competency?: string | null, unitStudyBox?: string | null, unitStudyHeading?: string | null, isNewCover?: boolean | null, categories?: string | null, suggestedLessonCount?: number | null, suggestedDuration?: string | null, isEducatorCaregiverLessonLayout?: boolean | null, unitStudyReview?: { __typename?: 'UnitStudyReview', status: string } | null }> | null }> };

export type UnitsQueryVariables = Exact<{ [key: string]: never; }>;


export type UnitsQuery = { __typename?: 'Query', units?: Array<{ __typename?: 'Unit', id: string, name: string, uniqueName?: string | null, subHeading?: string | null, skill: string, coverImage?: string | null, popupCover?: string | null, type: string, country?: string | null, default: boolean, description?: string | null, courseId?: string | null, pace?: string | null, tags?: string | null, teacherBox?: string | null, teacherImage?: string | null, box1?: string | null, box2?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, progress?: number | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, isNew?: boolean | null, newLabelPosition?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonLabelPosition?: string | null, comingSoonAt?: string | null, competency?: string | null, unitStudyBox?: string | null, unitStudyHeading?: string | null, isNewCover?: boolean | null, categories?: string | null, suggestedLessonCount?: number | null, suggestedDuration?: string | null, isEducatorCaregiverLessonLayout?: boolean | null, unitStudyReview?: { __typename?: 'UnitStudyReview', status: string } | null }> | null };

export type GetUnitQueryVariables = Exact<{
  input: IdInput;
}>;


export type GetUnitQuery = { __typename?: 'Query', getUnitInfo: { __typename?: 'Unit', id: string, name: string, uniqueName?: string | null, subHeading?: string | null, skill: string, coverImage?: string | null, popupCover?: string | null, type: string, country?: string | null, default: boolean, description?: string | null, courseId?: string | null, pace?: string | null, tags?: string | null, teacherBox?: string | null, teacherImage?: string | null, box1?: string | null, box2?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, progress?: number | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, isNew?: boolean | null, newLabelPosition?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonLabelPosition?: string | null, comingSoonAt?: string | null, competency?: string | null, unitStudyBox?: string | null, unitStudyHeading?: string | null, isNewCover?: boolean | null, categories?: string | null, suggestedLessonCount?: number | null, suggestedDuration?: string | null, isEducatorCaregiverLessonLayout?: boolean | null, teacherPreparation?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null> | null, alternateMaterials?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null> | null, classPresentation?: Array<{ __typename?: 'Lesson', id: string, name: string, uniqueName?: string | null, description?: string | null, number?: number | null, master?: boolean | null, image?: string | null, duration?: number | null, descriptionHeading?: string | null, descriptionAnswers?: string | null, prerequisite?: boolean | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, status?: string | null, lastVisitedAt?: string | null, group?: string | null, progress?: number | null, alternativeActivated?: boolean | null, isAlternative?: boolean | null, modules?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null }> | null, materials?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null }> | null, sections?: Array<{ __typename?: 'Section', id: string, name: string, position?: number | null, progress?: number | null, status?: string | null, modules?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null }> | null }> | null } | null> | null, studyGuides?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null> | null, studyGuideMaterials?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null> | null, unitStudyReview?: { __typename?: 'UnitStudyReview', status: string } | null } };

export type HeaGetUnitInfoQueryVariables = Exact<{
  input: IdInput;
}>;


export type HeaGetUnitInfoQuery = { __typename?: 'Query', heaGetUnitInfo: { __typename?: 'HEAUnit', id: string, originalUnitId: string, name: string, subHeading?: string | null, coverImage?: string | null, popupCover?: string | null, pace?: string | null, topics?: string | null, tags?: string | null, box1?: string | null, box2?: string | null, description?: string | null, parentBox?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, parentImage?: string | null, ageGroup?: string | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, parentPreparation?: Array<{ __typename?: 'HEAModule', id: string, originalModuleId?: string | null, name: string, type: ContentType, data?: string | null, position?: number | null, formData?: string | null, meta?: string | null }> | null, classPresentation?: Array<{ __typename?: 'HEALesson', id: string, originalLessonId: string, name: string, description?: string | null, number?: number | null, image?: string | null, duration?: number | null, descriptionHeading?: string | null, descriptionAnswers?: string | null, prerequisite?: boolean | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, group?: string | null, modules?: Array<{ __typename?: 'HEAPresentationModule', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, useDefault?: boolean | null }> | null }> | null } };

export type GetUnitInfoForSuperAdminQueryVariables = Exact<{
  input: IdInput;
}>;


export type GetUnitInfoForSuperAdminQuery = { __typename?: 'Query', getUnitInfoForSuperAdmin: { __typename?: 'Unit', hea?: boolean | null, id: string, name: string, uniqueName?: string | null, subHeading?: string | null, skill: string, coverImage?: string | null, popupCover?: string | null, type: string, country?: string | null, default: boolean, description?: string | null, courseId?: string | null, pace?: string | null, tags?: string | null, teacherBox?: string | null, teacherImage?: string | null, box1?: string | null, box2?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, progress?: number | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, isNew?: boolean | null, newLabelPosition?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonLabelPosition?: string | null, comingSoonAt?: string | null, competency?: string | null, unitStudyBox?: string | null, unitStudyHeading?: string | null, isNewCover?: boolean | null, categories?: string | null, suggestedLessonCount?: number | null, suggestedDuration?: string | null, isEducatorCaregiverLessonLayout?: boolean | null, teacherPreparation?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null> | null, alternateMaterials?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null> | null, classPresentation?: Array<{ __typename?: 'Lesson', id: string, name: string, uniqueName?: string | null, description?: string | null, number?: number | null, master?: boolean | null, image?: string | null, duration?: number | null, descriptionHeading?: string | null, descriptionAnswers?: string | null, prerequisite?: boolean | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, status?: string | null, lastVisitedAt?: string | null, group?: string | null, progress?: number | null, alternativeActivated?: boolean | null, isAlternative?: boolean | null, modules?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null }> | null, materials?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null }> | null, sections?: Array<{ __typename?: 'Section', id: string, name: string, position?: number | null, progress?: number | null, status?: string | null, modules?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null }> | null }> | null } | null> | null, studyGuides?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null> | null, studyGuideMaterials?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null> | null, studentQuizzes?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null> | null, unitStudyReview?: { __typename?: 'UnitStudyReview', status: string } | null } };

export type HeaGetUnitInfoForSuperAdminQueryVariables = Exact<{
  input: IdInput;
}>;


export type HeaGetUnitInfoForSuperAdminQuery = { __typename?: 'Query', heaGetUnitInfoForSuperAdmin: { __typename?: 'HEAUnit', id: string, originalUnitId: string, name: string, subHeading?: string | null, coverImage?: string | null, popupCover?: string | null, pace?: string | null, topics?: string | null, tags?: string | null, box1?: string | null, box2?: string | null, description?: string | null, parentBox?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, parentImage?: string | null, ageGroup?: string | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, parentPreparation?: Array<{ __typename?: 'HEAModule', id: string, originalModuleId?: string | null, name: string, type: ContentType, data?: string | null, position?: number | null, formData?: string | null, meta?: string | null }> | null, classPresentation?: Array<{ __typename?: 'HEALesson', id: string, originalLessonId: string, name: string, description?: string | null, number?: number | null, image?: string | null, duration?: number | null, descriptionHeading?: string | null, descriptionAnswers?: string | null, prerequisite?: boolean | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, group?: string | null, modules?: Array<{ __typename?: 'HEAPresentationModule', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, useDefault?: boolean | null }> | null }> | null } };

export type ContentGroupsQueryVariables = Exact<{
  input: IdInput;
}>;


export type ContentGroupsQuery = { __typename?: 'Query', contentGroups?: Array<string | null> | null };

export type EditUnitMutationVariables = Exact<{
  input: EditUnitInput;
}>;


export type EditUnitMutation = { __typename?: 'Mutation', editUnit: { __typename?: 'Unit', id: string, name: string, uniqueName?: string | null, subHeading?: string | null, skill: string, coverImage?: string | null, popupCover?: string | null, type: string, country?: string | null, default: boolean, description?: string | null, courseId?: string | null, pace?: string | null, tags?: string | null, teacherBox?: string | null, teacherImage?: string | null, box1?: string | null, box2?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, progress?: number | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, isNew?: boolean | null, newLabelPosition?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonLabelPosition?: string | null, comingSoonAt?: string | null, competency?: string | null, unitStudyBox?: string | null, unitStudyHeading?: string | null, isNewCover?: boolean | null, categories?: string | null, suggestedLessonCount?: number | null, suggestedDuration?: string | null, isEducatorCaregiverLessonLayout?: boolean | null, unitStudyReview?: { __typename?: 'UnitStudyReview', status: string } | null } };

export type MarkSchoolNewYearModalShownMutationVariables = Exact<{
  input: MarkSchoolNewYearModalShownInput;
}>;


export type MarkSchoolNewYearModalShownMutation = { __typename?: 'Mutation', markSchoolNewYearModalShown: boolean };

export type HeaUpdateUnitMutationVariables = Exact<{
  input: HeaUpdateUnitInput;
}>;


export type HeaUpdateUnitMutation = { __typename?: 'Mutation', heaUpdateUnit: { __typename?: 'HEAUnit', id: string, originalUnitId: string, name: string, subHeading?: string | null, coverImage?: string | null, popupCover?: string | null, pace?: string | null, topics?: string | null, tags?: string | null, box1?: string | null, box2?: string | null, description?: string | null, parentBox?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, parentImage?: string | null, ageGroup?: string | null, sensitive?: boolean | null, sensitiveTooltip?: string | null } };

export type RegisterParentMutationVariables = Exact<{
  input: ParentRegisterInput;
}>;


export type RegisterParentMutation = { __typename?: 'Mutation', registerParent?: { __typename?: 'ParentRegisterOutput', token: string, specialCourseId?: string | null, parentId?: string | null, schoolId?: string | null, schoolName?: string | null } | null };

export type UnsubscribeMutationVariables = Exact<{
  input: UserIdInput;
}>;


export type UnsubscribeMutation = { __typename?: 'Mutation', unsubscribe?: boolean | null };

export type CreateUnitMutationVariables = Exact<{
  input: CreateUnitInput;
}>;


export type CreateUnitMutation = { __typename?: 'Mutation', createUnit: { __typename?: 'Unit', id: string, name: string, uniqueName?: string | null, subHeading?: string | null, skill: string, coverImage?: string | null, popupCover?: string | null, type: string, country?: string | null, default: boolean, description?: string | null, courseId?: string | null, pace?: string | null, tags?: string | null, teacherBox?: string | null, teacherImage?: string | null, box1?: string | null, box2?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, progress?: number | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, isNew?: boolean | null, newLabelPosition?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonLabelPosition?: string | null, comingSoonAt?: string | null, competency?: string | null, unitStudyBox?: string | null, unitStudyHeading?: string | null, isNewCover?: boolean | null, categories?: string | null, suggestedLessonCount?: number | null, suggestedDuration?: string | null, isEducatorCaregiverLessonLayout?: boolean | null, unitStudyReview?: { __typename?: 'UnitStudyReview', status: string } | null } };

export type AddSchoolMutationVariables = Exact<{
  input: AddSchoolInput;
}>;


export type AddSchoolMutation = { __typename?: 'Mutation', addSchool?: { __typename?: 'School', id: string, name: string, status?: string | null, exitTicketCC?: string | null, preProgramQuizCC?: string | null, disabledPwLogin?: boolean | null, groups?: Array<{ __typename?: 'ProgramType', id: string, name: string } | null> | null, dataCollections?: Array<{ __typename?: 'SurveyType', id: string, name: string } | null> | null, courses?: Array<{ __typename?: 'Program', id: string } | null> | null } | null };

export type EditSchoolMutationVariables = Exact<{
  input: EditSchoolInput;
}>;


export type EditSchoolMutation = { __typename?: 'Mutation', editSchool?: { __typename?: 'School', id: string, name: string, status?: string | null, exitTicketCC?: string | null, preProgramQuizCC?: string | null, disabledPwLogin?: boolean | null, groups?: Array<{ __typename?: 'ProgramType', id: string, name: string } | null> | null, dataCollections?: Array<{ __typename?: 'SurveyType', id: string, name: string } | null> | null, courses?: Array<{ __typename?: 'Program', id: string } | null> | null } | null };

export type CreateLessonMutationVariables = Exact<{
  input: IdInput;
}>;


export type CreateLessonMutation = { __typename?: 'Mutation', createLesson?: { __typename?: 'Lesson', id: string, name: string, description?: string | null, number?: number | null, master?: boolean | null, image?: string | null, duration?: number | null, descriptionHeading?: string | null, descriptionAnswers?: string | null, group?: string | null, sensitive?: boolean | null, sensitiveTooltip?: string | null } | null };

export type UpdateLessonMutationVariables = Exact<{
  input?: InputMaybe<LessonUpdateInput>;
}>;


export type UpdateLessonMutation = { __typename?: 'Mutation', updateLesson?: { __typename?: 'Lesson', id: string, name: string, description?: string | null, number?: number | null, image?: string | null, prerequisite?: boolean | null, group?: string | null, descriptionHeading?: string | null, descriptionAnswers?: string | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, alternativeActivated?: boolean | null } | null };

export type DeleteLessonMutationVariables = Exact<{
  input: IdInput;
}>;


export type DeleteLessonMutation = { __typename?: 'Mutation', deleteLesson: boolean };

export type DeleteUnitMutationVariables = Exact<{
  input: IdInput;
}>;


export type DeleteUnitMutation = { __typename?: 'Mutation', deleteUnit: boolean };

export type HeaDeleteUnitMutationVariables = Exact<{
  input: IdInput;
}>;


export type HeaDeleteUnitMutation = { __typename?: 'Mutation', heaDeleteUnit: boolean };

export type MoveModuleMutationVariables = Exact<{
  input: MoveModuleInput;
}>;


export type MoveModuleMutation = { __typename?: 'Mutation', moveModule: boolean };

export type HeaMoveModuleMutationVariables = Exact<{
  input: HeaMoveModuleInput;
}>;


export type HeaMoveModuleMutation = { __typename?: 'Mutation', heaMoveModule: boolean };

export type CreateContentMutationVariables = Exact<{
  input: CreateContentInput;
}>;


export type CreateContentMutation = { __typename?: 'Mutation', createContent?: { __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null };

export type MoveLessonMutationVariables = Exact<{
  input: MoveLessonInput;
}>;


export type MoveLessonMutation = { __typename?: 'Mutation', moveLesson: boolean };

export type UpdateContentMutationVariables = Exact<{
  input: UpdateContentInput;
}>;


export type UpdateContentMutation = { __typename?: 'Mutation', updateContent?: { __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null };

export type UpdateVideoContentMutationVariables = Exact<{
  input: UpdateVideoContentInput;
}>;


export type UpdateVideoContentMutation = { __typename?: 'Mutation', updateVideoContent?: { __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null };

export type RemoveContentMutationVariables = Exact<{
  input: IdInput;
}>;


export type RemoveContentMutation = { __typename?: 'Mutation', removeContent?: boolean | null };

export type CreateNewGroupContentMutationVariables = Exact<{
  input: CreateNewGroupContentInput;
}>;


export type CreateNewGroupContentMutation = { __typename?: 'Mutation', createNewGroupContent?: { __typename?: 'GroupContent', groupName?: string | null, contentId: string, groupId: string, data?: string | null, meta?: string | null, formData?: string | null } | null };

export type UpdateGroupContentMutationVariables = Exact<{
  input: UpdateGroupContentInput;
}>;


export type UpdateGroupContentMutation = { __typename?: 'Mutation', updateGroupContent?: { __typename?: 'GroupContent', contentId: string, groupId: string, data?: string | null, meta?: string | null, formData?: string | null } | null };

export type UpdateVideoGroupContentMutationVariables = Exact<{
  input: UpdateVideoGroupContentInput;
}>;


export type UpdateVideoGroupContentMutation = { __typename?: 'Mutation', updateVideoGroupContent?: { __typename?: 'GroupContent', contentId: string, groupId: string, data?: string | null, meta?: string | null, formData?: string | null } | null };

export type DeleteGroupContentMutationVariables = Exact<{
  input: DeleteGroupModuleInput;
}>;


export type DeleteGroupContentMutation = { __typename?: 'Mutation', deleteGroupContent?: boolean | null };

export type DeleteModuleDataMutationVariables = Exact<{
  input: IdInput;
}>;


export type DeleteModuleDataMutation = { __typename?: 'Mutation', deleteModuleData?: boolean | null };

export type HeaDeleteModuleMutationVariables = Exact<{
  input: IdInput;
}>;


export type HeaDeleteModuleMutation = { __typename?: 'Mutation', heaDeleteModule?: boolean | null };

export type DeleteGroupModuleDataMutationVariables = Exact<{
  input: DeleteGroupModuleInput;
}>;


export type DeleteGroupModuleDataMutation = { __typename?: 'Mutation', deleteGroupModuleData?: boolean | null };

export type CalendarEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type CalendarEventsQuery = { __typename?: 'Query', calendarEvents?: { __typename?: 'OfficeHourEvents', onboarding: { __typename?: 'CalendarEventType', isInMeeting: boolean, timeLeftInSec: number }, clinical: { __typename?: 'CalendarEventType', isInMeeting: boolean, timeLeftInSec: number } } | null };

export type AccountSchoolsQueryVariables = Exact<{
  input: UserIdInput;
}>;


export type AccountSchoolsQuery = { __typename?: 'Query', accountSchools?: { __typename?: 'AccountSchool', schools?: Array<{ __typename?: 'School', id: string, name: string, disabledPwLogin?: boolean | null, status?: string | null, exitTicketCC?: string | null, preProgramQuizCC?: string | null, grades?: string | null, programs?: string | null, groups?: Array<{ __typename?: 'ProgramType', id: string, name: string } | null> | null, dataCollections?: Array<{ __typename?: 'SurveyType', id: string, name: string } | null> | null, courses?: Array<{ __typename?: 'Program', id: string } | null> | null } | null> | null, groups?: Array<{ __typename?: 'ProgramType', id: string, name: string } | null> | null, dataCollections?: Array<{ __typename?: 'SurveyType', id: string, name: string } | null> | null } | null };

export type GetAccountSchoolsQueryVariables = Exact<{
  input: UserIdInput;
}>;


export type GetAccountSchoolsQuery = { __typename?: 'Query', accountSchools?: { __typename?: 'AccountSchool', schools?: Array<{ __typename?: 'School', name: string, id: string } | null> | null } | null };

export type SchoolUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type SchoolUsersQuery = { __typename?: 'Query', schoolUsers?: Array<{ __typename?: 'SchoolUser', id: string, email: string, firstName: string, lastName: string, status: string, role: string, admin?: string | null, districtSchools?: string | null, lastLoginAt?: string | null, totalLogins: number, customer?: { __typename?: 'Customer', id: string, name: string, trial?: boolean | null } | null, schools?: Array<{ __typename?: 'School', id: string, name: string } | null> | null } | null> | null };

export type UsersQueryVariables = Exact<{
  input: SearchUsersInput;
}>;


export type UsersQuery = { __typename?: 'Query', users?: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string, email: string, disabled?: boolean | null, role: string, status: string, updatedAt?: string | null, admin?: string | null, districtSchools?: string | null, completedLessonCount?: number | null, schoolNewYearInfo?: string | null, disabledPwLogin?: boolean | null, autoLogoutEnabled?: boolean | null, customer?: { __typename?: 'Customer', id: string, name: string, country?: string | null, trial?: boolean | null, state?: string | null } | null, schools?: Array<{ __typename?: 'School', id: string, name: string, groupIds?: string | null, isPrimary?: boolean | null, programs?: string | null, grades?: string | null } | null> | null } | null> | null };

export type AccountUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountUsersQuery = { __typename?: 'Query', accountUsers?: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string, email: string, disabled?: boolean | null, role: string, status: string, updatedAt?: string | null, admin?: string | null, districtSchools?: string | null, completedLessonCount?: number | null, schoolNewYearInfo?: string | null, disabledPwLogin?: boolean | null, autoLogoutEnabled?: boolean | null, customer?: { __typename?: 'Customer', id: string, name: string, country?: string | null, trial?: boolean | null, state?: string | null } | null, schools?: Array<{ __typename?: 'School', id: string, name: string, groupIds?: string | null, isPrimary?: boolean | null, programs?: string | null, grades?: string | null } | null> | null } | null> | null };

export type GetContentAllGroupsQueryVariables = Exact<{
  input: IdInput;
}>;


export type GetContentAllGroupsQuery = { __typename?: 'Query', getContentAllGroups?: { __typename?: 'AllContent', groups?: Array<{ __typename?: 'GroupContent', groupName?: string | null, contentId: string, groupId: string, data?: string | null, meta?: string | null, formData?: string | null }> | null } | null };

export type AllProgramsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllProgramsQuery = { __typename?: 'Query', allPrograms?: Array<{ __typename?: 'Program', id: string, name: string, image?: string | null, description?: string | null, favorite?: boolean | null, lastUsed?: string | null, isTest?: boolean | null, isParentCourse?: boolean | null, isSpecial?: boolean | null, order?: number | null, country?: string | null, coverVideo?: string | null, meta?: string | null, isCustomized?: boolean | null, progress?: number | null, primary?: Array<{ __typename?: 'Unit', id: string, name: string, uniqueName?: string | null, subHeading?: string | null, skill: string, coverImage?: string | null, popupCover?: string | null, type: string, country?: string | null, default: boolean, description?: string | null, courseId?: string | null, pace?: string | null, tags?: string | null, teacherBox?: string | null, teacherImage?: string | null, box1?: string | null, box2?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, progress?: number | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, isNew?: boolean | null, newLabelPosition?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonLabelPosition?: string | null, comingSoonAt?: string | null, competency?: string | null, unitStudyBox?: string | null, unitStudyHeading?: string | null, isNewCover?: boolean | null, categories?: string | null, suggestedLessonCount?: number | null, suggestedDuration?: string | null, isEducatorCaregiverLessonLayout?: boolean | null, unitStudyReview?: { __typename?: 'UnitStudyReview', status: string } | null }> | null, additional?: Array<{ __typename?: 'Unit', id: string, name: string, uniqueName?: string | null, subHeading?: string | null, skill: string, coverImage?: string | null, popupCover?: string | null, type: string, country?: string | null, default: boolean, description?: string | null, courseId?: string | null, pace?: string | null, tags?: string | null, teacherBox?: string | null, teacherImage?: string | null, box1?: string | null, box2?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, progress?: number | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, isNew?: boolean | null, newLabelPosition?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonLabelPosition?: string | null, comingSoonAt?: string | null, competency?: string | null, unitStudyBox?: string | null, unitStudyHeading?: string | null, isNewCover?: boolean | null, categories?: string | null, suggestedLessonCount?: number | null, suggestedDuration?: string | null, isEducatorCaregiverLessonLayout?: boolean | null, unitStudyReview?: { __typename?: 'UnitStudyReview', status: string } | null }> | null, grade?: { __typename?: 'Grade', id: string, name?: string | null, position?: number | null } | null } | null> | null };

export type CustomersQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomersQuery = { __typename?: 'Query', allCustomers?: Array<{ __typename?: 'ExtendedCustomer', id: string, name: string, trial?: boolean | null, country?: string | null, state?: string | null, city?: string | null, expiry?: string | null, disabledPwLogin?: boolean | null, dataCollections?: Array<{ __typename?: 'DataCollectionsSimplified', id: string, name?: string | null } | null> | null } | null> | null };

export type GetSchoolCoursesQueryVariables = Exact<{
  input: UserIdInput;
}>;


export type GetSchoolCoursesQuery = { __typename?: 'Query', getSchoolCourses?: { __typename?: 'SchoolPrograms', programIds?: Array<{ __typename?: 'SchoolProgramID', id: string, customized?: boolean | null, newId?: string | null }> | null } | null };

export type CustomizeCoursesForSchoolMutationVariables = Exact<{
  input: CustomizeCoursesForSchoolInput;
}>;


export type CustomizeCoursesForSchoolMutation = { __typename?: 'Mutation', customizeCoursesForSchool?: boolean | null };

export type DeleteProgramMutationVariables = Exact<{
  input: IdInput;
}>;


export type DeleteProgramMutation = { __typename?: 'Mutation', deleteProgram?: boolean | null };

export type SaveProgramUnitsMutationVariables = Exact<{
  input: SaveProgramUnitsInput;
}>;


export type SaveProgramUnitsMutation = { __typename?: 'Mutation', saveProgramUnits?: boolean | null };

export type DuplicateCourseMutationVariables = Exact<{
  input: DuplicateCourseInput;
}>;


export type DuplicateCourseMutation = { __typename?: 'Mutation', duplicateCourse: string };

export type UpdateProgramMutationVariables = Exact<{
  input?: InputMaybe<ProgramEditInput>;
}>;


export type UpdateProgramMutation = { __typename?: 'Mutation', updateProgram?: { __typename?: 'Program', id: string, name: string, image?: string | null, description?: string | null, isParentCourse?: boolean | null, country?: string | null, coverVideo?: string | null, grade?: { __typename?: 'Grade', id: string } | null } | null };

export type UpdateLastVisitedLessonMutationVariables = Exact<{
  input?: InputMaybe<LastVisitedLessonInput>;
}>;


export type UpdateLastVisitedLessonMutation = { __typename?: 'Mutation', updateLastVisitedLesson?: { __typename?: 'LastVisitedLesson', userId: string, lessonId: string, moduleId: string, unitId: string, pageNumber?: number | null, status: string, lastVisitedAt: string, sectionId?: string | null } | null };

export type ProgramsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProgramsQuery = { __typename?: 'Query', programs?: Array<{ __typename?: 'Program', id: string, name: string, image?: string | null, description?: string | null, favorite?: boolean | null, lastUsed?: string | null, isTest?: boolean | null, isParentCourse?: boolean | null, isSpecial?: boolean | null, order?: number | null, country?: string | null, coverVideo?: string | null, meta?: string | null, isCustomized?: boolean | null, progress?: number | null, primary?: Array<{ __typename?: 'Unit', id: string, name: string, uniqueName?: string | null, subHeading?: string | null, skill: string, coverImage?: string | null, popupCover?: string | null, type: string, country?: string | null, default: boolean, description?: string | null, courseId?: string | null, pace?: string | null, tags?: string | null, teacherBox?: string | null, teacherImage?: string | null, box1?: string | null, box2?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, progress?: number | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, isNew?: boolean | null, newLabelPosition?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonLabelPosition?: string | null, comingSoonAt?: string | null, competency?: string | null, unitStudyBox?: string | null, unitStudyHeading?: string | null, isNewCover?: boolean | null, categories?: string | null, suggestedLessonCount?: number | null, suggestedDuration?: string | null, isEducatorCaregiverLessonLayout?: boolean | null, unitStudyReview?: { __typename?: 'UnitStudyReview', status: string } | null }> | null, additional?: Array<{ __typename?: 'Unit', id: string, name: string, uniqueName?: string | null, subHeading?: string | null, skill: string, coverImage?: string | null, popupCover?: string | null, type: string, country?: string | null, default: boolean, description?: string | null, courseId?: string | null, pace?: string | null, tags?: string | null, teacherBox?: string | null, teacherImage?: string | null, box1?: string | null, box2?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, progress?: number | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, isNew?: boolean | null, newLabelPosition?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonLabelPosition?: string | null, comingSoonAt?: string | null, competency?: string | null, unitStudyBox?: string | null, unitStudyHeading?: string | null, isNewCover?: boolean | null, categories?: string | null, suggestedLessonCount?: number | null, suggestedDuration?: string | null, isEducatorCaregiverLessonLayout?: boolean | null, unitStudyReview?: { __typename?: 'UnitStudyReview', status: string } | null }> | null, grade?: { __typename?: 'Grade', id: string, name?: string | null, position?: number | null } | null } | null> | null };

export type GetAllProgramsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllProgramsQuery = { __typename?: 'Query', programs?: Array<{ __typename?: 'Program', id: string, name: string, image?: string | null, description?: string | null, favorite?: boolean | null, lastUsed?: string | null, isTest?: boolean | null, isParentCourse?: boolean | null, isSpecial?: boolean | null, order?: number | null, country?: string | null, coverVideo?: string | null, meta?: string | null, isCustomized?: boolean | null, progress?: number | null, grade?: { __typename?: 'Grade', id: string, name?: string | null, position?: number | null } | null } | null> | null };

export type CreateFeedbackFormMutationVariables = Exact<{
  input: FeedbackFormContentInput;
}>;


export type CreateFeedbackFormMutation = { __typename?: 'Mutation', createFeedbackForm?: { __typename?: 'FeedbackFormContent', id: string, programName?: string | null, unitName?: string | null, lessonName?: string | null, className?: string | null, createdAt?: string | null, exitTicketCount?: number | null, expirationAt?: string | null, formData?: string | null, isCancelled?: boolean | null, type?: number | null, link?: string | null, grade: string, mcId?: string | null, mcName?: string | null, collectionId?: string | null, collectionName?: string | null, createdBy?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, disabled?: boolean | null, role: string, status: string, updatedAt?: string | null, admin?: string | null, districtSchools?: string | null, completedLessonCount?: number | null, schoolNewYearInfo?: string | null, disabledPwLogin?: boolean | null, autoLogoutEnabled?: boolean | null, customer?: { __typename?: 'Customer', id: string, name: string, country?: string | null, trial?: boolean | null, state?: string | null } | null, schools?: Array<{ __typename?: 'School', id: string, name: string, groupIds?: string | null, isPrimary?: boolean | null, programs?: string | null, grades?: string | null } | null> | null } | null } | null };

export type UpdateLessonCompleteStatusMutationVariables = Exact<{
  input: UpdateLessonCompleteStatusInput;
}>;


export type UpdateLessonCompleteStatusMutation = { __typename?: 'Mutation', updateLessonCompleteStatus: boolean };

export type MoveUnitMutationVariables = Exact<{
  input: MoveUnitInput;
}>;


export type MoveUnitMutation = { __typename?: 'Mutation', moveUnit?: boolean | null };

export type MoveCourseContentMutationVariables = Exact<{
  input: MoveCourseContentInput;
}>;


export type MoveCourseContentMutation = { __typename?: 'Mutation', moveCourseContent?: boolean | null };

export type UpdateProgramLastUsedMutationVariables = Exact<{
  input: IdInput;
}>;


export type UpdateProgramLastUsedMutation = { __typename?: 'Mutation', updateProgramLastUsed?: { __typename?: 'ProgramLastUsed', userId: string, programId: string, lastUsed: string } | null };

export type GenerateDashboardLinkMutationVariables = Exact<{
  input: UserIdInput;
}>;


export type GenerateDashboardLinkMutation = { __typename?: 'Mutation', generateDashboardLink: string };

export type HeaUpdateMeMutationVariables = Exact<{
  input: HeaUpdateMeInput;
}>;


export type HeaUpdateMeMutation = { __typename?: 'Mutation', heaUpdateMe: { __typename?: 'HEAUser', id: string, email: string, firstName?: string | null, lastName?: string | null, status?: string | null, enableFaith?: boolean | null, enablePasscode?: boolean | null } };

export type HeaRegisterMutationVariables = Exact<{
  input: HeaRegisterInput;
}>;


export type HeaRegisterMutation = { __typename?: 'Mutation', heaRegister: { __typename?: 'heaRegisterResponse', id: string, email: string, registeredAt: string } };

export type HeaLoginMutationVariables = Exact<{
  input: HeaLoginInput;
}>;


export type HeaLoginMutation = { __typename?: 'Mutation', heaLogin: { __typename?: 'HEALoginResponse', token: string, user?: { __typename?: 'HEAUser', id: string, email: string, firstName?: string | null, lastName?: string | null, status?: string | null } | null } };

export type CheckUserStatusMutationVariables = Exact<{
  input: HeaCheckUserStatusInput;
}>;


export type CheckUserStatusMutation = { __typename?: 'Mutation', heaCheckUserStatus: string };

export type HeaVerifyEmailTokenMutationVariables = Exact<{
  input: HeaVerifyEmailTokenInput;
}>;


export type HeaVerifyEmailTokenMutation = { __typename?: 'Mutation', heaVerifyEmailToken: string };

export type HeaSetPasswordMutationVariables = Exact<{
  input: HeaSetPasswordInput;
}>;


export type HeaSetPasswordMutation = { __typename?: 'Mutation', heaSetPassword: string };

export type HeaCreateUnitMutationVariables = Exact<{
  input: HeaCreateUnitInput;
}>;


export type HeaCreateUnitMutation = { __typename?: 'Mutation', heaCreateUnit: { __typename?: 'HEAUnit', id: string, originalUnitId: string, name: string, subHeading?: string | null, coverImage?: string | null, popupCover?: string | null, pace?: string | null, topics?: string | null, tags?: string | null, box1?: string | null, box2?: string | null, description?: string | null, parentBox?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, parentImage?: string | null, ageGroup?: string | null, sensitive?: boolean | null, sensitiveTooltip?: string | null } };

export type HeaCreateModuleMutationVariables = Exact<{
  input: HeaCreateModuleInput;
}>;


export type HeaCreateModuleMutation = { __typename?: 'Mutation', heaCreateModule?: { __typename?: 'HEAModule', id: string, originalModuleId?: string | null, name: string, type: ContentType, data?: string | null, position?: number | null, formData?: string | null, meta?: string | null } | null };

export type HeaUpdateModuleMutationVariables = Exact<{
  input: HeaUpdateModuleInput;
}>;


export type HeaUpdateModuleMutation = { __typename?: 'Mutation', heaUpdateModule?: boolean | null };

export type HeaListStudyPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type HeaListStudyPlansQuery = { __typename?: 'Query', heaListStudyPlans?: Array<{ __typename?: 'StudyPlan', id: string, name: string, color?: string | null, darkColor?: string | null, unitIds?: Array<string> | null }> | null };

export type HeaUnitsQueryVariables = Exact<{ [key: string]: never; }>;


export type HeaUnitsQuery = { __typename?: 'Query', heaUnits?: Array<{ __typename?: 'HEAUnit', id: string, originalUnitId: string, name: string, subHeading?: string | null, coverImage?: string | null, popupCover?: string | null, pace?: string | null, topics?: string | null, tags?: string | null, box1?: string | null, box2?: string | null, description?: string | null, parentBox?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, parentImage?: string | null, ageGroup?: string | null, sensitive?: boolean | null, sensitiveTooltip?: string | null }> | null };

export type GetVideoUrlQueryVariables = Exact<{
  uploadId: Scalars['String']['input'];
}>;


export type GetVideoUrlQuery = { __typename?: 'Query', getVideoUrl?: { __typename?: 'VideoData', url: string, meta?: string | null } | null };

export type HeaCreateStudyPlanMutationVariables = Exact<{
  input: HeaCreateStudyPlanInput;
}>;


export type HeaCreateStudyPlanMutation = { __typename?: 'Mutation', heaCreateStudyPlan: string };

export type HeaUpdateStudyPlanMutationVariables = Exact<{
  input: HeaUpdateStudyPlanInput;
}>;


export type HeaUpdateStudyPlanMutation = { __typename?: 'Mutation', heaUpdateStudyPlan: boolean };

export type HeaGetStudyPlansByUnitQueryVariables = Exact<{
  input: IdInput;
}>;


export type HeaGetStudyPlansByUnitQuery = { __typename?: 'Query', heaGetStudyPlansByUnit?: Array<{ __typename?: 'StudyPlan', id: string, name: string, color?: string | null, darkColor?: string | null, unitIds?: Array<string> | null }> | null };

export type HeaMeQueryVariables = Exact<{ [key: string]: never; }>;


export type HeaMeQuery = { __typename?: 'Query', heaMe?: { __typename?: 'HEAUser', id: string, email: string, firstName?: string | null, lastName?: string | null, status?: string | null, enableFaith?: boolean | null, enablePasscode?: boolean | null, locked?: boolean | null, studyplanId?: string | null, registeredAt?: string | null, studyplanName?: string | null, studyplanCount?: number | null, association?: string | null, blocked?: boolean | null, expired?: boolean | null, expireAt?: string | null, isTypeformShown?: boolean | null } | null };

export type HeaSetPasswordAfterLoginMutationVariables = Exact<{
  input: HeaSetPasswordAfterLoginInput;
}>;


export type HeaSetPasswordAfterLoginMutation = { __typename?: 'Mutation', heaSetPasswordAfterLogin?: boolean | null };

export type HeaLockAccountMutationVariables = Exact<{
  input: IdInput;
}>;


export type HeaLockAccountMutation = { __typename?: 'Mutation', heaLockAccount?: boolean | null };

export type HeaUnlockAccountMutationVariables = Exact<{
  input: HeaUnlockAccountInput;
}>;


export type HeaUnlockAccountMutation = { __typename?: 'Mutation', heaUnlockAccount?: boolean | null };

export type HeaDeleteStudyPlanMutationVariables = Exact<{
  input: IdInput;
}>;


export type HeaDeleteStudyPlanMutation = { __typename?: 'Mutation', heaDeleteStudyPlan: boolean };

export type HeaDeleteAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type HeaDeleteAccountMutation = { __typename?: 'Mutation', heaDeleteAccount?: boolean | null };

export type FinishStudyPlanMutationVariables = Exact<{ [key: string]: never; }>;


export type FinishStudyPlanMutation = { __typename?: 'Mutation', finishStudyPlan: { __typename?: 'HEAUser', id: string, email: string, firstName?: string | null, lastName?: string | null, status?: string | null, enableFaith?: boolean | null, enablePasscode?: boolean | null, locked?: boolean | null, studyplanId?: string | null, registeredAt?: string | null, studyplanName?: string | null, studyplanCount?: number | null, association?: string | null, blocked?: boolean | null, expired?: boolean | null, expireAt?: string | null, isTypeformShown?: boolean | null } };

export type HeaCreateFeedbackFormAnswerMutationVariables = Exact<{
  input: HeaCreateFeedbackFormAnswerInput;
}>;


export type HeaCreateFeedbackFormAnswerMutation = { __typename?: 'Mutation', heaCreateFeedbackFormAnswer?: { __typename?: 'HEAFeedbackFormAnswer', id: string, moduleId: string, formData: string, createdBy: string, createdAt: string, parentId: string, parentEmail: string, studyplanId: string, lessonId?: string | null, lessonName?: string | null, unitId?: string | null, unitName?: string | null, surveyType: number, moduleName?: string | null } | null };

export type HeaUpdateLessonStatusMutationVariables = Exact<{
  input: HeaUpdateLessonStatusInput;
}>;


export type HeaUpdateLessonStatusMutation = { __typename?: 'Mutation', heaUpdateLessonStatus: boolean };

export type HeaUpdateLessonMutationVariables = Exact<{
  input: HeaUpdateLessonInput;
}>;


export type HeaUpdateLessonMutation = { __typename?: 'Mutation', heaUpdateLesson?: { __typename?: 'HEALesson', id: string, originalLessonId: string, name: string, description?: string | null, number?: number | null, image?: string | null, duration?: number | null, descriptionHeading?: string | null, descriptionAnswers?: string | null, prerequisite?: boolean | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, group?: string | null, modules?: Array<{ __typename?: 'HEAPresentationModule', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, useDefault?: boolean | null }> | null } | null };

export type HeaGetLessonStatusQueryVariables = Exact<{
  input: HeaGetLessonStatusInput;
}>;


export type HeaGetLessonStatusQuery = { __typename?: 'Query', heaGetLessonStatus?: Array<{ __typename?: 'HEALessonStatus', lessonId: string, status: string, incomplete?: boolean | null }> | null };

export type HeaCreateGroupModuleMutationVariables = Exact<{
  input: HeaCreateGroupModuleInput;
}>;


export type HeaCreateGroupModuleMutation = { __typename?: 'Mutation', heaCreateGroupModule?: { __typename?: 'HEAGroupModule', moduleId: string, groupId: string, groupName?: string | null, data?: string | null, meta?: string | null, formData?: string | null } | null };

export type HeaUpdateGroupModuleMutationVariables = Exact<{
  input: HeaUpdateGroupModuleInput;
}>;


export type HeaUpdateGroupModuleMutation = { __typename?: 'Mutation', heaUpdateGroupModule?: { __typename?: 'HEAGroupModule', moduleId: string, groupId: string, groupName?: string | null, data?: string | null, meta?: string | null, formData?: string | null } | null };

export type HeaDeleteGroupModuleMutationVariables = Exact<{
  input: HeaDeleteGroupModuleInput;
}>;


export type HeaDeleteGroupModuleMutation = { __typename?: 'Mutation', heaDeleteGroupModule?: boolean | null };

export type HeaGetModuleAllGroupsQueryVariables = Exact<{
  input: IdInput;
}>;


export type HeaGetModuleAllGroupsQuery = { __typename?: 'Query', heaGetModuleAllGroups?: Array<{ __typename?: 'HEAGroupModule', moduleId: string, groupId: string, groupName?: string | null, data?: string | null, meta?: string | null, formData?: string | null } | null> | null };

export type HeaEnableFaithMutationVariables = Exact<{
  disable?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type HeaEnableFaithMutation = { __typename?: 'Mutation', heaEnableFaith?: boolean | null };

export type HeTokensQueryVariables = Exact<{ [key: string]: never; }>;


export type HeTokensQuery = { __typename?: 'Query', heTokens?: Array<{ __typename?: 'HEToken', association?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, token: string, generatedAt?: string | null, expireAt?: string | null, expired?: boolean | null, signups?: number | null }> | null };

export type HeTokenFragment = { __typename?: 'HEToken', association?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, notes?: string | null, token: string, generatedAt?: string | null, expireAt?: string | null, expired?: boolean | null, signups?: number | null };

export type HeaUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type HeaUsersQuery = { __typename?: 'Query', heaUsers?: Array<{ __typename?: 'HEAUser', id: string, email: string, firstName?: string | null, lastName?: string | null, status?: string | null, enableFaith?: boolean | null, enablePasscode?: boolean | null, locked?: boolean | null, studyplanId?: string | null, registeredAt?: string | null, studyplanName?: string | null, studyplanCount?: number | null, association?: string | null, blocked?: boolean | null, expired?: boolean | null, expireAt?: string | null, isTypeformShown?: boolean | null }> | null };

export type FeedbackFormQueryVariables = Exact<{
  input: IdInput;
}>;


export type FeedbackFormQuery = { __typename?: 'Query', feedbackForm?: { __typename?: 'FeedbackFormContent', id: string, programName?: string | null, unitName?: string | null, lessonName?: string | null, formData?: string | null, expirationAt?: string | null, createdAt?: string | null, type?: number | null, exitTicketCount?: number | null, link?: string | null, grade: string } | null };

export type CancelFeedbackFormMutationVariables = Exact<{
  input: IdInput;
}>;


export type CancelFeedbackFormMutation = { __typename?: 'Mutation', cancelFeedbackForm?: boolean | null };

export type CopyPasswordLinkMutationVariables = Exact<{
  input: EmailInput;
}>;


export type CopyPasswordLinkMutation = { __typename?: 'Mutation', copyPasswordLink: string };

export type EmailPasswordLinkMutationVariables = Exact<{
  input: EmailInput;
}>;


export type EmailPasswordLinkMutation = { __typename?: 'Mutation', emailPasswordLink: boolean };

export type HeaUpdateStudyPlanNameMutationVariables = Exact<{
  input: HeaUpdateStudyPlanNameInput;
}>;


export type HeaUpdateStudyPlanNameMutation = { __typename?: 'Mutation', heaUpdateStudyPlanName: boolean };

export type HeaSendResetPasswordLinkMutationVariables = Exact<{
  input: HeaSendResetPasswordLinkInput;
}>;


export type HeaSendResetPasswordLinkMutation = { __typename?: 'Mutation', heaSendResetPasswordLink: boolean };

export type HeaResetPasswordMutationVariables = Exact<{
  input: HeaResetPasswordInput;
}>;


export type HeaResetPasswordMutation = { __typename?: 'Mutation', heaResetPassword: string };

export type GetInvitedUserQueryVariables = Exact<{
  input: UserIdInput;
}>;


export type GetInvitedUserQuery = { __typename?: 'Query', invitedUser?: { __typename?: 'User', email: string, firstName: string, lastName: string, status: string, customer?: { __typename?: 'Customer', name: string, id: string } | null, schools?: Array<{ __typename?: 'School', id: string } | null> | null } | null };

export type RevalidateMutationVariables = Exact<{
  input: RevalidateTokenInput;
}>;


export type RevalidateMutation = { __typename?: 'Mutation', revalidateToken?: { __typename?: 'RevalidateTokenResponse', token?: string | null, clientId: string, email?: string | null } | null };

export type RegistrationMutationVariables = Exact<{
  input: UserRegistrationInput;
}>;


export type RegistrationMutation = { __typename?: 'Mutation', registration: { __typename?: 'UserRegistrationResponse', token: string, user?: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, status: string, createdAt?: string | null, customer?: { __typename?: 'Customer', name: string, id: string } | null, schools?: Array<{ __typename?: 'School', id: string, name: string } | null> | null } | null } };

export type HeaLessonsToConfirmQueryVariables = Exact<{ [key: string]: never; }>;


export type HeaLessonsToConfirmQuery = { __typename?: 'Query', heaLessonsToConfirm?: Array<{ __typename?: 'LessonToConfirm', studyplanId: string, studyplanName: string, unitId: string, incomplete?: boolean | null, lesson?: { __typename?: 'HEALesson', id: string, originalLessonId: string, name: string, description?: string | null, number?: number | null, image?: string | null, duration?: number | null, descriptionHeading?: string | null, descriptionAnswers?: string | null, prerequisite?: boolean | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, group?: string | null, modules?: Array<{ __typename?: 'HEAPresentationModule', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, useDefault?: boolean | null }> | null } | null }> | null };

export type HeaConfirmLessonMutationVariables = Exact<{
  input: HeaConfirmLessonInput;
}>;


export type HeaConfirmLessonMutation = { __typename?: 'Mutation', heaConfirmLesson: boolean };

export type HeaSetTypeformShownMutationVariables = Exact<{ [key: string]: never; }>;


export type HeaSetTypeformShownMutation = { __typename?: 'Mutation', heaSetTypeformShown: boolean };

export type HeExitTicketResultQueryVariables = Exact<{
  input: HeExitTicketResultInput;
}>;


export type HeExitTicketResultQuery = { __typename?: 'Query', heExitTicketResult?: { __typename?: 'HEFeedbackAnswerResult', formData: string, parentEmail: string, createdBy: string, createdAt: string, moduleName?: string | null, studyPlanName?: string | null, lessonName?: string | null, unitName?: string | null, surveyType: number } | null };

export type CreateAlternateLessonMutationVariables = Exact<{
  input: IdInput;
}>;


export type CreateAlternateLessonMutation = { __typename?: 'Mutation', createAlternateLesson?: Array<{ __typename?: 'Section', id: string, name: string, position?: number | null, progress?: number | null, status?: string | null, modules?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null }> | null }> | null };

export type DeleteAlternateLessonMutationVariables = Exact<{
  input: IdInput;
}>;


export type DeleteAlternateLessonMutation = { __typename?: 'Mutation', deleteAlternateLesson: boolean };

export type CreateSectionMutationVariables = Exact<{
  input: CreateSectionInput;
}>;


export type CreateSectionMutation = { __typename?: 'Mutation', createSection?: { __typename?: 'Section', id: string, name: string, position?: number | null, progress?: number | null, status?: string | null, modules?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null }> | null } | null };

export type DeleteSectionMutationVariables = Exact<{
  input: IdInput;
}>;


export type DeleteSectionMutation = { __typename?: 'Mutation', deleteSection: boolean };

export type UpdateSectionMutationVariables = Exact<{
  input: UpdateSectionInput;
}>;


export type UpdateSectionMutation = { __typename?: 'Mutation', updateSection: boolean };

export type SwitchLessonFlowMutationVariables = Exact<{
  input: SwitchLessonFlowInput;
}>;


export type SwitchLessonFlowMutation = { __typename?: 'Mutation', switchLessonFlow: boolean };

export type UpdateSectionCompleteStatusMutationVariables = Exact<{
  input: UpdateSectionCompleteStatusInput;
}>;


export type UpdateSectionCompleteStatusMutation = { __typename?: 'Mutation', updateSectionCompleteStatus: boolean };

export type SchoolQueryVariables = Exact<{
  input: UserIdInput;
}>;


export type SchoolQuery = { __typename?: 'Query', school?: boolean | null };

export type AccountQueryVariables = Exact<{
  input: UserIdInput;
}>;


export type AccountQuery = { __typename?: 'Query', account?: Array<{ __typename?: 'School', id: string, name: string } | null> | null };

export type ConfirmEmailQueryVariables = Exact<{
  input: ConfirmEmailInput;
}>;


export type ConfirmEmailQuery = { __typename?: 'Query', confirmEmail: string };

export type GetSurveysQueryVariables = Exact<{
  input: GetSurveysInput;
}>;


export type GetSurveysQuery = { __typename?: 'Query', getSurveys: { __typename?: 'SurveyReport', success: boolean, csvData?: string | null, filename?: string | null } };

export type ListSchoolReportsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListSchoolReportsQuery = { __typename?: 'Query', listSchoolReports?: Array<{ __typename?: 'SchoolReport', id: string, name: string, surveyId: string, generatedAt: string, startDate: string, endDate: string, key: string, url?: string | null, schoolIds: string }> | null };

export type GetSchoolReportsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetSchoolReportsQuery = { __typename?: 'Query', getSchoolReports?: Array<{ __typename?: 'SchoolReport', id: string, name: string, surveyId: string, generatedAt: string, startDate: string, endDate: string, key: string, url?: string | null, schoolIds: string }> | null };

export type GenerateSchoolReportMutationVariables = Exact<{
  input: GenerateSchoolReportInput;
}>;


export type GenerateSchoolReportMutation = { __typename?: 'Mutation', generateSchoolReport?: { __typename?: 'SchoolReport', name: string, surveyId: string, startDate: string, endDate: string, key: string, url?: string | null, schoolIds: string } | null };

export type GetFeedbackFormByLinkQueryVariables = Exact<{
  input: FeedbackLinkInput;
}>;


export type GetFeedbackFormByLinkQuery = { __typename?: 'Query', getFeedbackFormByLink?: { __typename?: 'FeedbackFormContent', id: string, programName?: string | null, unitName?: string | null, lessonName?: string | null, className?: string | null, createdAt?: string | null, exitTicketCount?: number | null, expirationAt?: string | null, formData?: string | null, isCancelled?: boolean | null, type?: number | null, link?: string | null, grade: string, mcId?: string | null, mcName?: string | null, collectionId?: string | null, collectionName?: string | null, createdBy?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, disabled?: boolean | null, role: string, status: string, updatedAt?: string | null, admin?: string | null, districtSchools?: string | null, completedLessonCount?: number | null, schoolNewYearInfo?: string | null, disabledPwLogin?: boolean | null, autoLogoutEnabled?: boolean | null, customer?: { __typename?: 'Customer', id: string, name: string, country?: string | null, trial?: boolean | null, state?: string | null } | null, schools?: Array<{ __typename?: 'School', id: string, name: string, groupIds?: string | null, isPrimary?: boolean | null, programs?: string | null, grades?: string | null } | null> | null } | null } | null };

export type GetSchoolReportDownloadUrlQueryVariables = Exact<{
  input: GetSchoolReportDownloadUrlInput;
}>;


export type GetSchoolReportDownloadUrlQuery = { __typename?: 'Query', getSchoolReportDownloadURL: string };

export type SllGetLessonsQueryVariables = Exact<{
  input: SllGetLessonsInput;
}>;


export type SllGetLessonsQuery = { __typename?: 'Query', sllGetLessons?: Array<{ __typename?: 'SLLLesson', id: string, meta?: string | null, status?: string | null, progress?: number | null, name: string, uniqueName?: string | null, coverImage?: string | null, bannerImage?: string | null, coverVideo?: string | null, country: string, ageGroup?: string | null, gradeLabelPosition?: string | null, mainTopics?: string | null, subTopics?: string | null, skill?: string | null, gradeLevel?: string | null, duration: number, lessonMaterialHeading?: string | null, lessonMaterialAnswers?: string | null, overviewHeading1?: string | null, overviewAnswers1?: string | null, overviewHeading2?: string | null, overviewAnswers2?: string | null, recommendedPrior?: string | null, recommendedNext?: string | null, isPublished?: boolean | null, isNew?: boolean | null, newLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonAt?: string | null, comingSoonLabelPosition?: string | null, groupId?: string | null, competency?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isOpReel?: boolean | null, categories?: string | null, isNewCover?: boolean | null, suggestedDuration?: string | null, sllType?: SllLessonType | null, isExtensionAvailable?: boolean | null, isEducatorCaregiverLessonLayout?: boolean | null, lessonType?: string | null, showLessonMaterialsNotice?: boolean | null, lessonDetails?: string | null, materials?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null, presentation?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null, sections?: Array<{ __typename?: 'SLLSection', id: string, name: string, position?: number | null, modules?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null } | null> | null, collections?: Array<{ __typename?: 'SLLLessonCollection', id: string, name: string, collectionType: string } | null> | null, multiCollections?: Array<{ __typename?: 'SLLLessonMultiCollection', id: string, name: string, grade: string, programType?: string | null } | null> | null }> | null };

export type SllGetGettingStartedLessonsQueryVariables = Exact<{ [key: string]: never; }>;


export type SllGetGettingStartedLessonsQuery = { __typename?: 'Query', sllGetGettingStartedLessons?: Array<{ __typename?: 'SLLLesson', id: string, meta?: string | null, status?: string | null, progress?: number | null, name: string, uniqueName?: string | null, coverImage?: string | null, bannerImage?: string | null, coverVideo?: string | null, country: string, ageGroup?: string | null, gradeLabelPosition?: string | null, mainTopics?: string | null, subTopics?: string | null, skill?: string | null, gradeLevel?: string | null, duration: number, lessonMaterialHeading?: string | null, lessonMaterialAnswers?: string | null, overviewHeading1?: string | null, overviewAnswers1?: string | null, overviewHeading2?: string | null, overviewAnswers2?: string | null, recommendedPrior?: string | null, recommendedNext?: string | null, isPublished?: boolean | null, isNew?: boolean | null, newLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonAt?: string | null, comingSoonLabelPosition?: string | null, groupId?: string | null, competency?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isOpReel?: boolean | null, categories?: string | null, isNewCover?: boolean | null, suggestedDuration?: string | null, sllType?: SllLessonType | null, isExtensionAvailable?: boolean | null, isEducatorCaregiverLessonLayout?: boolean | null, lessonType?: string | null, showLessonMaterialsNotice?: boolean | null, lessonDetails?: string | null, materials?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null, presentation?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null, sections?: Array<{ __typename?: 'SLLSection', id: string, name: string, position?: number | null, modules?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null } | null> | null, collections?: Array<{ __typename?: 'SLLLessonCollection', id: string, name: string, collectionType: string } | null> | null, multiCollections?: Array<{ __typename?: 'SLLLessonMultiCollection', id: string, name: string, grade: string, programType?: string | null } | null> | null }> | null };

export type SllGetCaregiverLessonsQueryVariables = Exact<{ [key: string]: never; }>;


export type SllGetCaregiverLessonsQuery = { __typename?: 'Query', sllGetCaregiverLessons?: Array<{ __typename?: 'SLLLesson', id: string, meta?: string | null, status?: string | null, progress?: number | null, name: string, uniqueName?: string | null, coverImage?: string | null, bannerImage?: string | null, coverVideo?: string | null, country: string, ageGroup?: string | null, gradeLabelPosition?: string | null, mainTopics?: string | null, subTopics?: string | null, skill?: string | null, gradeLevel?: string | null, duration: number, lessonMaterialHeading?: string | null, lessonMaterialAnswers?: string | null, overviewHeading1?: string | null, overviewAnswers1?: string | null, overviewHeading2?: string | null, overviewAnswers2?: string | null, recommendedPrior?: string | null, recommendedNext?: string | null, isPublished?: boolean | null, isNew?: boolean | null, newLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonAt?: string | null, comingSoonLabelPosition?: string | null, groupId?: string | null, competency?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isOpReel?: boolean | null, categories?: string | null, isNewCover?: boolean | null, suggestedDuration?: string | null, sllType?: SllLessonType | null, isExtensionAvailable?: boolean | null, isEducatorCaregiverLessonLayout?: boolean | null, lessonType?: string | null, showLessonMaterialsNotice?: boolean | null, lessonDetails?: string | null, materials?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null, presentation?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null, sections?: Array<{ __typename?: 'SLLSection', id: string, name: string, position?: number | null, modules?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null } | null> | null, collections?: Array<{ __typename?: 'SLLLessonCollection', id: string, name: string, collectionType: string } | null> | null, multiCollections?: Array<{ __typename?: 'SLLLessonMultiCollection', id: string, name: string, grade: string, programType?: string | null } | null> | null }> | null };

export type SllGetLessonsForSaQueryVariables = Exact<{
  input: SllGetLessonsForSaInput;
}>;


export type SllGetLessonsForSaQuery = { __typename?: 'Query', sllGetLessonsForSA?: { __typename?: 'SLLGetLessonsForSAResponse', totals: number, data?: Array<{ __typename?: 'SLLLesson', id: string, name: string, uniqueName?: string | null, coverImage?: string | null, bannerImage?: string | null, coverVideo?: string | null, country: string, ageGroup?: string | null, gradeLabelPosition?: string | null, mainTopics?: string | null, subTopics?: string | null, skill?: string | null, gradeLevel?: string | null, duration: number, lessonMaterialHeading?: string | null, lessonMaterialAnswers?: string | null, overviewHeading1?: string | null, overviewAnswers1?: string | null, overviewHeading2?: string | null, overviewAnswers2?: string | null, recommendedPrior?: string | null, recommendedNext?: string | null, isPublished?: boolean | null, isNew?: boolean | null, newLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonAt?: string | null, comingSoonLabelPosition?: string | null, groupId?: string | null, competency?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isOpReel?: boolean | null, categories?: string | null, isNewCover?: boolean | null, suggestedDuration?: string | null, sllType?: SllLessonType | null, isExtensionAvailable?: boolean | null, isEducatorCaregiverLessonLayout?: boolean | null, lessonType?: string | null, showLessonMaterialsNotice?: boolean | null, lessonDetails?: string | null }> | null } | null };

export type SllGetLessonInfoQueryVariables = Exact<{
  input: IdInput;
}>;


export type SllGetLessonInfoQuery = { __typename?: 'Query', sllGetLessonInfo: { __typename?: 'SLLLesson', id: string, meta?: string | null, status?: string | null, progress?: number | null, name: string, uniqueName?: string | null, coverImage?: string | null, bannerImage?: string | null, coverVideo?: string | null, country: string, ageGroup?: string | null, gradeLabelPosition?: string | null, mainTopics?: string | null, subTopics?: string | null, skill?: string | null, gradeLevel?: string | null, duration: number, lessonMaterialHeading?: string | null, lessonMaterialAnswers?: string | null, overviewHeading1?: string | null, overviewAnswers1?: string | null, overviewHeading2?: string | null, overviewAnswers2?: string | null, recommendedPrior?: string | null, recommendedNext?: string | null, isPublished?: boolean | null, isNew?: boolean | null, newLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonAt?: string | null, comingSoonLabelPosition?: string | null, groupId?: string | null, competency?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isOpReel?: boolean | null, categories?: string | null, isNewCover?: boolean | null, suggestedDuration?: string | null, sllType?: SllLessonType | null, isExtensionAvailable?: boolean | null, isEducatorCaregiverLessonLayout?: boolean | null, lessonType?: string | null, showLessonMaterialsNotice?: boolean | null, lessonDetails?: string | null, materials?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null, presentation?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null, sections?: Array<{ __typename?: 'SLLSection', id: string, name: string, position?: number | null, modules?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null } | null> | null, collections?: Array<{ __typename?: 'SLLLessonCollection', id: string, name: string, collectionType: string } | null> | null, multiCollections?: Array<{ __typename?: 'SLLLessonMultiCollection', id: string, name: string, grade: string, programType?: string | null } | null> | null } };

export type SllGetLessonInfoForSaQueryVariables = Exact<{
  input: IdInput;
}>;


export type SllGetLessonInfoForSaQuery = { __typename?: 'Query', sllGetLessonInfoForSA: { __typename?: 'SLLLesson', id: string, meta?: string | null, name: string, uniqueName?: string | null, coverImage?: string | null, bannerImage?: string | null, coverVideo?: string | null, country: string, ageGroup?: string | null, gradeLabelPosition?: string | null, mainTopics?: string | null, subTopics?: string | null, skill?: string | null, gradeLevel?: string | null, duration: number, lessonMaterialHeading?: string | null, lessonMaterialAnswers?: string | null, overviewHeading1?: string | null, overviewAnswers1?: string | null, overviewHeading2?: string | null, overviewAnswers2?: string | null, recommendedPrior?: string | null, recommendedNext?: string | null, isPublished?: boolean | null, isNew?: boolean | null, newLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonAt?: string | null, comingSoonLabelPosition?: string | null, groupId?: string | null, competency?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isOpReel?: boolean | null, categories?: string | null, isNewCover?: boolean | null, suggestedDuration?: string | null, sllType?: SllLessonType | null, isExtensionAvailable?: boolean | null, isEducatorCaregiverLessonLayout?: boolean | null, lessonType?: string | null, showLessonMaterialsNotice?: boolean | null, lessonDetails?: string | null, materials?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null, presentation?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null, sections?: Array<{ __typename?: 'SLLSection', id: string, name: string, position?: number | null, modules?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null } | null> | null } };

export type SllCreateLessonMutationVariables = Exact<{
  input: SllCreateLessonInput;
}>;


export type SllCreateLessonMutation = { __typename?: 'Mutation', sllCreateLesson?: { __typename?: 'SLLLesson', id: string, meta?: string | null, name: string, uniqueName?: string | null, coverImage?: string | null, bannerImage?: string | null, coverVideo?: string | null, country: string, ageGroup?: string | null, gradeLabelPosition?: string | null, mainTopics?: string | null, subTopics?: string | null, skill?: string | null, gradeLevel?: string | null, duration: number, lessonMaterialHeading?: string | null, lessonMaterialAnswers?: string | null, overviewHeading1?: string | null, overviewAnswers1?: string | null, overviewHeading2?: string | null, overviewAnswers2?: string | null, recommendedPrior?: string | null, recommendedNext?: string | null, isPublished?: boolean | null, isNew?: boolean | null, newLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonAt?: string | null, comingSoonLabelPosition?: string | null, groupId?: string | null, competency?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isOpReel?: boolean | null, categories?: string | null, isNewCover?: boolean | null, suggestedDuration?: string | null, sllType?: SllLessonType | null, isExtensionAvailable?: boolean | null, isEducatorCaregiverLessonLayout?: boolean | null, lessonType?: string | null, showLessonMaterialsNotice?: boolean | null, lessonDetails?: string | null, materials?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null, presentation?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null, sections?: Array<{ __typename?: 'SLLSection', id: string, name: string, position?: number | null, modules?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null } | null> | null } | null };

export type SllUpdateLessonMutationVariables = Exact<{
  input: SllUpdateLessonInput;
}>;


export type SllUpdateLessonMutation = { __typename?: 'Mutation', sllUpdateLesson?: { __typename?: 'SLLLesson', id: string, meta?: string | null, name: string, uniqueName?: string | null, coverImage?: string | null, bannerImage?: string | null, coverVideo?: string | null, country: string, ageGroup?: string | null, gradeLabelPosition?: string | null, mainTopics?: string | null, subTopics?: string | null, skill?: string | null, gradeLevel?: string | null, duration: number, lessonMaterialHeading?: string | null, lessonMaterialAnswers?: string | null, overviewHeading1?: string | null, overviewAnswers1?: string | null, overviewHeading2?: string | null, overviewAnswers2?: string | null, recommendedPrior?: string | null, recommendedNext?: string | null, isPublished?: boolean | null, isNew?: boolean | null, newLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonAt?: string | null, comingSoonLabelPosition?: string | null, groupId?: string | null, competency?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isOpReel?: boolean | null, categories?: string | null, isNewCover?: boolean | null, suggestedDuration?: string | null, sllType?: SllLessonType | null, isExtensionAvailable?: boolean | null, isEducatorCaregiverLessonLayout?: boolean | null, lessonType?: string | null, showLessonMaterialsNotice?: boolean | null, lessonDetails?: string | null, materials?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null, presentation?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null, sections?: Array<{ __typename?: 'SLLSection', id: string, name: string, position?: number | null, modules?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null } | null> | null } | null };

export type SllDeleteLessonMutationVariables = Exact<{
  input: IdInput;
}>;


export type SllDeleteLessonMutation = { __typename?: 'Mutation', sllDeleteLesson: boolean };

export type SllGetLessonExclusionsQueryVariables = Exact<{
  input: IdInput;
}>;


export type SllGetLessonExclusionsQuery = { __typename?: 'Query', sllGetLessonExclusions?: Array<{ __typename?: 'SLLLessonExclusion', lessonId: string, groupId: string, groupName?: string | null }> | null };

export type SllAddLessonExclusionMutationVariables = Exact<{
  input: SllLessonExclusionInput;
}>;


export type SllAddLessonExclusionMutation = { __typename?: 'Mutation', sllAddLessonExclusion: boolean };

export type SllRemoveLessonExclusionMutationVariables = Exact<{
  input: SllLessonExclusionInput;
}>;


export type SllRemoveLessonExclusionMutation = { __typename?: 'Mutation', sllRemoveLessonExclusion: boolean };

export type ListGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListGroupsQuery = { __typename?: 'Query', listGroups?: Array<{ __typename?: 'Group', id: string, name: string } | null> | null };

export type SllCreateSectionMutationVariables = Exact<{
  input: IdInput;
}>;


export type SllCreateSectionMutation = { __typename?: 'Mutation', sllCreateSection?: { __typename?: 'SLLSection', id: string, name: string, position?: number | null, modules?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null } | null };

export type SllUpdateSectionMutationVariables = Exact<{
  input: SllUpdateSectionInput;
}>;


export type SllUpdateSectionMutation = { __typename?: 'Mutation', sllUpdateSection: boolean };

export type SllDeleteSectionMutationVariables = Exact<{
  input: IdInput;
}>;


export type SllDeleteSectionMutation = { __typename?: 'Mutation', sllDeleteSection: boolean };

export type SllCreateModuleMutationVariables = Exact<{
  input: SllCreateModuleInput;
}>;


export type SllCreateModuleMutation = { __typename?: 'Mutation', sllCreateModule?: { __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null };

export type SllUpdateModuleMutationVariables = Exact<{
  input: SllUpdateModuleInput;
}>;


export type SllUpdateModuleMutation = { __typename?: 'Mutation', sllUpdateModule?: { __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null };

export type SllDeleteModuleMutationVariables = Exact<{
  input: IdInput;
}>;


export type SllDeleteModuleMutation = { __typename?: 'Mutation', sllDeleteModule: boolean };

export type SllUpdateVideoModuleMutationVariables = Exact<{
  input: SllUpdateVideoModuleInput;
}>;


export type SllUpdateVideoModuleMutation = { __typename?: 'Mutation', sllUpdateVideoModule?: { __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null };

export type SllGetCoursesQueryVariables = Exact<{ [key: string]: never; }>;


export type SllGetCoursesQuery = { __typename?: 'Query', sllGetCourses?: Array<{ __typename?: 'SLLCourse', id: string, name: string, color?: string | null, darkColor?: string | null, lessonIds?: Array<string> | null }> | null };

export type SllCreateCourseMutationVariables = Exact<{
  input: SllCreateCourseInput;
}>;


export type SllCreateCourseMutation = { __typename?: 'Mutation', sllCreateCourse: string };

export type SllUpdateCourseMutationVariables = Exact<{
  input: SllUpdateCourseInput;
}>;


export type SllUpdateCourseMutation = { __typename?: 'Mutation', sllUpdateCourse: boolean };

export type SllUpdateCourseNameMutationVariables = Exact<{
  input: SllUpdateSectionInput;
}>;


export type SllUpdateCourseNameMutation = { __typename?: 'Mutation', sllUpdateCourseName: boolean };

export type SllDeleteCourseMutationVariables = Exact<{
  input: IdInput;
}>;


export type SllDeleteCourseMutation = { __typename?: 'Mutation', sllDeleteCourse: boolean };

export type SllMoveModuleMutationVariables = Exact<{
  input: SllMoveModuleInput;
}>;


export type SllMoveModuleMutation = { __typename?: 'Mutation', sllMoveModule: boolean };

export type DeleteSchoolReportMutationVariables = Exact<{
  input: IdInput;
}>;


export type DeleteSchoolReportMutation = { __typename?: 'Mutation', deleteSchoolReport: boolean };

export type SllCreateGroupModuleMutationVariables = Exact<{
  input: SllCreateGroupModuleInput;
}>;


export type SllCreateGroupModuleMutation = { __typename?: 'Mutation', sllCreateGroupModule?: { __typename?: 'SLLGroupModule', moduleId: string, groupId: string, groupName?: string | null, data?: string | null, meta?: string | null, formData?: string | null } | null };

export type SllUpdateGroupModuleMutationVariables = Exact<{
  input: SllUpdateGroupModuleInput;
}>;


export type SllUpdateGroupModuleMutation = { __typename?: 'Mutation', sllUpdateGroupModule?: { __typename?: 'SLLGroupModule', moduleId: string, groupId: string, groupName?: string | null, data?: string | null, meta?: string | null, formData?: string | null } | null };

export type SllDeleteGroupModuleMutationVariables = Exact<{
  input: SllDeleteGroupModuleInput;
}>;


export type SllDeleteGroupModuleMutation = { __typename?: 'Mutation', sllDeleteGroupModule: boolean };

export type SllGetGroupModulesQueryVariables = Exact<{
  input: IdInput;
}>;


export type SllGetGroupModulesQuery = { __typename?: 'Query', sllGetGroupModules?: { __typename?: 'SLLExtendedModule', groups?: Array<{ __typename?: 'SLLGroupModule', moduleId: string, groupId: string, groupName?: string | null, data?: string | null, meta?: string | null, formData?: string | null }> | null } | null };

export type SllDeleteModuleContentMutationVariables = Exact<{
  input: IdInput;
}>;


export type SllDeleteModuleContentMutation = { __typename?: 'Mutation', sllDeleteModuleContent: boolean };

export type SllDeleteGroupModuleContentMutationVariables = Exact<{
  input: SllDeleteGroupModuleInput;
}>;


export type SllDeleteGroupModuleContentMutation = { __typename?: 'Mutation', sllDeleteGroupModuleContent: boolean };

export type SllUpdateVideoGroupModuleMutationVariables = Exact<{
  input: SllUpdateVideoGroupModuleInput;
}>;


export type SllUpdateVideoGroupModuleMutation = { __typename?: 'Mutation', sllUpdateVideoGroupModule?: { __typename?: 'SLLGroupModule', moduleId: string, groupId: string, groupName?: string | null, data?: string | null, meta?: string | null, formData?: string | null } | null };

export type TrackAnalyticsMutationVariables = Exact<{
  input: TrackDataInput;
}>;


export type TrackAnalyticsMutation = { __typename?: 'Mutation', trackAnalytics?: boolean | null };

export type AdminUsersQueryVariables = Exact<{
  input: UserIdInput;
}>;


export type AdminUsersQuery = { __typename?: 'Query', adminUsers?: Array<{ __typename?: 'AdminUser', id: string, name: string } | null> | null };

export type CreateInviteMutationVariables = Exact<{
  input: SuperAdminInviteUserInput;
}>;


export type CreateInviteMutation = { __typename?: 'Mutation', superAdminInviteUser?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, disabled?: boolean | null, role: string, status: string, updatedAt?: string | null, admin?: string | null, districtSchools?: string | null, completedLessonCount?: number | null, schoolNewYearInfo?: string | null, disabledPwLogin?: boolean | null, autoLogoutEnabled?: boolean | null, customer?: { __typename?: 'Customer', id: string, name: string, country?: string | null, trial?: boolean | null, state?: string | null } | null, schools?: Array<{ __typename?: 'School', id: string, name: string, groupIds?: string | null, isPrimary?: boolean | null, programs?: string | null, grades?: string | null } | null> | null } | null };

export type InviteUserAsEducatorMutationVariables = Exact<{
  input: UserInviteInput;
}>;


export type InviteUserAsEducatorMutation = { __typename?: 'Mutation', inviteUserAsEducator?: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, status: string, schools?: Array<{ __typename?: 'School', id: string, name: string } | null> | null } | null };

export type SllUpdateLessonCompleteStatusMutationVariables = Exact<{
  input: SllUpdateLessonCompleteStatusInput;
}>;


export type SllUpdateLessonCompleteStatusMutation = { __typename?: 'Mutation', sllUpdateLessonCompleteStatus: boolean };

export type SllGetLastVisitedModuleQueryVariables = Exact<{
  input: IdInput;
}>;


export type SllGetLastVisitedModuleQuery = { __typename?: 'Query', sllGetLastVisitedModule?: { __typename?: 'SLLLastVisitedModule', lastVisitedAt: string, lessonId: string, moduleId: string, pageNumber?: number | null, status: string } | null };

export type SllUpdateLastVisitedModuleMutationVariables = Exact<{
  input: SllUpdateLastVisitedModuleInput;
}>;


export type SllUpdateLastVisitedModuleMutation = { __typename?: 'Mutation', sllUpdateLastVisitedModule: boolean };

export type ListLessonsInProgressQueryVariables = Exact<{ [key: string]: never; }>;


export type ListLessonsInProgressQuery = { __typename?: 'Query', listLessonsInProgress?: Array<{ __typename?: 'LessonInProgress', completionCount?: number | null, lastCompletedAt?: string | null, lessonId: string, lessonName: string, progress?: number | null, status: string, unitId?: string | null, unitName?: string | null, gradeName?: string | null }> | null };

export type ResetAllLessonProgressMutationVariables = Exact<{ [key: string]: never; }>;


export type ResetAllLessonProgressMutation = { __typename?: 'Mutation', resetAllLessonProgress: boolean };

export type ResetLessonProgressMutationVariables = Exact<{
  input: ResetLessonProgressInput;
}>;


export type ResetLessonProgressMutation = { __typename?: 'Mutation', resetLessonProgress: boolean };

export type SllGetBrainBreakLessonsQueryVariables = Exact<{ [key: string]: never; }>;


export type SllGetBrainBreakLessonsQuery = { __typename?: 'Query', sllGetBrainBreakLessons?: Array<{ __typename?: 'SLLLesson', id: string, meta?: string | null, status?: string | null, progress?: number | null, name: string, uniqueName?: string | null, coverImage?: string | null, bannerImage?: string | null, coverVideo?: string | null, country: string, ageGroup?: string | null, gradeLabelPosition?: string | null, mainTopics?: string | null, subTopics?: string | null, skill?: string | null, gradeLevel?: string | null, duration: number, lessonMaterialHeading?: string | null, lessonMaterialAnswers?: string | null, overviewHeading1?: string | null, overviewAnswers1?: string | null, overviewHeading2?: string | null, overviewAnswers2?: string | null, recommendedPrior?: string | null, recommendedNext?: string | null, isPublished?: boolean | null, isNew?: boolean | null, newLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonAt?: string | null, comingSoonLabelPosition?: string | null, groupId?: string | null, competency?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isOpReel?: boolean | null, categories?: string | null, isNewCover?: boolean | null, suggestedDuration?: string | null, sllType?: SllLessonType | null, isExtensionAvailable?: boolean | null, isEducatorCaregiverLessonLayout?: boolean | null, lessonType?: string | null, showLessonMaterialsNotice?: boolean | null, lessonDetails?: string | null, materials?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null, presentation?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null, sections?: Array<{ __typename?: 'SLLSection', id: string, name: string, position?: number | null, modules?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null } | null> | null, collections?: Array<{ __typename?: 'SLLLessonCollection', id: string, name: string, collectionType: string } | null> | null, multiCollections?: Array<{ __typename?: 'SLLLessonMultiCollection', id: string, name: string, grade: string, programType?: string | null } | null> | null }> | null };

export type GetPreProgramQuizUnitQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPreProgramQuizUnitQuery = { __typename?: 'Query', getPreProgramQuizUnit: { __typename?: 'Unit', id: string, name: string, uniqueName?: string | null, subHeading?: string | null, skill: string, coverImage?: string | null, popupCover?: string | null, type: string, country?: string | null, default: boolean, description?: string | null, courseId?: string | null, pace?: string | null, tags?: string | null, teacherBox?: string | null, teacherImage?: string | null, box1?: string | null, box2?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, progress?: number | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, isNew?: boolean | null, newLabelPosition?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonLabelPosition?: string | null, comingSoonAt?: string | null, competency?: string | null, unitStudyBox?: string | null, unitStudyHeading?: string | null, isNewCover?: boolean | null, categories?: string | null, suggestedLessonCount?: number | null, suggestedDuration?: string | null, isEducatorCaregiverLessonLayout?: boolean | null, teacherPreparation?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null> | null, alternateMaterials?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null> | null, classPresentation?: Array<{ __typename?: 'Lesson', id: string, name: string, uniqueName?: string | null, description?: string | null, number?: number | null, master?: boolean | null, image?: string | null, duration?: number | null, descriptionHeading?: string | null, descriptionAnswers?: string | null, prerequisite?: boolean | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, status?: string | null, lastVisitedAt?: string | null, group?: string | null, progress?: number | null, alternativeActivated?: boolean | null, isAlternative?: boolean | null, modules?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null }> | null, materials?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null }> | null, sections?: Array<{ __typename?: 'Section', id: string, name: string, position?: number | null, progress?: number | null, status?: string | null, modules?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null }> | null }> | null } | null> | null, studyGuides?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null> | null, studyGuideMaterials?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null> | null, unitStudyReview?: { __typename?: 'UnitStudyReview', status: string } | null } };

export type GenerateParentLinkForUserMutationVariables = Exact<{
  input?: InputMaybe<ParentLinkInput>;
}>;


export type GenerateParentLinkForUserMutation = { __typename?: 'Mutation', generateParentLinkForUser: { __typename?: 'ParentLinkOutput', id: string, resource?: string | null } };

export type GetUnitQuickInfoQueryVariables = Exact<{
  input: IdInput;
}>;


export type GetUnitQuickInfoQuery = { __typename?: 'Query', getUnitInfo: { __typename?: 'Unit', teacherPreparationCount?: number | null, alternateMaterialsCount?: number | null, classPresentationCount?: number | null, id: string, name: string, uniqueName?: string | null, subHeading?: string | null, skill: string, coverImage?: string | null, popupCover?: string | null, type: string, country?: string | null, default: boolean, description?: string | null, courseId?: string | null, pace?: string | null, tags?: string | null, teacherBox?: string | null, teacherImage?: string | null, box1?: string | null, box2?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, progress?: number | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, isNew?: boolean | null, newLabelPosition?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonLabelPosition?: string | null, comingSoonAt?: string | null, competency?: string | null, unitStudyBox?: string | null, unitStudyHeading?: string | null, isNewCover?: boolean | null, categories?: string | null, suggestedLessonCount?: number | null, suggestedDuration?: string | null, isEducatorCaregiverLessonLayout?: boolean | null, unitStudyReview?: { __typename?: 'UnitStudyReview', status: string } | null } };

export type GetAllVideosQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllVideosQuery = { __typename?: 'Query', allVideos?: Array<{ __typename?: 'Video', name: string, data: string, created: string, meta?: string | null }> | null };

export type GetAllCoverVideosQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCoverVideosQuery = { __typename?: 'Query', allCoverVideos?: Array<{ __typename?: 'Video', name: string, data: string, created: string, meta?: string | null }> | null };

export type UpdateUnitStudyReviewStatusMutationVariables = Exact<{
  input: UpdateUnitStudyReviewStatusInput;
}>;


export type UpdateUnitStudyReviewStatusMutation = { __typename?: 'Mutation', updateUnitStudyReviewStatus?: boolean | null };

export type LastVisitedUnitStudyReviewQueryVariables = Exact<{
  input: IdInput;
}>;


export type LastVisitedUnitStudyReviewQuery = { __typename?: 'Query', lastVisitedUnitStudyReview?: Array<{ __typename?: 'LastVisitedUnitStudyReview', lastVisitedAt: string, moduleId: string, pageNumber?: number | null, status: string, unitId: string, userId: string } | null> | null };

export type UpdateLastVisitedUnitStudyReviewMutationVariables = Exact<{
  input?: InputMaybe<LastVisitedUnitStudyReviewInput>;
}>;


export type UpdateLastVisitedUnitStudyReviewMutation = { __typename?: 'Mutation', updateLastVisitedUnitStudyReview?: { __typename?: 'LastVisitedUnitStudyReview', lastVisitedAt: string, moduleId: string, pageNumber?: number | null, status: string, unitId: string, userId: string } | null };

export type IsValidUnitUniqueNameQueryVariables = Exact<{
  input: UniqueNameInput;
}>;


export type IsValidUnitUniqueNameQuery = { __typename?: 'Query', isValidUnitUniqueName: boolean };

export type IsValidSllUniqueNameQueryVariables = Exact<{
  input: UniqueNameInput;
}>;


export type IsValidSllUniqueNameQuery = { __typename?: 'Query', isValidSLLUniqueName: boolean };

export type IsValidLessonUniqueNameQueryVariables = Exact<{
  input: UniqueNameInput;
}>;


export type IsValidLessonUniqueNameQuery = { __typename?: 'Query', isValidLessonUniqueName: boolean };

export type GetUnitInfoByUniqueNameQueryVariables = Exact<{
  input: UniqueNameInput;
}>;


export type GetUnitInfoByUniqueNameQuery = { __typename?: 'Query', getUnitInfoByUniqueName: { __typename?: 'Unit', hea?: boolean | null, id: string, name: string, uniqueName?: string | null, subHeading?: string | null, skill: string, coverImage?: string | null, popupCover?: string | null, type: string, country?: string | null, default: boolean, description?: string | null, courseId?: string | null, pace?: string | null, tags?: string | null, teacherBox?: string | null, teacherImage?: string | null, box1?: string | null, box2?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, progress?: number | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, isNew?: boolean | null, newLabelPosition?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonLabelPosition?: string | null, comingSoonAt?: string | null, competency?: string | null, unitStudyBox?: string | null, unitStudyHeading?: string | null, isNewCover?: boolean | null, categories?: string | null, suggestedLessonCount?: number | null, suggestedDuration?: string | null, isEducatorCaregiverLessonLayout?: boolean | null, teacherPreparation?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null> | null, alternateMaterials?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null> | null, classPresentation?: Array<{ __typename?: 'Lesson', id: string, name: string, uniqueName?: string | null, description?: string | null, number?: number | null, master?: boolean | null, image?: string | null, duration?: number | null, descriptionHeading?: string | null, descriptionAnswers?: string | null, prerequisite?: boolean | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, status?: string | null, lastVisitedAt?: string | null, group?: string | null, progress?: number | null, alternativeActivated?: boolean | null, isAlternative?: boolean | null, modules?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null }> | null, materials?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null }> | null, sections?: Array<{ __typename?: 'Section', id: string, name: string, position?: number | null, progress?: number | null, status?: string | null, modules?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null }> | null }> | null } | null> | null, studyGuides?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null> | null, studyGuideMaterials?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null> | null, studentQuizzes?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null> | null, unitStudyReview?: { __typename?: 'UnitStudyReview', status: string } | null } };

export type SllGetLessonInfoByUniqueNameQueryVariables = Exact<{
  input: UniqueNameInput;
}>;


export type SllGetLessonInfoByUniqueNameQuery = { __typename?: 'Query', sllGetLessonInfoByUniqueName: { __typename?: 'SLLLesson', id: string, meta?: string | null, status?: string | null, progress?: number | null, name: string, uniqueName?: string | null, coverImage?: string | null, bannerImage?: string | null, coverVideo?: string | null, country: string, ageGroup?: string | null, gradeLabelPosition?: string | null, mainTopics?: string | null, subTopics?: string | null, skill?: string | null, gradeLevel?: string | null, duration: number, lessonMaterialHeading?: string | null, lessonMaterialAnswers?: string | null, overviewHeading1?: string | null, overviewAnswers1?: string | null, overviewHeading2?: string | null, overviewAnswers2?: string | null, recommendedPrior?: string | null, recommendedNext?: string | null, isPublished?: boolean | null, isNew?: boolean | null, newLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonAt?: string | null, comingSoonLabelPosition?: string | null, groupId?: string | null, competency?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isOpReel?: boolean | null, categories?: string | null, isNewCover?: boolean | null, suggestedDuration?: string | null, sllType?: SllLessonType | null, isExtensionAvailable?: boolean | null, isEducatorCaregiverLessonLayout?: boolean | null, lessonType?: string | null, showLessonMaterialsNotice?: boolean | null, lessonDetails?: string | null, materials?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null, presentation?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null, sections?: Array<{ __typename?: 'SLLSection', id: string, name: string, position?: number | null, modules?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null } | null> | null, collections?: Array<{ __typename?: 'SLLLessonCollection', id: string, name: string, collectionType: string } | null> | null, multiCollections?: Array<{ __typename?: 'SLLLessonMultiCollection', id: string, name: string, grade: string, programType?: string | null } | null> | null } };

export type GetAllUnitsWithQuizQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllUnitsWithQuizQuery = { __typename?: 'Query', getAllUnitsWithQuiz: Array<{ __typename?: 'UnitsByProgram', id?: string | null, name?: string | null, units?: Array<{ __typename?: 'Unit', id: string, name: string, uniqueName?: string | null, subHeading?: string | null, skill: string, coverImage?: string | null, popupCover?: string | null, type: string, country?: string | null, default: boolean, description?: string | null, courseId?: string | null, pace?: string | null, tags?: string | null, teacherBox?: string | null, teacherImage?: string | null, box1?: string | null, box2?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, progress?: number | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, isNew?: boolean | null, newLabelPosition?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonLabelPosition?: string | null, comingSoonAt?: string | null, competency?: string | null, unitStudyBox?: string | null, unitStudyHeading?: string | null, isNewCover?: boolean | null, categories?: string | null, suggestedLessonCount?: number | null, suggestedDuration?: string | null, isEducatorCaregiverLessonLayout?: boolean | null, unitStudyReview?: { __typename?: 'UnitStudyReview', status: string } | null }> | null }> };

export type GetAllCollectionsQueryVariables = Exact<{
  input: GetAllCollectionsInput;
}>;


export type GetAllCollectionsQuery = { __typename?: 'Query', getAllCollections?: Array<{ __typename?: 'Collection', id: string, name: string, grade?: string | null, country?: string | null, subHeading?: string | null, subHeadingHighlight?: string | null, collectionType?: CollectionType | null, bannerImage?: string | null, bannerVideo?: string | null, tags?: string | null, requirements?: string | null, addlMatHeading?: string | null, addlMatBox?: string | null, unitOvwHeading1?: string | null, unitOvwBox1?: string | null, unitOvwHeading2?: string | null, unitOvwBox2?: string | null, isSensitive?: number | null, pacing?: string | null, isSubHeading?: boolean | null, sllLessons?: Array<{ __typename?: 'SLLLesson', id: string, name: string, uniqueName?: string | null, coverImage?: string | null, bannerImage?: string | null, coverVideo?: string | null, country: string, gradeLabelPosition?: string | null, mainTopics?: string | null, subTopics?: string | null, skill?: string | null, gradeLevel?: string | null, duration: number, progress?: number | null, isPublished?: boolean | null, isNew?: boolean | null, newLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonAt?: string | null, comingSoonLabelPosition?: string | null, groupId?: string | null, competency?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isOpReel?: boolean | null, categories?: string | null, isNewCover?: boolean | null, suggestedDuration?: string | null, sllType?: SllLessonType | null, isExtensionAvailable?: boolean | null, lessonType?: string | null, showLessonMaterialsNotice?: boolean | null, lessonDetails?: string | null } | null> | null } | null> | null };

export type GetCollectionQueryVariables = Exact<{
  input: IdInput;
}>;


export type GetCollectionQuery = { __typename?: 'Query', getCollection?: { __typename?: 'Collection', id: string, name: string, grade?: string | null, country?: string | null, subHeading?: string | null, subHeadingHighlight?: string | null, collectionType?: CollectionType | null, bannerImage?: string | null, bannerVideo?: string | null, tags?: string | null, requirements?: string | null, addlMatHeading?: string | null, addlMatBox?: string | null, unitOvwHeading1?: string | null, unitOvwBox1?: string | null, unitOvwHeading2?: string | null, unitOvwBox2?: string | null, isSensitive?: number | null, pacing?: string | null, isSubHeading?: boolean | null, sllLessons?: Array<{ __typename?: 'SLLLesson', id: string, name: string, uniqueName?: string | null, coverImage?: string | null, bannerImage?: string | null, coverVideo?: string | null, country: string, gradeLabelPosition?: string | null, mainTopics?: string | null, subTopics?: string | null, skill?: string | null, gradeLevel?: string | null, duration: number, progress?: number | null, isPublished?: boolean | null, isNew?: boolean | null, newLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonAt?: string | null, comingSoonLabelPosition?: string | null, groupId?: string | null, competency?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isOpReel?: boolean | null, categories?: string | null, isNewCover?: boolean | null, suggestedDuration?: string | null, sllType?: SllLessonType | null, isExtensionAvailable?: boolean | null, lessonType?: string | null, showLessonMaterialsNotice?: boolean | null, lessonDetails?: string | null, presentation?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null } | null> | null } | null };

export type CreateCollectionMutationVariables = Exact<{
  input: CreateCollectionInput;
}>;


export type CreateCollectionMutation = { __typename?: 'Mutation', createCollection?: { __typename?: 'Collection', id: string, name: string, grade?: string | null, country?: string | null, subHeading?: string | null, subHeadingHighlight?: string | null, collectionType?: CollectionType | null, bannerImage?: string | null, bannerVideo?: string | null, tags?: string | null, requirements?: string | null, addlMatHeading?: string | null, addlMatBox?: string | null, unitOvwHeading1?: string | null, unitOvwBox1?: string | null, unitOvwHeading2?: string | null, unitOvwBox2?: string | null, isSensitive?: number | null, pacing?: string | null, isSubHeading?: boolean | null, sllLessons?: Array<{ __typename?: 'SLLLesson', id: string, name: string, uniqueName?: string | null, coverImage?: string | null, bannerImage?: string | null, coverVideo?: string | null, country: string, gradeLabelPosition?: string | null, mainTopics?: string | null, subTopics?: string | null, skill?: string | null, gradeLevel?: string | null, duration: number, progress?: number | null, isPublished?: boolean | null, isNew?: boolean | null, newLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonAt?: string | null, comingSoonLabelPosition?: string | null, groupId?: string | null, competency?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isOpReel?: boolean | null, categories?: string | null, isNewCover?: boolean | null, suggestedDuration?: string | null, sllType?: SllLessonType | null, isExtensionAvailable?: boolean | null, lessonType?: string | null, showLessonMaterialsNotice?: boolean | null, lessonDetails?: string | null } | null> | null } | null };

export type UpdateCollectionMutationVariables = Exact<{
  input: UpdateCollectionInput;
}>;


export type UpdateCollectionMutation = { __typename?: 'Mutation', updateCollection?: { __typename?: 'Collection', id: string, name: string, grade?: string | null, country?: string | null, subHeading?: string | null, subHeadingHighlight?: string | null, collectionType?: CollectionType | null, bannerImage?: string | null, bannerVideo?: string | null, tags?: string | null, requirements?: string | null, addlMatHeading?: string | null, addlMatBox?: string | null, unitOvwHeading1?: string | null, unitOvwBox1?: string | null, unitOvwHeading2?: string | null, unitOvwBox2?: string | null, isSensitive?: number | null, pacing?: string | null, isSubHeading?: boolean | null, sllLessons?: Array<{ __typename?: 'SLLLesson', id: string, name: string, uniqueName?: string | null, coverImage?: string | null, bannerImage?: string | null, coverVideo?: string | null, country: string, gradeLabelPosition?: string | null, mainTopics?: string | null, subTopics?: string | null, skill?: string | null, gradeLevel?: string | null, duration: number, progress?: number | null, isPublished?: boolean | null, isNew?: boolean | null, newLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonAt?: string | null, comingSoonLabelPosition?: string | null, groupId?: string | null, competency?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isOpReel?: boolean | null, categories?: string | null, isNewCover?: boolean | null, suggestedDuration?: string | null, sllType?: SllLessonType | null, isExtensionAvailable?: boolean | null, lessonType?: string | null, showLessonMaterialsNotice?: boolean | null, lessonDetails?: string | null } | null> | null } | null };

export type DeleteCollectionMutationVariables = Exact<{
  input: IdInput;
}>;


export type DeleteCollectionMutation = { __typename?: 'Mutation', deleteCollection?: boolean | null };

export type SaveCollectionLessonsMutationVariables = Exact<{
  input: SaveCollectionLessonsInput;
}>;


export type SaveCollectionLessonsMutation = { __typename?: 'Mutation', saveCollectionLessons?: boolean | null };

export type GetMyQuizzesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyQuizzesQuery = { __typename?: 'Query', myQuizzes?: Array<{ __typename?: 'Quiz', id: string, name: string, unitIds?: Array<string> | null, color?: string | null, darkColor?: string | null, feedbackForm?: { __typename?: 'FeedbackFormContent', id: string, programName?: string | null, unitName?: string | null, lessonName?: string | null, className?: string | null, createdAt?: string | null, exitTicketCount?: number | null, expirationAt?: string | null, formData?: string | null, isCancelled?: boolean | null, type?: number | null, link?: string | null } | null }> | null };

export type CreateQuizMutationVariables = Exact<{
  input: CreateQuizInput;
}>;


export type CreateQuizMutation = { __typename?: 'Mutation', createQuiz: string };

export type UpdateQuizMutationVariables = Exact<{
  input: UpdateQuizInput;
}>;


export type UpdateQuizMutation = { __typename?: 'Mutation', updateQuiz: boolean };

export type UpdateQuizNameMutationVariables = Exact<{
  input: UpdateQuizNameInput;
}>;


export type UpdateQuizNameMutation = { __typename?: 'Mutation', updateQuizName: boolean };

export type DeleteQuizMutationVariables = Exact<{
  input: IdInput;
}>;


export type DeleteQuizMutation = { __typename?: 'Mutation', deleteQuiz: boolean };

export type CreateQuizFeedbackFormMutationVariables = Exact<{
  input: QuizFeedbackFormInput;
}>;


export type CreateQuizFeedbackFormMutation = { __typename?: 'Mutation', createQuizFeedbackForm?: { __typename?: 'FeedbackFormContent', id: string, programName?: string | null, unitName?: string | null, lessonName?: string | null, className?: string | null, createdAt?: string | null, exitTicketCount?: number | null, expirationAt?: string | null, formData?: string | null, isCancelled?: boolean | null, type?: number | null, link?: string | null, grade: string, mcId?: string | null, mcName?: string | null, collectionId?: string | null, collectionName?: string | null, createdBy?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, disabled?: boolean | null, role: string, status: string, updatedAt?: string | null, admin?: string | null, districtSchools?: string | null, completedLessonCount?: number | null, schoolNewYearInfo?: string | null, disabledPwLogin?: boolean | null, autoLogoutEnabled?: boolean | null, customer?: { __typename?: 'Customer', id: string, name: string, country?: string | null, trial?: boolean | null, state?: string | null } | null, schools?: Array<{ __typename?: 'School', id: string, name: string, groupIds?: string | null, isPrimary?: boolean | null, programs?: string | null, grades?: string | null } | null> | null } | null } | null };

export type GetQuizQueryVariables = Exact<{
  input: IdInput;
}>;


export type GetQuizQuery = { __typename?: 'Query', getQuiz: { __typename?: 'QuizContent', id: string, name: string, color?: string | null, darkColor?: string | null, contents?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null }> | null } };

export type GetStudyReviewUnitQueryVariables = Exact<{
  input: IdInput;
}>;


export type GetStudyReviewUnitQuery = { __typename?: 'Query', getUnitInfo: { __typename?: 'Unit', id: string, name: string, uniqueName?: string | null, subHeading?: string | null, skill: string, coverImage?: string | null, popupCover?: string | null, type: string, country?: string | null, default: boolean, description?: string | null, courseId?: string | null, pace?: string | null, tags?: string | null, teacherBox?: string | null, teacherImage?: string | null, box1?: string | null, box2?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, progress?: number | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, isNew?: boolean | null, newLabelPosition?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonLabelPosition?: string | null, comingSoonAt?: string | null, competency?: string | null, unitStudyBox?: string | null, unitStudyHeading?: string | null, isNewCover?: boolean | null, categories?: string | null, suggestedLessonCount?: number | null, suggestedDuration?: string | null, isEducatorCaregiverLessonLayout?: boolean | null, teacherPreparation?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null> | null, classPresentation?: Array<{ __typename?: 'Lesson', id: string, name: string, uniqueName?: string | null, description?: string | null, number?: number | null, master?: boolean | null, image?: string | null, duration?: number | null, descriptionHeading?: string | null, descriptionAnswers?: string | null, prerequisite?: boolean | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, status?: string | null, lastVisitedAt?: string | null, group?: string | null, progress?: number | null, alternativeActivated?: boolean | null, isAlternative?: boolean | null, modules?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null }> | null, materials?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null }> | null, sections?: Array<{ __typename?: 'Section', id: string, name: string, position?: number | null, progress?: number | null, status?: string | null, modules?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null }> | null }> | null } | null> | null, studyGuides?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null> | null, studyGuideMaterials?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null> | null, unitStudyReview?: { __typename?: 'UnitStudyReview', status: string } | null } };

export type VideoSubtitlesQueryVariables = Exact<{
  assetId?: InputMaybe<Scalars['String']['input']>;
  playbackId?: InputMaybe<Scalars['String']['input']>;
}>;


export type VideoSubtitlesQuery = { __typename?: 'Query', videoSubtitles?: Array<{ __typename?: 'VideoSubtitle', id?: string | null, languageCode?: string | null, name?: string | null } | null> | null };

export type SllGetPreProgramInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type SllGetPreProgramInfoQuery = { __typename?: 'Query', sllGetPreProgramInfo: { __typename?: 'SLLLesson', id: string, meta?: string | null, status?: string | null, progress?: number | null, name: string, uniqueName?: string | null, coverImage?: string | null, bannerImage?: string | null, coverVideo?: string | null, country: string, ageGroup?: string | null, gradeLabelPosition?: string | null, mainTopics?: string | null, subTopics?: string | null, skill?: string | null, gradeLevel?: string | null, duration: number, lessonMaterialHeading?: string | null, lessonMaterialAnswers?: string | null, overviewHeading1?: string | null, overviewAnswers1?: string | null, overviewHeading2?: string | null, overviewAnswers2?: string | null, recommendedPrior?: string | null, recommendedNext?: string | null, isPublished?: boolean | null, isNew?: boolean | null, newLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonAt?: string | null, comingSoonLabelPosition?: string | null, groupId?: string | null, competency?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isOpReel?: boolean | null, categories?: string | null, isNewCover?: boolean | null, suggestedDuration?: string | null, sllType?: SllLessonType | null, isExtensionAvailable?: boolean | null, isEducatorCaregiverLessonLayout?: boolean | null, lessonType?: string | null, showLessonMaterialsNotice?: boolean | null, lessonDetails?: string | null, materials?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null, presentation?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null, sections?: Array<{ __typename?: 'SLLSection', id: string, name: string, position?: number | null, modules?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null } | null> | null, collections?: Array<{ __typename?: 'SLLLessonCollection', id: string, name: string, collectionType: string } | null> | null, multiCollections?: Array<{ __typename?: 'SLLLessonMultiCollection', id: string, name: string, grade: string, programType?: string | null } | null> | null } };

export type SllPreProgramQuizQueryVariables = Exact<{
  input: IdInput;
}>;


export type SllPreProgramQuizQuery = { __typename?: 'Query', sllPreProgramQuiz?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null }> | null };

export type SslCreatePreProgramFeedbackFormMutationVariables = Exact<{
  input: SllPreProgramQuizInput;
}>;


export type SslCreatePreProgramFeedbackFormMutation = { __typename?: 'Mutation', sslCreatePreProgramFeedbackForm: { __typename?: 'FeedbackFormContent', unitName?: string | null, type?: number | null, programName?: string | null, link?: string | null, lessonName?: string | null, isCancelled?: boolean | null, id: string, formData?: string | null, expirationAt?: string | null, exitTicketCount?: number | null, createdAt?: string | null, className?: string | null, grade: string } };

export type AllProgramsForSuperAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type AllProgramsForSuperAdminQuery = { __typename?: 'Query', allProgramsForSuperAdmin?: Array<{ __typename?: 'Program', id: string, name: string, image?: string | null, description?: string | null, favorite?: boolean | null, lastUsed?: string | null, isTest?: boolean | null, isParentCourse?: boolean | null, isSpecial?: boolean | null, order?: number | null, country?: string | null, coverVideo?: string | null, meta?: string | null, isCustomized?: boolean | null, progress?: number | null, primary?: Array<{ __typename?: 'Unit', id: string, name: string, uniqueName?: string | null, subHeading?: string | null, skill: string, coverImage?: string | null, popupCover?: string | null, type: string, country?: string | null, default: boolean, description?: string | null, courseId?: string | null, pace?: string | null, tags?: string | null, teacherBox?: string | null, teacherImage?: string | null, box1?: string | null, box2?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, progress?: number | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, isNew?: boolean | null, newLabelPosition?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonLabelPosition?: string | null, comingSoonAt?: string | null, competency?: string | null, unitStudyBox?: string | null, unitStudyHeading?: string | null, isNewCover?: boolean | null, categories?: string | null, suggestedLessonCount?: number | null, suggestedDuration?: string | null, isEducatorCaregiverLessonLayout?: boolean | null, unitStudyReview?: { __typename?: 'UnitStudyReview', status: string } | null }> | null, additional?: Array<{ __typename?: 'Unit', id: string, name: string, uniqueName?: string | null, subHeading?: string | null, skill: string, coverImage?: string | null, popupCover?: string | null, type: string, country?: string | null, default: boolean, description?: string | null, courseId?: string | null, pace?: string | null, tags?: string | null, teacherBox?: string | null, teacherImage?: string | null, box1?: string | null, box2?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, progress?: number | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, isNew?: boolean | null, newLabelPosition?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonLabelPosition?: string | null, comingSoonAt?: string | null, competency?: string | null, unitStudyBox?: string | null, unitStudyHeading?: string | null, isNewCover?: boolean | null, categories?: string | null, suggestedLessonCount?: number | null, suggestedDuration?: string | null, isEducatorCaregiverLessonLayout?: boolean | null, unitStudyReview?: { __typename?: 'UnitStudyReview', status: string } | null }> | null, grade?: { __typename?: 'Grade', id: string, name?: string | null, position?: number | null } | null } | null> | null };

export type GetAllUnitsAndSllLessonsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllUnitsAndSllLessonsQuery = { __typename?: 'Query', getAllUnitsAndSLLLessons: { __typename?: 'UnitAndSLLLesson', sllLessons?: Array<{ __typename?: 'SLLLesson', id: string, meta?: string | null, status?: string | null, progress?: number | null, name: string, uniqueName?: string | null, coverImage?: string | null, bannerImage?: string | null, coverVideo?: string | null, country: string, ageGroup?: string | null, gradeLabelPosition?: string | null, mainTopics?: string | null, subTopics?: string | null, skill?: string | null, gradeLevel?: string | null, duration: number, lessonMaterialHeading?: string | null, lessonMaterialAnswers?: string | null, overviewHeading1?: string | null, overviewAnswers1?: string | null, overviewHeading2?: string | null, overviewAnswers2?: string | null, recommendedPrior?: string | null, recommendedNext?: string | null, isPublished?: boolean | null, isNew?: boolean | null, newLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonAt?: string | null, comingSoonLabelPosition?: string | null, groupId?: string | null, competency?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isOpReel?: boolean | null, categories?: string | null, isNewCover?: boolean | null, suggestedDuration?: string | null, sllType?: SllLessonType | null, isExtensionAvailable?: boolean | null, isEducatorCaregiverLessonLayout?: boolean | null, lessonType?: string | null, showLessonMaterialsNotice?: boolean | null, lessonDetails?: string | null, materials?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null, presentation?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null, sections?: Array<{ __typename?: 'SLLSection', id: string, name: string, position?: number | null, modules?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null } | null> | null, collections?: Array<{ __typename?: 'SLLLessonCollection', id: string, name: string, collectionType: string } | null> | null, multiCollections?: Array<{ __typename?: 'SLLLessonMultiCollection', id: string, name: string, grade: string, programType?: string | null } | null> | null } | null> | null, units?: Array<{ __typename?: 'Unit', id: string, name: string, uniqueName?: string | null, subHeading?: string | null, skill: string, coverImage?: string | null, popupCover?: string | null, type: string, country?: string | null, default: boolean, description?: string | null, courseId?: string | null, pace?: string | null, tags?: string | null, teacherBox?: string | null, teacherImage?: string | null, box1?: string | null, box2?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, progress?: number | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, isNew?: boolean | null, newLabelPosition?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonLabelPosition?: string | null, comingSoonAt?: string | null, competency?: string | null, unitStudyBox?: string | null, unitStudyHeading?: string | null, isNewCover?: boolean | null, categories?: string | null, suggestedLessonCount?: number | null, suggestedDuration?: string | null, isEducatorCaregiverLessonLayout?: boolean | null, unitStudyReview?: { __typename?: 'UnitStudyReview', status: string } | null } | null> | null } };

export type SaveReelsProgramMutationVariables = Exact<{
  input: Array<SaveReelInput> | SaveReelInput;
}>;


export type SaveReelsProgramMutation = { __typename?: 'Mutation', saveReel?: boolean | null };

export type GetAusCourseQueryVariables = Exact<{
  input: IdInput;
}>;


export type GetAusCourseQuery = { __typename?: 'Query', getAUSCourse: { __typename?: 'AUSProgram', id: string, country?: string | null, coverVideo?: string | null, description?: string | null, image?: string | null, isCustomized?: boolean | null, isParentCourse?: boolean | null, isSpecial?: boolean | null, isTest?: boolean | null, name: string, meta?: string | null, courseContents?: Array<{ __typename?: 'AUSCourseContent', categories: string, comingSoonAt: string, coverImage: string, gradeLevel: string, id: string, isComingSoon: boolean, isNew: boolean, isNewCover: boolean, isOpReel: boolean, isUpdated: boolean, name: string, number: number, progress: number, subHeading: string, suggestedDuration: string, suggestedLessonCount: number, type: CourseContentType, comingSoonLabelPosition: string, newLabelPosition: string, updatedLabelPosition: string }> | null, grade?: { __typename?: 'Grade', id: string, name?: string | null, position?: number | null } | null } };

export type GetCourseContentsQueryVariables = Exact<{
  input: IdInput;
}>;


export type GetCourseContentsQuery = { __typename?: 'Query', getCourseContents: { __typename?: 'CourseContent', primary?: Array<{ __typename?: 'Unit', id: string, name: string, uniqueName?: string | null, subHeading?: string | null, skill: string, coverImage?: string | null, popupCover?: string | null, type: string, country?: string | null, default: boolean, description?: string | null, courseId?: string | null, pace?: string | null, tags?: string | null, teacherBox?: string | null, teacherImage?: string | null, box1?: string | null, box2?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, progress?: number | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, isNew?: boolean | null, newLabelPosition?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonLabelPosition?: string | null, comingSoonAt?: string | null, competency?: string | null, unitStudyBox?: string | null, unitStudyHeading?: string | null, isNewCover?: boolean | null, categories?: string | null, suggestedLessonCount?: number | null, suggestedDuration?: string | null, isEducatorCaregiverLessonLayout?: boolean | null, unitStudyReview?: { __typename?: 'UnitStudyReview', status: string } | null }> | null, additional?: Array<{ __typename?: 'Unit', id: string, name: string, uniqueName?: string | null, subHeading?: string | null, skill: string, coverImage?: string | null, popupCover?: string | null, type: string, country?: string | null, default: boolean, description?: string | null, courseId?: string | null, pace?: string | null, tags?: string | null, teacherBox?: string | null, teacherImage?: string | null, box1?: string | null, box2?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, progress?: number | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, isNew?: boolean | null, newLabelPosition?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonLabelPosition?: string | null, comingSoonAt?: string | null, competency?: string | null, unitStudyBox?: string | null, unitStudyHeading?: string | null, isNewCover?: boolean | null, categories?: string | null, suggestedLessonCount?: number | null, suggestedDuration?: string | null, isEducatorCaregiverLessonLayout?: boolean | null, unitStudyReview?: { __typename?: 'UnitStudyReview', status: string } | null }> | null } };

export type GetAusCourseContentsQueryVariables = Exact<{
  input: IdInput;
}>;


export type GetAusCourseContentsQuery = { __typename?: 'Query', getAUSCourseContents?: Array<{ __typename?: 'AUSCourseContent', categories: string, comingSoonAt: string, coverImage: string, gradeLevel: string, id: string, isComingSoon: boolean, isNew: boolean, isNewCover: boolean, isOpReel: boolean, isUpdated: boolean, name: string, number: number, progress: number, subHeading: string, suggestedDuration: string, suggestedLessonCount: number, type: CourseContentType, comingSoonLabelPosition: string, newLabelPosition: string, updatedLabelPosition: string }> | null };

export type RegisteredUsersQueryVariables = Exact<{
  input: AnalyticsInput;
}>;


export type RegisteredUsersQuery = { __typename?: 'Query', registeredUsers: { __typename?: 'SummaryMetaData', items?: Array<number | null> | null, result?: number | null, total?: number | null } };

export type LoginAnalyticsQueryVariables = Exact<{
  input: AnalyticsInput;
}>;


export type LoginAnalyticsQuery = { __typename?: 'Query', loginAnalytics: { __typename?: 'LoginAnalyticsData', total: { __typename?: 'TotalLoginAnalyticsData', items?: Array<number | null> | null, count?: number | null, data?: Array<{ __typename?: 'LoginDataByUser', count: number, name?: string | null } | null> | null }, unique: { __typename?: 'TotalLoginAnalyticsData', items?: Array<number | null> | null, count?: number | null } } };

export type LessonsByTeacherQueryVariables = Exact<{
  input: AnalyticsInput;
}>;


export type LessonsByTeacherQuery = { __typename?: 'Query', lessonsByTeacher?: { __typename?: 'PaginationLessonCompleted', total?: number | null, totalTimeSpent?: number | null, data?: Array<{ __typename?: 'LessonCompleted', teacherName: string, schoolName: string, engagement: number, totalLogins: number, totalSessions: number, activeSessions: number, completedLessons: number, lastActiveAt: string, lastSessionAt: string, timeSpent?: number | null, items?: Array<{ __typename?: 'EducatorLessonItem', completedAt?: string | null, grade?: string | null, lessonId?: string | null, lessonName?: string | null, lessonType?: string | null, lessonPosition?: number | null, type?: string | null, unitName?: string | null } | null> | null } | null> | null } | null };

export type EducatorWellBeingByLessonsQueryVariables = Exact<{
  input: AnalyticsInput;
}>;


export type EducatorWellBeingByLessonsQuery = { __typename?: 'Query', educatorWellBeingByLessons?: Array<{ __typename?: 'EducatorWellBeingByLessonsType', lessonId?: string | null, lessonName?: string | null, lessonsCompleted?: number | null, progress?: number | null, lessons?: Array<{ __typename?: 'WellBeingLesson', completedAt: string, schoolId?: string | null, schoolName?: string | null, teacherId?: string | null, teacherName?: string | null } | null> | null } | null> | null };

export type GetPostProgramQuizUnitQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPostProgramQuizUnitQuery = { __typename?: 'Query', getPostProgramQuizUnit: { __typename?: 'Unit', id: string, name: string, uniqueName?: string | null, subHeading?: string | null, skill: string, coverImage?: string | null, popupCover?: string | null, type: string, country?: string | null, default: boolean, description?: string | null, courseId?: string | null, pace?: string | null, tags?: string | null, teacherBox?: string | null, teacherImage?: string | null, box1?: string | null, box2?: string | null, skillsHeading?: string | null, helpfulHeading?: string | null, progress?: number | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, isNew?: boolean | null, newLabelPosition?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonLabelPosition?: string | null, comingSoonAt?: string | null, competency?: string | null, unitStudyBox?: string | null, unitStudyHeading?: string | null, isNewCover?: boolean | null, categories?: string | null, suggestedLessonCount?: number | null, suggestedDuration?: string | null, isEducatorCaregiverLessonLayout?: boolean | null, teacherPreparation?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null> | null, alternateMaterials?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null> | null, classPresentation?: Array<{ __typename?: 'Lesson', id: string, name: string, uniqueName?: string | null, description?: string | null, number?: number | null, master?: boolean | null, image?: string | null, duration?: number | null, descriptionHeading?: string | null, descriptionAnswers?: string | null, prerequisite?: boolean | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, status?: string | null, lastVisitedAt?: string | null, group?: string | null, progress?: number | null, alternativeActivated?: boolean | null, isAlternative?: boolean | null, modules?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null }> | null, materials?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null }> | null, sections?: Array<{ __typename?: 'Section', id: string, name: string, position?: number | null, progress?: number | null, status?: string | null, modules?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null }> | null }> | null } | null> | null, studyGuides?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null> | null, studyGuideMaterials?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null } | null> | null, unitStudyReview?: { __typename?: 'UnitStudyReview', status: string } | null } };

export type GetLessonsByGradeQueryVariables = Exact<{
  input: AnalyticsInput;
}>;


export type GetLessonsByGradeQuery = { __typename?: 'Query', lessonsByGrade?: { __typename?: 'LessonsByGrade', byCompetency?: { __typename?: 'LessonsByCompetency', relationshipSkills?: number | null, responsibleDecisionMaking?: number | null, selfAwareness?: number | null, selfManagement?: number | null, socialAwareness?: number | null } | null, byGrade?: { __typename?: 'PaginationLessonByCourse', total?: number | null, data?: Array<{ __typename?: 'LessonByCourse', grade?: string | null, lessonsCompleted?: number | null, progress?: number | null, lessons?: Array<{ __typename?: 'CourseLesson', completedLessons?: number | null, teacherName?: string | null, schoolName?: string | null, grade?: string | null, items?: Array<{ __typename?: 'LessonDetails', completedAt: string, lessonId?: string | null, lessonName?: string | null, lessonPosition?: string | null, unitId?: string | null, unitName?: string | null, lessonType?: string | null, type?: string | null } | null> | null } | null> | null } | null> | null } | null, summary?: { __typename?: 'SummaryMetaData', items?: Array<number | null> | null, result?: number | null, total?: number | null } | null } | null };

export type GetSurveySubmittedQueryVariables = Exact<{
  input: AnalyticsInput;
}>;


export type GetSurveySubmittedQuery = { __typename?: 'Query', surveySubmitted?: { __typename?: 'SurveySubmitted', exitTicket?: { __typename?: 'SurveySummaryData', result?: number | null, total?: number | null, items?: Array<{ __typename?: 'SurveySummaryDetail', dateCompleted?: string | null, educator?: string | null, grade?: string | null, lessonName?: string | null, responses?: number | null, score?: number | null } | null> | null } | null, preProgramQuiz?: { __typename?: 'SurveySummaryData', result?: number | null, total?: number | null, items?: Array<{ __typename?: 'SurveySummaryDetail', dateCompleted?: string | null, educator?: string | null, grade?: string | null, responses?: number | null, score?: number | null } | null> | null } | null } | null };

export type DistrictCompetencyRatingQueryVariables = Exact<{
  input: AnalyticsInput;
}>;


export type DistrictCompetencyRatingQuery = { __typename?: 'Query', districtCompetencyRating?: { __typename?: 'CompetencyRating', relationshipSkills?: number | null, responsibleDecisionMaking?: number | null, selfAwareness?: number | null, selfManagement?: number | null, socialAwareness?: number | null } | null };

export type SaveTimeSpentMutationVariables = Exact<{
  input: TimeSpentInput;
}>;


export type SaveTimeSpentMutation = { __typename?: 'Mutation', userTimeSpent?: boolean | null };

export type SllGetPopularLessonsQueryVariables = Exact<{
  input?: InputMaybe<SllGetPopularLessonsInput>;
}>;


export type SllGetPopularLessonsQuery = { __typename?: 'Query', sllGetPopularLessons: Array<{ __typename?: 'SLLLesson', id: string, name: string, progress?: number | null, competency?: string | null, categories?: string | null, coverImage?: string | null, duration: number, lessonType?: string | null } | null> };

export type GetAllMultiCollectionsQueryVariables = Exact<{
  input: GetAllMultiCollectionsInput;
}>;


export type GetAllMultiCollectionsQuery = { __typename?: 'Query', getAllMultiCollections?: Array<{ __typename?: 'MultiCollection', country: string, grade: string, id: string, isScopeAndSeq?: number | null, name: string, scopeAndSeqId?: string | null, type: MultiCollectionType, collections?: Array<{ __typename?: 'Collection', addlMatBox?: string | null, addlMatHeading?: string | null, bannerImage?: string | null, bannerVideo?: string | null, country?: string | null, grade?: string | null, id: string, isSensitive?: number | null, name: string, requirements?: string | null, subHeading?: string | null, tags?: string | null, unitOvwBox1?: string | null, unitOvwBox2?: string | null, unitOvwHeading1?: string | null, unitOvwHeading2?: string | null, sllLessons?: Array<{ __typename?: 'SLLLesson', id: string, name: string, progress?: number | null, competency?: string | null, categories?: string | null, coverImage?: string | null, duration: number, lessonType?: string | null } | null> | null } | null> | null } | null> | null };

export type GetListNormalMultiCollectionsQueryVariables = Exact<{
  input: ListNormalMultiCollectionsInput;
}>;


export type GetListNormalMultiCollectionsQuery = { __typename?: 'Query', listNormalMultiCollections?: Array<{ __typename?: 'MultiCollection', country: string, grade: string, id: string, description?: string | null, hidden?: boolean | null, isScopeAndSeq?: number | null, name: string, scopeAndSeqId?: string | null, type: MultiCollectionType, position?: number | null, collections?: Array<{ __typename?: 'Collection', id: string, name: string, bannerImage?: string | null, bannerVideo?: string | null, tags?: string | null, sllLessons?: Array<{ __typename?: 'SLLLesson', id: string, name: string, progress?: number | null, competency?: string | null, categories?: string | null, coverImage?: string | null, duration: number, lessonType?: string | null } | null> | null } | null> | null } | null> | null };

export type CreateMultiCollectionMutationVariables = Exact<{
  input: CreateMultiCollectionInput;
}>;


export type CreateMultiCollectionMutation = { __typename?: 'Mutation', createMultiCollection?: { __typename?: 'MultiCollection', country: string, grade: string, id: string, isScopeAndSeq?: number | null, name: string, scopeAndSeqId?: string | null, type: MultiCollectionType, position?: number | null, collections?: Array<{ __typename?: 'Collection', id: string, name: string, grade?: string | null, country?: string | null, subHeading?: string | null, subHeadingHighlight?: string | null, collectionType?: CollectionType | null, bannerImage?: string | null, bannerVideo?: string | null, tags?: string | null, requirements?: string | null, addlMatHeading?: string | null, addlMatBox?: string | null, unitOvwHeading1?: string | null, unitOvwBox1?: string | null, unitOvwHeading2?: string | null, unitOvwBox2?: string | null, isSensitive?: number | null, pacing?: string | null, isSubHeading?: boolean | null, sllLessons?: Array<{ __typename?: 'SLLLesson', id: string, name: string, uniqueName?: string | null, coverImage?: string | null, bannerImage?: string | null, coverVideo?: string | null, country: string, gradeLabelPosition?: string | null, mainTopics?: string | null, subTopics?: string | null, skill?: string | null, gradeLevel?: string | null, duration: number, progress?: number | null, isPublished?: boolean | null, isNew?: boolean | null, newLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonAt?: string | null, comingSoonLabelPosition?: string | null, groupId?: string | null, competency?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isOpReel?: boolean | null, categories?: string | null, isNewCover?: boolean | null, suggestedDuration?: string | null, sllType?: SllLessonType | null, isExtensionAvailable?: boolean | null, lessonType?: string | null, showLessonMaterialsNotice?: boolean | null, lessonDetails?: string | null } | null> | null } | null> | null } | null };

export type UpdateMultiCollectionMutationVariables = Exact<{
  input: UpdateMultiCollectionInput;
}>;


export type UpdateMultiCollectionMutation = { __typename?: 'Mutation', updateMultiCollection?: { __typename?: 'MultiCollection', country: string, grade: string, id: string, isScopeAndSeq?: number | null, name: string, scopeAndSeqId?: string | null, type: MultiCollectionType, position?: number | null, collections?: Array<{ __typename?: 'Collection', id: string, name: string, grade?: string | null, country?: string | null, subHeading?: string | null, subHeadingHighlight?: string | null, collectionType?: CollectionType | null, bannerImage?: string | null, bannerVideo?: string | null, tags?: string | null, requirements?: string | null, addlMatHeading?: string | null, addlMatBox?: string | null, unitOvwHeading1?: string | null, unitOvwBox1?: string | null, unitOvwHeading2?: string | null, unitOvwBox2?: string | null, isSensitive?: number | null, pacing?: string | null, isSubHeading?: boolean | null, sllLessons?: Array<{ __typename?: 'SLLLesson', id: string, name: string, uniqueName?: string | null, coverImage?: string | null, bannerImage?: string | null, coverVideo?: string | null, country: string, gradeLabelPosition?: string | null, mainTopics?: string | null, subTopics?: string | null, skill?: string | null, gradeLevel?: string | null, duration: number, progress?: number | null, isPublished?: boolean | null, isNew?: boolean | null, newLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonAt?: string | null, comingSoonLabelPosition?: string | null, groupId?: string | null, competency?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isOpReel?: boolean | null, categories?: string | null, isNewCover?: boolean | null, suggestedDuration?: string | null, sllType?: SllLessonType | null, isExtensionAvailable?: boolean | null, lessonType?: string | null, showLessonMaterialsNotice?: boolean | null, lessonDetails?: string | null } | null> | null } | null> | null } | null };

export type DeleteMultiCollectionMutationVariables = Exact<{
  input: IdInput;
}>;


export type DeleteMultiCollectionMutation = { __typename?: 'Mutation', deleteMultiCollection: boolean };

export type SaveMultiCollectionsMutationVariables = Exact<{
  input: Array<SaveMultiCollectionsInput> | SaveMultiCollectionsInput;
}>;


export type SaveMultiCollectionsMutation = { __typename?: 'Mutation', saveMultiCollections?: boolean | null };

export type GetMultiCollectionQueryVariables = Exact<{
  input: IdInput;
}>;


export type GetMultiCollectionQuery = { __typename?: 'Query', getMultiCollection?: { __typename?: 'NormalMultiCollection', country: string, grade: string, id: string, isScopeAndSeq?: number | null, name: string, scopeAndSeqId?: string | null, content?: Array<{ __typename?: 'MultiCollectionContent', id: string, name: string, position: number, subHeading?: string | null, isNewCover?: boolean | null, ageGroup?: string | null, bannerImage?: string | null, bannerVideo?: string | null, categories?: string | null, collectionType?: CollectionType | null, coverImage?: string | null, grade?: string | null, gradeLevel?: string | null, suggestedDuration?: string | null, suggestedLessonCount?: number | null, type: MultiCollectionContentType, duration?: string | null, competency?: string | null, progress?: number | null, lessonType?: string | null, lessonDetails?: string | null, isNew?: boolean | null, newLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonAt?: string | null, comingSoonLabelPosition?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null } | null> | null } | null };

export type GetMultiCollectionsQueryVariables = Exact<{
  input: IDsInput;
}>;


export type GetMultiCollectionsQuery = { __typename?: 'Query', getMultiCollections?: Array<{ __typename?: 'NormalMultiCollection', country: string, grade: string, id: string, isScopeAndSeq?: number | null, name: string, scopeAndSeqId?: string | null, content?: Array<{ __typename?: 'MultiCollectionContent', id: string, name: string, position: number, subHeading?: string | null, isNewCover?: boolean | null, ageGroup?: string | null, bannerImage?: string | null, bannerVideo?: string | null, categories?: string | null, collectionType?: CollectionType | null, coverImage?: string | null, grade?: string | null, gradeLevel?: string | null, suggestedDuration?: string | null, suggestedLessonCount?: number | null, type: MultiCollectionContentType, duration?: string | null, competency?: string | null, progress?: number | null, lessonType?: string | null, lessonDetails?: string | null, isNew?: boolean | null, newLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonAt?: string | null, comingSoonLabelPosition?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null } | null> | null } | null> | null };

export type SearchLessonLibraryQueryVariables = Exact<{
  input: LessonLibrarySearchInput;
}>;


export type SearchLessonLibraryQuery = { __typename?: 'Query', searchLessonLibrary?: Array<{ __typename?: 'LessonLibrarySearchResult', mCollectionId: string, mCollectionName: string, mIsScopeandSeq?: string | null, mScopeAndSeqId?: string | null, position: number, content: Array<{ __typename?: 'LessonForLessonLibrary', id: string, name: string, competency: string, categories: string, coverImage: string, duration: string, mainTopics: string, isExtensionAvailable?: boolean | null, lessonType: string } | null> } | null> | null };

export type CreateAbsentStudentLessonMutationVariables = Exact<{
  input: AbsentStudentLessonInput;
}>;


export type CreateAbsentStudentLessonMutation = { __typename?: 'Mutation', createAbsentStudentLesson: { __typename?: 'AbsentStudentLesson', id: string, createdBy: string, expireAt: string, generatedAt: string, isActive: boolean, isSLL: boolean, lessonId: string, link: string, studentsCount: number } };

export type GetAbsentStudentLessonQueryVariables = Exact<{
  input: IdInput;
}>;


export type GetAbsentStudentLessonQuery = { __typename?: 'Query', getAbsentStudentLesson?: { __typename?: 'AbsentStudentLesson', id: string, createdBy: string, expireAt: string, generatedAt: string, isActive: boolean, isSLL: boolean, lessonId: string, link: string, studentsCount: number } | null };

export type CancelAbsentStudentLessonMutationVariables = Exact<{
  input: IdInput;
}>;


export type CancelAbsentStudentLessonMutation = { __typename?: 'Mutation', cancelAbsentStudentLesson?: boolean | null };

export type GetLessonInfoByLinkQueryVariables = Exact<{
  input: AbsentStudentLessonByLinkInput;
}>;


export type GetLessonInfoByLinkQuery = { __typename?: 'Query', getLessonInfoByLink: { __typename?: 'Lesson', id: string, name: string, uniqueName?: string | null, description?: string | null, number?: number | null, master?: boolean | null, image?: string | null, duration?: number | null, descriptionHeading?: string | null, descriptionAnswers?: string | null, prerequisite?: boolean | null, sensitive?: boolean | null, sensitiveTooltip?: string | null, status?: string | null, lastVisitedAt?: string | null, group?: string | null, progress?: number | null, alternativeActivated?: boolean | null, isAlternative?: boolean | null, modules?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null }> | null, materials?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null }> | null, sections?: Array<{ __typename?: 'Section', id: string, name: string, position?: number | null, progress?: number | null, status?: string | null, modules?: Array<{ __typename?: 'Content', id: string, name: string, lastInGroup?: boolean | null, type: ContentType, description?: string | null, data?: string | null, position?: number | null, pauseHere?: boolean | null, formData?: string | null, meta?: string | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, created: string, updated: string, isRequired?: boolean | null }> | null }> | null } };

export type GetSllLessonInfoByLinkQueryVariables = Exact<{
  input: AbsentStudentLessonByLinkInput;
}>;


export type GetSllLessonInfoByLinkQuery = { __typename?: 'Query', getSllLessonInfoByLink: { __typename?: 'SLLLesson', id: string, meta?: string | null, status?: string | null, progress?: number | null, name: string, uniqueName?: string | null, coverImage?: string | null, bannerImage?: string | null, coverVideo?: string | null, country: string, ageGroup?: string | null, gradeLabelPosition?: string | null, mainTopics?: string | null, subTopics?: string | null, skill?: string | null, gradeLevel?: string | null, duration: number, lessonMaterialHeading?: string | null, lessonMaterialAnswers?: string | null, overviewHeading1?: string | null, overviewAnswers1?: string | null, overviewHeading2?: string | null, overviewAnswers2?: string | null, recommendedPrior?: string | null, recommendedNext?: string | null, isPublished?: boolean | null, isNew?: boolean | null, newLabelPosition?: string | null, isComingSoon?: boolean | null, comingSoonAt?: string | null, comingSoonLabelPosition?: string | null, groupId?: string | null, competency?: string | null, isUpdated?: boolean | null, updatedLabelPosition?: string | null, isOpReel?: boolean | null, categories?: string | null, isNewCover?: boolean | null, suggestedDuration?: string | null, sllType?: SllLessonType | null, isExtensionAvailable?: boolean | null, isEducatorCaregiverLessonLayout?: boolean | null, lessonType?: string | null, showLessonMaterialsNotice?: boolean | null, lessonDetails?: string | null, materials?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null, presentation?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null, sections?: Array<{ __typename?: 'SLLSection', id: string, name: string, position?: number | null, modules?: Array<{ __typename?: 'SLLModule', id: string, name: string, type: ContentType, data?: string | null, formData?: string | null, meta?: string | null, lastInGroup?: boolean | null, pauseHere?: boolean | null, lastInLesson?: boolean | null, additionalAfter?: boolean | null, position?: number | null, isRequired?: boolean | null } | null> | null } | null> | null, collections?: Array<{ __typename?: 'SLLLessonCollection', id: string, name: string, collectionType: string } | null> | null, multiCollections?: Array<{ __typename?: 'SLLLessonMultiCollection', id: string, name: string, grade: string, programType?: string | null } | null> | null } };

export type UpdateMeMutationVariables = Exact<{
  input: UserUpdateInput;
}>;


export type UpdateMeMutation = { __typename?: 'Mutation', updateMe: string };

export type EducatorResilientClassroomByLessonsQueryVariables = Exact<{
  input: AnalyticsInput;
}>;


export type EducatorResilientClassroomByLessonsQuery = { __typename?: 'Query', educatorResilientClassroomByLessons?: Array<{ __typename?: 'EducatorWellBeingByLessonsType', lessonId?: string | null, lessonName?: string | null, lessonsCompleted?: number | null, progress?: number | null, lessons?: Array<{ __typename?: 'WellBeingLesson', completedAt: string, schoolId?: string | null, schoolName?: string | null, teacherId?: string | null, teacherName?: string | null } | null> | null } | null> | null };

export type SubmitFeedbackFormAnswerForAbsentMutationVariables = Exact<{
  input: FeedbackFormAnswerForAbsentInput;
}>;


export type SubmitFeedbackFormAnswerForAbsentMutation = { __typename?: 'Mutation', submitFeedbackFormAnswerForAbsent?: { __typename?: 'FeedbackFormContentAnswer', id: string, formId: string, formData?: string | null, createdAt?: string | null } | null };

export type DistrictAdminInviteUsersMutationVariables = Exact<{
  input?: InputMaybe<Array<InputMaybe<DistrictAdminBulkInviteUserInput>> | InputMaybe<DistrictAdminBulkInviteUserInput>>;
}>;


export type DistrictAdminInviteUsersMutation = { __typename?: 'Mutation', districtAdminInviteUsers?: Array<{ __typename?: 'User', id: string, firstName: string, lastName: string, email: string } | null> | null };

export type ConvertTextToAudioMutationVariables = Exact<{
  text: Scalars['String']['input'];
  isAU?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ConvertTextToAudioMutation = { __typename?: 'Mutation', convertTextToAudio: string };

export type GetProgramsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProgramsQuery = { __typename?: 'Query', getPrograms?: Array<{ __typename?: 'SLLProgram', avgDuration?: string | null, bannerDesc?: string | null, bannerImage?: string | null, country: string, description?: string | null, grade?: string | null, id: string, isShown: boolean, labels?: string | null, learnMoreDesc?: string | null, name: string, numberOfLessons?: string | null, tier?: string | null, iconUrl?: string | null, hoverText?: string | null, position?: number | null, mcs?: Array<{ __typename?: 'MultiCollection', country: string, grade: string, id: string, description?: string | null, hidden?: boolean | null, name: string, position?: number | null } | null> | null }> | null };

export type CreateSllProgramMutationVariables = Exact<{
  input: SllCreateProgramInput;
}>;


export type CreateSllProgramMutation = { __typename?: 'Mutation', sllCreateProgram: { __typename?: 'SLLProgram', avgDuration?: string | null, bannerDesc?: string | null, bannerImage?: string | null, country: string, description?: string | null, grade?: string | null, id: string, isShown: boolean, labels?: string | null, learnMoreDesc?: string | null, name: string, numberOfLessons?: string | null, tier?: string | null, iconUrl?: string | null, hoverText?: string | null, position?: number | null, mcs?: Array<{ __typename?: 'MultiCollection', country: string, grade: string, id: string, description?: string | null, hidden?: boolean | null, name: string, position?: number | null } | null> | null } };

export type UpdateSllProgramMutationVariables = Exact<{
  input: SllUpdateProgramInput;
}>;


export type UpdateSllProgramMutation = { __typename?: 'Mutation', sllUpdateProgram: { __typename?: 'SLLProgram', avgDuration?: string | null, bannerDesc?: string | null, bannerImage?: string | null, country: string, description?: string | null, grade?: string | null, id: string, isShown: boolean, labels?: string | null, learnMoreDesc?: string | null, name: string, numberOfLessons?: string | null, tier?: string | null, iconUrl?: string | null, hoverText?: string | null, position?: number | null, mcs?: Array<{ __typename?: 'MultiCollection', country: string, grade: string, id: string, description?: string | null, hidden?: boolean | null, name: string, position?: number | null } | null> | null } };

export type DeleteSllProgramMutationVariables = Exact<{
  input: IdInput;
}>;


export type DeleteSllProgramMutation = { __typename?: 'Mutation', sllDeleteProgram: boolean };

export type AddMcToProgramMutationVariables = Exact<{
  input: AddMcToProgramInput;
}>;


export type AddMcToProgramMutation = { __typename?: 'Mutation', addMCToProgram: boolean };

export type RemoveMcFromProgramMutationVariables = Exact<{
  input: RemoveMcFromProgramInput;
}>;


export type RemoveMcFromProgramMutation = { __typename?: 'Mutation', removeMCFromProgram: boolean };

export type GetListMultiCollectionsQueryVariables = Exact<{
  input: ListNormalMultiCollectionsInput;
}>;


export type GetListMultiCollectionsQuery = { __typename?: 'Query', listNormalMultiCollections?: Array<{ __typename?: 'MultiCollection', country: string, grade: string, id: string, description?: string | null, hidden?: boolean | null, name: string, position?: number | null } | null> | null };

export type GetProgramQueryVariables = Exact<{
  input: IdInput;
}>;


export type GetProgramQuery = { __typename?: 'Query', getProgram?: { __typename?: 'SLLProgram', avgDuration?: string | null, bannerDesc?: string | null, bannerImage?: string | null, country: string, description?: string | null, grade?: string | null, id: string, isShown: boolean, labels?: string | null, learnMoreDesc?: string | null, name: string, numberOfLessons?: string | null, tier?: string | null, iconUrl?: string | null, hoverText?: string | null, position?: number | null, mcs?: Array<{ __typename?: 'MultiCollection', country: string, grade: string, id: string, description?: string | null, hidden?: boolean | null, name: string, position?: number | null } | null> | null } | null };

export type UploadZipSlideMutationVariables = Exact<{
  input: UploadZipSlideInput;
}>;


export type UploadZipSlideMutation = { __typename?: 'Mutation', uploadZIPSlide: boolean };

export type GetZipSlideUrlQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  isCourse?: InputMaybe<Scalars['Boolean']['input']>;
  isHomeEd?: InputMaybe<Scalars['Boolean']['input']>;
  groupId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetZipSlideUrlQuery = { __typename?: 'Query', getZIPSlideUrl: string };

export type DeleteAccountMutationVariables = Exact<{
  input: UserIdInput;
}>;


export type DeleteAccountMutation = { __typename?: 'Mutation', deleteAccount?: boolean | null };

export type DeleteSchoolMutationVariables = Exact<{
  input: UserIdInput;
}>;


export type DeleteSchoolMutation = { __typename?: 'Mutation', deleteSchool?: boolean | null };

export type GenerateAwsKeysMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateAwsKeysMutation = { __typename?: 'Mutation', generateAWSKeys: { __typename?: 'AWSKeys', AccessKeyId: string, SecretKey: string, SessionToken: string, Expiration: string } };

export type AddUrlToAirtableMutationVariables = Exact<{
  urls: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AddUrlToAirtableMutation = { __typename?: 'Mutation', addUrlToAirtable: boolean };

export type AiSearchLessonCardFragment = { __typename?: 'AiSearchLesson', mCollectionId: string, mCollectionName: string, grades: Array<string>, lesson: { __typename?: 'LessonForLessonLibrary', id: string, name: string, competency: string, categories: string, coverImage: string, duration: string, mainTopics: string, isExtensionAvailable?: boolean | null, lessonType: string } };

export type AiSearchLessonLibraryQueryVariables = Exact<{
  input: AiLessonLibrarySearchInput;
}>;


export type AiSearchLessonLibraryQuery = { __typename?: 'Query', aiSearchLessonLibrary?: Array<{ __typename?: 'LessonLibrarySearchResult', mCollectionId: string, mCollectionName: string, mIsScopeandSeq?: string | null, mScopeAndSeqId?: string | null, position: number, content: Array<{ __typename?: 'LessonForLessonLibrary', id: string, name: string, competency: string, categories: string, coverImage: string, duration: string, mainTopics: string, isExtensionAvailable?: boolean | null, lessonType: string } | null> } | null> | null };

export type AiLessonChatMutationVariables = Exact<{
  input: AiLessonChatInput;
}>;


export type AiLessonChatMutation = { __typename?: 'Mutation', aiLessonChat: { __typename?: 'AiLessonChatResult', answer: string, sources: Array<{ __typename?: 'AiLessonChatSource', namespace: string, name: string }>, lessons: Array<{ __typename?: 'AiSearchLesson', mCollectionId: string, mCollectionName: string, grades: Array<string>, lesson: { __typename?: 'LessonForLessonLibrary', id: string, name: string, competency: string, categories: string, coverImage: string, duration: string, mainTopics: string, isExtensionAvailable?: boolean | null, lessonType: string } } | null> } };

export type GetSupportedLanguagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSupportedLanguagesQuery = { __typename?: 'Query', supportedLanguages: Array<string> };

export type TranslateTextMutationVariables = Exact<{
  input: TranslateTextInput;
}>;


export type TranslateTextMutation = { __typename?: 'Mutation', translateText: { __typename?: 'TranslationResult', translatedText: string, targetLanguage: string } };

export type TranslateTextsMutationVariables = Exact<{
  input: TranslateTextsInput;
}>;


export type TranslateTextsMutation = { __typename?: 'Mutation', translateTexts: { __typename?: 'TranslationBatchResult', translatedTexts: Array<string>, targetLanguage: string } };

export type GenerateEnglishCaptionsMutationVariables = Exact<{
  input: GenerateEnglishCaptionsInput;
}>;


export type GenerateEnglishCaptionsMutation = { __typename?: 'Mutation', generateEnglishCaptions: { __typename?: 'EnglishCaptionJob', id: string, userId: string, videoUrl: string, status: EnglishCaptionStatus, progressPercentage: number, subtitleUrl?: string | null, errorMessage?: string | null, createdAt: string, updatedAt: string, completedAt?: string | null } };

export type GetEnglishCaptionJobQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetEnglishCaptionJobQuery = { __typename?: 'Query', englishCaptionJob?: { __typename?: 'EnglishCaptionJob', id: string, userId: string, videoUrl: string, status: EnglishCaptionStatus, progressPercentage: number, subtitleUrl?: string | null, errorMessage?: string | null, createdAt: string, updatedAt: string, completedAt?: string | null } | null };

export type CreateTranslationJobMutationVariables = Exact<{
  input: CreateTranslationJobInput;
}>;


export type CreateTranslationJobMutation = { __typename?: 'Mutation', createTranslationJob: { __typename?: 'TranslationJob', id: string, userId: string, videoUrl: string, targetLanguages: Array<string>, status: TranslationStatus, progressPercentage: number, translationResults?: any | null, errorMessage?: string | null, externalJobId?: string | null, createdAt: string, updatedAt: string, completedAt?: string | null, englishSubtitleUrl?: string | null, languageJobs?: Array<{ __typename?: 'TranslationLanguageJob', id: string, parentJobId: string, languageCode: string, status: TranslationLanguageStatus, subtitleUrl?: string | null, errorMessage?: string | null, retryCount: number, maxRetries: number, createdAt: string, updatedAt: string, completedAt?: string | null }> | null } };

export type GetTranslationJobQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetTranslationJobQuery = { __typename?: 'Query', translationJob?: { __typename?: 'TranslationJob', id: string, userId: string, videoUrl: string, targetLanguages: Array<string>, status: TranslationStatus, progressPercentage: number, translationResults?: any | null, errorMessage?: string | null, externalJobId?: string | null, createdAt: string, updatedAt: string, completedAt?: string | null, englishSubtitleUrl?: string | null, languageJobs?: Array<{ __typename?: 'TranslationLanguageJob', id: string, parentJobId: string, languageCode: string, status: TranslationLanguageStatus, subtitleUrl?: string | null, errorMessage?: string | null, retryCount: number, maxRetries: number, createdAt: string, updatedAt: string, completedAt?: string | null }> | null } | null };

export const SurveyFormReportFragmentDoc = gql`
    fragment SurveyFormReport on SurveyFormReport {
  id
  type
  createdBy
  createdAt
  expirationAt
  programName
  lessonName
  unitName
  className
  isSent
  isCancelled
  email_status
  email_error
  email_attempts
  last_email_attempt
  firstName
  lastName
  email
  schoolName
  feedbackFormCount
  dataIntact
}
    `;
export const UserFragmentDoc = gql`
    fragment User on User {
  id
  firstName
  lastName
  email
  disabled
  customer {
    id
    name
    country
    trial
    state
  }
  role
  schools {
    id
    name
    groupIds
    isPrimary
    programs
    grades
  }
  status
  updatedAt
  admin
  districtSchools
  completedLessonCount
  schoolNewYearInfo
  disabledPwLogin
  autoLogoutEnabled
}
    `;
export const ExtendedUserFragmentDoc = gql`
    fragment ExtendedUser on User {
  ...User
  subject
  firstLoginFormFilled
  usages
  roleDesc
  createdAt
  position {
    id
    name
  }
  uiStatus {
    isLLDescriptionHidden
    isSVDescriptionHidden
    isTDescriptionHidden
    isSIDescriptionHidden
    isBBDescriptionHidden
    isSBDescriptionHidden
    isCCDescriptionHidden
  }
  previousLoginAt
}
    ${UserFragmentDoc}`;
export const HeaUserFragmentDoc = gql`
    fragment HEAUser on HEAUser {
  id
  email
  firstName
  lastName
  status
  enableFaith
  enablePasscode
  locked
  studyplanId
  registeredAt
  studyplanName
  studyplanCount
  association
  blocked
  expired
  expireAt
  isTypeformShown
}
    `;
export const SllGroupModuleFragmentDoc = gql`
    fragment SLLGroupModule on SLLGroupModule {
  moduleId
  groupId
  groupName
  data
  meta
  formData
}
    `;
export const LessonContentFragmentDoc = gql`
    fragment LessonContent on SLLLesson {
  id
  name
  uniqueName
  coverImage
  bannerImage
  coverVideo
  country
  gradeLabelPosition
  mainTopics
  subTopics
  skill
  gradeLevel
  duration
  progress
  isPublished
  isNew
  newLabelPosition
  isComingSoon
  comingSoonAt
  comingSoonLabelPosition
  groupId
  competency
  isUpdated
  updatedLabelPosition
  isOpReel
  categories
  isNewCover
  suggestedDuration
  sllType
  isExtensionAvailable
  lessonType
  showLessonMaterialsNotice
  lessonDetails
}
    `;
export const SllModuleFragmentDoc = gql`
    fragment SLLModule on SLLModule {
  id
  name
  type
  data
  formData
  meta
  lastInGroup
  pauseHere
  lastInLesson
  additionalAfter
  position
  isRequired
}
    `;
export const CollectionWithPresentationFragmentDoc = gql`
    fragment CollectionWithPresentation on Collection {
  id
  name
  grade
  country
  subHeading
  subHeadingHighlight
  collectionType
  bannerImage
  bannerVideo
  tags
  requirements
  addlMatHeading
  addlMatBox
  unitOvwHeading1
  unitOvwBox1
  unitOvwHeading2
  unitOvwBox2
  isSensitive
  pacing
  isSubHeading
  sllLessons {
    ...LessonContent
    presentation {
      ...SLLModule
    }
  }
}
    ${LessonContentFragmentDoc}
${SllModuleFragmentDoc}`;
export const CollectionFragmentDoc = gql`
    fragment Collection on Collection {
  id
  name
  grade
  country
  subHeading
  subHeadingHighlight
  collectionType
  bannerImage
  bannerVideo
  tags
  requirements
  addlMatHeading
  addlMatBox
  unitOvwHeading1
  unitOvwBox1
  unitOvwHeading2
  unitOvwBox2
  isSensitive
  pacing
  isSubHeading
  sllLessons {
    ...LessonContent
  }
}
    ${LessonContentFragmentDoc}`;
export const MultiCollectionFragmentDoc = gql`
    fragment MultiCollection on MultiCollection {
  collections {
    ...Collection
  }
  country
  grade
  id
  isScopeAndSeq
  name
  scopeAndSeqId
  type
  position
}
    ${CollectionFragmentDoc}`;
export const MultiCollectionContentFragmentDoc = gql`
    fragment MultiCollectionContent on MultiCollectionContent {
  id
  name
  position
  subHeading
  isNewCover
  ageGroup
  bannerImage
  bannerVideo
  categories
  collectionType
  coverImage
  grade
  gradeLevel
  suggestedDuration
  suggestedLessonCount
  type
  duration
  competency
  progress
  lessonType
  lessonDetails
  isNew
  newLabelPosition
  isComingSoon
  comingSoonAt
  comingSoonLabelPosition
  isUpdated
  updatedLabelPosition
}
    `;
export const NormalMultiCollectionFragmentDoc = gql`
    fragment NormalMultiCollection on NormalMultiCollection {
  content {
    ...MultiCollectionContent
  }
  country
  grade
  id
  isScopeAndSeq
  name
  scopeAndSeqId
}
    ${MultiCollectionContentFragmentDoc}`;
export const CollectionLessonFragmentDoc = gql`
    fragment CollectionLesson on SLLLesson {
  id
  name
  progress
  competency
  categories
  coverImage
  duration
  lessonType
}
    `;
export const DefaultCollectionFragmentDoc = gql`
    fragment DefaultCollection on Collection {
  id
  name
  bannerImage
  bannerVideo
  tags
  sllLessons {
    ...CollectionLesson
  }
}
    ${CollectionLessonFragmentDoc}`;
export const DefaultMultiCollectionFragmentDoc = gql`
    fragment DefaultMultiCollection on MultiCollection {
  collections {
    ...DefaultCollection
  }
  country
  grade
  id
  description
  hidden
  isScopeAndSeq
  name
  scopeAndSeqId
  type
  position
}
    ${DefaultCollectionFragmentDoc}`;
export const BannerContentFragmentDoc = gql`
    fragment BannerContent on Content {
  id
  name
  data
}
    `;
export const SllLessonContentFragmentDoc = gql`
    fragment SLLLessonContent on SLLLesson {
  name
  uniqueName
  coverImage
  bannerImage
  coverVideo
  country
  ageGroup
  gradeLabelPosition
  mainTopics
  subTopics
  skill
  gradeLevel
  duration
  lessonMaterialHeading
  lessonMaterialAnswers
  overviewHeading1
  overviewAnswers1
  overviewHeading2
  overviewAnswers2
  recommendedPrior
  recommendedNext
  isPublished
  isNew
  newLabelPosition
  isComingSoon
  comingSoonAt
  comingSoonLabelPosition
  groupId
  competency
  isUpdated
  updatedLabelPosition
  isOpReel
  categories
  isNewCover
  suggestedDuration
  sllType
  isExtensionAvailable
  isEducatorCaregiverLessonLayout
  lessonType
  showLessonMaterialsNotice
  lessonDetails
}
    `;
export const SllSectionFragmentDoc = gql`
    fragment SLLSection on SLLSection {
  id
  name
  position
  modules {
    ...SLLModule
  }
}
    ${SllModuleFragmentDoc}`;
export const SllLessonCollectionFragmentDoc = gql`
    fragment SLLLessonCollection on SLLLessonCollection {
  id
  name
  collectionType
}
    `;
export const SllLessonMultiCollectionFragmentDoc = gql`
    fragment SLLLessonMultiCollection on SLLLessonMultiCollection {
  id
  name
  grade
  programType
}
    `;
export const SllLessonFragmentDoc = gql`
    fragment SLLLesson on SLLLesson {
  id
  ...SLLLessonContent
  meta
  materials {
    ...SLLModule
  }
  presentation {
    ...SLLModule
  }
  sections {
    ...SLLSection
  }
  status
  progress
  collections {
    ...SLLLessonCollection
  }
  multiCollections {
    ...SLLLessonMultiCollection
  }
}
    ${SllLessonContentFragmentDoc}
${SllModuleFragmentDoc}
${SllSectionFragmentDoc}
${SllLessonCollectionFragmentDoc}
${SllLessonMultiCollectionFragmentDoc}`;
export const SllLessonForSaFragmentDoc = gql`
    fragment SLLLessonForSA on SLLLesson {
  id
  ...SLLLessonContent
  meta
  materials {
    ...SLLModule
  }
  presentation {
    ...SLLModule
  }
  sections {
    ...SLLSection
  }
}
    ${SllLessonContentFragmentDoc}
${SllModuleFragmentDoc}
${SllSectionFragmentDoc}`;
export const SllDefaultLessonForSaFragmentDoc = gql`
    fragment SLLDefaultLessonForSA on SLLLesson {
  id
  ...SLLLessonContent
}
    ${SllLessonContentFragmentDoc}`;
export const AusCourseContentFragmentDoc = gql`
    fragment AUSCourseContent on AUSCourseContent {
  categories
  comingSoonAt
  coverImage
  gradeLevel
  id
  isComingSoon
  isNew
  isNewCover
  isOpReel
  isUpdated
  name
  number
  progress
  subHeading
  suggestedDuration
  suggestedLessonCount
  type
  comingSoonLabelPosition
  newLabelPosition
  updatedLabelPosition
}
    `;
export const StudyPlanContentFragmentDoc = gql`
    fragment StudyPlanContent on StudyPlan {
  id
  name
  color
  darkColor
  unitIds
}
    `;
export const UnitContentFragmentDoc = gql`
    fragment UnitContent on Unit {
  id
  name
  uniqueName
  subHeading
  skill
  coverImage
  popupCover
  type
  country
  default
  description
  courseId
  pace
  tags
  teacherBox
  teacherImage
  box1
  box2
  skillsHeading
  helpfulHeading
  progress
  sensitive
  sensitiveTooltip
  isNew
  newLabelPosition
  isUpdated
  updatedLabelPosition
  isComingSoon
  comingSoonLabelPosition
  comingSoonAt
  competency
  unitStudyBox
  unitStudyHeading
  isNewCover
  categories
  suggestedLessonCount
  suggestedDuration
  unitStudyReview {
    status
  }
  isEducatorCaregiverLessonLayout
}
    `;
export const ProgramFragmentDoc = gql`
    fragment Program on Program {
  id
  name
  image
  primary {
    ...UnitContent
  }
  additional {
    ...UnitContent
  }
  description
  favorite
  lastUsed
  grade {
    id
    name
    position
  }
  isTest
  isParentCourse
  isSpecial
  order
  country
  coverVideo
  meta
  isCustomized
  progress
}
    ${UnitContentFragmentDoc}`;
export const RestrictProgramFragmentDoc = gql`
    fragment RestrictProgram on Program {
  id
  name
  image
  description
  favorite
  lastUsed
  grade {
    id
    name
    position
  }
  isTest
  isParentCourse
  isSpecial
  order
  country
  coverVideo
  meta
  isCustomized
  progress
}
    `;
export const SpecialProgramFragmentDoc = gql`
    fragment SpecialProgram on SpecialProgram {
  id
  iconType
  program {
    id
    name
    grade {
      position
    }
  }
  name
  adminOnly
  position
}
    `;
export const EditProgramFragmentDoc = gql`
    fragment EditProgram on Program {
  id
  name
  image
  description
  grade {
    id
  }
  isParentCourse
  country
  coverVideo
}
    `;
export const ContentFragmentDoc = gql`
    fragment Content on Content {
  id
  name
  lastInGroup
  type
  description
  data
  position
  pauseHere
  formData
  meta
  lastInLesson
  additionalAfter
  created
  updated
  isRequired
}
    `;
export const SectionFragmentDoc = gql`
    fragment Section on Section {
  id
  name
  position
  progress
  status
  modules {
    ...Content
  }
}
    ${ContentFragmentDoc}`;
export const LessonFragmentDoc = gql`
    fragment Lesson on Lesson {
  id
  name
  uniqueName
  description
  number
  master
  image
  duration
  descriptionHeading
  descriptionAnswers
  prerequisite
  sensitive
  sensitiveTooltip
  modules {
    ...Content
  }
  materials {
    ...Content
  }
  sections {
    ...Section
  }
  status
  lastVisitedAt
  group
  progress
  alternativeActivated
  isAlternative
}
    ${ContentFragmentDoc}
${SectionFragmentDoc}`;
export const ExtendedUnitFragmentDoc = gql`
    fragment ExtendedUnit on Unit {
  ...UnitContent
  teacherPreparation {
    ...Content
  }
  alternateMaterials {
    ...Content
  }
  classPresentation {
    ...Lesson
  }
  studyGuides {
    ...Content
  }
  studyGuideMaterials {
    ...Content
  }
}
    ${UnitContentFragmentDoc}
${ContentFragmentDoc}
${LessonFragmentDoc}`;
export const ShortenUnitFragmentDoc = gql`
    fragment ShortenUnit on Unit {
  ...UnitContent
  teacherPreparation {
    ...Content
  }
  classPresentation {
    ...Lesson
  }
  studyGuides {
    ...Content
  }
  studyGuideMaterials {
    ...Content
  }
}
    ${UnitContentFragmentDoc}
${ContentFragmentDoc}
${LessonFragmentDoc}`;
export const HeaUnitContentFragmentDoc = gql`
    fragment HEAUnitContent on HEAUnit {
  id
  originalUnitId
  name
  subHeading
  coverImage
  popupCover
  pace
  topics
  tags
  box1
  box2
  description
  parentBox
  skillsHeading
  helpfulHeading
  parentImage
  skillsHeading
  helpfulHeading
  ageGroup
  sensitive
  sensitiveTooltip
}
    `;
export const HeaModuleFragmentDoc = gql`
    fragment HEAModule on HEAModule {
  id
  originalModuleId
  name
  type
  data
  position
  formData
  meta
}
    `;
export const HeaPresentationModuleFragmentDoc = gql`
    fragment HEAPresentationModule on HEAPresentationModule {
  id
  name
  lastInGroup
  type
  description
  data
  position
  pauseHere
  formData
  meta
  lastInLesson
  useDefault
}
    `;
export const HeaLessonFragmentDoc = gql`
    fragment HEALesson on HEALesson {
  id
  originalLessonId
  name
  description
  number
  image
  duration
  descriptionHeading
  descriptionAnswers
  prerequisite
  sensitive
  sensitiveTooltip
  group
  modules {
    ...HEAPresentationModule
  }
}
    ${HeaPresentationModuleFragmentDoc}`;
export const ExtendedHeaUnitFragmentDoc = gql`
    fragment ExtendedHEAUnit on HEAUnit {
  ...HEAUnitContent
  parentPreparation {
    ...HEAModule
  }
  classPresentation {
    ...HEALesson
  }
}
    ${HeaUnitContentFragmentDoc}
${HeaModuleFragmentDoc}
${HeaLessonFragmentDoc}`;
export const ExtendedUnitWithHeaFragmentDoc = gql`
    fragment ExtendedUnitWithHEA on Unit {
  ...UnitContent
  teacherPreparation {
    ...Content
  }
  alternateMaterials {
    ...Content
  }
  classPresentation {
    ...Lesson
    modules {
      ...Content
    }
  }
  studyGuides {
    ...Content
  }
  studyGuideMaterials {
    ...Content
  }
  studentQuizzes {
    ...Content
  }
  hea
}
    ${UnitContentFragmentDoc}
${ContentFragmentDoc}
${LessonFragmentDoc}`;
export const SchoolDataFragmentDoc = gql`
    fragment SchoolData on School {
  id
  name
  status
  exitTicketCC
  preProgramQuizCC
  disabledPwLogin
  groups {
    id
    name
  }
  dataCollections {
    id
    name
  }
  courses {
    id
  }
}
    `;
export const ExtendedCustomerFragmentDoc = gql`
    fragment ExtendedCustomer on ExtendedCustomer {
  id
  name
  trial
  country
  state
  city
  expiry
  disabledPwLogin
  dataCollections {
    id
    name
  }
}
    `;
export const GroupContentFragmentDoc = gql`
    fragment GroupContent on GroupContent {
  contentId
  groupId
  data
  meta
  formData
}
    `;
export const SchoolProgramIdFragmentDoc = gql`
    fragment SchoolProgramID on SchoolProgramID {
  id
  customized
  newId
}
    `;
export const CustomizedProgramFragmentDoc = gql`
    fragment CustomizedProgram on CustomizedProgram {
  programId
  primary
  additional
}
    `;
export const LastVisitedLessonContentFragmentDoc = gql`
    fragment LastVisitedLessonContent on LastVisitedLesson {
  userId
  lessonId
  moduleId
  unitId
  pageNumber
  status
  lastVisitedAt
  sectionId
}
    `;
export const SllLastVisitedModuleFragmentDoc = gql`
    fragment SLLLastVisitedModule on SLLLastVisitedModule {
  lastVisitedAt
  lessonId
  moduleId
  pageNumber
  status
}
    `;
export const LastVisitedUnitStudyReviewContentFragmentDoc = gql`
    fragment LastVisitedUnitStudyReviewContent on LastVisitedUnitStudyReview {
  lastVisitedAt
  moduleId
  pageNumber
  status
  unitId
  userId
}
    `;
export const ProgramLastUsedContentFragmentDoc = gql`
    fragment ProgramLastUsedContent on ProgramLastUsed {
  userId
  programId
  lastUsed
}
    `;
export const FeedbackFormContentFragmentDoc = gql`
    fragment FeedbackFormContent on FeedbackFormContent {
  id
  programName
  unitName
  lessonName
  className
  createdAt
  exitTicketCount
  expirationAt
  formData
  isCancelled
  type
  link
  grade
  mcId
  mcName
  collectionId
  collectionName
  createdBy {
    ...User
  }
}
    ${UserFragmentDoc}`;
export const AbsentStudentLessonFragmentDoc = gql`
    fragment AbsentStudentLesson on AbsentStudentLesson {
  id
  createdBy
  expireAt
  generatedAt
  isActive
  isSLL
  lessonId
  link
  studentsCount
}
    `;
export const HeaGroupModuleFragmentDoc = gql`
    fragment HEAGroupModule on HEAGroupModule {
  moduleId
  groupId
  groupName
  data
  meta
  formData
}
    `;
export const LessonToConfirmFragmentDoc = gql`
    fragment LessonToConfirm on LessonToConfirm {
  studyplanId
  studyplanName
  unitId
  lesson {
    ...HEALesson
  }
  incomplete
}
    ${HeaLessonFragmentDoc}`;
export const SllCourseFragmentDoc = gql`
    fragment SLLCourse on SLLCourse {
  id
  name
  color
  darkColor
  lessonIds
}
    `;
export const LessonInProgressFragmentDoc = gql`
    fragment LessonInProgress on LessonInProgress {
  completionCount
  lastCompletedAt
  lessonId
  lessonName
  progress
  status
  unitId
  unitName
  gradeName
}
    `;
export const QuizFragmentDoc = gql`
    fragment Quiz on Quiz {
  id
  name
  unitIds
  color
  darkColor
  feedbackForm {
    id
    programName
    unitName
    lessonName
    className
    createdAt
    exitTicketCount
    expirationAt
    formData
    isCancelled
    type
    link
  }
}
    `;
export const LessonDetailsFragmentDoc = gql`
    fragment LessonDetails on LessonDetails {
  completedAt
  lessonId
  lessonName
  lessonPosition
  unitId
  unitName
  lessonType
  type
}
    `;
export const CourseLessonFragmentDoc = gql`
    fragment CourseLesson on CourseLesson {
  completedLessons
  items {
    ...LessonDetails
  }
  teacherName
  schoolName
  grade
}
    ${LessonDetailsFragmentDoc}`;
export const LessonByCourseFragmentDoc = gql`
    fragment LessonByCourse on LessonByCourse {
  grade
  lessons {
    ...CourseLesson
  }
  lessonsCompleted
  progress
}
    ${CourseLessonFragmentDoc}`;
export const SimpleMultiCollectionFragmentDoc = gql`
    fragment SimpleMultiCollection on MultiCollection {
  country
  grade
  id
  description
  hidden
  name
  position
}
    `;
export const SllProgramFragmentDoc = gql`
    fragment SLLProgram on SLLProgram {
  avgDuration
  bannerDesc
  bannerImage
  country
  description
  grade
  id
  isShown
  labels
  learnMoreDesc
  mcs {
    ...SimpleMultiCollection
  }
  name
  numberOfLessons
  tier
  iconUrl
  hoverText
  position
}
    ${SimpleMultiCollectionFragmentDoc}`;
export const SchoolUserFragmentDoc = gql`
    fragment SchoolUser on SchoolUser {
  id
  email
  firstName
  lastName
  status
  customer {
    id
    name
    trial
  }
  role
  admin
  status
  districtSchools
  lastLoginAt
  totalLogins
  schools {
    id
    name
  }
}
    `;
export const HeTokenFragmentDoc = gql`
    fragment HEToken on HEToken {
  association
  firstName
  lastName
  email
  notes
  token
  generatedAt
  expireAt
  expired
  signups
}
    `;
export const AiSearchLessonCardFragmentDoc = gql`
    fragment AiSearchLessonCard on AiSearchLesson {
  mCollectionId
  mCollectionName
  grades
  lesson {
    id
    name
    competency
    categories
    coverImage
    duration
    mainTopics
    isExtensionAvailable
    lessonType
  }
}
    `;
export const GetReportsDocument = gql`
    query GetReports($input: GetReportsInput!) {
  getReports(input: $input) {
    reports {
      ...SurveyFormReport
    }
    totalCount
    hasMore
  }
}
    ${SurveyFormReportFragmentDoc}`;

/**
 * __useGetReportsQuery__
 *
 * To run a query within a React component, call `useGetReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetReportsQuery(baseOptions: Apollo.QueryHookOptions<GetReportsQuery, GetReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportsQuery, GetReportsQueryVariables>(GetReportsDocument, options);
      }
export function useGetReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportsQuery, GetReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportsQuery, GetReportsQueryVariables>(GetReportsDocument, options);
        }
export type GetReportsQueryHookResult = ReturnType<typeof useGetReportsQuery>;
export type GetReportsLazyQueryHookResult = ReturnType<typeof useGetReportsLazyQuery>;
export type GetReportsQueryResult = Apollo.QueryResult<GetReportsQuery, GetReportsQueryVariables>;
export const ManuallyTriggerReportDocument = gql`
    mutation ManuallyTriggerReport($input: ManuallyTriggerReportInput!) {
  manuallyTriggerReport(input: $input)
}
    `;
export type ManuallyTriggerReportMutationFn = Apollo.MutationFunction<ManuallyTriggerReportMutation, ManuallyTriggerReportMutationVariables>;

/**
 * __useManuallyTriggerReportMutation__
 *
 * To run a mutation, you first call `useManuallyTriggerReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManuallyTriggerReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manuallyTriggerReportMutation, { data, loading, error }] = useManuallyTriggerReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useManuallyTriggerReportMutation(baseOptions?: Apollo.MutationHookOptions<ManuallyTriggerReportMutation, ManuallyTriggerReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManuallyTriggerReportMutation, ManuallyTriggerReportMutationVariables>(ManuallyTriggerReportDocument, options);
      }
export type ManuallyTriggerReportMutationHookResult = ReturnType<typeof useManuallyTriggerReportMutation>;
export type ManuallyTriggerReportMutationResult = Apollo.MutationResult<ManuallyTriggerReportMutation>;
export type ManuallyTriggerReportMutationOptions = Apollo.BaseMutationOptions<ManuallyTriggerReportMutation, ManuallyTriggerReportMutationVariables>;
export const MeDocument = gql`
    query me {
  me {
    ...ExtendedUser
  }
}
    ${ExtendedUserFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const CheckAccessDocument = gql`
    query checkAccess($input: UserIDInput!) {
  checkAccess(input: $input)
}
    `;

/**
 * __useCheckAccessQuery__
 *
 * To run a query within a React component, call `useCheckAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckAccessQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckAccessQuery(baseOptions: Apollo.QueryHookOptions<CheckAccessQuery, CheckAccessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckAccessQuery, CheckAccessQueryVariables>(CheckAccessDocument, options);
      }
export function useCheckAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckAccessQuery, CheckAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckAccessQuery, CheckAccessQueryVariables>(CheckAccessDocument, options);
        }
export type CheckAccessQueryHookResult = ReturnType<typeof useCheckAccessQuery>;
export type CheckAccessLazyQueryHookResult = ReturnType<typeof useCheckAccessLazyQuery>;
export type CheckAccessQueryResult = Apollo.QueryResult<CheckAccessQuery, CheckAccessQueryVariables>;
export const ParentProgramsDocument = gql`
    query parentPrograms {
  parentPrograms {
    ...Program
  }
  parentSpecialPrograms {
    id
    iconType
    name
    program {
      ...Program
    }
    adminOnly
    position
  }
}
    ${ProgramFragmentDoc}`;

/**
 * __useParentProgramsQuery__
 *
 * To run a query within a React component, call `useParentProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useParentProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParentProgramsQuery({
 *   variables: {
 *   },
 * });
 */
export function useParentProgramsQuery(baseOptions?: Apollo.QueryHookOptions<ParentProgramsQuery, ParentProgramsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParentProgramsQuery, ParentProgramsQueryVariables>(ParentProgramsDocument, options);
      }
export function useParentProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParentProgramsQuery, ParentProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParentProgramsQuery, ParentProgramsQueryVariables>(ParentProgramsDocument, options);
        }
export type ParentProgramsQueryHookResult = ReturnType<typeof useParentProgramsQuery>;
export type ParentProgramsLazyQueryHookResult = ReturnType<typeof useParentProgramsLazyQuery>;
export type ParentProgramsQueryResult = Apollo.QueryResult<ParentProgramsQuery, ParentProgramsQueryVariables>;
export const GetProgramByIdDocument = gql`
    query getProgramById($input: IDInput!) {
  getCourse(input: $input) {
    id
    name
    image
    description
    isParentCourse
    isSpecial
    order
    country
    coverVideo
    meta
    primary {
      ...UnitContent
    }
    additional {
      ...UnitContent
    }
  }
}
    ${UnitContentFragmentDoc}`;

/**
 * __useGetProgramByIdQuery__
 *
 * To run a query within a React component, call `useGetProgramByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramByIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetProgramByIdQuery(baseOptions: Apollo.QueryHookOptions<GetProgramByIdQuery, GetProgramByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProgramByIdQuery, GetProgramByIdQueryVariables>(GetProgramByIdDocument, options);
      }
export function useGetProgramByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProgramByIdQuery, GetProgramByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProgramByIdQuery, GetProgramByIdQueryVariables>(GetProgramByIdDocument, options);
        }
export type GetProgramByIdQueryHookResult = ReturnType<typeof useGetProgramByIdQuery>;
export type GetProgramByIdLazyQueryHookResult = ReturnType<typeof useGetProgramByIdLazyQuery>;
export type GetProgramByIdQueryResult = Apollo.QueryResult<GetProgramByIdQuery, GetProgramByIdQueryVariables>;
export const GetLasVisitedLessonByProgramIdDocument = gql`
    query getLasVisitedLessonByProgramId($input: IDInput!) {
  lastVisitedLesson(input: $input) {
    ...LastVisitedLessonContent
  }
}
    ${LastVisitedLessonContentFragmentDoc}`;

/**
 * __useGetLasVisitedLessonByProgramIdQuery__
 *
 * To run a query within a React component, call `useGetLasVisitedLessonByProgramIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLasVisitedLessonByProgramIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLasVisitedLessonByProgramIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetLasVisitedLessonByProgramIdQuery(baseOptions: Apollo.QueryHookOptions<GetLasVisitedLessonByProgramIdQuery, GetLasVisitedLessonByProgramIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLasVisitedLessonByProgramIdQuery, GetLasVisitedLessonByProgramIdQueryVariables>(GetLasVisitedLessonByProgramIdDocument, options);
      }
export function useGetLasVisitedLessonByProgramIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLasVisitedLessonByProgramIdQuery, GetLasVisitedLessonByProgramIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLasVisitedLessonByProgramIdQuery, GetLasVisitedLessonByProgramIdQueryVariables>(GetLasVisitedLessonByProgramIdDocument, options);
        }
export type GetLasVisitedLessonByProgramIdQueryHookResult = ReturnType<typeof useGetLasVisitedLessonByProgramIdQuery>;
export type GetLasVisitedLessonByProgramIdLazyQueryHookResult = ReturnType<typeof useGetLasVisitedLessonByProgramIdLazyQuery>;
export type GetLasVisitedLessonByProgramIdQueryResult = Apollo.QueryResult<GetLasVisitedLessonByProgramIdQuery, GetLasVisitedLessonByProgramIdQueryVariables>;
export const GetCourseDocument = gql`
    query getCourse($input: IDInput!) {
  getCourse(input: $input) {
    id
    grade {
      id
      name
    }
    name
    description
    image
    isTest
    isParentCourse
    isSpecial
    country
    coverVideo
    meta
  }
  getProgramUnits(input: $input) {
    primary
    additional
  }
}
    `;

/**
 * __useGetCourseQuery__
 *
 * To run a query within a React component, call `useGetCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCourseQuery(baseOptions: Apollo.QueryHookOptions<GetCourseQuery, GetCourseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseQuery, GetCourseQueryVariables>(GetCourseDocument, options);
      }
export function useGetCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseQuery, GetCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseQuery, GetCourseQueryVariables>(GetCourseDocument, options);
        }
export type GetCourseQueryHookResult = ReturnType<typeof useGetCourseQuery>;
export type GetCourseLazyQueryHookResult = ReturnType<typeof useGetCourseLazyQuery>;
export type GetCourseQueryResult = Apollo.QueryResult<GetCourseQuery, GetCourseQueryVariables>;
export const SkillsDocument = gql`
    query Skills {
  skills {
    id
    name
  }
}
    `;

/**
 * __useSkillsQuery__
 *
 * To run a query within a React component, call `useSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkillsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSkillsQuery(baseOptions?: Apollo.QueryHookOptions<SkillsQuery, SkillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkillsQuery, SkillsQueryVariables>(SkillsDocument, options);
      }
export function useSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkillsQuery, SkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkillsQuery, SkillsQueryVariables>(SkillsDocument, options);
        }
export type SkillsQueryHookResult = ReturnType<typeof useSkillsQuery>;
export type SkillsLazyQueryHookResult = ReturnType<typeof useSkillsLazyQuery>;
export type SkillsQueryResult = Apollo.QueryResult<SkillsQuery, SkillsQueryVariables>;
export const GetUrlDocument = gql`
    query GetUrl($input: VideoUploadInput!) {
  videoUpload(input: $input) {
    uploadId
    url
  }
}
    `;

/**
 * __useGetUrlQuery__
 *
 * To run a query within a React component, call `useGetUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUrlQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUrlQuery(baseOptions: Apollo.QueryHookOptions<GetUrlQuery, GetUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUrlQuery, GetUrlQueryVariables>(GetUrlDocument, options);
      }
export function useGetUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUrlQuery, GetUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUrlQuery, GetUrlQueryVariables>(GetUrlDocument, options);
        }
export type GetUrlQueryHookResult = ReturnType<typeof useGetUrlQuery>;
export type GetUrlLazyQueryHookResult = ReturnType<typeof useGetUrlLazyQuery>;
export type GetUrlQueryResult = Apollo.QueryResult<GetUrlQuery, GetUrlQueryVariables>;
export const GetAllUnitsDocument = gql`
    query getAllUnits($input: GetAllUnitsInput!) {
  getAllUnits(input: $input) {
    id
    name
    units {
      ...UnitContent
    }
  }
}
    ${UnitContentFragmentDoc}`;

/**
 * __useGetAllUnitsQuery__
 *
 * To run a query within a React component, call `useGetAllUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUnitsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllUnitsQuery(baseOptions: Apollo.QueryHookOptions<GetAllUnitsQuery, GetAllUnitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllUnitsQuery, GetAllUnitsQueryVariables>(GetAllUnitsDocument, options);
      }
export function useGetAllUnitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllUnitsQuery, GetAllUnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllUnitsQuery, GetAllUnitsQueryVariables>(GetAllUnitsDocument, options);
        }
export type GetAllUnitsQueryHookResult = ReturnType<typeof useGetAllUnitsQuery>;
export type GetAllUnitsLazyQueryHookResult = ReturnType<typeof useGetAllUnitsLazyQuery>;
export type GetAllUnitsQueryResult = Apollo.QueryResult<GetAllUnitsQuery, GetAllUnitsQueryVariables>;
export const UnitsDocument = gql`
    query units {
  units {
    ...UnitContent
  }
}
    ${UnitContentFragmentDoc}`;

/**
 * __useUnitsQuery__
 *
 * To run a query within a React component, call `useUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnitsQuery(baseOptions?: Apollo.QueryHookOptions<UnitsQuery, UnitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnitsQuery, UnitsQueryVariables>(UnitsDocument, options);
      }
export function useUnitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnitsQuery, UnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnitsQuery, UnitsQueryVariables>(UnitsDocument, options);
        }
export type UnitsQueryHookResult = ReturnType<typeof useUnitsQuery>;
export type UnitsLazyQueryHookResult = ReturnType<typeof useUnitsLazyQuery>;
export type UnitsQueryResult = Apollo.QueryResult<UnitsQuery, UnitsQueryVariables>;
export const GetUnitDocument = gql`
    query getUnit($input: IDInput!) {
  getUnitInfo(input: $input) {
    ...ExtendedUnit
  }
}
    ${ExtendedUnitFragmentDoc}`;

/**
 * __useGetUnitQuery__
 *
 * To run a query within a React component, call `useGetUnitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUnitQuery(baseOptions: Apollo.QueryHookOptions<GetUnitQuery, GetUnitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitQuery, GetUnitQueryVariables>(GetUnitDocument, options);
      }
export function useGetUnitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitQuery, GetUnitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitQuery, GetUnitQueryVariables>(GetUnitDocument, options);
        }
export type GetUnitQueryHookResult = ReturnType<typeof useGetUnitQuery>;
export type GetUnitLazyQueryHookResult = ReturnType<typeof useGetUnitLazyQuery>;
export type GetUnitQueryResult = Apollo.QueryResult<GetUnitQuery, GetUnitQueryVariables>;
export const HeaGetUnitInfoDocument = gql`
    query heaGetUnitInfo($input: IDInput!) {
  heaGetUnitInfo(input: $input) {
    ...ExtendedHEAUnit
  }
}
    ${ExtendedHeaUnitFragmentDoc}`;

/**
 * __useHeaGetUnitInfoQuery__
 *
 * To run a query within a React component, call `useHeaGetUnitInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeaGetUnitInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeaGetUnitInfoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeaGetUnitInfoQuery(baseOptions: Apollo.QueryHookOptions<HeaGetUnitInfoQuery, HeaGetUnitInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HeaGetUnitInfoQuery, HeaGetUnitInfoQueryVariables>(HeaGetUnitInfoDocument, options);
      }
export function useHeaGetUnitInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HeaGetUnitInfoQuery, HeaGetUnitInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HeaGetUnitInfoQuery, HeaGetUnitInfoQueryVariables>(HeaGetUnitInfoDocument, options);
        }
export type HeaGetUnitInfoQueryHookResult = ReturnType<typeof useHeaGetUnitInfoQuery>;
export type HeaGetUnitInfoLazyQueryHookResult = ReturnType<typeof useHeaGetUnitInfoLazyQuery>;
export type HeaGetUnitInfoQueryResult = Apollo.QueryResult<HeaGetUnitInfoQuery, HeaGetUnitInfoQueryVariables>;
export const GetUnitInfoForSuperAdminDocument = gql`
    query getUnitInfoForSuperAdmin($input: IDInput!) {
  getUnitInfoForSuperAdmin(input: $input) {
    ...ExtendedUnitWithHEA
  }
}
    ${ExtendedUnitWithHeaFragmentDoc}`;

/**
 * __useGetUnitInfoForSuperAdminQuery__
 *
 * To run a query within a React component, call `useGetUnitInfoForSuperAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitInfoForSuperAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitInfoForSuperAdminQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUnitInfoForSuperAdminQuery(baseOptions: Apollo.QueryHookOptions<GetUnitInfoForSuperAdminQuery, GetUnitInfoForSuperAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitInfoForSuperAdminQuery, GetUnitInfoForSuperAdminQueryVariables>(GetUnitInfoForSuperAdminDocument, options);
      }
export function useGetUnitInfoForSuperAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitInfoForSuperAdminQuery, GetUnitInfoForSuperAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitInfoForSuperAdminQuery, GetUnitInfoForSuperAdminQueryVariables>(GetUnitInfoForSuperAdminDocument, options);
        }
export type GetUnitInfoForSuperAdminQueryHookResult = ReturnType<typeof useGetUnitInfoForSuperAdminQuery>;
export type GetUnitInfoForSuperAdminLazyQueryHookResult = ReturnType<typeof useGetUnitInfoForSuperAdminLazyQuery>;
export type GetUnitInfoForSuperAdminQueryResult = Apollo.QueryResult<GetUnitInfoForSuperAdminQuery, GetUnitInfoForSuperAdminQueryVariables>;
export const HeaGetUnitInfoForSuperAdminDocument = gql`
    query heaGetUnitInfoForSuperAdmin($input: IDInput!) {
  heaGetUnitInfoForSuperAdmin(input: $input) {
    ...ExtendedHEAUnit
  }
}
    ${ExtendedHeaUnitFragmentDoc}`;

/**
 * __useHeaGetUnitInfoForSuperAdminQuery__
 *
 * To run a query within a React component, call `useHeaGetUnitInfoForSuperAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeaGetUnitInfoForSuperAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeaGetUnitInfoForSuperAdminQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeaGetUnitInfoForSuperAdminQuery(baseOptions: Apollo.QueryHookOptions<HeaGetUnitInfoForSuperAdminQuery, HeaGetUnitInfoForSuperAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HeaGetUnitInfoForSuperAdminQuery, HeaGetUnitInfoForSuperAdminQueryVariables>(HeaGetUnitInfoForSuperAdminDocument, options);
      }
export function useHeaGetUnitInfoForSuperAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HeaGetUnitInfoForSuperAdminQuery, HeaGetUnitInfoForSuperAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HeaGetUnitInfoForSuperAdminQuery, HeaGetUnitInfoForSuperAdminQueryVariables>(HeaGetUnitInfoForSuperAdminDocument, options);
        }
export type HeaGetUnitInfoForSuperAdminQueryHookResult = ReturnType<typeof useHeaGetUnitInfoForSuperAdminQuery>;
export type HeaGetUnitInfoForSuperAdminLazyQueryHookResult = ReturnType<typeof useHeaGetUnitInfoForSuperAdminLazyQuery>;
export type HeaGetUnitInfoForSuperAdminQueryResult = Apollo.QueryResult<HeaGetUnitInfoForSuperAdminQuery, HeaGetUnitInfoForSuperAdminQueryVariables>;
export const ContentGroupsDocument = gql`
    query ContentGroups($input: IDInput!) {
  contentGroups(input: $input)
}
    `;

/**
 * __useContentGroupsQuery__
 *
 * To run a query within a React component, call `useContentGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentGroupsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContentGroupsQuery(baseOptions: Apollo.QueryHookOptions<ContentGroupsQuery, ContentGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentGroupsQuery, ContentGroupsQueryVariables>(ContentGroupsDocument, options);
      }
export function useContentGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentGroupsQuery, ContentGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentGroupsQuery, ContentGroupsQueryVariables>(ContentGroupsDocument, options);
        }
export type ContentGroupsQueryHookResult = ReturnType<typeof useContentGroupsQuery>;
export type ContentGroupsLazyQueryHookResult = ReturnType<typeof useContentGroupsLazyQuery>;
export type ContentGroupsQueryResult = Apollo.QueryResult<ContentGroupsQuery, ContentGroupsQueryVariables>;
export const EditUnitDocument = gql`
    mutation editUnit($input: EditUnitInput!) {
  editUnit(input: $input) {
    ...UnitContent
  }
}
    ${UnitContentFragmentDoc}`;
export type EditUnitMutationFn = Apollo.MutationFunction<EditUnitMutation, EditUnitMutationVariables>;

/**
 * __useEditUnitMutation__
 *
 * To run a mutation, you first call `useEditUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUnitMutation, { data, loading, error }] = useEditUnitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditUnitMutation(baseOptions?: Apollo.MutationHookOptions<EditUnitMutation, EditUnitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditUnitMutation, EditUnitMutationVariables>(EditUnitDocument, options);
      }
export type EditUnitMutationHookResult = ReturnType<typeof useEditUnitMutation>;
export type EditUnitMutationResult = Apollo.MutationResult<EditUnitMutation>;
export type EditUnitMutationOptions = Apollo.BaseMutationOptions<EditUnitMutation, EditUnitMutationVariables>;
export const MarkSchoolNewYearModalShownDocument = gql`
    mutation markSchoolNewYearModalShown($input: MarkSchoolNewYearModalShownInput!) {
  markSchoolNewYearModalShown(input: $input)
}
    `;
export type MarkSchoolNewYearModalShownMutationFn = Apollo.MutationFunction<MarkSchoolNewYearModalShownMutation, MarkSchoolNewYearModalShownMutationVariables>;

/**
 * __useMarkSchoolNewYearModalShownMutation__
 *
 * To run a mutation, you first call `useMarkSchoolNewYearModalShownMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkSchoolNewYearModalShownMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markSchoolNewYearModalShownMutation, { data, loading, error }] = useMarkSchoolNewYearModalShownMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkSchoolNewYearModalShownMutation(baseOptions?: Apollo.MutationHookOptions<MarkSchoolNewYearModalShownMutation, MarkSchoolNewYearModalShownMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkSchoolNewYearModalShownMutation, MarkSchoolNewYearModalShownMutationVariables>(MarkSchoolNewYearModalShownDocument, options);
      }
export type MarkSchoolNewYearModalShownMutationHookResult = ReturnType<typeof useMarkSchoolNewYearModalShownMutation>;
export type MarkSchoolNewYearModalShownMutationResult = Apollo.MutationResult<MarkSchoolNewYearModalShownMutation>;
export type MarkSchoolNewYearModalShownMutationOptions = Apollo.BaseMutationOptions<MarkSchoolNewYearModalShownMutation, MarkSchoolNewYearModalShownMutationVariables>;
export const HeaUpdateUnitDocument = gql`
    mutation heaUpdateUnit($input: HEAUpdateUnitInput!) {
  heaUpdateUnit(input: $input) {
    ...HEAUnitContent
  }
}
    ${HeaUnitContentFragmentDoc}`;
export type HeaUpdateUnitMutationFn = Apollo.MutationFunction<HeaUpdateUnitMutation, HeaUpdateUnitMutationVariables>;

/**
 * __useHeaUpdateUnitMutation__
 *
 * To run a mutation, you first call `useHeaUpdateUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeaUpdateUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [heaUpdateUnitMutation, { data, loading, error }] = useHeaUpdateUnitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeaUpdateUnitMutation(baseOptions?: Apollo.MutationHookOptions<HeaUpdateUnitMutation, HeaUpdateUnitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HeaUpdateUnitMutation, HeaUpdateUnitMutationVariables>(HeaUpdateUnitDocument, options);
      }
export type HeaUpdateUnitMutationHookResult = ReturnType<typeof useHeaUpdateUnitMutation>;
export type HeaUpdateUnitMutationResult = Apollo.MutationResult<HeaUpdateUnitMutation>;
export type HeaUpdateUnitMutationOptions = Apollo.BaseMutationOptions<HeaUpdateUnitMutation, HeaUpdateUnitMutationVariables>;
export const RegisterParentDocument = gql`
    mutation RegisterParent($input: ParentRegisterInput!) {
  registerParent(input: $input) {
    token
    specialCourseId
    parentId
    schoolId
    schoolName
  }
}
    `;
export type RegisterParentMutationFn = Apollo.MutationFunction<RegisterParentMutation, RegisterParentMutationVariables>;

/**
 * __useRegisterParentMutation__
 *
 * To run a mutation, you first call `useRegisterParentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterParentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerParentMutation, { data, loading, error }] = useRegisterParentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterParentMutation(baseOptions?: Apollo.MutationHookOptions<RegisterParentMutation, RegisterParentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterParentMutation, RegisterParentMutationVariables>(RegisterParentDocument, options);
      }
export type RegisterParentMutationHookResult = ReturnType<typeof useRegisterParentMutation>;
export type RegisterParentMutationResult = Apollo.MutationResult<RegisterParentMutation>;
export type RegisterParentMutationOptions = Apollo.BaseMutationOptions<RegisterParentMutation, RegisterParentMutationVariables>;
export const UnsubscribeDocument = gql`
    mutation Unsubscribe($input: UserIDInput!) {
  unsubscribe(input: $input)
}
    `;
export type UnsubscribeMutationFn = Apollo.MutationFunction<UnsubscribeMutation, UnsubscribeMutationVariables>;

/**
 * __useUnsubscribeMutation__
 *
 * To run a mutation, you first call `useUnsubscribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubscribeMutation, { data, loading, error }] = useUnsubscribeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnsubscribeMutation(baseOptions?: Apollo.MutationHookOptions<UnsubscribeMutation, UnsubscribeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsubscribeMutation, UnsubscribeMutationVariables>(UnsubscribeDocument, options);
      }
export type UnsubscribeMutationHookResult = ReturnType<typeof useUnsubscribeMutation>;
export type UnsubscribeMutationResult = Apollo.MutationResult<UnsubscribeMutation>;
export type UnsubscribeMutationOptions = Apollo.BaseMutationOptions<UnsubscribeMutation, UnsubscribeMutationVariables>;
export const CreateUnitDocument = gql`
    mutation CreateUnit($input: CreateUnitInput!) {
  createUnit(input: $input) {
    ...UnitContent
  }
}
    ${UnitContentFragmentDoc}`;
export type CreateUnitMutationFn = Apollo.MutationFunction<CreateUnitMutation, CreateUnitMutationVariables>;

/**
 * __useCreateUnitMutation__
 *
 * To run a mutation, you first call `useCreateUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUnitMutation, { data, loading, error }] = useCreateUnitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUnitMutation(baseOptions?: Apollo.MutationHookOptions<CreateUnitMutation, CreateUnitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUnitMutation, CreateUnitMutationVariables>(CreateUnitDocument, options);
      }
export type CreateUnitMutationHookResult = ReturnType<typeof useCreateUnitMutation>;
export type CreateUnitMutationResult = Apollo.MutationResult<CreateUnitMutation>;
export type CreateUnitMutationOptions = Apollo.BaseMutationOptions<CreateUnitMutation, CreateUnitMutationVariables>;
export const AddSchoolDocument = gql`
    mutation AddSchool($input: AddSchoolInput!) {
  addSchool(input: $input) {
    ...SchoolData
  }
}
    ${SchoolDataFragmentDoc}`;
export type AddSchoolMutationFn = Apollo.MutationFunction<AddSchoolMutation, AddSchoolMutationVariables>;

/**
 * __useAddSchoolMutation__
 *
 * To run a mutation, you first call `useAddSchoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSchoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSchoolMutation, { data, loading, error }] = useAddSchoolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSchoolMutation(baseOptions?: Apollo.MutationHookOptions<AddSchoolMutation, AddSchoolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSchoolMutation, AddSchoolMutationVariables>(AddSchoolDocument, options);
      }
export type AddSchoolMutationHookResult = ReturnType<typeof useAddSchoolMutation>;
export type AddSchoolMutationResult = Apollo.MutationResult<AddSchoolMutation>;
export type AddSchoolMutationOptions = Apollo.BaseMutationOptions<AddSchoolMutation, AddSchoolMutationVariables>;
export const EditSchoolDocument = gql`
    mutation EditSchool($input: EditSchoolInput!) {
  editSchool(input: $input) {
    ...SchoolData
  }
}
    ${SchoolDataFragmentDoc}`;
export type EditSchoolMutationFn = Apollo.MutationFunction<EditSchoolMutation, EditSchoolMutationVariables>;

/**
 * __useEditSchoolMutation__
 *
 * To run a mutation, you first call `useEditSchoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSchoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSchoolMutation, { data, loading, error }] = useEditSchoolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditSchoolMutation(baseOptions?: Apollo.MutationHookOptions<EditSchoolMutation, EditSchoolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditSchoolMutation, EditSchoolMutationVariables>(EditSchoolDocument, options);
      }
export type EditSchoolMutationHookResult = ReturnType<typeof useEditSchoolMutation>;
export type EditSchoolMutationResult = Apollo.MutationResult<EditSchoolMutation>;
export type EditSchoolMutationOptions = Apollo.BaseMutationOptions<EditSchoolMutation, EditSchoolMutationVariables>;
export const CreateLessonDocument = gql`
    mutation CreateLesson($input: IDInput!) {
  createLesson(input: $input) {
    id
    name
    description
    number
    master
    image
    duration
    descriptionHeading
    descriptionAnswers
    group
    sensitive
    sensitiveTooltip
  }
}
    `;
export type CreateLessonMutationFn = Apollo.MutationFunction<CreateLessonMutation, CreateLessonMutationVariables>;

/**
 * __useCreateLessonMutation__
 *
 * To run a mutation, you first call `useCreateLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLessonMutation, { data, loading, error }] = useCreateLessonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLessonMutation(baseOptions?: Apollo.MutationHookOptions<CreateLessonMutation, CreateLessonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLessonMutation, CreateLessonMutationVariables>(CreateLessonDocument, options);
      }
export type CreateLessonMutationHookResult = ReturnType<typeof useCreateLessonMutation>;
export type CreateLessonMutationResult = Apollo.MutationResult<CreateLessonMutation>;
export type CreateLessonMutationOptions = Apollo.BaseMutationOptions<CreateLessonMutation, CreateLessonMutationVariables>;
export const UpdateLessonDocument = gql`
    mutation UpdateLesson($input: LessonUpdateInput) {
  updateLesson(input: $input) {
    id
    name
    description
    number
    image
    prerequisite
    group
    descriptionHeading
    descriptionAnswers
    sensitive
    sensitiveTooltip
    alternativeActivated
  }
}
    `;
export type UpdateLessonMutationFn = Apollo.MutationFunction<UpdateLessonMutation, UpdateLessonMutationVariables>;

/**
 * __useUpdateLessonMutation__
 *
 * To run a mutation, you first call `useUpdateLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLessonMutation, { data, loading, error }] = useUpdateLessonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLessonMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLessonMutation, UpdateLessonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLessonMutation, UpdateLessonMutationVariables>(UpdateLessonDocument, options);
      }
export type UpdateLessonMutationHookResult = ReturnType<typeof useUpdateLessonMutation>;
export type UpdateLessonMutationResult = Apollo.MutationResult<UpdateLessonMutation>;
export type UpdateLessonMutationOptions = Apollo.BaseMutationOptions<UpdateLessonMutation, UpdateLessonMutationVariables>;
export const DeleteLessonDocument = gql`
    mutation deleteLesson($input: IDInput!) {
  deleteLesson(input: $input)
}
    `;
export type DeleteLessonMutationFn = Apollo.MutationFunction<DeleteLessonMutation, DeleteLessonMutationVariables>;

/**
 * __useDeleteLessonMutation__
 *
 * To run a mutation, you first call `useDeleteLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLessonMutation, { data, loading, error }] = useDeleteLessonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteLessonMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLessonMutation, DeleteLessonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLessonMutation, DeleteLessonMutationVariables>(DeleteLessonDocument, options);
      }
export type DeleteLessonMutationHookResult = ReturnType<typeof useDeleteLessonMutation>;
export type DeleteLessonMutationResult = Apollo.MutationResult<DeleteLessonMutation>;
export type DeleteLessonMutationOptions = Apollo.BaseMutationOptions<DeleteLessonMutation, DeleteLessonMutationVariables>;
export const DeleteUnitDocument = gql`
    mutation deleteUnit($input: IDInput!) {
  deleteUnit(input: $input)
}
    `;
export type DeleteUnitMutationFn = Apollo.MutationFunction<DeleteUnitMutation, DeleteUnitMutationVariables>;

/**
 * __useDeleteUnitMutation__
 *
 * To run a mutation, you first call `useDeleteUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUnitMutation, { data, loading, error }] = useDeleteUnitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUnitMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUnitMutation, DeleteUnitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUnitMutation, DeleteUnitMutationVariables>(DeleteUnitDocument, options);
      }
export type DeleteUnitMutationHookResult = ReturnType<typeof useDeleteUnitMutation>;
export type DeleteUnitMutationResult = Apollo.MutationResult<DeleteUnitMutation>;
export type DeleteUnitMutationOptions = Apollo.BaseMutationOptions<DeleteUnitMutation, DeleteUnitMutationVariables>;
export const HeaDeleteUnitDocument = gql`
    mutation heaDeleteUnit($input: IDInput!) {
  heaDeleteUnit(input: $input)
}
    `;
export type HeaDeleteUnitMutationFn = Apollo.MutationFunction<HeaDeleteUnitMutation, HeaDeleteUnitMutationVariables>;

/**
 * __useHeaDeleteUnitMutation__
 *
 * To run a mutation, you first call `useHeaDeleteUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeaDeleteUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [heaDeleteUnitMutation, { data, loading, error }] = useHeaDeleteUnitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeaDeleteUnitMutation(baseOptions?: Apollo.MutationHookOptions<HeaDeleteUnitMutation, HeaDeleteUnitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HeaDeleteUnitMutation, HeaDeleteUnitMutationVariables>(HeaDeleteUnitDocument, options);
      }
export type HeaDeleteUnitMutationHookResult = ReturnType<typeof useHeaDeleteUnitMutation>;
export type HeaDeleteUnitMutationResult = Apollo.MutationResult<HeaDeleteUnitMutation>;
export type HeaDeleteUnitMutationOptions = Apollo.BaseMutationOptions<HeaDeleteUnitMutation, HeaDeleteUnitMutationVariables>;
export const MoveModuleDocument = gql`
    mutation moveModule($input: MoveModuleInput!) {
  moveModule(input: $input)
}
    `;
export type MoveModuleMutationFn = Apollo.MutationFunction<MoveModuleMutation, MoveModuleMutationVariables>;

/**
 * __useMoveModuleMutation__
 *
 * To run a mutation, you first call `useMoveModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveModuleMutation, { data, loading, error }] = useMoveModuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveModuleMutation(baseOptions?: Apollo.MutationHookOptions<MoveModuleMutation, MoveModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveModuleMutation, MoveModuleMutationVariables>(MoveModuleDocument, options);
      }
export type MoveModuleMutationHookResult = ReturnType<typeof useMoveModuleMutation>;
export type MoveModuleMutationResult = Apollo.MutationResult<MoveModuleMutation>;
export type MoveModuleMutationOptions = Apollo.BaseMutationOptions<MoveModuleMutation, MoveModuleMutationVariables>;
export const HeaMoveModuleDocument = gql`
    mutation heaMoveModule($input: HEAMoveModuleInput!) {
  heaMoveModule(input: $input)
}
    `;
export type HeaMoveModuleMutationFn = Apollo.MutationFunction<HeaMoveModuleMutation, HeaMoveModuleMutationVariables>;

/**
 * __useHeaMoveModuleMutation__
 *
 * To run a mutation, you first call `useHeaMoveModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeaMoveModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [heaMoveModuleMutation, { data, loading, error }] = useHeaMoveModuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeaMoveModuleMutation(baseOptions?: Apollo.MutationHookOptions<HeaMoveModuleMutation, HeaMoveModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HeaMoveModuleMutation, HeaMoveModuleMutationVariables>(HeaMoveModuleDocument, options);
      }
export type HeaMoveModuleMutationHookResult = ReturnType<typeof useHeaMoveModuleMutation>;
export type HeaMoveModuleMutationResult = Apollo.MutationResult<HeaMoveModuleMutation>;
export type HeaMoveModuleMutationOptions = Apollo.BaseMutationOptions<HeaMoveModuleMutation, HeaMoveModuleMutationVariables>;
export const CreateContentDocument = gql`
    mutation CreateContent($input: CreateContentInput!) {
  createContent(input: $input) {
    ...Content
  }
}
    ${ContentFragmentDoc}`;
export type CreateContentMutationFn = Apollo.MutationFunction<CreateContentMutation, CreateContentMutationVariables>;

/**
 * __useCreateContentMutation__
 *
 * To run a mutation, you first call `useCreateContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContentMutation, { data, loading, error }] = useCreateContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContentMutation(baseOptions?: Apollo.MutationHookOptions<CreateContentMutation, CreateContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContentMutation, CreateContentMutationVariables>(CreateContentDocument, options);
      }
export type CreateContentMutationHookResult = ReturnType<typeof useCreateContentMutation>;
export type CreateContentMutationResult = Apollo.MutationResult<CreateContentMutation>;
export type CreateContentMutationOptions = Apollo.BaseMutationOptions<CreateContentMutation, CreateContentMutationVariables>;
export const MoveLessonDocument = gql`
    mutation moveLesson($input: MoveLessonInput!) {
  moveLesson(input: $input)
}
    `;
export type MoveLessonMutationFn = Apollo.MutationFunction<MoveLessonMutation, MoveLessonMutationVariables>;

/**
 * __useMoveLessonMutation__
 *
 * To run a mutation, you first call `useMoveLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveLessonMutation, { data, loading, error }] = useMoveLessonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveLessonMutation(baseOptions?: Apollo.MutationHookOptions<MoveLessonMutation, MoveLessonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveLessonMutation, MoveLessonMutationVariables>(MoveLessonDocument, options);
      }
export type MoveLessonMutationHookResult = ReturnType<typeof useMoveLessonMutation>;
export type MoveLessonMutationResult = Apollo.MutationResult<MoveLessonMutation>;
export type MoveLessonMutationOptions = Apollo.BaseMutationOptions<MoveLessonMutation, MoveLessonMutationVariables>;
export const UpdateContentDocument = gql`
    mutation updateContent($input: UpdateContentInput!) {
  updateContent(input: $input) {
    ...Content
  }
}
    ${ContentFragmentDoc}`;
export type UpdateContentMutationFn = Apollo.MutationFunction<UpdateContentMutation, UpdateContentMutationVariables>;

/**
 * __useUpdateContentMutation__
 *
 * To run a mutation, you first call `useUpdateContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentMutation, { data, loading, error }] = useUpdateContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentMutation, UpdateContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentMutation, UpdateContentMutationVariables>(UpdateContentDocument, options);
      }
export type UpdateContentMutationHookResult = ReturnType<typeof useUpdateContentMutation>;
export type UpdateContentMutationResult = Apollo.MutationResult<UpdateContentMutation>;
export type UpdateContentMutationOptions = Apollo.BaseMutationOptions<UpdateContentMutation, UpdateContentMutationVariables>;
export const UpdateVideoContentDocument = gql`
    mutation updateVideoContent($input: UpdateVideoContentInput!) {
  updateVideoContent(input: $input) {
    ...Content
  }
}
    ${ContentFragmentDoc}`;
export type UpdateVideoContentMutationFn = Apollo.MutationFunction<UpdateVideoContentMutation, UpdateVideoContentMutationVariables>;

/**
 * __useUpdateVideoContentMutation__
 *
 * To run a mutation, you first call `useUpdateVideoContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVideoContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVideoContentMutation, { data, loading, error }] = useUpdateVideoContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVideoContentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVideoContentMutation, UpdateVideoContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVideoContentMutation, UpdateVideoContentMutationVariables>(UpdateVideoContentDocument, options);
      }
export type UpdateVideoContentMutationHookResult = ReturnType<typeof useUpdateVideoContentMutation>;
export type UpdateVideoContentMutationResult = Apollo.MutationResult<UpdateVideoContentMutation>;
export type UpdateVideoContentMutationOptions = Apollo.BaseMutationOptions<UpdateVideoContentMutation, UpdateVideoContentMutationVariables>;
export const RemoveContentDocument = gql`
    mutation removeContent($input: IDInput!) {
  removeContent(input: $input)
}
    `;
export type RemoveContentMutationFn = Apollo.MutationFunction<RemoveContentMutation, RemoveContentMutationVariables>;

/**
 * __useRemoveContentMutation__
 *
 * To run a mutation, you first call `useRemoveContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeContentMutation, { data, loading, error }] = useRemoveContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveContentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveContentMutation, RemoveContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveContentMutation, RemoveContentMutationVariables>(RemoveContentDocument, options);
      }
export type RemoveContentMutationHookResult = ReturnType<typeof useRemoveContentMutation>;
export type RemoveContentMutationResult = Apollo.MutationResult<RemoveContentMutation>;
export type RemoveContentMutationOptions = Apollo.BaseMutationOptions<RemoveContentMutation, RemoveContentMutationVariables>;
export const CreateNewGroupContentDocument = gql`
    mutation createNewGroupContent($input: CreateNewGroupContentInput!) {
  createNewGroupContent(input: $input) {
    ...GroupContent
    groupName
  }
}
    ${GroupContentFragmentDoc}`;
export type CreateNewGroupContentMutationFn = Apollo.MutationFunction<CreateNewGroupContentMutation, CreateNewGroupContentMutationVariables>;

/**
 * __useCreateNewGroupContentMutation__
 *
 * To run a mutation, you first call `useCreateNewGroupContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewGroupContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewGroupContentMutation, { data, loading, error }] = useCreateNewGroupContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNewGroupContentMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewGroupContentMutation, CreateNewGroupContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewGroupContentMutation, CreateNewGroupContentMutationVariables>(CreateNewGroupContentDocument, options);
      }
export type CreateNewGroupContentMutationHookResult = ReturnType<typeof useCreateNewGroupContentMutation>;
export type CreateNewGroupContentMutationResult = Apollo.MutationResult<CreateNewGroupContentMutation>;
export type CreateNewGroupContentMutationOptions = Apollo.BaseMutationOptions<CreateNewGroupContentMutation, CreateNewGroupContentMutationVariables>;
export const UpdateGroupContentDocument = gql`
    mutation updateGroupContent($input: UpdateGroupContentInput!) {
  updateGroupContent(input: $input) {
    ...GroupContent
  }
}
    ${GroupContentFragmentDoc}`;
export type UpdateGroupContentMutationFn = Apollo.MutationFunction<UpdateGroupContentMutation, UpdateGroupContentMutationVariables>;

/**
 * __useUpdateGroupContentMutation__
 *
 * To run a mutation, you first call `useUpdateGroupContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupContentMutation, { data, loading, error }] = useUpdateGroupContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGroupContentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupContentMutation, UpdateGroupContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupContentMutation, UpdateGroupContentMutationVariables>(UpdateGroupContentDocument, options);
      }
export type UpdateGroupContentMutationHookResult = ReturnType<typeof useUpdateGroupContentMutation>;
export type UpdateGroupContentMutationResult = Apollo.MutationResult<UpdateGroupContentMutation>;
export type UpdateGroupContentMutationOptions = Apollo.BaseMutationOptions<UpdateGroupContentMutation, UpdateGroupContentMutationVariables>;
export const UpdateVideoGroupContentDocument = gql`
    mutation updateVideoGroupContent($input: UpdateVideoGroupContentInput!) {
  updateVideoGroupContent(input: $input) {
    ...GroupContent
  }
}
    ${GroupContentFragmentDoc}`;
export type UpdateVideoGroupContentMutationFn = Apollo.MutationFunction<UpdateVideoGroupContentMutation, UpdateVideoGroupContentMutationVariables>;

/**
 * __useUpdateVideoGroupContentMutation__
 *
 * To run a mutation, you first call `useUpdateVideoGroupContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVideoGroupContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVideoGroupContentMutation, { data, loading, error }] = useUpdateVideoGroupContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVideoGroupContentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVideoGroupContentMutation, UpdateVideoGroupContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVideoGroupContentMutation, UpdateVideoGroupContentMutationVariables>(UpdateVideoGroupContentDocument, options);
      }
export type UpdateVideoGroupContentMutationHookResult = ReturnType<typeof useUpdateVideoGroupContentMutation>;
export type UpdateVideoGroupContentMutationResult = Apollo.MutationResult<UpdateVideoGroupContentMutation>;
export type UpdateVideoGroupContentMutationOptions = Apollo.BaseMutationOptions<UpdateVideoGroupContentMutation, UpdateVideoGroupContentMutationVariables>;
export const DeleteGroupContentDocument = gql`
    mutation deleteGroupContent($input: DeleteGroupModuleInput!) {
  deleteGroupContent(input: $input)
}
    `;
export type DeleteGroupContentMutationFn = Apollo.MutationFunction<DeleteGroupContentMutation, DeleteGroupContentMutationVariables>;

/**
 * __useDeleteGroupContentMutation__
 *
 * To run a mutation, you first call `useDeleteGroupContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupContentMutation, { data, loading, error }] = useDeleteGroupContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteGroupContentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGroupContentMutation, DeleteGroupContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGroupContentMutation, DeleteGroupContentMutationVariables>(DeleteGroupContentDocument, options);
      }
export type DeleteGroupContentMutationHookResult = ReturnType<typeof useDeleteGroupContentMutation>;
export type DeleteGroupContentMutationResult = Apollo.MutationResult<DeleteGroupContentMutation>;
export type DeleteGroupContentMutationOptions = Apollo.BaseMutationOptions<DeleteGroupContentMutation, DeleteGroupContentMutationVariables>;
export const DeleteModuleDataDocument = gql`
    mutation deleteModuleData($input: IDInput!) {
  deleteModuleData(input: $input)
}
    `;
export type DeleteModuleDataMutationFn = Apollo.MutationFunction<DeleteModuleDataMutation, DeleteModuleDataMutationVariables>;

/**
 * __useDeleteModuleDataMutation__
 *
 * To run a mutation, you first call `useDeleteModuleDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteModuleDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteModuleDataMutation, { data, loading, error }] = useDeleteModuleDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteModuleDataMutation(baseOptions?: Apollo.MutationHookOptions<DeleteModuleDataMutation, DeleteModuleDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteModuleDataMutation, DeleteModuleDataMutationVariables>(DeleteModuleDataDocument, options);
      }
export type DeleteModuleDataMutationHookResult = ReturnType<typeof useDeleteModuleDataMutation>;
export type DeleteModuleDataMutationResult = Apollo.MutationResult<DeleteModuleDataMutation>;
export type DeleteModuleDataMutationOptions = Apollo.BaseMutationOptions<DeleteModuleDataMutation, DeleteModuleDataMutationVariables>;
export const HeaDeleteModuleDocument = gql`
    mutation heaDeleteModule($input: IDInput!) {
  heaDeleteModule(input: $input)
}
    `;
export type HeaDeleteModuleMutationFn = Apollo.MutationFunction<HeaDeleteModuleMutation, HeaDeleteModuleMutationVariables>;

/**
 * __useHeaDeleteModuleMutation__
 *
 * To run a mutation, you first call `useHeaDeleteModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeaDeleteModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [heaDeleteModuleMutation, { data, loading, error }] = useHeaDeleteModuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeaDeleteModuleMutation(baseOptions?: Apollo.MutationHookOptions<HeaDeleteModuleMutation, HeaDeleteModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HeaDeleteModuleMutation, HeaDeleteModuleMutationVariables>(HeaDeleteModuleDocument, options);
      }
export type HeaDeleteModuleMutationHookResult = ReturnType<typeof useHeaDeleteModuleMutation>;
export type HeaDeleteModuleMutationResult = Apollo.MutationResult<HeaDeleteModuleMutation>;
export type HeaDeleteModuleMutationOptions = Apollo.BaseMutationOptions<HeaDeleteModuleMutation, HeaDeleteModuleMutationVariables>;
export const DeleteGroupModuleDataDocument = gql`
    mutation deleteGroupModuleData($input: DeleteGroupModuleInput!) {
  deleteGroupModuleData(input: $input)
}
    `;
export type DeleteGroupModuleDataMutationFn = Apollo.MutationFunction<DeleteGroupModuleDataMutation, DeleteGroupModuleDataMutationVariables>;

/**
 * __useDeleteGroupModuleDataMutation__
 *
 * To run a mutation, you first call `useDeleteGroupModuleDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupModuleDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupModuleDataMutation, { data, loading, error }] = useDeleteGroupModuleDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteGroupModuleDataMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGroupModuleDataMutation, DeleteGroupModuleDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGroupModuleDataMutation, DeleteGroupModuleDataMutationVariables>(DeleteGroupModuleDataDocument, options);
      }
export type DeleteGroupModuleDataMutationHookResult = ReturnType<typeof useDeleteGroupModuleDataMutation>;
export type DeleteGroupModuleDataMutationResult = Apollo.MutationResult<DeleteGroupModuleDataMutation>;
export type DeleteGroupModuleDataMutationOptions = Apollo.BaseMutationOptions<DeleteGroupModuleDataMutation, DeleteGroupModuleDataMutationVariables>;
export const CalendarEventsDocument = gql`
    query CalendarEvents {
  calendarEvents {
    onboarding {
      isInMeeting
      timeLeftInSec
    }
    clinical {
      isInMeeting
      timeLeftInSec
    }
  }
}
    `;

/**
 * __useCalendarEventsQuery__
 *
 * To run a query within a React component, call `useCalendarEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCalendarEventsQuery(baseOptions?: Apollo.QueryHookOptions<CalendarEventsQuery, CalendarEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalendarEventsQuery, CalendarEventsQueryVariables>(CalendarEventsDocument, options);
      }
export function useCalendarEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventsQuery, CalendarEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalendarEventsQuery, CalendarEventsQueryVariables>(CalendarEventsDocument, options);
        }
export type CalendarEventsQueryHookResult = ReturnType<typeof useCalendarEventsQuery>;
export type CalendarEventsLazyQueryHookResult = ReturnType<typeof useCalendarEventsLazyQuery>;
export type CalendarEventsQueryResult = Apollo.QueryResult<CalendarEventsQuery, CalendarEventsQueryVariables>;
export const AccountSchoolsDocument = gql`
    query accountSchools($input: UserIDInput!) {
  accountSchools(input: $input) {
    schools {
      id
      name
      disabledPwLogin
      status
      groups {
        id
        name
      }
      dataCollections {
        id
        name
      }
      courses {
        id
      }
      exitTicketCC
      preProgramQuizCC
      grades
      programs
    }
    groups {
      id
      name
    }
    dataCollections {
      id
      name
    }
  }
}
    `;

/**
 * __useAccountSchoolsQuery__
 *
 * To run a query within a React component, call `useAccountSchoolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountSchoolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountSchoolsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAccountSchoolsQuery(baseOptions: Apollo.QueryHookOptions<AccountSchoolsQuery, AccountSchoolsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountSchoolsQuery, AccountSchoolsQueryVariables>(AccountSchoolsDocument, options);
      }
export function useAccountSchoolsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountSchoolsQuery, AccountSchoolsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountSchoolsQuery, AccountSchoolsQueryVariables>(AccountSchoolsDocument, options);
        }
export type AccountSchoolsQueryHookResult = ReturnType<typeof useAccountSchoolsQuery>;
export type AccountSchoolsLazyQueryHookResult = ReturnType<typeof useAccountSchoolsLazyQuery>;
export type AccountSchoolsQueryResult = Apollo.QueryResult<AccountSchoolsQuery, AccountSchoolsQueryVariables>;
export const GetAccountSchoolsDocument = gql`
    query getAccountSchools($input: UserIDInput!) {
  accountSchools(input: $input) {
    schools {
      name
      id
    }
  }
}
    `;

/**
 * __useGetAccountSchoolsQuery__
 *
 * To run a query within a React component, call `useGetAccountSchoolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountSchoolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountSchoolsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAccountSchoolsQuery(baseOptions: Apollo.QueryHookOptions<GetAccountSchoolsQuery, GetAccountSchoolsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountSchoolsQuery, GetAccountSchoolsQueryVariables>(GetAccountSchoolsDocument, options);
      }
export function useGetAccountSchoolsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountSchoolsQuery, GetAccountSchoolsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountSchoolsQuery, GetAccountSchoolsQueryVariables>(GetAccountSchoolsDocument, options);
        }
export type GetAccountSchoolsQueryHookResult = ReturnType<typeof useGetAccountSchoolsQuery>;
export type GetAccountSchoolsLazyQueryHookResult = ReturnType<typeof useGetAccountSchoolsLazyQuery>;
export type GetAccountSchoolsQueryResult = Apollo.QueryResult<GetAccountSchoolsQuery, GetAccountSchoolsQueryVariables>;
export const SchoolUsersDocument = gql`
    query SchoolUsers {
  schoolUsers {
    ...SchoolUser
  }
}
    ${SchoolUserFragmentDoc}`;

/**
 * __useSchoolUsersQuery__
 *
 * To run a query within a React component, call `useSchoolUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useSchoolUsersQuery(baseOptions?: Apollo.QueryHookOptions<SchoolUsersQuery, SchoolUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchoolUsersQuery, SchoolUsersQueryVariables>(SchoolUsersDocument, options);
      }
export function useSchoolUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchoolUsersQuery, SchoolUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchoolUsersQuery, SchoolUsersQueryVariables>(SchoolUsersDocument, options);
        }
export type SchoolUsersQueryHookResult = ReturnType<typeof useSchoolUsersQuery>;
export type SchoolUsersLazyQueryHookResult = ReturnType<typeof useSchoolUsersLazyQuery>;
export type SchoolUsersQueryResult = Apollo.QueryResult<SchoolUsersQuery, SchoolUsersQueryVariables>;
export const UsersDocument = gql`
    query Users($input: SearchUsersInput!) {
  users(input: $input) {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUsersQuery(baseOptions: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export const AccountUsersDocument = gql`
    query accountUsers {
  accountUsers {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useAccountUsersQuery__
 *
 * To run a query within a React component, call `useAccountUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountUsersQuery(baseOptions?: Apollo.QueryHookOptions<AccountUsersQuery, AccountUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountUsersQuery, AccountUsersQueryVariables>(AccountUsersDocument, options);
      }
export function useAccountUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountUsersQuery, AccountUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountUsersQuery, AccountUsersQueryVariables>(AccountUsersDocument, options);
        }
export type AccountUsersQueryHookResult = ReturnType<typeof useAccountUsersQuery>;
export type AccountUsersLazyQueryHookResult = ReturnType<typeof useAccountUsersLazyQuery>;
export type AccountUsersQueryResult = Apollo.QueryResult<AccountUsersQuery, AccountUsersQueryVariables>;
export const GetContentAllGroupsDocument = gql`
    query getContentAllGroups($input: IDInput!) {
  getContentAllGroups(input: $input) {
    groups {
      ...GroupContent
      groupName
    }
  }
}
    ${GroupContentFragmentDoc}`;

/**
 * __useGetContentAllGroupsQuery__
 *
 * To run a query within a React component, call `useGetContentAllGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentAllGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentAllGroupsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetContentAllGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetContentAllGroupsQuery, GetContentAllGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentAllGroupsQuery, GetContentAllGroupsQueryVariables>(GetContentAllGroupsDocument, options);
      }
export function useGetContentAllGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentAllGroupsQuery, GetContentAllGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentAllGroupsQuery, GetContentAllGroupsQueryVariables>(GetContentAllGroupsDocument, options);
        }
export type GetContentAllGroupsQueryHookResult = ReturnType<typeof useGetContentAllGroupsQuery>;
export type GetContentAllGroupsLazyQueryHookResult = ReturnType<typeof useGetContentAllGroupsLazyQuery>;
export type GetContentAllGroupsQueryResult = Apollo.QueryResult<GetContentAllGroupsQuery, GetContentAllGroupsQueryVariables>;
export const AllProgramsDocument = gql`
    query allPrograms {
  allPrograms {
    ...Program
  }
}
    ${ProgramFragmentDoc}`;

/**
 * __useAllProgramsQuery__
 *
 * To run a query within a React component, call `useAllProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllProgramsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllProgramsQuery(baseOptions?: Apollo.QueryHookOptions<AllProgramsQuery, AllProgramsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllProgramsQuery, AllProgramsQueryVariables>(AllProgramsDocument, options);
      }
export function useAllProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllProgramsQuery, AllProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllProgramsQuery, AllProgramsQueryVariables>(AllProgramsDocument, options);
        }
export type AllProgramsQueryHookResult = ReturnType<typeof useAllProgramsQuery>;
export type AllProgramsLazyQueryHookResult = ReturnType<typeof useAllProgramsLazyQuery>;
export type AllProgramsQueryResult = Apollo.QueryResult<AllProgramsQuery, AllProgramsQueryVariables>;
export const CustomersDocument = gql`
    query Customers {
  allCustomers {
    ...ExtendedCustomer
  }
}
    ${ExtendedCustomerFragmentDoc}`;

/**
 * __useCustomersQuery__
 *
 * To run a query within a React component, call `useCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomersQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomersQuery(baseOptions?: Apollo.QueryHookOptions<CustomersQuery, CustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomersQuery, CustomersQueryVariables>(CustomersDocument, options);
      }
export function useCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomersQuery, CustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomersQuery, CustomersQueryVariables>(CustomersDocument, options);
        }
export type CustomersQueryHookResult = ReturnType<typeof useCustomersQuery>;
export type CustomersLazyQueryHookResult = ReturnType<typeof useCustomersLazyQuery>;
export type CustomersQueryResult = Apollo.QueryResult<CustomersQuery, CustomersQueryVariables>;
export const GetSchoolCoursesDocument = gql`
    query getSchoolCourses($input: UserIDInput!) {
  getSchoolCourses(input: $input) {
    programIds {
      ...SchoolProgramID
    }
  }
}
    ${SchoolProgramIdFragmentDoc}`;

/**
 * __useGetSchoolCoursesQuery__
 *
 * To run a query within a React component, call `useGetSchoolCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolCoursesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSchoolCoursesQuery(baseOptions: Apollo.QueryHookOptions<GetSchoolCoursesQuery, GetSchoolCoursesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchoolCoursesQuery, GetSchoolCoursesQueryVariables>(GetSchoolCoursesDocument, options);
      }
export function useGetSchoolCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchoolCoursesQuery, GetSchoolCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchoolCoursesQuery, GetSchoolCoursesQueryVariables>(GetSchoolCoursesDocument, options);
        }
export type GetSchoolCoursesQueryHookResult = ReturnType<typeof useGetSchoolCoursesQuery>;
export type GetSchoolCoursesLazyQueryHookResult = ReturnType<typeof useGetSchoolCoursesLazyQuery>;
export type GetSchoolCoursesQueryResult = Apollo.QueryResult<GetSchoolCoursesQuery, GetSchoolCoursesQueryVariables>;
export const CustomizeCoursesForSchoolDocument = gql`
    mutation customizeCoursesForSchool($input: CustomizeCoursesForSchoolInput!) {
  customizeCoursesForSchool(input: $input)
}
    `;
export type CustomizeCoursesForSchoolMutationFn = Apollo.MutationFunction<CustomizeCoursesForSchoolMutation, CustomizeCoursesForSchoolMutationVariables>;

/**
 * __useCustomizeCoursesForSchoolMutation__
 *
 * To run a mutation, you first call `useCustomizeCoursesForSchoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomizeCoursesForSchoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customizeCoursesForSchoolMutation, { data, loading, error }] = useCustomizeCoursesForSchoolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomizeCoursesForSchoolMutation(baseOptions?: Apollo.MutationHookOptions<CustomizeCoursesForSchoolMutation, CustomizeCoursesForSchoolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomizeCoursesForSchoolMutation, CustomizeCoursesForSchoolMutationVariables>(CustomizeCoursesForSchoolDocument, options);
      }
export type CustomizeCoursesForSchoolMutationHookResult = ReturnType<typeof useCustomizeCoursesForSchoolMutation>;
export type CustomizeCoursesForSchoolMutationResult = Apollo.MutationResult<CustomizeCoursesForSchoolMutation>;
export type CustomizeCoursesForSchoolMutationOptions = Apollo.BaseMutationOptions<CustomizeCoursesForSchoolMutation, CustomizeCoursesForSchoolMutationVariables>;
export const DeleteProgramDocument = gql`
    mutation deleteProgram($input: IDInput!) {
  deleteProgram(input: $input)
}
    `;
export type DeleteProgramMutationFn = Apollo.MutationFunction<DeleteProgramMutation, DeleteProgramMutationVariables>;

/**
 * __useDeleteProgramMutation__
 *
 * To run a mutation, you first call `useDeleteProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProgramMutation, { data, loading, error }] = useDeleteProgramMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteProgramMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProgramMutation, DeleteProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProgramMutation, DeleteProgramMutationVariables>(DeleteProgramDocument, options);
      }
export type DeleteProgramMutationHookResult = ReturnType<typeof useDeleteProgramMutation>;
export type DeleteProgramMutationResult = Apollo.MutationResult<DeleteProgramMutation>;
export type DeleteProgramMutationOptions = Apollo.BaseMutationOptions<DeleteProgramMutation, DeleteProgramMutationVariables>;
export const SaveProgramUnitsDocument = gql`
    mutation saveProgramUnits($input: SaveProgramUnitsInput!) {
  saveProgramUnits(input: $input)
}
    `;
export type SaveProgramUnitsMutationFn = Apollo.MutationFunction<SaveProgramUnitsMutation, SaveProgramUnitsMutationVariables>;

/**
 * __useSaveProgramUnitsMutation__
 *
 * To run a mutation, you first call `useSaveProgramUnitsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveProgramUnitsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveProgramUnitsMutation, { data, loading, error }] = useSaveProgramUnitsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveProgramUnitsMutation(baseOptions?: Apollo.MutationHookOptions<SaveProgramUnitsMutation, SaveProgramUnitsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveProgramUnitsMutation, SaveProgramUnitsMutationVariables>(SaveProgramUnitsDocument, options);
      }
export type SaveProgramUnitsMutationHookResult = ReturnType<typeof useSaveProgramUnitsMutation>;
export type SaveProgramUnitsMutationResult = Apollo.MutationResult<SaveProgramUnitsMutation>;
export type SaveProgramUnitsMutationOptions = Apollo.BaseMutationOptions<SaveProgramUnitsMutation, SaveProgramUnitsMutationVariables>;
export const DuplicateCourseDocument = gql`
    mutation duplicateCourse($input: DuplicateCourseInput!) {
  duplicateCourse(input: $input)
}
    `;
export type DuplicateCourseMutationFn = Apollo.MutationFunction<DuplicateCourseMutation, DuplicateCourseMutationVariables>;

/**
 * __useDuplicateCourseMutation__
 *
 * To run a mutation, you first call `useDuplicateCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateCourseMutation, { data, loading, error }] = useDuplicateCourseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateCourseMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateCourseMutation, DuplicateCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateCourseMutation, DuplicateCourseMutationVariables>(DuplicateCourseDocument, options);
      }
export type DuplicateCourseMutationHookResult = ReturnType<typeof useDuplicateCourseMutation>;
export type DuplicateCourseMutationResult = Apollo.MutationResult<DuplicateCourseMutation>;
export type DuplicateCourseMutationOptions = Apollo.BaseMutationOptions<DuplicateCourseMutation, DuplicateCourseMutationVariables>;
export const UpdateProgramDocument = gql`
    mutation updateProgram($input: ProgramEditInput) {
  updateProgram(input: $input) {
    ...EditProgram
  }
}
    ${EditProgramFragmentDoc}`;
export type UpdateProgramMutationFn = Apollo.MutationFunction<UpdateProgramMutation, UpdateProgramMutationVariables>;

/**
 * __useUpdateProgramMutation__
 *
 * To run a mutation, you first call `useUpdateProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProgramMutation, { data, loading, error }] = useUpdateProgramMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProgramMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProgramMutation, UpdateProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProgramMutation, UpdateProgramMutationVariables>(UpdateProgramDocument, options);
      }
export type UpdateProgramMutationHookResult = ReturnType<typeof useUpdateProgramMutation>;
export type UpdateProgramMutationResult = Apollo.MutationResult<UpdateProgramMutation>;
export type UpdateProgramMutationOptions = Apollo.BaseMutationOptions<UpdateProgramMutation, UpdateProgramMutationVariables>;
export const UpdateLastVisitedLessonDocument = gql`
    mutation UpdateLastVisitedLesson($input: LastVisitedLessonInput) {
  updateLastVisitedLesson(input: $input) {
    ...LastVisitedLessonContent
  }
}
    ${LastVisitedLessonContentFragmentDoc}`;
export type UpdateLastVisitedLessonMutationFn = Apollo.MutationFunction<UpdateLastVisitedLessonMutation, UpdateLastVisitedLessonMutationVariables>;

/**
 * __useUpdateLastVisitedLessonMutation__
 *
 * To run a mutation, you first call `useUpdateLastVisitedLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLastVisitedLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLastVisitedLessonMutation, { data, loading, error }] = useUpdateLastVisitedLessonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLastVisitedLessonMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLastVisitedLessonMutation, UpdateLastVisitedLessonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLastVisitedLessonMutation, UpdateLastVisitedLessonMutationVariables>(UpdateLastVisitedLessonDocument, options);
      }
export type UpdateLastVisitedLessonMutationHookResult = ReturnType<typeof useUpdateLastVisitedLessonMutation>;
export type UpdateLastVisitedLessonMutationResult = Apollo.MutationResult<UpdateLastVisitedLessonMutation>;
export type UpdateLastVisitedLessonMutationOptions = Apollo.BaseMutationOptions<UpdateLastVisitedLessonMutation, UpdateLastVisitedLessonMutationVariables>;
export const ProgramsDocument = gql`
    query programs {
  programs {
    ...Program
  }
}
    ${ProgramFragmentDoc}`;

/**
 * __useProgramsQuery__
 *
 * To run a query within a React component, call `useProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProgramsQuery(baseOptions?: Apollo.QueryHookOptions<ProgramsQuery, ProgramsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramsQuery, ProgramsQueryVariables>(ProgramsDocument, options);
      }
export function useProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramsQuery, ProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramsQuery, ProgramsQueryVariables>(ProgramsDocument, options);
        }
export type ProgramsQueryHookResult = ReturnType<typeof useProgramsQuery>;
export type ProgramsLazyQueryHookResult = ReturnType<typeof useProgramsLazyQuery>;
export type ProgramsQueryResult = Apollo.QueryResult<ProgramsQuery, ProgramsQueryVariables>;
export const GetAllProgramsDocument = gql`
    query getAllPrograms {
  programs {
    ...RestrictProgram
  }
}
    ${RestrictProgramFragmentDoc}`;

/**
 * __useGetAllProgramsQuery__
 *
 * To run a query within a React component, call `useGetAllProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProgramsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllProgramsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllProgramsQuery, GetAllProgramsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllProgramsQuery, GetAllProgramsQueryVariables>(GetAllProgramsDocument, options);
      }
export function useGetAllProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProgramsQuery, GetAllProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllProgramsQuery, GetAllProgramsQueryVariables>(GetAllProgramsDocument, options);
        }
export type GetAllProgramsQueryHookResult = ReturnType<typeof useGetAllProgramsQuery>;
export type GetAllProgramsLazyQueryHookResult = ReturnType<typeof useGetAllProgramsLazyQuery>;
export type GetAllProgramsQueryResult = Apollo.QueryResult<GetAllProgramsQuery, GetAllProgramsQueryVariables>;
export const CreateFeedbackFormDocument = gql`
    mutation CreateFeedbackForm($input: FeedbackFormContentInput!) {
  createFeedbackForm(input: $input) {
    ...FeedbackFormContent
  }
}
    ${FeedbackFormContentFragmentDoc}`;
export type CreateFeedbackFormMutationFn = Apollo.MutationFunction<CreateFeedbackFormMutation, CreateFeedbackFormMutationVariables>;

/**
 * __useCreateFeedbackFormMutation__
 *
 * To run a mutation, you first call `useCreateFeedbackFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeedbackFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeedbackFormMutation, { data, loading, error }] = useCreateFeedbackFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFeedbackFormMutation(baseOptions?: Apollo.MutationHookOptions<CreateFeedbackFormMutation, CreateFeedbackFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFeedbackFormMutation, CreateFeedbackFormMutationVariables>(CreateFeedbackFormDocument, options);
      }
export type CreateFeedbackFormMutationHookResult = ReturnType<typeof useCreateFeedbackFormMutation>;
export type CreateFeedbackFormMutationResult = Apollo.MutationResult<CreateFeedbackFormMutation>;
export type CreateFeedbackFormMutationOptions = Apollo.BaseMutationOptions<CreateFeedbackFormMutation, CreateFeedbackFormMutationVariables>;
export const UpdateLessonCompleteStatusDocument = gql`
    mutation UpdateLessonCompleteStatus($input: UpdateLessonCompleteStatusInput!) {
  updateLessonCompleteStatus(input: $input)
}
    `;
export type UpdateLessonCompleteStatusMutationFn = Apollo.MutationFunction<UpdateLessonCompleteStatusMutation, UpdateLessonCompleteStatusMutationVariables>;

/**
 * __useUpdateLessonCompleteStatusMutation__
 *
 * To run a mutation, you first call `useUpdateLessonCompleteStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLessonCompleteStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLessonCompleteStatusMutation, { data, loading, error }] = useUpdateLessonCompleteStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLessonCompleteStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLessonCompleteStatusMutation, UpdateLessonCompleteStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLessonCompleteStatusMutation, UpdateLessonCompleteStatusMutationVariables>(UpdateLessonCompleteStatusDocument, options);
      }
export type UpdateLessonCompleteStatusMutationHookResult = ReturnType<typeof useUpdateLessonCompleteStatusMutation>;
export type UpdateLessonCompleteStatusMutationResult = Apollo.MutationResult<UpdateLessonCompleteStatusMutation>;
export type UpdateLessonCompleteStatusMutationOptions = Apollo.BaseMutationOptions<UpdateLessonCompleteStatusMutation, UpdateLessonCompleteStatusMutationVariables>;
export const MoveUnitDocument = gql`
    mutation moveUnit($input: MoveUnitInput!) {
  moveUnit(input: $input)
}
    `;
export type MoveUnitMutationFn = Apollo.MutationFunction<MoveUnitMutation, MoveUnitMutationVariables>;

/**
 * __useMoveUnitMutation__
 *
 * To run a mutation, you first call `useMoveUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveUnitMutation, { data, loading, error }] = useMoveUnitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveUnitMutation(baseOptions?: Apollo.MutationHookOptions<MoveUnitMutation, MoveUnitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveUnitMutation, MoveUnitMutationVariables>(MoveUnitDocument, options);
      }
export type MoveUnitMutationHookResult = ReturnType<typeof useMoveUnitMutation>;
export type MoveUnitMutationResult = Apollo.MutationResult<MoveUnitMutation>;
export type MoveUnitMutationOptions = Apollo.BaseMutationOptions<MoveUnitMutation, MoveUnitMutationVariables>;
export const MoveCourseContentDocument = gql`
    mutation moveCourseContent($input: MoveCourseContentInput!) {
  moveCourseContent(input: $input)
}
    `;
export type MoveCourseContentMutationFn = Apollo.MutationFunction<MoveCourseContentMutation, MoveCourseContentMutationVariables>;

/**
 * __useMoveCourseContentMutation__
 *
 * To run a mutation, you first call `useMoveCourseContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveCourseContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveCourseContentMutation, { data, loading, error }] = useMoveCourseContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveCourseContentMutation(baseOptions?: Apollo.MutationHookOptions<MoveCourseContentMutation, MoveCourseContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveCourseContentMutation, MoveCourseContentMutationVariables>(MoveCourseContentDocument, options);
      }
export type MoveCourseContentMutationHookResult = ReturnType<typeof useMoveCourseContentMutation>;
export type MoveCourseContentMutationResult = Apollo.MutationResult<MoveCourseContentMutation>;
export type MoveCourseContentMutationOptions = Apollo.BaseMutationOptions<MoveCourseContentMutation, MoveCourseContentMutationVariables>;
export const UpdateProgramLastUsedDocument = gql`
    mutation UpdateProgramLastUsed($input: IDInput!) {
  updateProgramLastUsed(input: $input) {
    ...ProgramLastUsedContent
  }
}
    ${ProgramLastUsedContentFragmentDoc}`;
export type UpdateProgramLastUsedMutationFn = Apollo.MutationFunction<UpdateProgramLastUsedMutation, UpdateProgramLastUsedMutationVariables>;

/**
 * __useUpdateProgramLastUsedMutation__
 *
 * To run a mutation, you first call `useUpdateProgramLastUsedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProgramLastUsedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProgramLastUsedMutation, { data, loading, error }] = useUpdateProgramLastUsedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProgramLastUsedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProgramLastUsedMutation, UpdateProgramLastUsedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProgramLastUsedMutation, UpdateProgramLastUsedMutationVariables>(UpdateProgramLastUsedDocument, options);
      }
export type UpdateProgramLastUsedMutationHookResult = ReturnType<typeof useUpdateProgramLastUsedMutation>;
export type UpdateProgramLastUsedMutationResult = Apollo.MutationResult<UpdateProgramLastUsedMutation>;
export type UpdateProgramLastUsedMutationOptions = Apollo.BaseMutationOptions<UpdateProgramLastUsedMutation, UpdateProgramLastUsedMutationVariables>;
export const GenerateDashboardLinkDocument = gql`
    mutation generateDashboardLink($input: UserIDInput!) {
  generateDashboardLink(input: $input)
}
    `;
export type GenerateDashboardLinkMutationFn = Apollo.MutationFunction<GenerateDashboardLinkMutation, GenerateDashboardLinkMutationVariables>;

/**
 * __useGenerateDashboardLinkMutation__
 *
 * To run a mutation, you first call `useGenerateDashboardLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateDashboardLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateDashboardLinkMutation, { data, loading, error }] = useGenerateDashboardLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateDashboardLinkMutation(baseOptions?: Apollo.MutationHookOptions<GenerateDashboardLinkMutation, GenerateDashboardLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateDashboardLinkMutation, GenerateDashboardLinkMutationVariables>(GenerateDashboardLinkDocument, options);
      }
export type GenerateDashboardLinkMutationHookResult = ReturnType<typeof useGenerateDashboardLinkMutation>;
export type GenerateDashboardLinkMutationResult = Apollo.MutationResult<GenerateDashboardLinkMutation>;
export type GenerateDashboardLinkMutationOptions = Apollo.BaseMutationOptions<GenerateDashboardLinkMutation, GenerateDashboardLinkMutationVariables>;
export const HeaUpdateMeDocument = gql`
    mutation HeaUpdateMe($input: HEAUpdateMeInput!) {
  heaUpdateMe(input: $input) {
    id
    email
    firstName
    lastName
    status
    enableFaith
    enablePasscode
  }
}
    `;
export type HeaUpdateMeMutationFn = Apollo.MutationFunction<HeaUpdateMeMutation, HeaUpdateMeMutationVariables>;

/**
 * __useHeaUpdateMeMutation__
 *
 * To run a mutation, you first call `useHeaUpdateMeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeaUpdateMeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [heaUpdateMeMutation, { data, loading, error }] = useHeaUpdateMeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeaUpdateMeMutation(baseOptions?: Apollo.MutationHookOptions<HeaUpdateMeMutation, HeaUpdateMeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HeaUpdateMeMutation, HeaUpdateMeMutationVariables>(HeaUpdateMeDocument, options);
      }
export type HeaUpdateMeMutationHookResult = ReturnType<typeof useHeaUpdateMeMutation>;
export type HeaUpdateMeMutationResult = Apollo.MutationResult<HeaUpdateMeMutation>;
export type HeaUpdateMeMutationOptions = Apollo.BaseMutationOptions<HeaUpdateMeMutation, HeaUpdateMeMutationVariables>;
export const HeaRegisterDocument = gql`
    mutation heaRegister($input: HEARegisterInput!) {
  heaRegister(input: $input) {
    id
    email
    registeredAt
  }
}
    `;
export type HeaRegisterMutationFn = Apollo.MutationFunction<HeaRegisterMutation, HeaRegisterMutationVariables>;

/**
 * __useHeaRegisterMutation__
 *
 * To run a mutation, you first call `useHeaRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeaRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [heaRegisterMutation, { data, loading, error }] = useHeaRegisterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeaRegisterMutation(baseOptions?: Apollo.MutationHookOptions<HeaRegisterMutation, HeaRegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HeaRegisterMutation, HeaRegisterMutationVariables>(HeaRegisterDocument, options);
      }
export type HeaRegisterMutationHookResult = ReturnType<typeof useHeaRegisterMutation>;
export type HeaRegisterMutationResult = Apollo.MutationResult<HeaRegisterMutation>;
export type HeaRegisterMutationOptions = Apollo.BaseMutationOptions<HeaRegisterMutation, HeaRegisterMutationVariables>;
export const HeaLoginDocument = gql`
    mutation heaLogin($input: HEALoginInput!) {
  heaLogin(input: $input) {
    token
    user {
      id
      email
      firstName
      lastName
      status
    }
  }
}
    `;
export type HeaLoginMutationFn = Apollo.MutationFunction<HeaLoginMutation, HeaLoginMutationVariables>;

/**
 * __useHeaLoginMutation__
 *
 * To run a mutation, you first call `useHeaLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeaLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [heaLoginMutation, { data, loading, error }] = useHeaLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeaLoginMutation(baseOptions?: Apollo.MutationHookOptions<HeaLoginMutation, HeaLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HeaLoginMutation, HeaLoginMutationVariables>(HeaLoginDocument, options);
      }
export type HeaLoginMutationHookResult = ReturnType<typeof useHeaLoginMutation>;
export type HeaLoginMutationResult = Apollo.MutationResult<HeaLoginMutation>;
export type HeaLoginMutationOptions = Apollo.BaseMutationOptions<HeaLoginMutation, HeaLoginMutationVariables>;
export const CheckUserStatusDocument = gql`
    mutation checkUserStatus($input: HEACheckUserStatusInput!) {
  heaCheckUserStatus(input: $input)
}
    `;
export type CheckUserStatusMutationFn = Apollo.MutationFunction<CheckUserStatusMutation, CheckUserStatusMutationVariables>;

/**
 * __useCheckUserStatusMutation__
 *
 * To run a mutation, you first call `useCheckUserStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckUserStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkUserStatusMutation, { data, loading, error }] = useCheckUserStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckUserStatusMutation(baseOptions?: Apollo.MutationHookOptions<CheckUserStatusMutation, CheckUserStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckUserStatusMutation, CheckUserStatusMutationVariables>(CheckUserStatusDocument, options);
      }
export type CheckUserStatusMutationHookResult = ReturnType<typeof useCheckUserStatusMutation>;
export type CheckUserStatusMutationResult = Apollo.MutationResult<CheckUserStatusMutation>;
export type CheckUserStatusMutationOptions = Apollo.BaseMutationOptions<CheckUserStatusMutation, CheckUserStatusMutationVariables>;
export const HeaVerifyEmailTokenDocument = gql`
    mutation heaVerifyEmailToken($input: HEAVerifyEmailTokenInput!) {
  heaVerifyEmailToken(input: $input)
}
    `;
export type HeaVerifyEmailTokenMutationFn = Apollo.MutationFunction<HeaVerifyEmailTokenMutation, HeaVerifyEmailTokenMutationVariables>;

/**
 * __useHeaVerifyEmailTokenMutation__
 *
 * To run a mutation, you first call `useHeaVerifyEmailTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeaVerifyEmailTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [heaVerifyEmailTokenMutation, { data, loading, error }] = useHeaVerifyEmailTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeaVerifyEmailTokenMutation(baseOptions?: Apollo.MutationHookOptions<HeaVerifyEmailTokenMutation, HeaVerifyEmailTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HeaVerifyEmailTokenMutation, HeaVerifyEmailTokenMutationVariables>(HeaVerifyEmailTokenDocument, options);
      }
export type HeaVerifyEmailTokenMutationHookResult = ReturnType<typeof useHeaVerifyEmailTokenMutation>;
export type HeaVerifyEmailTokenMutationResult = Apollo.MutationResult<HeaVerifyEmailTokenMutation>;
export type HeaVerifyEmailTokenMutationOptions = Apollo.BaseMutationOptions<HeaVerifyEmailTokenMutation, HeaVerifyEmailTokenMutationVariables>;
export const HeaSetPasswordDocument = gql`
    mutation heaSetPassword($input: HEASetPasswordInput!) {
  heaSetPassword(input: $input)
}
    `;
export type HeaSetPasswordMutationFn = Apollo.MutationFunction<HeaSetPasswordMutation, HeaSetPasswordMutationVariables>;

/**
 * __useHeaSetPasswordMutation__
 *
 * To run a mutation, you first call `useHeaSetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeaSetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [heaSetPasswordMutation, { data, loading, error }] = useHeaSetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeaSetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<HeaSetPasswordMutation, HeaSetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HeaSetPasswordMutation, HeaSetPasswordMutationVariables>(HeaSetPasswordDocument, options);
      }
export type HeaSetPasswordMutationHookResult = ReturnType<typeof useHeaSetPasswordMutation>;
export type HeaSetPasswordMutationResult = Apollo.MutationResult<HeaSetPasswordMutation>;
export type HeaSetPasswordMutationOptions = Apollo.BaseMutationOptions<HeaSetPasswordMutation, HeaSetPasswordMutationVariables>;
export const HeaCreateUnitDocument = gql`
    mutation heaCreateUnit($input: HEACreateUnitInput!) {
  heaCreateUnit(input: $input) {
    ...HEAUnitContent
  }
}
    ${HeaUnitContentFragmentDoc}`;
export type HeaCreateUnitMutationFn = Apollo.MutationFunction<HeaCreateUnitMutation, HeaCreateUnitMutationVariables>;

/**
 * __useHeaCreateUnitMutation__
 *
 * To run a mutation, you first call `useHeaCreateUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeaCreateUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [heaCreateUnitMutation, { data, loading, error }] = useHeaCreateUnitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeaCreateUnitMutation(baseOptions?: Apollo.MutationHookOptions<HeaCreateUnitMutation, HeaCreateUnitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HeaCreateUnitMutation, HeaCreateUnitMutationVariables>(HeaCreateUnitDocument, options);
      }
export type HeaCreateUnitMutationHookResult = ReturnType<typeof useHeaCreateUnitMutation>;
export type HeaCreateUnitMutationResult = Apollo.MutationResult<HeaCreateUnitMutation>;
export type HeaCreateUnitMutationOptions = Apollo.BaseMutationOptions<HeaCreateUnitMutation, HeaCreateUnitMutationVariables>;
export const HeaCreateModuleDocument = gql`
    mutation heaCreateModule($input: HEACreateModuleInput!) {
  heaCreateModule(input: $input) {
    ...HEAModule
  }
}
    ${HeaModuleFragmentDoc}`;
export type HeaCreateModuleMutationFn = Apollo.MutationFunction<HeaCreateModuleMutation, HeaCreateModuleMutationVariables>;

/**
 * __useHeaCreateModuleMutation__
 *
 * To run a mutation, you first call `useHeaCreateModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeaCreateModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [heaCreateModuleMutation, { data, loading, error }] = useHeaCreateModuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeaCreateModuleMutation(baseOptions?: Apollo.MutationHookOptions<HeaCreateModuleMutation, HeaCreateModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HeaCreateModuleMutation, HeaCreateModuleMutationVariables>(HeaCreateModuleDocument, options);
      }
export type HeaCreateModuleMutationHookResult = ReturnType<typeof useHeaCreateModuleMutation>;
export type HeaCreateModuleMutationResult = Apollo.MutationResult<HeaCreateModuleMutation>;
export type HeaCreateModuleMutationOptions = Apollo.BaseMutationOptions<HeaCreateModuleMutation, HeaCreateModuleMutationVariables>;
export const HeaUpdateModuleDocument = gql`
    mutation heaUpdateModule($input: HEAUpdateModuleInput!) {
  heaUpdateModule(input: $input)
}
    `;
export type HeaUpdateModuleMutationFn = Apollo.MutationFunction<HeaUpdateModuleMutation, HeaUpdateModuleMutationVariables>;

/**
 * __useHeaUpdateModuleMutation__
 *
 * To run a mutation, you first call `useHeaUpdateModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeaUpdateModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [heaUpdateModuleMutation, { data, loading, error }] = useHeaUpdateModuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeaUpdateModuleMutation(baseOptions?: Apollo.MutationHookOptions<HeaUpdateModuleMutation, HeaUpdateModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HeaUpdateModuleMutation, HeaUpdateModuleMutationVariables>(HeaUpdateModuleDocument, options);
      }
export type HeaUpdateModuleMutationHookResult = ReturnType<typeof useHeaUpdateModuleMutation>;
export type HeaUpdateModuleMutationResult = Apollo.MutationResult<HeaUpdateModuleMutation>;
export type HeaUpdateModuleMutationOptions = Apollo.BaseMutationOptions<HeaUpdateModuleMutation, HeaUpdateModuleMutationVariables>;
export const HeaListStudyPlansDocument = gql`
    query heaListStudyPlans {
  heaListStudyPlans {
    ...StudyPlanContent
  }
}
    ${StudyPlanContentFragmentDoc}`;

/**
 * __useHeaListStudyPlansQuery__
 *
 * To run a query within a React component, call `useHeaListStudyPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeaListStudyPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeaListStudyPlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useHeaListStudyPlansQuery(baseOptions?: Apollo.QueryHookOptions<HeaListStudyPlansQuery, HeaListStudyPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HeaListStudyPlansQuery, HeaListStudyPlansQueryVariables>(HeaListStudyPlansDocument, options);
      }
export function useHeaListStudyPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HeaListStudyPlansQuery, HeaListStudyPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HeaListStudyPlansQuery, HeaListStudyPlansQueryVariables>(HeaListStudyPlansDocument, options);
        }
export type HeaListStudyPlansQueryHookResult = ReturnType<typeof useHeaListStudyPlansQuery>;
export type HeaListStudyPlansLazyQueryHookResult = ReturnType<typeof useHeaListStudyPlansLazyQuery>;
export type HeaListStudyPlansQueryResult = Apollo.QueryResult<HeaListStudyPlansQuery, HeaListStudyPlansQueryVariables>;
export const HeaUnitsDocument = gql`
    query heaUnits {
  heaUnits {
    ...HEAUnitContent
  }
}
    ${HeaUnitContentFragmentDoc}`;

/**
 * __useHeaUnitsQuery__
 *
 * To run a query within a React component, call `useHeaUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeaUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeaUnitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHeaUnitsQuery(baseOptions?: Apollo.QueryHookOptions<HeaUnitsQuery, HeaUnitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HeaUnitsQuery, HeaUnitsQueryVariables>(HeaUnitsDocument, options);
      }
export function useHeaUnitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HeaUnitsQuery, HeaUnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HeaUnitsQuery, HeaUnitsQueryVariables>(HeaUnitsDocument, options);
        }
export type HeaUnitsQueryHookResult = ReturnType<typeof useHeaUnitsQuery>;
export type HeaUnitsLazyQueryHookResult = ReturnType<typeof useHeaUnitsLazyQuery>;
export type HeaUnitsQueryResult = Apollo.QueryResult<HeaUnitsQuery, HeaUnitsQueryVariables>;
export const GetVideoUrlDocument = gql`
    query getVideoUrl($uploadId: String!) {
  getVideoUrl(uploadId: $uploadId) {
    url
    meta
  }
}
    `;

/**
 * __useGetVideoUrlQuery__
 *
 * To run a query within a React component, call `useGetVideoUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoUrlQuery({
 *   variables: {
 *      uploadId: // value for 'uploadId'
 *   },
 * });
 */
export function useGetVideoUrlQuery(baseOptions: Apollo.QueryHookOptions<GetVideoUrlQuery, GetVideoUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVideoUrlQuery, GetVideoUrlQueryVariables>(GetVideoUrlDocument, options);
      }
export function useGetVideoUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVideoUrlQuery, GetVideoUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVideoUrlQuery, GetVideoUrlQueryVariables>(GetVideoUrlDocument, options);
        }
export type GetVideoUrlQueryHookResult = ReturnType<typeof useGetVideoUrlQuery>;
export type GetVideoUrlLazyQueryHookResult = ReturnType<typeof useGetVideoUrlLazyQuery>;
export type GetVideoUrlQueryResult = Apollo.QueryResult<GetVideoUrlQuery, GetVideoUrlQueryVariables>;
export const HeaCreateStudyPlanDocument = gql`
    mutation heaCreateStudyPlan($input: HEACreateStudyPlanInput!) {
  heaCreateStudyPlan(input: $input)
}
    `;
export type HeaCreateStudyPlanMutationFn = Apollo.MutationFunction<HeaCreateStudyPlanMutation, HeaCreateStudyPlanMutationVariables>;

/**
 * __useHeaCreateStudyPlanMutation__
 *
 * To run a mutation, you first call `useHeaCreateStudyPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeaCreateStudyPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [heaCreateStudyPlanMutation, { data, loading, error }] = useHeaCreateStudyPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeaCreateStudyPlanMutation(baseOptions?: Apollo.MutationHookOptions<HeaCreateStudyPlanMutation, HeaCreateStudyPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HeaCreateStudyPlanMutation, HeaCreateStudyPlanMutationVariables>(HeaCreateStudyPlanDocument, options);
      }
export type HeaCreateStudyPlanMutationHookResult = ReturnType<typeof useHeaCreateStudyPlanMutation>;
export type HeaCreateStudyPlanMutationResult = Apollo.MutationResult<HeaCreateStudyPlanMutation>;
export type HeaCreateStudyPlanMutationOptions = Apollo.BaseMutationOptions<HeaCreateStudyPlanMutation, HeaCreateStudyPlanMutationVariables>;
export const HeaUpdateStudyPlanDocument = gql`
    mutation heaUpdateStudyPlan($input: HEAUpdateStudyPlanInput!) {
  heaUpdateStudyPlan(input: $input)
}
    `;
export type HeaUpdateStudyPlanMutationFn = Apollo.MutationFunction<HeaUpdateStudyPlanMutation, HeaUpdateStudyPlanMutationVariables>;

/**
 * __useHeaUpdateStudyPlanMutation__
 *
 * To run a mutation, you first call `useHeaUpdateStudyPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeaUpdateStudyPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [heaUpdateStudyPlanMutation, { data, loading, error }] = useHeaUpdateStudyPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeaUpdateStudyPlanMutation(baseOptions?: Apollo.MutationHookOptions<HeaUpdateStudyPlanMutation, HeaUpdateStudyPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HeaUpdateStudyPlanMutation, HeaUpdateStudyPlanMutationVariables>(HeaUpdateStudyPlanDocument, options);
      }
export type HeaUpdateStudyPlanMutationHookResult = ReturnType<typeof useHeaUpdateStudyPlanMutation>;
export type HeaUpdateStudyPlanMutationResult = Apollo.MutationResult<HeaUpdateStudyPlanMutation>;
export type HeaUpdateStudyPlanMutationOptions = Apollo.BaseMutationOptions<HeaUpdateStudyPlanMutation, HeaUpdateStudyPlanMutationVariables>;
export const HeaGetStudyPlansByUnitDocument = gql`
    query heaGetStudyPlansByUnit($input: IDInput!) {
  heaGetStudyPlansByUnit(input: $input) {
    ...StudyPlanContent
  }
}
    ${StudyPlanContentFragmentDoc}`;

/**
 * __useHeaGetStudyPlansByUnitQuery__
 *
 * To run a query within a React component, call `useHeaGetStudyPlansByUnitQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeaGetStudyPlansByUnitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeaGetStudyPlansByUnitQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeaGetStudyPlansByUnitQuery(baseOptions: Apollo.QueryHookOptions<HeaGetStudyPlansByUnitQuery, HeaGetStudyPlansByUnitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HeaGetStudyPlansByUnitQuery, HeaGetStudyPlansByUnitQueryVariables>(HeaGetStudyPlansByUnitDocument, options);
      }
export function useHeaGetStudyPlansByUnitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HeaGetStudyPlansByUnitQuery, HeaGetStudyPlansByUnitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HeaGetStudyPlansByUnitQuery, HeaGetStudyPlansByUnitQueryVariables>(HeaGetStudyPlansByUnitDocument, options);
        }
export type HeaGetStudyPlansByUnitQueryHookResult = ReturnType<typeof useHeaGetStudyPlansByUnitQuery>;
export type HeaGetStudyPlansByUnitLazyQueryHookResult = ReturnType<typeof useHeaGetStudyPlansByUnitLazyQuery>;
export type HeaGetStudyPlansByUnitQueryResult = Apollo.QueryResult<HeaGetStudyPlansByUnitQuery, HeaGetStudyPlansByUnitQueryVariables>;
export const HeaMeDocument = gql`
    query heaMe {
  heaMe {
    ...HEAUser
  }
}
    ${HeaUserFragmentDoc}`;

/**
 * __useHeaMeQuery__
 *
 * To run a query within a React component, call `useHeaMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeaMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeaMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useHeaMeQuery(baseOptions?: Apollo.QueryHookOptions<HeaMeQuery, HeaMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HeaMeQuery, HeaMeQueryVariables>(HeaMeDocument, options);
      }
export function useHeaMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HeaMeQuery, HeaMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HeaMeQuery, HeaMeQueryVariables>(HeaMeDocument, options);
        }
export type HeaMeQueryHookResult = ReturnType<typeof useHeaMeQuery>;
export type HeaMeLazyQueryHookResult = ReturnType<typeof useHeaMeLazyQuery>;
export type HeaMeQueryResult = Apollo.QueryResult<HeaMeQuery, HeaMeQueryVariables>;
export const HeaSetPasswordAfterLoginDocument = gql`
    mutation heaSetPasswordAfterLogin($input: HEASetPasswordAfterLoginInput!) {
  heaSetPasswordAfterLogin(input: $input)
}
    `;
export type HeaSetPasswordAfterLoginMutationFn = Apollo.MutationFunction<HeaSetPasswordAfterLoginMutation, HeaSetPasswordAfterLoginMutationVariables>;

/**
 * __useHeaSetPasswordAfterLoginMutation__
 *
 * To run a mutation, you first call `useHeaSetPasswordAfterLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeaSetPasswordAfterLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [heaSetPasswordAfterLoginMutation, { data, loading, error }] = useHeaSetPasswordAfterLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeaSetPasswordAfterLoginMutation(baseOptions?: Apollo.MutationHookOptions<HeaSetPasswordAfterLoginMutation, HeaSetPasswordAfterLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HeaSetPasswordAfterLoginMutation, HeaSetPasswordAfterLoginMutationVariables>(HeaSetPasswordAfterLoginDocument, options);
      }
export type HeaSetPasswordAfterLoginMutationHookResult = ReturnType<typeof useHeaSetPasswordAfterLoginMutation>;
export type HeaSetPasswordAfterLoginMutationResult = Apollo.MutationResult<HeaSetPasswordAfterLoginMutation>;
export type HeaSetPasswordAfterLoginMutationOptions = Apollo.BaseMutationOptions<HeaSetPasswordAfterLoginMutation, HeaSetPasswordAfterLoginMutationVariables>;
export const HeaLockAccountDocument = gql`
    mutation heaLockAccount($input: IDInput!) {
  heaLockAccount(input: $input)
}
    `;
export type HeaLockAccountMutationFn = Apollo.MutationFunction<HeaLockAccountMutation, HeaLockAccountMutationVariables>;

/**
 * __useHeaLockAccountMutation__
 *
 * To run a mutation, you first call `useHeaLockAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeaLockAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [heaLockAccountMutation, { data, loading, error }] = useHeaLockAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeaLockAccountMutation(baseOptions?: Apollo.MutationHookOptions<HeaLockAccountMutation, HeaLockAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HeaLockAccountMutation, HeaLockAccountMutationVariables>(HeaLockAccountDocument, options);
      }
export type HeaLockAccountMutationHookResult = ReturnType<typeof useHeaLockAccountMutation>;
export type HeaLockAccountMutationResult = Apollo.MutationResult<HeaLockAccountMutation>;
export type HeaLockAccountMutationOptions = Apollo.BaseMutationOptions<HeaLockAccountMutation, HeaLockAccountMutationVariables>;
export const HeaUnlockAccountDocument = gql`
    mutation heaUnlockAccount($input: HEAUnlockAccountInput!) {
  heaUnlockAccount(input: $input)
}
    `;
export type HeaUnlockAccountMutationFn = Apollo.MutationFunction<HeaUnlockAccountMutation, HeaUnlockAccountMutationVariables>;

/**
 * __useHeaUnlockAccountMutation__
 *
 * To run a mutation, you first call `useHeaUnlockAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeaUnlockAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [heaUnlockAccountMutation, { data, loading, error }] = useHeaUnlockAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeaUnlockAccountMutation(baseOptions?: Apollo.MutationHookOptions<HeaUnlockAccountMutation, HeaUnlockAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HeaUnlockAccountMutation, HeaUnlockAccountMutationVariables>(HeaUnlockAccountDocument, options);
      }
export type HeaUnlockAccountMutationHookResult = ReturnType<typeof useHeaUnlockAccountMutation>;
export type HeaUnlockAccountMutationResult = Apollo.MutationResult<HeaUnlockAccountMutation>;
export type HeaUnlockAccountMutationOptions = Apollo.BaseMutationOptions<HeaUnlockAccountMutation, HeaUnlockAccountMutationVariables>;
export const HeaDeleteStudyPlanDocument = gql`
    mutation heaDeleteStudyPlan($input: IDInput!) {
  heaDeleteStudyPlan(input: $input)
}
    `;
export type HeaDeleteStudyPlanMutationFn = Apollo.MutationFunction<HeaDeleteStudyPlanMutation, HeaDeleteStudyPlanMutationVariables>;

/**
 * __useHeaDeleteStudyPlanMutation__
 *
 * To run a mutation, you first call `useHeaDeleteStudyPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeaDeleteStudyPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [heaDeleteStudyPlanMutation, { data, loading, error }] = useHeaDeleteStudyPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeaDeleteStudyPlanMutation(baseOptions?: Apollo.MutationHookOptions<HeaDeleteStudyPlanMutation, HeaDeleteStudyPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HeaDeleteStudyPlanMutation, HeaDeleteStudyPlanMutationVariables>(HeaDeleteStudyPlanDocument, options);
      }
export type HeaDeleteStudyPlanMutationHookResult = ReturnType<typeof useHeaDeleteStudyPlanMutation>;
export type HeaDeleteStudyPlanMutationResult = Apollo.MutationResult<HeaDeleteStudyPlanMutation>;
export type HeaDeleteStudyPlanMutationOptions = Apollo.BaseMutationOptions<HeaDeleteStudyPlanMutation, HeaDeleteStudyPlanMutationVariables>;
export const HeaDeleteAccountDocument = gql`
    mutation heaDeleteAccount {
  heaDeleteAccount
}
    `;
export type HeaDeleteAccountMutationFn = Apollo.MutationFunction<HeaDeleteAccountMutation, HeaDeleteAccountMutationVariables>;

/**
 * __useHeaDeleteAccountMutation__
 *
 * To run a mutation, you first call `useHeaDeleteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeaDeleteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [heaDeleteAccountMutation, { data, loading, error }] = useHeaDeleteAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useHeaDeleteAccountMutation(baseOptions?: Apollo.MutationHookOptions<HeaDeleteAccountMutation, HeaDeleteAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HeaDeleteAccountMutation, HeaDeleteAccountMutationVariables>(HeaDeleteAccountDocument, options);
      }
export type HeaDeleteAccountMutationHookResult = ReturnType<typeof useHeaDeleteAccountMutation>;
export type HeaDeleteAccountMutationResult = Apollo.MutationResult<HeaDeleteAccountMutation>;
export type HeaDeleteAccountMutationOptions = Apollo.BaseMutationOptions<HeaDeleteAccountMutation, HeaDeleteAccountMutationVariables>;
export const FinishStudyPlanDocument = gql`
    mutation finishStudyPlan {
  finishStudyPlan {
    ...HEAUser
  }
}
    ${HeaUserFragmentDoc}`;
export type FinishStudyPlanMutationFn = Apollo.MutationFunction<FinishStudyPlanMutation, FinishStudyPlanMutationVariables>;

/**
 * __useFinishStudyPlanMutation__
 *
 * To run a mutation, you first call `useFinishStudyPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishStudyPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishStudyPlanMutation, { data, loading, error }] = useFinishStudyPlanMutation({
 *   variables: {
 *   },
 * });
 */
export function useFinishStudyPlanMutation(baseOptions?: Apollo.MutationHookOptions<FinishStudyPlanMutation, FinishStudyPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishStudyPlanMutation, FinishStudyPlanMutationVariables>(FinishStudyPlanDocument, options);
      }
export type FinishStudyPlanMutationHookResult = ReturnType<typeof useFinishStudyPlanMutation>;
export type FinishStudyPlanMutationResult = Apollo.MutationResult<FinishStudyPlanMutation>;
export type FinishStudyPlanMutationOptions = Apollo.BaseMutationOptions<FinishStudyPlanMutation, FinishStudyPlanMutationVariables>;
export const HeaCreateFeedbackFormAnswerDocument = gql`
    mutation heaCreateFeedbackFormAnswer($input: HEACreateFeedbackFormAnswerInput!) {
  heaCreateFeedbackFormAnswer(input: $input) {
    id
    moduleId
    formData
    createdBy
    createdAt
    parentId
    parentEmail
    studyplanId
    lessonId
    lessonName
    unitId
    unitName
    surveyType
    moduleName
  }
}
    `;
export type HeaCreateFeedbackFormAnswerMutationFn = Apollo.MutationFunction<HeaCreateFeedbackFormAnswerMutation, HeaCreateFeedbackFormAnswerMutationVariables>;

/**
 * __useHeaCreateFeedbackFormAnswerMutation__
 *
 * To run a mutation, you first call `useHeaCreateFeedbackFormAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeaCreateFeedbackFormAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [heaCreateFeedbackFormAnswerMutation, { data, loading, error }] = useHeaCreateFeedbackFormAnswerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeaCreateFeedbackFormAnswerMutation(baseOptions?: Apollo.MutationHookOptions<HeaCreateFeedbackFormAnswerMutation, HeaCreateFeedbackFormAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HeaCreateFeedbackFormAnswerMutation, HeaCreateFeedbackFormAnswerMutationVariables>(HeaCreateFeedbackFormAnswerDocument, options);
      }
export type HeaCreateFeedbackFormAnswerMutationHookResult = ReturnType<typeof useHeaCreateFeedbackFormAnswerMutation>;
export type HeaCreateFeedbackFormAnswerMutationResult = Apollo.MutationResult<HeaCreateFeedbackFormAnswerMutation>;
export type HeaCreateFeedbackFormAnswerMutationOptions = Apollo.BaseMutationOptions<HeaCreateFeedbackFormAnswerMutation, HeaCreateFeedbackFormAnswerMutationVariables>;
export const HeaUpdateLessonStatusDocument = gql`
    mutation heaUpdateLessonStatus($input: HEAUpdateLessonStatusInput!) {
  heaUpdateLessonStatus(input: $input)
}
    `;
export type HeaUpdateLessonStatusMutationFn = Apollo.MutationFunction<HeaUpdateLessonStatusMutation, HeaUpdateLessonStatusMutationVariables>;

/**
 * __useHeaUpdateLessonStatusMutation__
 *
 * To run a mutation, you first call `useHeaUpdateLessonStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeaUpdateLessonStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [heaUpdateLessonStatusMutation, { data, loading, error }] = useHeaUpdateLessonStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeaUpdateLessonStatusMutation(baseOptions?: Apollo.MutationHookOptions<HeaUpdateLessonStatusMutation, HeaUpdateLessonStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HeaUpdateLessonStatusMutation, HeaUpdateLessonStatusMutationVariables>(HeaUpdateLessonStatusDocument, options);
      }
export type HeaUpdateLessonStatusMutationHookResult = ReturnType<typeof useHeaUpdateLessonStatusMutation>;
export type HeaUpdateLessonStatusMutationResult = Apollo.MutationResult<HeaUpdateLessonStatusMutation>;
export type HeaUpdateLessonStatusMutationOptions = Apollo.BaseMutationOptions<HeaUpdateLessonStatusMutation, HeaUpdateLessonStatusMutationVariables>;
export const HeaUpdateLessonDocument = gql`
    mutation heaUpdateLesson($input: HEAUpdateLessonInput!) {
  heaUpdateLesson(input: $input) {
    ...HEALesson
  }
}
    ${HeaLessonFragmentDoc}`;
export type HeaUpdateLessonMutationFn = Apollo.MutationFunction<HeaUpdateLessonMutation, HeaUpdateLessonMutationVariables>;

/**
 * __useHeaUpdateLessonMutation__
 *
 * To run a mutation, you first call `useHeaUpdateLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeaUpdateLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [heaUpdateLessonMutation, { data, loading, error }] = useHeaUpdateLessonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeaUpdateLessonMutation(baseOptions?: Apollo.MutationHookOptions<HeaUpdateLessonMutation, HeaUpdateLessonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HeaUpdateLessonMutation, HeaUpdateLessonMutationVariables>(HeaUpdateLessonDocument, options);
      }
export type HeaUpdateLessonMutationHookResult = ReturnType<typeof useHeaUpdateLessonMutation>;
export type HeaUpdateLessonMutationResult = Apollo.MutationResult<HeaUpdateLessonMutation>;
export type HeaUpdateLessonMutationOptions = Apollo.BaseMutationOptions<HeaUpdateLessonMutation, HeaUpdateLessonMutationVariables>;
export const HeaGetLessonStatusDocument = gql`
    query heaGetLessonStatus($input: HEAGetLessonStatusInput!) {
  heaGetLessonStatus(input: $input) {
    lessonId
    status
    incomplete
  }
}
    `;

/**
 * __useHeaGetLessonStatusQuery__
 *
 * To run a query within a React component, call `useHeaGetLessonStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeaGetLessonStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeaGetLessonStatusQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeaGetLessonStatusQuery(baseOptions: Apollo.QueryHookOptions<HeaGetLessonStatusQuery, HeaGetLessonStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HeaGetLessonStatusQuery, HeaGetLessonStatusQueryVariables>(HeaGetLessonStatusDocument, options);
      }
export function useHeaGetLessonStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HeaGetLessonStatusQuery, HeaGetLessonStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HeaGetLessonStatusQuery, HeaGetLessonStatusQueryVariables>(HeaGetLessonStatusDocument, options);
        }
export type HeaGetLessonStatusQueryHookResult = ReturnType<typeof useHeaGetLessonStatusQuery>;
export type HeaGetLessonStatusLazyQueryHookResult = ReturnType<typeof useHeaGetLessonStatusLazyQuery>;
export type HeaGetLessonStatusQueryResult = Apollo.QueryResult<HeaGetLessonStatusQuery, HeaGetLessonStatusQueryVariables>;
export const HeaCreateGroupModuleDocument = gql`
    mutation heaCreateGroupModule($input: HEACreateGroupModuleInput!) {
  heaCreateGroupModule(input: $input) {
    ...HEAGroupModule
  }
}
    ${HeaGroupModuleFragmentDoc}`;
export type HeaCreateGroupModuleMutationFn = Apollo.MutationFunction<HeaCreateGroupModuleMutation, HeaCreateGroupModuleMutationVariables>;

/**
 * __useHeaCreateGroupModuleMutation__
 *
 * To run a mutation, you first call `useHeaCreateGroupModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeaCreateGroupModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [heaCreateGroupModuleMutation, { data, loading, error }] = useHeaCreateGroupModuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeaCreateGroupModuleMutation(baseOptions?: Apollo.MutationHookOptions<HeaCreateGroupModuleMutation, HeaCreateGroupModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HeaCreateGroupModuleMutation, HeaCreateGroupModuleMutationVariables>(HeaCreateGroupModuleDocument, options);
      }
export type HeaCreateGroupModuleMutationHookResult = ReturnType<typeof useHeaCreateGroupModuleMutation>;
export type HeaCreateGroupModuleMutationResult = Apollo.MutationResult<HeaCreateGroupModuleMutation>;
export type HeaCreateGroupModuleMutationOptions = Apollo.BaseMutationOptions<HeaCreateGroupModuleMutation, HeaCreateGroupModuleMutationVariables>;
export const HeaUpdateGroupModuleDocument = gql`
    mutation heaUpdateGroupModule($input: HEAUpdateGroupModuleInput!) {
  heaUpdateGroupModule(input: $input) {
    ...HEAGroupModule
  }
}
    ${HeaGroupModuleFragmentDoc}`;
export type HeaUpdateGroupModuleMutationFn = Apollo.MutationFunction<HeaUpdateGroupModuleMutation, HeaUpdateGroupModuleMutationVariables>;

/**
 * __useHeaUpdateGroupModuleMutation__
 *
 * To run a mutation, you first call `useHeaUpdateGroupModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeaUpdateGroupModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [heaUpdateGroupModuleMutation, { data, loading, error }] = useHeaUpdateGroupModuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeaUpdateGroupModuleMutation(baseOptions?: Apollo.MutationHookOptions<HeaUpdateGroupModuleMutation, HeaUpdateGroupModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HeaUpdateGroupModuleMutation, HeaUpdateGroupModuleMutationVariables>(HeaUpdateGroupModuleDocument, options);
      }
export type HeaUpdateGroupModuleMutationHookResult = ReturnType<typeof useHeaUpdateGroupModuleMutation>;
export type HeaUpdateGroupModuleMutationResult = Apollo.MutationResult<HeaUpdateGroupModuleMutation>;
export type HeaUpdateGroupModuleMutationOptions = Apollo.BaseMutationOptions<HeaUpdateGroupModuleMutation, HeaUpdateGroupModuleMutationVariables>;
export const HeaDeleteGroupModuleDocument = gql`
    mutation heaDeleteGroupModule($input: HEADeleteGroupModuleInput!) {
  heaDeleteGroupModule(input: $input)
}
    `;
export type HeaDeleteGroupModuleMutationFn = Apollo.MutationFunction<HeaDeleteGroupModuleMutation, HeaDeleteGroupModuleMutationVariables>;

/**
 * __useHeaDeleteGroupModuleMutation__
 *
 * To run a mutation, you first call `useHeaDeleteGroupModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeaDeleteGroupModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [heaDeleteGroupModuleMutation, { data, loading, error }] = useHeaDeleteGroupModuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeaDeleteGroupModuleMutation(baseOptions?: Apollo.MutationHookOptions<HeaDeleteGroupModuleMutation, HeaDeleteGroupModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HeaDeleteGroupModuleMutation, HeaDeleteGroupModuleMutationVariables>(HeaDeleteGroupModuleDocument, options);
      }
export type HeaDeleteGroupModuleMutationHookResult = ReturnType<typeof useHeaDeleteGroupModuleMutation>;
export type HeaDeleteGroupModuleMutationResult = Apollo.MutationResult<HeaDeleteGroupModuleMutation>;
export type HeaDeleteGroupModuleMutationOptions = Apollo.BaseMutationOptions<HeaDeleteGroupModuleMutation, HeaDeleteGroupModuleMutationVariables>;
export const HeaGetModuleAllGroupsDocument = gql`
    query heaGetModuleAllGroups($input: IDInput!) {
  heaGetModuleAllGroups(input: $input) {
    ...HEAGroupModule
  }
}
    ${HeaGroupModuleFragmentDoc}`;

/**
 * __useHeaGetModuleAllGroupsQuery__
 *
 * To run a query within a React component, call `useHeaGetModuleAllGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeaGetModuleAllGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeaGetModuleAllGroupsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeaGetModuleAllGroupsQuery(baseOptions: Apollo.QueryHookOptions<HeaGetModuleAllGroupsQuery, HeaGetModuleAllGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HeaGetModuleAllGroupsQuery, HeaGetModuleAllGroupsQueryVariables>(HeaGetModuleAllGroupsDocument, options);
      }
export function useHeaGetModuleAllGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HeaGetModuleAllGroupsQuery, HeaGetModuleAllGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HeaGetModuleAllGroupsQuery, HeaGetModuleAllGroupsQueryVariables>(HeaGetModuleAllGroupsDocument, options);
        }
export type HeaGetModuleAllGroupsQueryHookResult = ReturnType<typeof useHeaGetModuleAllGroupsQuery>;
export type HeaGetModuleAllGroupsLazyQueryHookResult = ReturnType<typeof useHeaGetModuleAllGroupsLazyQuery>;
export type HeaGetModuleAllGroupsQueryResult = Apollo.QueryResult<HeaGetModuleAllGroupsQuery, HeaGetModuleAllGroupsQueryVariables>;
export const HeaEnableFaithDocument = gql`
    mutation heaEnableFaith($disable: Boolean) {
  heaEnableFaith(disable: $disable)
}
    `;
export type HeaEnableFaithMutationFn = Apollo.MutationFunction<HeaEnableFaithMutation, HeaEnableFaithMutationVariables>;

/**
 * __useHeaEnableFaithMutation__
 *
 * To run a mutation, you first call `useHeaEnableFaithMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeaEnableFaithMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [heaEnableFaithMutation, { data, loading, error }] = useHeaEnableFaithMutation({
 *   variables: {
 *      disable: // value for 'disable'
 *   },
 * });
 */
export function useHeaEnableFaithMutation(baseOptions?: Apollo.MutationHookOptions<HeaEnableFaithMutation, HeaEnableFaithMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HeaEnableFaithMutation, HeaEnableFaithMutationVariables>(HeaEnableFaithDocument, options);
      }
export type HeaEnableFaithMutationHookResult = ReturnType<typeof useHeaEnableFaithMutation>;
export type HeaEnableFaithMutationResult = Apollo.MutationResult<HeaEnableFaithMutation>;
export type HeaEnableFaithMutationOptions = Apollo.BaseMutationOptions<HeaEnableFaithMutation, HeaEnableFaithMutationVariables>;
export const HeTokensDocument = gql`
    query heTokens {
  heTokens {
    ...HEToken
  }
}
    ${HeTokenFragmentDoc}`;

/**
 * __useHeTokensQuery__
 *
 * To run a query within a React component, call `useHeTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeTokensQuery({
 *   variables: {
 *   },
 * });
 */
export function useHeTokensQuery(baseOptions?: Apollo.QueryHookOptions<HeTokensQuery, HeTokensQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HeTokensQuery, HeTokensQueryVariables>(HeTokensDocument, options);
      }
export function useHeTokensLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HeTokensQuery, HeTokensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HeTokensQuery, HeTokensQueryVariables>(HeTokensDocument, options);
        }
export type HeTokensQueryHookResult = ReturnType<typeof useHeTokensQuery>;
export type HeTokensLazyQueryHookResult = ReturnType<typeof useHeTokensLazyQuery>;
export type HeTokensQueryResult = Apollo.QueryResult<HeTokensQuery, HeTokensQueryVariables>;
export const HeaUsersDocument = gql`
    query heaUsers {
  heaUsers {
    ...HEAUser
  }
}
    ${HeaUserFragmentDoc}`;

/**
 * __useHeaUsersQuery__
 *
 * To run a query within a React component, call `useHeaUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeaUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeaUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useHeaUsersQuery(baseOptions?: Apollo.QueryHookOptions<HeaUsersQuery, HeaUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HeaUsersQuery, HeaUsersQueryVariables>(HeaUsersDocument, options);
      }
export function useHeaUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HeaUsersQuery, HeaUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HeaUsersQuery, HeaUsersQueryVariables>(HeaUsersDocument, options);
        }
export type HeaUsersQueryHookResult = ReturnType<typeof useHeaUsersQuery>;
export type HeaUsersLazyQueryHookResult = ReturnType<typeof useHeaUsersLazyQuery>;
export type HeaUsersQueryResult = Apollo.QueryResult<HeaUsersQuery, HeaUsersQueryVariables>;
export const FeedbackFormDocument = gql`
    query feedbackForm($input: IDInput!) {
  feedbackForm(input: $input) {
    id
    programName
    unitName
    lessonName
    formData
    expirationAt
    createdAt
    type
    exitTicketCount
    link
    grade
  }
}
    `;

/**
 * __useFeedbackFormQuery__
 *
 * To run a query within a React component, call `useFeedbackFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedbackFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedbackFormQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFeedbackFormQuery(baseOptions: Apollo.QueryHookOptions<FeedbackFormQuery, FeedbackFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedbackFormQuery, FeedbackFormQueryVariables>(FeedbackFormDocument, options);
      }
export function useFeedbackFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedbackFormQuery, FeedbackFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedbackFormQuery, FeedbackFormQueryVariables>(FeedbackFormDocument, options);
        }
export type FeedbackFormQueryHookResult = ReturnType<typeof useFeedbackFormQuery>;
export type FeedbackFormLazyQueryHookResult = ReturnType<typeof useFeedbackFormLazyQuery>;
export type FeedbackFormQueryResult = Apollo.QueryResult<FeedbackFormQuery, FeedbackFormQueryVariables>;
export const CancelFeedbackFormDocument = gql`
    mutation cancelFeedbackForm($input: IDInput!) {
  cancelFeedbackForm(input: $input)
}
    `;
export type CancelFeedbackFormMutationFn = Apollo.MutationFunction<CancelFeedbackFormMutation, CancelFeedbackFormMutationVariables>;

/**
 * __useCancelFeedbackFormMutation__
 *
 * To run a mutation, you first call `useCancelFeedbackFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelFeedbackFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelFeedbackFormMutation, { data, loading, error }] = useCancelFeedbackFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelFeedbackFormMutation(baseOptions?: Apollo.MutationHookOptions<CancelFeedbackFormMutation, CancelFeedbackFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelFeedbackFormMutation, CancelFeedbackFormMutationVariables>(CancelFeedbackFormDocument, options);
      }
export type CancelFeedbackFormMutationHookResult = ReturnType<typeof useCancelFeedbackFormMutation>;
export type CancelFeedbackFormMutationResult = Apollo.MutationResult<CancelFeedbackFormMutation>;
export type CancelFeedbackFormMutationOptions = Apollo.BaseMutationOptions<CancelFeedbackFormMutation, CancelFeedbackFormMutationVariables>;
export const CopyPasswordLinkDocument = gql`
    mutation copyPasswordLink($input: EmailInput!) {
  copyPasswordLink(input: $input)
}
    `;
export type CopyPasswordLinkMutationFn = Apollo.MutationFunction<CopyPasswordLinkMutation, CopyPasswordLinkMutationVariables>;

/**
 * __useCopyPasswordLinkMutation__
 *
 * To run a mutation, you first call `useCopyPasswordLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyPasswordLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyPasswordLinkMutation, { data, loading, error }] = useCopyPasswordLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCopyPasswordLinkMutation(baseOptions?: Apollo.MutationHookOptions<CopyPasswordLinkMutation, CopyPasswordLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyPasswordLinkMutation, CopyPasswordLinkMutationVariables>(CopyPasswordLinkDocument, options);
      }
export type CopyPasswordLinkMutationHookResult = ReturnType<typeof useCopyPasswordLinkMutation>;
export type CopyPasswordLinkMutationResult = Apollo.MutationResult<CopyPasswordLinkMutation>;
export type CopyPasswordLinkMutationOptions = Apollo.BaseMutationOptions<CopyPasswordLinkMutation, CopyPasswordLinkMutationVariables>;
export const EmailPasswordLinkDocument = gql`
    mutation emailPasswordLink($input: EmailInput!) {
  emailPasswordLink(input: $input)
}
    `;
export type EmailPasswordLinkMutationFn = Apollo.MutationFunction<EmailPasswordLinkMutation, EmailPasswordLinkMutationVariables>;

/**
 * __useEmailPasswordLinkMutation__
 *
 * To run a mutation, you first call `useEmailPasswordLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailPasswordLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailPasswordLinkMutation, { data, loading, error }] = useEmailPasswordLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEmailPasswordLinkMutation(baseOptions?: Apollo.MutationHookOptions<EmailPasswordLinkMutation, EmailPasswordLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmailPasswordLinkMutation, EmailPasswordLinkMutationVariables>(EmailPasswordLinkDocument, options);
      }
export type EmailPasswordLinkMutationHookResult = ReturnType<typeof useEmailPasswordLinkMutation>;
export type EmailPasswordLinkMutationResult = Apollo.MutationResult<EmailPasswordLinkMutation>;
export type EmailPasswordLinkMutationOptions = Apollo.BaseMutationOptions<EmailPasswordLinkMutation, EmailPasswordLinkMutationVariables>;
export const HeaUpdateStudyPlanNameDocument = gql`
    mutation heaUpdateStudyPlanName($input: HEAUpdateStudyPlanNameInput!) {
  heaUpdateStudyPlanName(input: $input)
}
    `;
export type HeaUpdateStudyPlanNameMutationFn = Apollo.MutationFunction<HeaUpdateStudyPlanNameMutation, HeaUpdateStudyPlanNameMutationVariables>;

/**
 * __useHeaUpdateStudyPlanNameMutation__
 *
 * To run a mutation, you first call `useHeaUpdateStudyPlanNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeaUpdateStudyPlanNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [heaUpdateStudyPlanNameMutation, { data, loading, error }] = useHeaUpdateStudyPlanNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeaUpdateStudyPlanNameMutation(baseOptions?: Apollo.MutationHookOptions<HeaUpdateStudyPlanNameMutation, HeaUpdateStudyPlanNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HeaUpdateStudyPlanNameMutation, HeaUpdateStudyPlanNameMutationVariables>(HeaUpdateStudyPlanNameDocument, options);
      }
export type HeaUpdateStudyPlanNameMutationHookResult = ReturnType<typeof useHeaUpdateStudyPlanNameMutation>;
export type HeaUpdateStudyPlanNameMutationResult = Apollo.MutationResult<HeaUpdateStudyPlanNameMutation>;
export type HeaUpdateStudyPlanNameMutationOptions = Apollo.BaseMutationOptions<HeaUpdateStudyPlanNameMutation, HeaUpdateStudyPlanNameMutationVariables>;
export const HeaSendResetPasswordLinkDocument = gql`
    mutation heaSendResetPasswordLink($input: HEASendResetPasswordLinkInput!) {
  heaSendResetPasswordLink(input: $input)
}
    `;
export type HeaSendResetPasswordLinkMutationFn = Apollo.MutationFunction<HeaSendResetPasswordLinkMutation, HeaSendResetPasswordLinkMutationVariables>;

/**
 * __useHeaSendResetPasswordLinkMutation__
 *
 * To run a mutation, you first call `useHeaSendResetPasswordLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeaSendResetPasswordLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [heaSendResetPasswordLinkMutation, { data, loading, error }] = useHeaSendResetPasswordLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeaSendResetPasswordLinkMutation(baseOptions?: Apollo.MutationHookOptions<HeaSendResetPasswordLinkMutation, HeaSendResetPasswordLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HeaSendResetPasswordLinkMutation, HeaSendResetPasswordLinkMutationVariables>(HeaSendResetPasswordLinkDocument, options);
      }
export type HeaSendResetPasswordLinkMutationHookResult = ReturnType<typeof useHeaSendResetPasswordLinkMutation>;
export type HeaSendResetPasswordLinkMutationResult = Apollo.MutationResult<HeaSendResetPasswordLinkMutation>;
export type HeaSendResetPasswordLinkMutationOptions = Apollo.BaseMutationOptions<HeaSendResetPasswordLinkMutation, HeaSendResetPasswordLinkMutationVariables>;
export const HeaResetPasswordDocument = gql`
    mutation heaResetPassword($input: HEAResetPasswordInput!) {
  heaResetPassword(input: $input)
}
    `;
export type HeaResetPasswordMutationFn = Apollo.MutationFunction<HeaResetPasswordMutation, HeaResetPasswordMutationVariables>;

/**
 * __useHeaResetPasswordMutation__
 *
 * To run a mutation, you first call `useHeaResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeaResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [heaResetPasswordMutation, { data, loading, error }] = useHeaResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeaResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<HeaResetPasswordMutation, HeaResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HeaResetPasswordMutation, HeaResetPasswordMutationVariables>(HeaResetPasswordDocument, options);
      }
export type HeaResetPasswordMutationHookResult = ReturnType<typeof useHeaResetPasswordMutation>;
export type HeaResetPasswordMutationResult = Apollo.MutationResult<HeaResetPasswordMutation>;
export type HeaResetPasswordMutationOptions = Apollo.BaseMutationOptions<HeaResetPasswordMutation, HeaResetPasswordMutationVariables>;
export const GetInvitedUserDocument = gql`
    query getInvitedUser($input: UserIDInput!) {
  invitedUser(input: $input) {
    email
    firstName
    lastName
    customer {
      name
      id
    }
    schools {
      id
    }
    status
  }
}
    `;

/**
 * __useGetInvitedUserQuery__
 *
 * To run a query within a React component, call `useGetInvitedUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvitedUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvitedUserQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetInvitedUserQuery(baseOptions: Apollo.QueryHookOptions<GetInvitedUserQuery, GetInvitedUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvitedUserQuery, GetInvitedUserQueryVariables>(GetInvitedUserDocument, options);
      }
export function useGetInvitedUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvitedUserQuery, GetInvitedUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvitedUserQuery, GetInvitedUserQueryVariables>(GetInvitedUserDocument, options);
        }
export type GetInvitedUserQueryHookResult = ReturnType<typeof useGetInvitedUserQuery>;
export type GetInvitedUserLazyQueryHookResult = ReturnType<typeof useGetInvitedUserLazyQuery>;
export type GetInvitedUserQueryResult = Apollo.QueryResult<GetInvitedUserQuery, GetInvitedUserQueryVariables>;
export const RevalidateDocument = gql`
    mutation revalidate($input: RevalidateTokenInput!) {
  revalidateToken(input: $input) {
    token
    clientId
    email
  }
}
    `;
export type RevalidateMutationFn = Apollo.MutationFunction<RevalidateMutation, RevalidateMutationVariables>;

/**
 * __useRevalidateMutation__
 *
 * To run a mutation, you first call `useRevalidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevalidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revalidateMutation, { data, loading, error }] = useRevalidateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevalidateMutation(baseOptions?: Apollo.MutationHookOptions<RevalidateMutation, RevalidateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevalidateMutation, RevalidateMutationVariables>(RevalidateDocument, options);
      }
export type RevalidateMutationHookResult = ReturnType<typeof useRevalidateMutation>;
export type RevalidateMutationResult = Apollo.MutationResult<RevalidateMutation>;
export type RevalidateMutationOptions = Apollo.BaseMutationOptions<RevalidateMutation, RevalidateMutationVariables>;
export const RegistrationDocument = gql`
    mutation registration($input: UserRegistrationInput!) {
  registration(input: $input) {
    token
    user {
      id
      email
      firstName
      lastName
      status
      customer {
        name
        id
      }
      schools {
        id
        name
      }
      createdAt
    }
  }
}
    `;
export type RegistrationMutationFn = Apollo.MutationFunction<RegistrationMutation, RegistrationMutationVariables>;

/**
 * __useRegistrationMutation__
 *
 * To run a mutation, you first call `useRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registrationMutation, { data, loading, error }] = useRegistrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<RegistrationMutation, RegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegistrationMutation, RegistrationMutationVariables>(RegistrationDocument, options);
      }
export type RegistrationMutationHookResult = ReturnType<typeof useRegistrationMutation>;
export type RegistrationMutationResult = Apollo.MutationResult<RegistrationMutation>;
export type RegistrationMutationOptions = Apollo.BaseMutationOptions<RegistrationMutation, RegistrationMutationVariables>;
export const HeaLessonsToConfirmDocument = gql`
    query heaLessonsToConfirm {
  heaLessonsToConfirm {
    ...LessonToConfirm
  }
}
    ${LessonToConfirmFragmentDoc}`;

/**
 * __useHeaLessonsToConfirmQuery__
 *
 * To run a query within a React component, call `useHeaLessonsToConfirmQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeaLessonsToConfirmQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeaLessonsToConfirmQuery({
 *   variables: {
 *   },
 * });
 */
export function useHeaLessonsToConfirmQuery(baseOptions?: Apollo.QueryHookOptions<HeaLessonsToConfirmQuery, HeaLessonsToConfirmQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HeaLessonsToConfirmQuery, HeaLessonsToConfirmQueryVariables>(HeaLessonsToConfirmDocument, options);
      }
export function useHeaLessonsToConfirmLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HeaLessonsToConfirmQuery, HeaLessonsToConfirmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HeaLessonsToConfirmQuery, HeaLessonsToConfirmQueryVariables>(HeaLessonsToConfirmDocument, options);
        }
export type HeaLessonsToConfirmQueryHookResult = ReturnType<typeof useHeaLessonsToConfirmQuery>;
export type HeaLessonsToConfirmLazyQueryHookResult = ReturnType<typeof useHeaLessonsToConfirmLazyQuery>;
export type HeaLessonsToConfirmQueryResult = Apollo.QueryResult<HeaLessonsToConfirmQuery, HeaLessonsToConfirmQueryVariables>;
export const HeaConfirmLessonDocument = gql`
    mutation heaConfirmLesson($input: HEAConfirmLessonInput!) {
  heaConfirmLesson(input: $input)
}
    `;
export type HeaConfirmLessonMutationFn = Apollo.MutationFunction<HeaConfirmLessonMutation, HeaConfirmLessonMutationVariables>;

/**
 * __useHeaConfirmLessonMutation__
 *
 * To run a mutation, you first call `useHeaConfirmLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeaConfirmLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [heaConfirmLessonMutation, { data, loading, error }] = useHeaConfirmLessonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeaConfirmLessonMutation(baseOptions?: Apollo.MutationHookOptions<HeaConfirmLessonMutation, HeaConfirmLessonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HeaConfirmLessonMutation, HeaConfirmLessonMutationVariables>(HeaConfirmLessonDocument, options);
      }
export type HeaConfirmLessonMutationHookResult = ReturnType<typeof useHeaConfirmLessonMutation>;
export type HeaConfirmLessonMutationResult = Apollo.MutationResult<HeaConfirmLessonMutation>;
export type HeaConfirmLessonMutationOptions = Apollo.BaseMutationOptions<HeaConfirmLessonMutation, HeaConfirmLessonMutationVariables>;
export const HeaSetTypeformShownDocument = gql`
    mutation heaSetTypeformShown {
  heaSetTypeformShown
}
    `;
export type HeaSetTypeformShownMutationFn = Apollo.MutationFunction<HeaSetTypeformShownMutation, HeaSetTypeformShownMutationVariables>;

/**
 * __useHeaSetTypeformShownMutation__
 *
 * To run a mutation, you first call `useHeaSetTypeformShownMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeaSetTypeformShownMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [heaSetTypeformShownMutation, { data, loading, error }] = useHeaSetTypeformShownMutation({
 *   variables: {
 *   },
 * });
 */
export function useHeaSetTypeformShownMutation(baseOptions?: Apollo.MutationHookOptions<HeaSetTypeformShownMutation, HeaSetTypeformShownMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HeaSetTypeformShownMutation, HeaSetTypeformShownMutationVariables>(HeaSetTypeformShownDocument, options);
      }
export type HeaSetTypeformShownMutationHookResult = ReturnType<typeof useHeaSetTypeformShownMutation>;
export type HeaSetTypeformShownMutationResult = Apollo.MutationResult<HeaSetTypeformShownMutation>;
export type HeaSetTypeformShownMutationOptions = Apollo.BaseMutationOptions<HeaSetTypeformShownMutation, HeaSetTypeformShownMutationVariables>;
export const HeExitTicketResultDocument = gql`
    query heExitTicketResult($input: HEExitTicketResultInput!) {
  heExitTicketResult(input: $input) {
    formData
    parentEmail
    createdBy
    createdAt
    moduleName
    studyPlanName
    lessonName
    unitName
    surveyType
  }
}
    `;

/**
 * __useHeExitTicketResultQuery__
 *
 * To run a query within a React component, call `useHeExitTicketResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeExitTicketResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeExitTicketResultQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHeExitTicketResultQuery(baseOptions: Apollo.QueryHookOptions<HeExitTicketResultQuery, HeExitTicketResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HeExitTicketResultQuery, HeExitTicketResultQueryVariables>(HeExitTicketResultDocument, options);
      }
export function useHeExitTicketResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HeExitTicketResultQuery, HeExitTicketResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HeExitTicketResultQuery, HeExitTicketResultQueryVariables>(HeExitTicketResultDocument, options);
        }
export type HeExitTicketResultQueryHookResult = ReturnType<typeof useHeExitTicketResultQuery>;
export type HeExitTicketResultLazyQueryHookResult = ReturnType<typeof useHeExitTicketResultLazyQuery>;
export type HeExitTicketResultQueryResult = Apollo.QueryResult<HeExitTicketResultQuery, HeExitTicketResultQueryVariables>;
export const CreateAlternateLessonDocument = gql`
    mutation createAlternateLesson($input: IDInput!) {
  createAlternateLesson(input: $input) {
    ...Section
  }
}
    ${SectionFragmentDoc}`;
export type CreateAlternateLessonMutationFn = Apollo.MutationFunction<CreateAlternateLessonMutation, CreateAlternateLessonMutationVariables>;

/**
 * __useCreateAlternateLessonMutation__
 *
 * To run a mutation, you first call `useCreateAlternateLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlternateLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAlternateLessonMutation, { data, loading, error }] = useCreateAlternateLessonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAlternateLessonMutation(baseOptions?: Apollo.MutationHookOptions<CreateAlternateLessonMutation, CreateAlternateLessonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAlternateLessonMutation, CreateAlternateLessonMutationVariables>(CreateAlternateLessonDocument, options);
      }
export type CreateAlternateLessonMutationHookResult = ReturnType<typeof useCreateAlternateLessonMutation>;
export type CreateAlternateLessonMutationResult = Apollo.MutationResult<CreateAlternateLessonMutation>;
export type CreateAlternateLessonMutationOptions = Apollo.BaseMutationOptions<CreateAlternateLessonMutation, CreateAlternateLessonMutationVariables>;
export const DeleteAlternateLessonDocument = gql`
    mutation deleteAlternateLesson($input: IDInput!) {
  deleteAlternateLesson(input: $input)
}
    `;
export type DeleteAlternateLessonMutationFn = Apollo.MutationFunction<DeleteAlternateLessonMutation, DeleteAlternateLessonMutationVariables>;

/**
 * __useDeleteAlternateLessonMutation__
 *
 * To run a mutation, you first call `useDeleteAlternateLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAlternateLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAlternateLessonMutation, { data, loading, error }] = useDeleteAlternateLessonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAlternateLessonMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAlternateLessonMutation, DeleteAlternateLessonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAlternateLessonMutation, DeleteAlternateLessonMutationVariables>(DeleteAlternateLessonDocument, options);
      }
export type DeleteAlternateLessonMutationHookResult = ReturnType<typeof useDeleteAlternateLessonMutation>;
export type DeleteAlternateLessonMutationResult = Apollo.MutationResult<DeleteAlternateLessonMutation>;
export type DeleteAlternateLessonMutationOptions = Apollo.BaseMutationOptions<DeleteAlternateLessonMutation, DeleteAlternateLessonMutationVariables>;
export const CreateSectionDocument = gql`
    mutation createSection($input: CreateSectionInput!) {
  createSection(input: $input) {
    ...Section
  }
}
    ${SectionFragmentDoc}`;
export type CreateSectionMutationFn = Apollo.MutationFunction<CreateSectionMutation, CreateSectionMutationVariables>;

/**
 * __useCreateSectionMutation__
 *
 * To run a mutation, you first call `useCreateSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSectionMutation, { data, loading, error }] = useCreateSectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSectionMutation, CreateSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSectionMutation, CreateSectionMutationVariables>(CreateSectionDocument, options);
      }
export type CreateSectionMutationHookResult = ReturnType<typeof useCreateSectionMutation>;
export type CreateSectionMutationResult = Apollo.MutationResult<CreateSectionMutation>;
export type CreateSectionMutationOptions = Apollo.BaseMutationOptions<CreateSectionMutation, CreateSectionMutationVariables>;
export const DeleteSectionDocument = gql`
    mutation deleteSection($input: IDInput!) {
  deleteSection(input: $input)
}
    `;
export type DeleteSectionMutationFn = Apollo.MutationFunction<DeleteSectionMutation, DeleteSectionMutationVariables>;

/**
 * __useDeleteSectionMutation__
 *
 * To run a mutation, you first call `useDeleteSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSectionMutation, { data, loading, error }] = useDeleteSectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSectionMutation, DeleteSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSectionMutation, DeleteSectionMutationVariables>(DeleteSectionDocument, options);
      }
export type DeleteSectionMutationHookResult = ReturnType<typeof useDeleteSectionMutation>;
export type DeleteSectionMutationResult = Apollo.MutationResult<DeleteSectionMutation>;
export type DeleteSectionMutationOptions = Apollo.BaseMutationOptions<DeleteSectionMutation, DeleteSectionMutationVariables>;
export const UpdateSectionDocument = gql`
    mutation updateSection($input: UpdateSectionInput!) {
  updateSection(input: $input)
}
    `;
export type UpdateSectionMutationFn = Apollo.MutationFunction<UpdateSectionMutation, UpdateSectionMutationVariables>;

/**
 * __useUpdateSectionMutation__
 *
 * To run a mutation, you first call `useUpdateSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSectionMutation, { data, loading, error }] = useUpdateSectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSectionMutation, UpdateSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSectionMutation, UpdateSectionMutationVariables>(UpdateSectionDocument, options);
      }
export type UpdateSectionMutationHookResult = ReturnType<typeof useUpdateSectionMutation>;
export type UpdateSectionMutationResult = Apollo.MutationResult<UpdateSectionMutation>;
export type UpdateSectionMutationOptions = Apollo.BaseMutationOptions<UpdateSectionMutation, UpdateSectionMutationVariables>;
export const SwitchLessonFlowDocument = gql`
    mutation switchLessonFlow($input: SwitchLessonFlowInput!) {
  switchLessonFlow(input: $input)
}
    `;
export type SwitchLessonFlowMutationFn = Apollo.MutationFunction<SwitchLessonFlowMutation, SwitchLessonFlowMutationVariables>;

/**
 * __useSwitchLessonFlowMutation__
 *
 * To run a mutation, you first call `useSwitchLessonFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchLessonFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchLessonFlowMutation, { data, loading, error }] = useSwitchLessonFlowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSwitchLessonFlowMutation(baseOptions?: Apollo.MutationHookOptions<SwitchLessonFlowMutation, SwitchLessonFlowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwitchLessonFlowMutation, SwitchLessonFlowMutationVariables>(SwitchLessonFlowDocument, options);
      }
export type SwitchLessonFlowMutationHookResult = ReturnType<typeof useSwitchLessonFlowMutation>;
export type SwitchLessonFlowMutationResult = Apollo.MutationResult<SwitchLessonFlowMutation>;
export type SwitchLessonFlowMutationOptions = Apollo.BaseMutationOptions<SwitchLessonFlowMutation, SwitchLessonFlowMutationVariables>;
export const UpdateSectionCompleteStatusDocument = gql`
    mutation updateSectionCompleteStatus($input: UpdateSectionCompleteStatusInput!) {
  updateSectionCompleteStatus(input: $input)
}
    `;
export type UpdateSectionCompleteStatusMutationFn = Apollo.MutationFunction<UpdateSectionCompleteStatusMutation, UpdateSectionCompleteStatusMutationVariables>;

/**
 * __useUpdateSectionCompleteStatusMutation__
 *
 * To run a mutation, you first call `useUpdateSectionCompleteStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSectionCompleteStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSectionCompleteStatusMutation, { data, loading, error }] = useUpdateSectionCompleteStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSectionCompleteStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSectionCompleteStatusMutation, UpdateSectionCompleteStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSectionCompleteStatusMutation, UpdateSectionCompleteStatusMutationVariables>(UpdateSectionCompleteStatusDocument, options);
      }
export type UpdateSectionCompleteStatusMutationHookResult = ReturnType<typeof useUpdateSectionCompleteStatusMutation>;
export type UpdateSectionCompleteStatusMutationResult = Apollo.MutationResult<UpdateSectionCompleteStatusMutation>;
export type UpdateSectionCompleteStatusMutationOptions = Apollo.BaseMutationOptions<UpdateSectionCompleteStatusMutation, UpdateSectionCompleteStatusMutationVariables>;
export const SchoolDocument = gql`
    query school($input: UserIDInput!) {
  school(input: $input)
}
    `;

/**
 * __useSchoolQuery__
 *
 * To run a query within a React component, call `useSchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSchoolQuery(baseOptions: Apollo.QueryHookOptions<SchoolQuery, SchoolQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchoolQuery, SchoolQueryVariables>(SchoolDocument, options);
      }
export function useSchoolLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchoolQuery, SchoolQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchoolQuery, SchoolQueryVariables>(SchoolDocument, options);
        }
export type SchoolQueryHookResult = ReturnType<typeof useSchoolQuery>;
export type SchoolLazyQueryHookResult = ReturnType<typeof useSchoolLazyQuery>;
export type SchoolQueryResult = Apollo.QueryResult<SchoolQuery, SchoolQueryVariables>;
export const AccountDocument = gql`
    query account($input: UserIDInput!) {
  account(input: $input) {
    id
    name
  }
}
    `;

/**
 * __useAccountQuery__
 *
 * To run a query within a React component, call `useAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAccountQuery(baseOptions: Apollo.QueryHookOptions<AccountQuery, AccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountQuery, AccountQueryVariables>(AccountDocument, options);
      }
export function useAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountQuery, AccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountQuery, AccountQueryVariables>(AccountDocument, options);
        }
export type AccountQueryHookResult = ReturnType<typeof useAccountQuery>;
export type AccountLazyQueryHookResult = ReturnType<typeof useAccountLazyQuery>;
export type AccountQueryResult = Apollo.QueryResult<AccountQuery, AccountQueryVariables>;
export const ConfirmEmailDocument = gql`
    query confirmEmail($input: ConfirmEmailInput!) {
  confirmEmail(input: $input)
}
    `;

/**
 * __useConfirmEmailQuery__
 *
 * To run a query within a React component, call `useConfirmEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfirmEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfirmEmailQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmEmailQuery(baseOptions: Apollo.QueryHookOptions<ConfirmEmailQuery, ConfirmEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConfirmEmailQuery, ConfirmEmailQueryVariables>(ConfirmEmailDocument, options);
      }
export function useConfirmEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfirmEmailQuery, ConfirmEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConfirmEmailQuery, ConfirmEmailQueryVariables>(ConfirmEmailDocument, options);
        }
export type ConfirmEmailQueryHookResult = ReturnType<typeof useConfirmEmailQuery>;
export type ConfirmEmailLazyQueryHookResult = ReturnType<typeof useConfirmEmailLazyQuery>;
export type ConfirmEmailQueryResult = Apollo.QueryResult<ConfirmEmailQuery, ConfirmEmailQueryVariables>;
export const GetSurveysDocument = gql`
    query getSurveys($input: GetSurveysInput!) {
  getSurveys(input: $input) {
    success
    csvData
    filename
  }
}
    `;

/**
 * __useGetSurveysQuery__
 *
 * To run a query within a React component, call `useGetSurveysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveysQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSurveysQuery(baseOptions: Apollo.QueryHookOptions<GetSurveysQuery, GetSurveysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSurveysQuery, GetSurveysQueryVariables>(GetSurveysDocument, options);
      }
export function useGetSurveysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSurveysQuery, GetSurveysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSurveysQuery, GetSurveysQueryVariables>(GetSurveysDocument, options);
        }
export type GetSurveysQueryHookResult = ReturnType<typeof useGetSurveysQuery>;
export type GetSurveysLazyQueryHookResult = ReturnType<typeof useGetSurveysLazyQuery>;
export type GetSurveysQueryResult = Apollo.QueryResult<GetSurveysQuery, GetSurveysQueryVariables>;
export const ListSchoolReportsDocument = gql`
    query listSchoolReports {
  listSchoolReports {
    id
    name
    surveyId
    generatedAt
    startDate
    endDate
    key
    url
    schoolIds
  }
}
    `;

/**
 * __useListSchoolReportsQuery__
 *
 * To run a query within a React component, call `useListSchoolReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSchoolReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSchoolReportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListSchoolReportsQuery(baseOptions?: Apollo.QueryHookOptions<ListSchoolReportsQuery, ListSchoolReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSchoolReportsQuery, ListSchoolReportsQueryVariables>(ListSchoolReportsDocument, options);
      }
export function useListSchoolReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSchoolReportsQuery, ListSchoolReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSchoolReportsQuery, ListSchoolReportsQueryVariables>(ListSchoolReportsDocument, options);
        }
export type ListSchoolReportsQueryHookResult = ReturnType<typeof useListSchoolReportsQuery>;
export type ListSchoolReportsLazyQueryHookResult = ReturnType<typeof useListSchoolReportsLazyQuery>;
export type ListSchoolReportsQueryResult = Apollo.QueryResult<ListSchoolReportsQuery, ListSchoolReportsQueryVariables>;
export const GetSchoolReportsDocument = gql`
    query getSchoolReports($ids: [ID!]) {
  getSchoolReports(ids: $ids) {
    id
    name
    surveyId
    generatedAt
    startDate
    endDate
    key
    url
    schoolIds
  }
}
    `;

/**
 * __useGetSchoolReportsQuery__
 *
 * To run a query within a React component, call `useGetSchoolReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolReportsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetSchoolReportsQuery(baseOptions?: Apollo.QueryHookOptions<GetSchoolReportsQuery, GetSchoolReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchoolReportsQuery, GetSchoolReportsQueryVariables>(GetSchoolReportsDocument, options);
      }
export function useGetSchoolReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchoolReportsQuery, GetSchoolReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchoolReportsQuery, GetSchoolReportsQueryVariables>(GetSchoolReportsDocument, options);
        }
export type GetSchoolReportsQueryHookResult = ReturnType<typeof useGetSchoolReportsQuery>;
export type GetSchoolReportsLazyQueryHookResult = ReturnType<typeof useGetSchoolReportsLazyQuery>;
export type GetSchoolReportsQueryResult = Apollo.QueryResult<GetSchoolReportsQuery, GetSchoolReportsQueryVariables>;
export const GenerateSchoolReportDocument = gql`
    mutation generateSchoolReport($input: GenerateSchoolReportInput!) {
  generateSchoolReport(input: $input) {
    name
    surveyId
    startDate
    endDate
    key
    url
    schoolIds
  }
}
    `;
export type GenerateSchoolReportMutationFn = Apollo.MutationFunction<GenerateSchoolReportMutation, GenerateSchoolReportMutationVariables>;

/**
 * __useGenerateSchoolReportMutation__
 *
 * To run a mutation, you first call `useGenerateSchoolReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSchoolReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSchoolReportMutation, { data, loading, error }] = useGenerateSchoolReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateSchoolReportMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSchoolReportMutation, GenerateSchoolReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSchoolReportMutation, GenerateSchoolReportMutationVariables>(GenerateSchoolReportDocument, options);
      }
export type GenerateSchoolReportMutationHookResult = ReturnType<typeof useGenerateSchoolReportMutation>;
export type GenerateSchoolReportMutationResult = Apollo.MutationResult<GenerateSchoolReportMutation>;
export type GenerateSchoolReportMutationOptions = Apollo.BaseMutationOptions<GenerateSchoolReportMutation, GenerateSchoolReportMutationVariables>;
export const GetFeedbackFormByLinkDocument = gql`
    query getFeedbackFormByLink($input: FeedbackLinkInput!) {
  getFeedbackFormByLink(input: $input) {
    ...FeedbackFormContent
  }
}
    ${FeedbackFormContentFragmentDoc}`;

/**
 * __useGetFeedbackFormByLinkQuery__
 *
 * To run a query within a React component, call `useGetFeedbackFormByLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedbackFormByLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedbackFormByLinkQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetFeedbackFormByLinkQuery(baseOptions: Apollo.QueryHookOptions<GetFeedbackFormByLinkQuery, GetFeedbackFormByLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeedbackFormByLinkQuery, GetFeedbackFormByLinkQueryVariables>(GetFeedbackFormByLinkDocument, options);
      }
export function useGetFeedbackFormByLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeedbackFormByLinkQuery, GetFeedbackFormByLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeedbackFormByLinkQuery, GetFeedbackFormByLinkQueryVariables>(GetFeedbackFormByLinkDocument, options);
        }
export type GetFeedbackFormByLinkQueryHookResult = ReturnType<typeof useGetFeedbackFormByLinkQuery>;
export type GetFeedbackFormByLinkLazyQueryHookResult = ReturnType<typeof useGetFeedbackFormByLinkLazyQuery>;
export type GetFeedbackFormByLinkQueryResult = Apollo.QueryResult<GetFeedbackFormByLinkQuery, GetFeedbackFormByLinkQueryVariables>;
export const GetSchoolReportDownloadUrlDocument = gql`
    query getSchoolReportDownloadURL($input: GetSchoolReportDownloadURLInput!) {
  getSchoolReportDownloadURL(input: $input)
}
    `;

/**
 * __useGetSchoolReportDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetSchoolReportDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolReportDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchoolReportDownloadUrlQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSchoolReportDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetSchoolReportDownloadUrlQuery, GetSchoolReportDownloadUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchoolReportDownloadUrlQuery, GetSchoolReportDownloadUrlQueryVariables>(GetSchoolReportDownloadUrlDocument, options);
      }
export function useGetSchoolReportDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchoolReportDownloadUrlQuery, GetSchoolReportDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchoolReportDownloadUrlQuery, GetSchoolReportDownloadUrlQueryVariables>(GetSchoolReportDownloadUrlDocument, options);
        }
export type GetSchoolReportDownloadUrlQueryHookResult = ReturnType<typeof useGetSchoolReportDownloadUrlQuery>;
export type GetSchoolReportDownloadUrlLazyQueryHookResult = ReturnType<typeof useGetSchoolReportDownloadUrlLazyQuery>;
export type GetSchoolReportDownloadUrlQueryResult = Apollo.QueryResult<GetSchoolReportDownloadUrlQuery, GetSchoolReportDownloadUrlQueryVariables>;
export const SllGetLessonsDocument = gql`
    query sllGetLessons($input: SLLGetLessonsInput!) {
  sllGetLessons(input: $input) {
    ...SLLLesson
  }
}
    ${SllLessonFragmentDoc}`;

/**
 * __useSllGetLessonsQuery__
 *
 * To run a query within a React component, call `useSllGetLessonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSllGetLessonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSllGetLessonsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSllGetLessonsQuery(baseOptions: Apollo.QueryHookOptions<SllGetLessonsQuery, SllGetLessonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SllGetLessonsQuery, SllGetLessonsQueryVariables>(SllGetLessonsDocument, options);
      }
export function useSllGetLessonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SllGetLessonsQuery, SllGetLessonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SllGetLessonsQuery, SllGetLessonsQueryVariables>(SllGetLessonsDocument, options);
        }
export type SllGetLessonsQueryHookResult = ReturnType<typeof useSllGetLessonsQuery>;
export type SllGetLessonsLazyQueryHookResult = ReturnType<typeof useSllGetLessonsLazyQuery>;
export type SllGetLessonsQueryResult = Apollo.QueryResult<SllGetLessonsQuery, SllGetLessonsQueryVariables>;
export const SllGetGettingStartedLessonsDocument = gql`
    query sllGetGettingStartedLessons {
  sllGetGettingStartedLessons {
    ...SLLLesson
  }
}
    ${SllLessonFragmentDoc}`;

/**
 * __useSllGetGettingStartedLessonsQuery__
 *
 * To run a query within a React component, call `useSllGetGettingStartedLessonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSllGetGettingStartedLessonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSllGetGettingStartedLessonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSllGetGettingStartedLessonsQuery(baseOptions?: Apollo.QueryHookOptions<SllGetGettingStartedLessonsQuery, SllGetGettingStartedLessonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SllGetGettingStartedLessonsQuery, SllGetGettingStartedLessonsQueryVariables>(SllGetGettingStartedLessonsDocument, options);
      }
export function useSllGetGettingStartedLessonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SllGetGettingStartedLessonsQuery, SllGetGettingStartedLessonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SllGetGettingStartedLessonsQuery, SllGetGettingStartedLessonsQueryVariables>(SllGetGettingStartedLessonsDocument, options);
        }
export type SllGetGettingStartedLessonsQueryHookResult = ReturnType<typeof useSllGetGettingStartedLessonsQuery>;
export type SllGetGettingStartedLessonsLazyQueryHookResult = ReturnType<typeof useSllGetGettingStartedLessonsLazyQuery>;
export type SllGetGettingStartedLessonsQueryResult = Apollo.QueryResult<SllGetGettingStartedLessonsQuery, SllGetGettingStartedLessonsQueryVariables>;
export const SllGetCaregiverLessonsDocument = gql`
    query sllGetCaregiverLessons {
  sllGetCaregiverLessons {
    ...SLLLesson
  }
}
    ${SllLessonFragmentDoc}`;

/**
 * __useSllGetCaregiverLessonsQuery__
 *
 * To run a query within a React component, call `useSllGetCaregiverLessonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSllGetCaregiverLessonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSllGetCaregiverLessonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSllGetCaregiverLessonsQuery(baseOptions?: Apollo.QueryHookOptions<SllGetCaregiverLessonsQuery, SllGetCaregiverLessonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SllGetCaregiverLessonsQuery, SllGetCaregiverLessonsQueryVariables>(SllGetCaregiverLessonsDocument, options);
      }
export function useSllGetCaregiverLessonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SllGetCaregiverLessonsQuery, SllGetCaregiverLessonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SllGetCaregiverLessonsQuery, SllGetCaregiverLessonsQueryVariables>(SllGetCaregiverLessonsDocument, options);
        }
export type SllGetCaregiverLessonsQueryHookResult = ReturnType<typeof useSllGetCaregiverLessonsQuery>;
export type SllGetCaregiverLessonsLazyQueryHookResult = ReturnType<typeof useSllGetCaregiverLessonsLazyQuery>;
export type SllGetCaregiverLessonsQueryResult = Apollo.QueryResult<SllGetCaregiverLessonsQuery, SllGetCaregiverLessonsQueryVariables>;
export const SllGetLessonsForSaDocument = gql`
    query sllGetLessonsForSA($input: SLLGetLessonsForSAInput!) {
  sllGetLessonsForSA(input: $input) {
    data {
      ...SLLDefaultLessonForSA
    }
    totals
  }
}
    ${SllDefaultLessonForSaFragmentDoc}`;

/**
 * __useSllGetLessonsForSaQuery__
 *
 * To run a query within a React component, call `useSllGetLessonsForSaQuery` and pass it any options that fit your needs.
 * When your component renders, `useSllGetLessonsForSaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSllGetLessonsForSaQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSllGetLessonsForSaQuery(baseOptions: Apollo.QueryHookOptions<SllGetLessonsForSaQuery, SllGetLessonsForSaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SllGetLessonsForSaQuery, SllGetLessonsForSaQueryVariables>(SllGetLessonsForSaDocument, options);
      }
export function useSllGetLessonsForSaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SllGetLessonsForSaQuery, SllGetLessonsForSaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SllGetLessonsForSaQuery, SllGetLessonsForSaQueryVariables>(SllGetLessonsForSaDocument, options);
        }
export type SllGetLessonsForSaQueryHookResult = ReturnType<typeof useSllGetLessonsForSaQuery>;
export type SllGetLessonsForSaLazyQueryHookResult = ReturnType<typeof useSllGetLessonsForSaLazyQuery>;
export type SllGetLessonsForSaQueryResult = Apollo.QueryResult<SllGetLessonsForSaQuery, SllGetLessonsForSaQueryVariables>;
export const SllGetLessonInfoDocument = gql`
    query sllGetLessonInfo($input: IDInput!) {
  sllGetLessonInfo(input: $input) {
    ...SLLLesson
  }
}
    ${SllLessonFragmentDoc}`;

/**
 * __useSllGetLessonInfoQuery__
 *
 * To run a query within a React component, call `useSllGetLessonInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useSllGetLessonInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSllGetLessonInfoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSllGetLessonInfoQuery(baseOptions: Apollo.QueryHookOptions<SllGetLessonInfoQuery, SllGetLessonInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SllGetLessonInfoQuery, SllGetLessonInfoQueryVariables>(SllGetLessonInfoDocument, options);
      }
export function useSllGetLessonInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SllGetLessonInfoQuery, SllGetLessonInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SllGetLessonInfoQuery, SllGetLessonInfoQueryVariables>(SllGetLessonInfoDocument, options);
        }
export type SllGetLessonInfoQueryHookResult = ReturnType<typeof useSllGetLessonInfoQuery>;
export type SllGetLessonInfoLazyQueryHookResult = ReturnType<typeof useSllGetLessonInfoLazyQuery>;
export type SllGetLessonInfoQueryResult = Apollo.QueryResult<SllGetLessonInfoQuery, SllGetLessonInfoQueryVariables>;
export const SllGetLessonInfoForSaDocument = gql`
    query sllGetLessonInfoForSA($input: IDInput!) {
  sllGetLessonInfoForSA(input: $input) {
    ...SLLLessonForSA
  }
}
    ${SllLessonForSaFragmentDoc}`;

/**
 * __useSllGetLessonInfoForSaQuery__
 *
 * To run a query within a React component, call `useSllGetLessonInfoForSaQuery` and pass it any options that fit your needs.
 * When your component renders, `useSllGetLessonInfoForSaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSllGetLessonInfoForSaQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSllGetLessonInfoForSaQuery(baseOptions: Apollo.QueryHookOptions<SllGetLessonInfoForSaQuery, SllGetLessonInfoForSaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SllGetLessonInfoForSaQuery, SllGetLessonInfoForSaQueryVariables>(SllGetLessonInfoForSaDocument, options);
      }
export function useSllGetLessonInfoForSaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SllGetLessonInfoForSaQuery, SllGetLessonInfoForSaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SllGetLessonInfoForSaQuery, SllGetLessonInfoForSaQueryVariables>(SllGetLessonInfoForSaDocument, options);
        }
export type SllGetLessonInfoForSaQueryHookResult = ReturnType<typeof useSllGetLessonInfoForSaQuery>;
export type SllGetLessonInfoForSaLazyQueryHookResult = ReturnType<typeof useSllGetLessonInfoForSaLazyQuery>;
export type SllGetLessonInfoForSaQueryResult = Apollo.QueryResult<SllGetLessonInfoForSaQuery, SllGetLessonInfoForSaQueryVariables>;
export const SllCreateLessonDocument = gql`
    mutation sllCreateLesson($input: SLLCreateLessonInput!) {
  sllCreateLesson(input: $input) {
    ...SLLLessonForSA
  }
}
    ${SllLessonForSaFragmentDoc}`;
export type SllCreateLessonMutationFn = Apollo.MutationFunction<SllCreateLessonMutation, SllCreateLessonMutationVariables>;

/**
 * __useSllCreateLessonMutation__
 *
 * To run a mutation, you first call `useSllCreateLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSllCreateLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sllCreateLessonMutation, { data, loading, error }] = useSllCreateLessonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSllCreateLessonMutation(baseOptions?: Apollo.MutationHookOptions<SllCreateLessonMutation, SllCreateLessonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SllCreateLessonMutation, SllCreateLessonMutationVariables>(SllCreateLessonDocument, options);
      }
export type SllCreateLessonMutationHookResult = ReturnType<typeof useSllCreateLessonMutation>;
export type SllCreateLessonMutationResult = Apollo.MutationResult<SllCreateLessonMutation>;
export type SllCreateLessonMutationOptions = Apollo.BaseMutationOptions<SllCreateLessonMutation, SllCreateLessonMutationVariables>;
export const SllUpdateLessonDocument = gql`
    mutation sllUpdateLesson($input: SLLUpdateLessonInput!) {
  sllUpdateLesson(input: $input) {
    ...SLLLessonForSA
  }
}
    ${SllLessonForSaFragmentDoc}`;
export type SllUpdateLessonMutationFn = Apollo.MutationFunction<SllUpdateLessonMutation, SllUpdateLessonMutationVariables>;

/**
 * __useSllUpdateLessonMutation__
 *
 * To run a mutation, you first call `useSllUpdateLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSllUpdateLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sllUpdateLessonMutation, { data, loading, error }] = useSllUpdateLessonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSllUpdateLessonMutation(baseOptions?: Apollo.MutationHookOptions<SllUpdateLessonMutation, SllUpdateLessonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SllUpdateLessonMutation, SllUpdateLessonMutationVariables>(SllUpdateLessonDocument, options);
      }
export type SllUpdateLessonMutationHookResult = ReturnType<typeof useSllUpdateLessonMutation>;
export type SllUpdateLessonMutationResult = Apollo.MutationResult<SllUpdateLessonMutation>;
export type SllUpdateLessonMutationOptions = Apollo.BaseMutationOptions<SllUpdateLessonMutation, SllUpdateLessonMutationVariables>;
export const SllDeleteLessonDocument = gql`
    mutation sllDeleteLesson($input: IDInput!) {
  sllDeleteLesson(input: $input)
}
    `;
export type SllDeleteLessonMutationFn = Apollo.MutationFunction<SllDeleteLessonMutation, SllDeleteLessonMutationVariables>;

/**
 * __useSllDeleteLessonMutation__
 *
 * To run a mutation, you first call `useSllDeleteLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSllDeleteLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sllDeleteLessonMutation, { data, loading, error }] = useSllDeleteLessonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSllDeleteLessonMutation(baseOptions?: Apollo.MutationHookOptions<SllDeleteLessonMutation, SllDeleteLessonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SllDeleteLessonMutation, SllDeleteLessonMutationVariables>(SllDeleteLessonDocument, options);
      }
export type SllDeleteLessonMutationHookResult = ReturnType<typeof useSllDeleteLessonMutation>;
export type SllDeleteLessonMutationResult = Apollo.MutationResult<SllDeleteLessonMutation>;
export type SllDeleteLessonMutationOptions = Apollo.BaseMutationOptions<SllDeleteLessonMutation, SllDeleteLessonMutationVariables>;
export const SllGetLessonExclusionsDocument = gql`
    query sllGetLessonExclusions($input: IDInput!) {
  sllGetLessonExclusions(input: $input) {
    lessonId
    groupId
    groupName
  }
}
    `;

/**
 * __useSllGetLessonExclusionsQuery__
 *
 * To run a query within a React component, call `useSllGetLessonExclusionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSllGetLessonExclusionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSllGetLessonExclusionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSllGetLessonExclusionsQuery(baseOptions: Apollo.QueryHookOptions<SllGetLessonExclusionsQuery, SllGetLessonExclusionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SllGetLessonExclusionsQuery, SllGetLessonExclusionsQueryVariables>(SllGetLessonExclusionsDocument, options);
      }
export function useSllGetLessonExclusionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SllGetLessonExclusionsQuery, SllGetLessonExclusionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SllGetLessonExclusionsQuery, SllGetLessonExclusionsQueryVariables>(SllGetLessonExclusionsDocument, options);
        }
export type SllGetLessonExclusionsQueryHookResult = ReturnType<typeof useSllGetLessonExclusionsQuery>;
export type SllGetLessonExclusionsLazyQueryHookResult = ReturnType<typeof useSllGetLessonExclusionsLazyQuery>;
export type SllGetLessonExclusionsQueryResult = Apollo.QueryResult<SllGetLessonExclusionsQuery, SllGetLessonExclusionsQueryVariables>;
export const SllAddLessonExclusionDocument = gql`
    mutation sllAddLessonExclusion($input: SLLLessonExclusionInput!) {
  sllAddLessonExclusion(input: $input)
}
    `;
export type SllAddLessonExclusionMutationFn = Apollo.MutationFunction<SllAddLessonExclusionMutation, SllAddLessonExclusionMutationVariables>;

/**
 * __useSllAddLessonExclusionMutation__
 *
 * To run a mutation, you first call `useSllAddLessonExclusionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSllAddLessonExclusionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sllAddLessonExclusionMutation, { data, loading, error }] = useSllAddLessonExclusionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSllAddLessonExclusionMutation(baseOptions?: Apollo.MutationHookOptions<SllAddLessonExclusionMutation, SllAddLessonExclusionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SllAddLessonExclusionMutation, SllAddLessonExclusionMutationVariables>(SllAddLessonExclusionDocument, options);
      }
export type SllAddLessonExclusionMutationHookResult = ReturnType<typeof useSllAddLessonExclusionMutation>;
export type SllAddLessonExclusionMutationResult = Apollo.MutationResult<SllAddLessonExclusionMutation>;
export type SllAddLessonExclusionMutationOptions = Apollo.BaseMutationOptions<SllAddLessonExclusionMutation, SllAddLessonExclusionMutationVariables>;
export const SllRemoveLessonExclusionDocument = gql`
    mutation sllRemoveLessonExclusion($input: SLLLessonExclusionInput!) {
  sllRemoveLessonExclusion(input: $input)
}
    `;
export type SllRemoveLessonExclusionMutationFn = Apollo.MutationFunction<SllRemoveLessonExclusionMutation, SllRemoveLessonExclusionMutationVariables>;

/**
 * __useSllRemoveLessonExclusionMutation__
 *
 * To run a mutation, you first call `useSllRemoveLessonExclusionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSllRemoveLessonExclusionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sllRemoveLessonExclusionMutation, { data, loading, error }] = useSllRemoveLessonExclusionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSllRemoveLessonExclusionMutation(baseOptions?: Apollo.MutationHookOptions<SllRemoveLessonExclusionMutation, SllRemoveLessonExclusionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SllRemoveLessonExclusionMutation, SllRemoveLessonExclusionMutationVariables>(SllRemoveLessonExclusionDocument, options);
      }
export type SllRemoveLessonExclusionMutationHookResult = ReturnType<typeof useSllRemoveLessonExclusionMutation>;
export type SllRemoveLessonExclusionMutationResult = Apollo.MutationResult<SllRemoveLessonExclusionMutation>;
export type SllRemoveLessonExclusionMutationOptions = Apollo.BaseMutationOptions<SllRemoveLessonExclusionMutation, SllRemoveLessonExclusionMutationVariables>;
export const ListGroupsDocument = gql`
    query listGroups {
  listGroups {
    id
    name
  }
}
    `;

/**
 * __useListGroupsQuery__
 *
 * To run a query within a React component, call `useListGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListGroupsQuery(baseOptions?: Apollo.QueryHookOptions<ListGroupsQuery, ListGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListGroupsQuery, ListGroupsQueryVariables>(ListGroupsDocument, options);
      }
export function useListGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListGroupsQuery, ListGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListGroupsQuery, ListGroupsQueryVariables>(ListGroupsDocument, options);
        }
export type ListGroupsQueryHookResult = ReturnType<typeof useListGroupsQuery>;
export type ListGroupsLazyQueryHookResult = ReturnType<typeof useListGroupsLazyQuery>;
export type ListGroupsQueryResult = Apollo.QueryResult<ListGroupsQuery, ListGroupsQueryVariables>;
export const SllCreateSectionDocument = gql`
    mutation sllCreateSection($input: IDInput!) {
  sllCreateSection(input: $input) {
    ...SLLSection
  }
}
    ${SllSectionFragmentDoc}`;
export type SllCreateSectionMutationFn = Apollo.MutationFunction<SllCreateSectionMutation, SllCreateSectionMutationVariables>;

/**
 * __useSllCreateSectionMutation__
 *
 * To run a mutation, you first call `useSllCreateSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSllCreateSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sllCreateSectionMutation, { data, loading, error }] = useSllCreateSectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSllCreateSectionMutation(baseOptions?: Apollo.MutationHookOptions<SllCreateSectionMutation, SllCreateSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SllCreateSectionMutation, SllCreateSectionMutationVariables>(SllCreateSectionDocument, options);
      }
export type SllCreateSectionMutationHookResult = ReturnType<typeof useSllCreateSectionMutation>;
export type SllCreateSectionMutationResult = Apollo.MutationResult<SllCreateSectionMutation>;
export type SllCreateSectionMutationOptions = Apollo.BaseMutationOptions<SllCreateSectionMutation, SllCreateSectionMutationVariables>;
export const SllUpdateSectionDocument = gql`
    mutation sllUpdateSection($input: SLLUpdateSectionInput!) {
  sllUpdateSection(input: $input)
}
    `;
export type SllUpdateSectionMutationFn = Apollo.MutationFunction<SllUpdateSectionMutation, SllUpdateSectionMutationVariables>;

/**
 * __useSllUpdateSectionMutation__
 *
 * To run a mutation, you first call `useSllUpdateSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSllUpdateSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sllUpdateSectionMutation, { data, loading, error }] = useSllUpdateSectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSllUpdateSectionMutation(baseOptions?: Apollo.MutationHookOptions<SllUpdateSectionMutation, SllUpdateSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SllUpdateSectionMutation, SllUpdateSectionMutationVariables>(SllUpdateSectionDocument, options);
      }
export type SllUpdateSectionMutationHookResult = ReturnType<typeof useSllUpdateSectionMutation>;
export type SllUpdateSectionMutationResult = Apollo.MutationResult<SllUpdateSectionMutation>;
export type SllUpdateSectionMutationOptions = Apollo.BaseMutationOptions<SllUpdateSectionMutation, SllUpdateSectionMutationVariables>;
export const SllDeleteSectionDocument = gql`
    mutation sllDeleteSection($input: IDInput!) {
  sllDeleteSection(input: $input)
}
    `;
export type SllDeleteSectionMutationFn = Apollo.MutationFunction<SllDeleteSectionMutation, SllDeleteSectionMutationVariables>;

/**
 * __useSllDeleteSectionMutation__
 *
 * To run a mutation, you first call `useSllDeleteSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSllDeleteSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sllDeleteSectionMutation, { data, loading, error }] = useSllDeleteSectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSllDeleteSectionMutation(baseOptions?: Apollo.MutationHookOptions<SllDeleteSectionMutation, SllDeleteSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SllDeleteSectionMutation, SllDeleteSectionMutationVariables>(SllDeleteSectionDocument, options);
      }
export type SllDeleteSectionMutationHookResult = ReturnType<typeof useSllDeleteSectionMutation>;
export type SllDeleteSectionMutationResult = Apollo.MutationResult<SllDeleteSectionMutation>;
export type SllDeleteSectionMutationOptions = Apollo.BaseMutationOptions<SllDeleteSectionMutation, SllDeleteSectionMutationVariables>;
export const SllCreateModuleDocument = gql`
    mutation sllCreateModule($input: SLLCreateModuleInput!) {
  sllCreateModule(input: $input) {
    ...SLLModule
  }
}
    ${SllModuleFragmentDoc}`;
export type SllCreateModuleMutationFn = Apollo.MutationFunction<SllCreateModuleMutation, SllCreateModuleMutationVariables>;

/**
 * __useSllCreateModuleMutation__
 *
 * To run a mutation, you first call `useSllCreateModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSllCreateModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sllCreateModuleMutation, { data, loading, error }] = useSllCreateModuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSllCreateModuleMutation(baseOptions?: Apollo.MutationHookOptions<SllCreateModuleMutation, SllCreateModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SllCreateModuleMutation, SllCreateModuleMutationVariables>(SllCreateModuleDocument, options);
      }
export type SllCreateModuleMutationHookResult = ReturnType<typeof useSllCreateModuleMutation>;
export type SllCreateModuleMutationResult = Apollo.MutationResult<SllCreateModuleMutation>;
export type SllCreateModuleMutationOptions = Apollo.BaseMutationOptions<SllCreateModuleMutation, SllCreateModuleMutationVariables>;
export const SllUpdateModuleDocument = gql`
    mutation sllUpdateModule($input: SLLUpdateModuleInput!) {
  sllUpdateModule(input: $input) {
    ...SLLModule
  }
}
    ${SllModuleFragmentDoc}`;
export type SllUpdateModuleMutationFn = Apollo.MutationFunction<SllUpdateModuleMutation, SllUpdateModuleMutationVariables>;

/**
 * __useSllUpdateModuleMutation__
 *
 * To run a mutation, you first call `useSllUpdateModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSllUpdateModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sllUpdateModuleMutation, { data, loading, error }] = useSllUpdateModuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSllUpdateModuleMutation(baseOptions?: Apollo.MutationHookOptions<SllUpdateModuleMutation, SllUpdateModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SllUpdateModuleMutation, SllUpdateModuleMutationVariables>(SllUpdateModuleDocument, options);
      }
export type SllUpdateModuleMutationHookResult = ReturnType<typeof useSllUpdateModuleMutation>;
export type SllUpdateModuleMutationResult = Apollo.MutationResult<SllUpdateModuleMutation>;
export type SllUpdateModuleMutationOptions = Apollo.BaseMutationOptions<SllUpdateModuleMutation, SllUpdateModuleMutationVariables>;
export const SllDeleteModuleDocument = gql`
    mutation sllDeleteModule($input: IDInput!) {
  sllDeleteModule(input: $input)
}
    `;
export type SllDeleteModuleMutationFn = Apollo.MutationFunction<SllDeleteModuleMutation, SllDeleteModuleMutationVariables>;

/**
 * __useSllDeleteModuleMutation__
 *
 * To run a mutation, you first call `useSllDeleteModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSllDeleteModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sllDeleteModuleMutation, { data, loading, error }] = useSllDeleteModuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSllDeleteModuleMutation(baseOptions?: Apollo.MutationHookOptions<SllDeleteModuleMutation, SllDeleteModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SllDeleteModuleMutation, SllDeleteModuleMutationVariables>(SllDeleteModuleDocument, options);
      }
export type SllDeleteModuleMutationHookResult = ReturnType<typeof useSllDeleteModuleMutation>;
export type SllDeleteModuleMutationResult = Apollo.MutationResult<SllDeleteModuleMutation>;
export type SllDeleteModuleMutationOptions = Apollo.BaseMutationOptions<SllDeleteModuleMutation, SllDeleteModuleMutationVariables>;
export const SllUpdateVideoModuleDocument = gql`
    mutation sllUpdateVideoModule($input: SLLUpdateVideoModuleInput!) {
  sllUpdateVideoModule(input: $input) {
    ...SLLModule
  }
}
    ${SllModuleFragmentDoc}`;
export type SllUpdateVideoModuleMutationFn = Apollo.MutationFunction<SllUpdateVideoModuleMutation, SllUpdateVideoModuleMutationVariables>;

/**
 * __useSllUpdateVideoModuleMutation__
 *
 * To run a mutation, you first call `useSllUpdateVideoModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSllUpdateVideoModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sllUpdateVideoModuleMutation, { data, loading, error }] = useSllUpdateVideoModuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSllUpdateVideoModuleMutation(baseOptions?: Apollo.MutationHookOptions<SllUpdateVideoModuleMutation, SllUpdateVideoModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SllUpdateVideoModuleMutation, SllUpdateVideoModuleMutationVariables>(SllUpdateVideoModuleDocument, options);
      }
export type SllUpdateVideoModuleMutationHookResult = ReturnType<typeof useSllUpdateVideoModuleMutation>;
export type SllUpdateVideoModuleMutationResult = Apollo.MutationResult<SllUpdateVideoModuleMutation>;
export type SllUpdateVideoModuleMutationOptions = Apollo.BaseMutationOptions<SllUpdateVideoModuleMutation, SllUpdateVideoModuleMutationVariables>;
export const SllGetCoursesDocument = gql`
    query sllGetCourses {
  sllGetCourses {
    ...SLLCourse
  }
}
    ${SllCourseFragmentDoc}`;

/**
 * __useSllGetCoursesQuery__
 *
 * To run a query within a React component, call `useSllGetCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSllGetCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSllGetCoursesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSllGetCoursesQuery(baseOptions?: Apollo.QueryHookOptions<SllGetCoursesQuery, SllGetCoursesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SllGetCoursesQuery, SllGetCoursesQueryVariables>(SllGetCoursesDocument, options);
      }
export function useSllGetCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SllGetCoursesQuery, SllGetCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SllGetCoursesQuery, SllGetCoursesQueryVariables>(SllGetCoursesDocument, options);
        }
export type SllGetCoursesQueryHookResult = ReturnType<typeof useSllGetCoursesQuery>;
export type SllGetCoursesLazyQueryHookResult = ReturnType<typeof useSllGetCoursesLazyQuery>;
export type SllGetCoursesQueryResult = Apollo.QueryResult<SllGetCoursesQuery, SllGetCoursesQueryVariables>;
export const SllCreateCourseDocument = gql`
    mutation sllCreateCourse($input: SLLCreateCourseInput!) {
  sllCreateCourse(input: $input)
}
    `;
export type SllCreateCourseMutationFn = Apollo.MutationFunction<SllCreateCourseMutation, SllCreateCourseMutationVariables>;

/**
 * __useSllCreateCourseMutation__
 *
 * To run a mutation, you first call `useSllCreateCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSllCreateCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sllCreateCourseMutation, { data, loading, error }] = useSllCreateCourseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSllCreateCourseMutation(baseOptions?: Apollo.MutationHookOptions<SllCreateCourseMutation, SllCreateCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SllCreateCourseMutation, SllCreateCourseMutationVariables>(SllCreateCourseDocument, options);
      }
export type SllCreateCourseMutationHookResult = ReturnType<typeof useSllCreateCourseMutation>;
export type SllCreateCourseMutationResult = Apollo.MutationResult<SllCreateCourseMutation>;
export type SllCreateCourseMutationOptions = Apollo.BaseMutationOptions<SllCreateCourseMutation, SllCreateCourseMutationVariables>;
export const SllUpdateCourseDocument = gql`
    mutation sllUpdateCourse($input: SLLUpdateCourseInput!) {
  sllUpdateCourse(input: $input)
}
    `;
export type SllUpdateCourseMutationFn = Apollo.MutationFunction<SllUpdateCourseMutation, SllUpdateCourseMutationVariables>;

/**
 * __useSllUpdateCourseMutation__
 *
 * To run a mutation, you first call `useSllUpdateCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSllUpdateCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sllUpdateCourseMutation, { data, loading, error }] = useSllUpdateCourseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSllUpdateCourseMutation(baseOptions?: Apollo.MutationHookOptions<SllUpdateCourseMutation, SllUpdateCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SllUpdateCourseMutation, SllUpdateCourseMutationVariables>(SllUpdateCourseDocument, options);
      }
export type SllUpdateCourseMutationHookResult = ReturnType<typeof useSllUpdateCourseMutation>;
export type SllUpdateCourseMutationResult = Apollo.MutationResult<SllUpdateCourseMutation>;
export type SllUpdateCourseMutationOptions = Apollo.BaseMutationOptions<SllUpdateCourseMutation, SllUpdateCourseMutationVariables>;
export const SllUpdateCourseNameDocument = gql`
    mutation sllUpdateCourseName($input: SLLUpdateSectionInput!) {
  sllUpdateCourseName(input: $input)
}
    `;
export type SllUpdateCourseNameMutationFn = Apollo.MutationFunction<SllUpdateCourseNameMutation, SllUpdateCourseNameMutationVariables>;

/**
 * __useSllUpdateCourseNameMutation__
 *
 * To run a mutation, you first call `useSllUpdateCourseNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSllUpdateCourseNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sllUpdateCourseNameMutation, { data, loading, error }] = useSllUpdateCourseNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSllUpdateCourseNameMutation(baseOptions?: Apollo.MutationHookOptions<SllUpdateCourseNameMutation, SllUpdateCourseNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SllUpdateCourseNameMutation, SllUpdateCourseNameMutationVariables>(SllUpdateCourseNameDocument, options);
      }
export type SllUpdateCourseNameMutationHookResult = ReturnType<typeof useSllUpdateCourseNameMutation>;
export type SllUpdateCourseNameMutationResult = Apollo.MutationResult<SllUpdateCourseNameMutation>;
export type SllUpdateCourseNameMutationOptions = Apollo.BaseMutationOptions<SllUpdateCourseNameMutation, SllUpdateCourseNameMutationVariables>;
export const SllDeleteCourseDocument = gql`
    mutation sllDeleteCourse($input: IDInput!) {
  sllDeleteCourse(input: $input)
}
    `;
export type SllDeleteCourseMutationFn = Apollo.MutationFunction<SllDeleteCourseMutation, SllDeleteCourseMutationVariables>;

/**
 * __useSllDeleteCourseMutation__
 *
 * To run a mutation, you first call `useSllDeleteCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSllDeleteCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sllDeleteCourseMutation, { data, loading, error }] = useSllDeleteCourseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSllDeleteCourseMutation(baseOptions?: Apollo.MutationHookOptions<SllDeleteCourseMutation, SllDeleteCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SllDeleteCourseMutation, SllDeleteCourseMutationVariables>(SllDeleteCourseDocument, options);
      }
export type SllDeleteCourseMutationHookResult = ReturnType<typeof useSllDeleteCourseMutation>;
export type SllDeleteCourseMutationResult = Apollo.MutationResult<SllDeleteCourseMutation>;
export type SllDeleteCourseMutationOptions = Apollo.BaseMutationOptions<SllDeleteCourseMutation, SllDeleteCourseMutationVariables>;
export const SllMoveModuleDocument = gql`
    mutation sllMoveModule($input: SLLMoveModuleInput!) {
  sllMoveModule(input: $input)
}
    `;
export type SllMoveModuleMutationFn = Apollo.MutationFunction<SllMoveModuleMutation, SllMoveModuleMutationVariables>;

/**
 * __useSllMoveModuleMutation__
 *
 * To run a mutation, you first call `useSllMoveModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSllMoveModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sllMoveModuleMutation, { data, loading, error }] = useSllMoveModuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSllMoveModuleMutation(baseOptions?: Apollo.MutationHookOptions<SllMoveModuleMutation, SllMoveModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SllMoveModuleMutation, SllMoveModuleMutationVariables>(SllMoveModuleDocument, options);
      }
export type SllMoveModuleMutationHookResult = ReturnType<typeof useSllMoveModuleMutation>;
export type SllMoveModuleMutationResult = Apollo.MutationResult<SllMoveModuleMutation>;
export type SllMoveModuleMutationOptions = Apollo.BaseMutationOptions<SllMoveModuleMutation, SllMoveModuleMutationVariables>;
export const DeleteSchoolReportDocument = gql`
    mutation deleteSchoolReport($input: IDInput!) {
  deleteSchoolReport(input: $input)
}
    `;
export type DeleteSchoolReportMutationFn = Apollo.MutationFunction<DeleteSchoolReportMutation, DeleteSchoolReportMutationVariables>;

/**
 * __useDeleteSchoolReportMutation__
 *
 * To run a mutation, you first call `useDeleteSchoolReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSchoolReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSchoolReportMutation, { data, loading, error }] = useDeleteSchoolReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSchoolReportMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSchoolReportMutation, DeleteSchoolReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSchoolReportMutation, DeleteSchoolReportMutationVariables>(DeleteSchoolReportDocument, options);
      }
export type DeleteSchoolReportMutationHookResult = ReturnType<typeof useDeleteSchoolReportMutation>;
export type DeleteSchoolReportMutationResult = Apollo.MutationResult<DeleteSchoolReportMutation>;
export type DeleteSchoolReportMutationOptions = Apollo.BaseMutationOptions<DeleteSchoolReportMutation, DeleteSchoolReportMutationVariables>;
export const SllCreateGroupModuleDocument = gql`
    mutation sllCreateGroupModule($input: SLLCreateGroupModuleInput!) {
  sllCreateGroupModule(input: $input) {
    ...SLLGroupModule
  }
}
    ${SllGroupModuleFragmentDoc}`;
export type SllCreateGroupModuleMutationFn = Apollo.MutationFunction<SllCreateGroupModuleMutation, SllCreateGroupModuleMutationVariables>;

/**
 * __useSllCreateGroupModuleMutation__
 *
 * To run a mutation, you first call `useSllCreateGroupModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSllCreateGroupModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sllCreateGroupModuleMutation, { data, loading, error }] = useSllCreateGroupModuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSllCreateGroupModuleMutation(baseOptions?: Apollo.MutationHookOptions<SllCreateGroupModuleMutation, SllCreateGroupModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SllCreateGroupModuleMutation, SllCreateGroupModuleMutationVariables>(SllCreateGroupModuleDocument, options);
      }
export type SllCreateGroupModuleMutationHookResult = ReturnType<typeof useSllCreateGroupModuleMutation>;
export type SllCreateGroupModuleMutationResult = Apollo.MutationResult<SllCreateGroupModuleMutation>;
export type SllCreateGroupModuleMutationOptions = Apollo.BaseMutationOptions<SllCreateGroupModuleMutation, SllCreateGroupModuleMutationVariables>;
export const SllUpdateGroupModuleDocument = gql`
    mutation sllUpdateGroupModule($input: SLLUpdateGroupModuleInput!) {
  sllUpdateGroupModule(input: $input) {
    ...SLLGroupModule
  }
}
    ${SllGroupModuleFragmentDoc}`;
export type SllUpdateGroupModuleMutationFn = Apollo.MutationFunction<SllUpdateGroupModuleMutation, SllUpdateGroupModuleMutationVariables>;

/**
 * __useSllUpdateGroupModuleMutation__
 *
 * To run a mutation, you first call `useSllUpdateGroupModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSllUpdateGroupModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sllUpdateGroupModuleMutation, { data, loading, error }] = useSllUpdateGroupModuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSllUpdateGroupModuleMutation(baseOptions?: Apollo.MutationHookOptions<SllUpdateGroupModuleMutation, SllUpdateGroupModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SllUpdateGroupModuleMutation, SllUpdateGroupModuleMutationVariables>(SllUpdateGroupModuleDocument, options);
      }
export type SllUpdateGroupModuleMutationHookResult = ReturnType<typeof useSllUpdateGroupModuleMutation>;
export type SllUpdateGroupModuleMutationResult = Apollo.MutationResult<SllUpdateGroupModuleMutation>;
export type SllUpdateGroupModuleMutationOptions = Apollo.BaseMutationOptions<SllUpdateGroupModuleMutation, SllUpdateGroupModuleMutationVariables>;
export const SllDeleteGroupModuleDocument = gql`
    mutation sllDeleteGroupModule($input: SLLDeleteGroupModuleInput!) {
  sllDeleteGroupModule(input: $input)
}
    `;
export type SllDeleteGroupModuleMutationFn = Apollo.MutationFunction<SllDeleteGroupModuleMutation, SllDeleteGroupModuleMutationVariables>;

/**
 * __useSllDeleteGroupModuleMutation__
 *
 * To run a mutation, you first call `useSllDeleteGroupModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSllDeleteGroupModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sllDeleteGroupModuleMutation, { data, loading, error }] = useSllDeleteGroupModuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSllDeleteGroupModuleMutation(baseOptions?: Apollo.MutationHookOptions<SllDeleteGroupModuleMutation, SllDeleteGroupModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SllDeleteGroupModuleMutation, SllDeleteGroupModuleMutationVariables>(SllDeleteGroupModuleDocument, options);
      }
export type SllDeleteGroupModuleMutationHookResult = ReturnType<typeof useSllDeleteGroupModuleMutation>;
export type SllDeleteGroupModuleMutationResult = Apollo.MutationResult<SllDeleteGroupModuleMutation>;
export type SllDeleteGroupModuleMutationOptions = Apollo.BaseMutationOptions<SllDeleteGroupModuleMutation, SllDeleteGroupModuleMutationVariables>;
export const SllGetGroupModulesDocument = gql`
    query sllGetGroupModules($input: IDInput!) {
  sllGetGroupModules(input: $input) {
    groups {
      ...SLLGroupModule
    }
  }
}
    ${SllGroupModuleFragmentDoc}`;

/**
 * __useSllGetGroupModulesQuery__
 *
 * To run a query within a React component, call `useSllGetGroupModulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSllGetGroupModulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSllGetGroupModulesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSllGetGroupModulesQuery(baseOptions: Apollo.QueryHookOptions<SllGetGroupModulesQuery, SllGetGroupModulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SllGetGroupModulesQuery, SllGetGroupModulesQueryVariables>(SllGetGroupModulesDocument, options);
      }
export function useSllGetGroupModulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SllGetGroupModulesQuery, SllGetGroupModulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SllGetGroupModulesQuery, SllGetGroupModulesQueryVariables>(SllGetGroupModulesDocument, options);
        }
export type SllGetGroupModulesQueryHookResult = ReturnType<typeof useSllGetGroupModulesQuery>;
export type SllGetGroupModulesLazyQueryHookResult = ReturnType<typeof useSllGetGroupModulesLazyQuery>;
export type SllGetGroupModulesQueryResult = Apollo.QueryResult<SllGetGroupModulesQuery, SllGetGroupModulesQueryVariables>;
export const SllDeleteModuleContentDocument = gql`
    mutation sllDeleteModuleContent($input: IDInput!) {
  sllDeleteModuleContent(input: $input)
}
    `;
export type SllDeleteModuleContentMutationFn = Apollo.MutationFunction<SllDeleteModuleContentMutation, SllDeleteModuleContentMutationVariables>;

/**
 * __useSllDeleteModuleContentMutation__
 *
 * To run a mutation, you first call `useSllDeleteModuleContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSllDeleteModuleContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sllDeleteModuleContentMutation, { data, loading, error }] = useSllDeleteModuleContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSllDeleteModuleContentMutation(baseOptions?: Apollo.MutationHookOptions<SllDeleteModuleContentMutation, SllDeleteModuleContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SllDeleteModuleContentMutation, SllDeleteModuleContentMutationVariables>(SllDeleteModuleContentDocument, options);
      }
export type SllDeleteModuleContentMutationHookResult = ReturnType<typeof useSllDeleteModuleContentMutation>;
export type SllDeleteModuleContentMutationResult = Apollo.MutationResult<SllDeleteModuleContentMutation>;
export type SllDeleteModuleContentMutationOptions = Apollo.BaseMutationOptions<SllDeleteModuleContentMutation, SllDeleteModuleContentMutationVariables>;
export const SllDeleteGroupModuleContentDocument = gql`
    mutation sllDeleteGroupModuleContent($input: SLLDeleteGroupModuleInput!) {
  sllDeleteGroupModuleContent(input: $input)
}
    `;
export type SllDeleteGroupModuleContentMutationFn = Apollo.MutationFunction<SllDeleteGroupModuleContentMutation, SllDeleteGroupModuleContentMutationVariables>;

/**
 * __useSllDeleteGroupModuleContentMutation__
 *
 * To run a mutation, you first call `useSllDeleteGroupModuleContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSllDeleteGroupModuleContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sllDeleteGroupModuleContentMutation, { data, loading, error }] = useSllDeleteGroupModuleContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSllDeleteGroupModuleContentMutation(baseOptions?: Apollo.MutationHookOptions<SllDeleteGroupModuleContentMutation, SllDeleteGroupModuleContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SllDeleteGroupModuleContentMutation, SllDeleteGroupModuleContentMutationVariables>(SllDeleteGroupModuleContentDocument, options);
      }
export type SllDeleteGroupModuleContentMutationHookResult = ReturnType<typeof useSllDeleteGroupModuleContentMutation>;
export type SllDeleteGroupModuleContentMutationResult = Apollo.MutationResult<SllDeleteGroupModuleContentMutation>;
export type SllDeleteGroupModuleContentMutationOptions = Apollo.BaseMutationOptions<SllDeleteGroupModuleContentMutation, SllDeleteGroupModuleContentMutationVariables>;
export const SllUpdateVideoGroupModuleDocument = gql`
    mutation sllUpdateVideoGroupModule($input: SLLUpdateVideoGroupModuleInput!) {
  sllUpdateVideoGroupModule(input: $input) {
    ...SLLGroupModule
  }
}
    ${SllGroupModuleFragmentDoc}`;
export type SllUpdateVideoGroupModuleMutationFn = Apollo.MutationFunction<SllUpdateVideoGroupModuleMutation, SllUpdateVideoGroupModuleMutationVariables>;

/**
 * __useSllUpdateVideoGroupModuleMutation__
 *
 * To run a mutation, you first call `useSllUpdateVideoGroupModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSllUpdateVideoGroupModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sllUpdateVideoGroupModuleMutation, { data, loading, error }] = useSllUpdateVideoGroupModuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSllUpdateVideoGroupModuleMutation(baseOptions?: Apollo.MutationHookOptions<SllUpdateVideoGroupModuleMutation, SllUpdateVideoGroupModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SllUpdateVideoGroupModuleMutation, SllUpdateVideoGroupModuleMutationVariables>(SllUpdateVideoGroupModuleDocument, options);
      }
export type SllUpdateVideoGroupModuleMutationHookResult = ReturnType<typeof useSllUpdateVideoGroupModuleMutation>;
export type SllUpdateVideoGroupModuleMutationResult = Apollo.MutationResult<SllUpdateVideoGroupModuleMutation>;
export type SllUpdateVideoGroupModuleMutationOptions = Apollo.BaseMutationOptions<SllUpdateVideoGroupModuleMutation, SllUpdateVideoGroupModuleMutationVariables>;
export const TrackAnalyticsDocument = gql`
    mutation trackAnalytics($input: TrackDataInput!) {
  trackAnalytics(input: $input)
}
    `;
export type TrackAnalyticsMutationFn = Apollo.MutationFunction<TrackAnalyticsMutation, TrackAnalyticsMutationVariables>;

/**
 * __useTrackAnalyticsMutation__
 *
 * To run a mutation, you first call `useTrackAnalyticsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackAnalyticsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackAnalyticsMutation, { data, loading, error }] = useTrackAnalyticsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTrackAnalyticsMutation(baseOptions?: Apollo.MutationHookOptions<TrackAnalyticsMutation, TrackAnalyticsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrackAnalyticsMutation, TrackAnalyticsMutationVariables>(TrackAnalyticsDocument, options);
      }
export type TrackAnalyticsMutationHookResult = ReturnType<typeof useTrackAnalyticsMutation>;
export type TrackAnalyticsMutationResult = Apollo.MutationResult<TrackAnalyticsMutation>;
export type TrackAnalyticsMutationOptions = Apollo.BaseMutationOptions<TrackAnalyticsMutation, TrackAnalyticsMutationVariables>;
export const AdminUsersDocument = gql`
    query AdminUsers($input: UserIDInput!) {
  adminUsers(input: $input) {
    id
    name
  }
}
    `;

/**
 * __useAdminUsersQuery__
 *
 * To run a query within a React component, call `useAdminUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUsersQuery(baseOptions: Apollo.QueryHookOptions<AdminUsersQuery, AdminUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminUsersQuery, AdminUsersQueryVariables>(AdminUsersDocument, options);
      }
export function useAdminUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminUsersQuery, AdminUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminUsersQuery, AdminUsersQueryVariables>(AdminUsersDocument, options);
        }
export type AdminUsersQueryHookResult = ReturnType<typeof useAdminUsersQuery>;
export type AdminUsersLazyQueryHookResult = ReturnType<typeof useAdminUsersLazyQuery>;
export type AdminUsersQueryResult = Apollo.QueryResult<AdminUsersQuery, AdminUsersQueryVariables>;
export const CreateInviteDocument = gql`
    mutation CreateInvite($input: SuperAdminInviteUserInput!) {
  superAdminInviteUser(input: $input) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type CreateInviteMutationFn = Apollo.MutationFunction<CreateInviteMutation, CreateInviteMutationVariables>;

/**
 * __useCreateInviteMutation__
 *
 * To run a mutation, you first call `useCreateInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInviteMutation, { data, loading, error }] = useCreateInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInviteMutation(baseOptions?: Apollo.MutationHookOptions<CreateInviteMutation, CreateInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInviteMutation, CreateInviteMutationVariables>(CreateInviteDocument, options);
      }
export type CreateInviteMutationHookResult = ReturnType<typeof useCreateInviteMutation>;
export type CreateInviteMutationResult = Apollo.MutationResult<CreateInviteMutation>;
export type CreateInviteMutationOptions = Apollo.BaseMutationOptions<CreateInviteMutation, CreateInviteMutationVariables>;
export const InviteUserAsEducatorDocument = gql`
    mutation InviteUserAsEducator($input: UserInviteInput!) {
  inviteUserAsEducator(input: $input) {
    id
    email
    firstName
    lastName
    status
    schools {
      id
      name
    }
  }
}
    `;
export type InviteUserAsEducatorMutationFn = Apollo.MutationFunction<InviteUserAsEducatorMutation, InviteUserAsEducatorMutationVariables>;

/**
 * __useInviteUserAsEducatorMutation__
 *
 * To run a mutation, you first call `useInviteUserAsEducatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserAsEducatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUserAsEducatorMutation, { data, loading, error }] = useInviteUserAsEducatorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteUserAsEducatorMutation(baseOptions?: Apollo.MutationHookOptions<InviteUserAsEducatorMutation, InviteUserAsEducatorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteUserAsEducatorMutation, InviteUserAsEducatorMutationVariables>(InviteUserAsEducatorDocument, options);
      }
export type InviteUserAsEducatorMutationHookResult = ReturnType<typeof useInviteUserAsEducatorMutation>;
export type InviteUserAsEducatorMutationResult = Apollo.MutationResult<InviteUserAsEducatorMutation>;
export type InviteUserAsEducatorMutationOptions = Apollo.BaseMutationOptions<InviteUserAsEducatorMutation, InviteUserAsEducatorMutationVariables>;
export const SllUpdateLessonCompleteStatusDocument = gql`
    mutation sllUpdateLessonCompleteStatus($input: SLLUpdateLessonCompleteStatusInput!) {
  sllUpdateLessonCompleteStatus(input: $input)
}
    `;
export type SllUpdateLessonCompleteStatusMutationFn = Apollo.MutationFunction<SllUpdateLessonCompleteStatusMutation, SllUpdateLessonCompleteStatusMutationVariables>;

/**
 * __useSllUpdateLessonCompleteStatusMutation__
 *
 * To run a mutation, you first call `useSllUpdateLessonCompleteStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSllUpdateLessonCompleteStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sllUpdateLessonCompleteStatusMutation, { data, loading, error }] = useSllUpdateLessonCompleteStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSllUpdateLessonCompleteStatusMutation(baseOptions?: Apollo.MutationHookOptions<SllUpdateLessonCompleteStatusMutation, SllUpdateLessonCompleteStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SllUpdateLessonCompleteStatusMutation, SllUpdateLessonCompleteStatusMutationVariables>(SllUpdateLessonCompleteStatusDocument, options);
      }
export type SllUpdateLessonCompleteStatusMutationHookResult = ReturnType<typeof useSllUpdateLessonCompleteStatusMutation>;
export type SllUpdateLessonCompleteStatusMutationResult = Apollo.MutationResult<SllUpdateLessonCompleteStatusMutation>;
export type SllUpdateLessonCompleteStatusMutationOptions = Apollo.BaseMutationOptions<SllUpdateLessonCompleteStatusMutation, SllUpdateLessonCompleteStatusMutationVariables>;
export const SllGetLastVisitedModuleDocument = gql`
    query sllGetLastVisitedModule($input: IDInput!) {
  sllGetLastVisitedModule(input: $input) {
    ...SLLLastVisitedModule
  }
}
    ${SllLastVisitedModuleFragmentDoc}`;

/**
 * __useSllGetLastVisitedModuleQuery__
 *
 * To run a query within a React component, call `useSllGetLastVisitedModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useSllGetLastVisitedModuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSllGetLastVisitedModuleQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSllGetLastVisitedModuleQuery(baseOptions: Apollo.QueryHookOptions<SllGetLastVisitedModuleQuery, SllGetLastVisitedModuleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SllGetLastVisitedModuleQuery, SllGetLastVisitedModuleQueryVariables>(SllGetLastVisitedModuleDocument, options);
      }
export function useSllGetLastVisitedModuleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SllGetLastVisitedModuleQuery, SllGetLastVisitedModuleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SllGetLastVisitedModuleQuery, SllGetLastVisitedModuleQueryVariables>(SllGetLastVisitedModuleDocument, options);
        }
export type SllGetLastVisitedModuleQueryHookResult = ReturnType<typeof useSllGetLastVisitedModuleQuery>;
export type SllGetLastVisitedModuleLazyQueryHookResult = ReturnType<typeof useSllGetLastVisitedModuleLazyQuery>;
export type SllGetLastVisitedModuleQueryResult = Apollo.QueryResult<SllGetLastVisitedModuleQuery, SllGetLastVisitedModuleQueryVariables>;
export const SllUpdateLastVisitedModuleDocument = gql`
    mutation sllUpdateLastVisitedModule($input: SLLUpdateLastVisitedModuleInput!) {
  sllUpdateLastVisitedModule(input: $input)
}
    `;
export type SllUpdateLastVisitedModuleMutationFn = Apollo.MutationFunction<SllUpdateLastVisitedModuleMutation, SllUpdateLastVisitedModuleMutationVariables>;

/**
 * __useSllUpdateLastVisitedModuleMutation__
 *
 * To run a mutation, you first call `useSllUpdateLastVisitedModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSllUpdateLastVisitedModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sllUpdateLastVisitedModuleMutation, { data, loading, error }] = useSllUpdateLastVisitedModuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSllUpdateLastVisitedModuleMutation(baseOptions?: Apollo.MutationHookOptions<SllUpdateLastVisitedModuleMutation, SllUpdateLastVisitedModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SllUpdateLastVisitedModuleMutation, SllUpdateLastVisitedModuleMutationVariables>(SllUpdateLastVisitedModuleDocument, options);
      }
export type SllUpdateLastVisitedModuleMutationHookResult = ReturnType<typeof useSllUpdateLastVisitedModuleMutation>;
export type SllUpdateLastVisitedModuleMutationResult = Apollo.MutationResult<SllUpdateLastVisitedModuleMutation>;
export type SllUpdateLastVisitedModuleMutationOptions = Apollo.BaseMutationOptions<SllUpdateLastVisitedModuleMutation, SllUpdateLastVisitedModuleMutationVariables>;
export const ListLessonsInProgressDocument = gql`
    query listLessonsInProgress {
  listLessonsInProgress {
    ...LessonInProgress
  }
}
    ${LessonInProgressFragmentDoc}`;

/**
 * __useListLessonsInProgressQuery__
 *
 * To run a query within a React component, call `useListLessonsInProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLessonsInProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLessonsInProgressQuery({
 *   variables: {
 *   },
 * });
 */
export function useListLessonsInProgressQuery(baseOptions?: Apollo.QueryHookOptions<ListLessonsInProgressQuery, ListLessonsInProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListLessonsInProgressQuery, ListLessonsInProgressQueryVariables>(ListLessonsInProgressDocument, options);
      }
export function useListLessonsInProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListLessonsInProgressQuery, ListLessonsInProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListLessonsInProgressQuery, ListLessonsInProgressQueryVariables>(ListLessonsInProgressDocument, options);
        }
export type ListLessonsInProgressQueryHookResult = ReturnType<typeof useListLessonsInProgressQuery>;
export type ListLessonsInProgressLazyQueryHookResult = ReturnType<typeof useListLessonsInProgressLazyQuery>;
export type ListLessonsInProgressQueryResult = Apollo.QueryResult<ListLessonsInProgressQuery, ListLessonsInProgressQueryVariables>;
export const ResetAllLessonProgressDocument = gql`
    mutation resetAllLessonProgress {
  resetAllLessonProgress
}
    `;
export type ResetAllLessonProgressMutationFn = Apollo.MutationFunction<ResetAllLessonProgressMutation, ResetAllLessonProgressMutationVariables>;

/**
 * __useResetAllLessonProgressMutation__
 *
 * To run a mutation, you first call `useResetAllLessonProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetAllLessonProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetAllLessonProgressMutation, { data, loading, error }] = useResetAllLessonProgressMutation({
 *   variables: {
 *   },
 * });
 */
export function useResetAllLessonProgressMutation(baseOptions?: Apollo.MutationHookOptions<ResetAllLessonProgressMutation, ResetAllLessonProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetAllLessonProgressMutation, ResetAllLessonProgressMutationVariables>(ResetAllLessonProgressDocument, options);
      }
export type ResetAllLessonProgressMutationHookResult = ReturnType<typeof useResetAllLessonProgressMutation>;
export type ResetAllLessonProgressMutationResult = Apollo.MutationResult<ResetAllLessonProgressMutation>;
export type ResetAllLessonProgressMutationOptions = Apollo.BaseMutationOptions<ResetAllLessonProgressMutation, ResetAllLessonProgressMutationVariables>;
export const ResetLessonProgressDocument = gql`
    mutation resetLessonProgress($input: ResetLessonProgressInput!) {
  resetLessonProgress(input: $input)
}
    `;
export type ResetLessonProgressMutationFn = Apollo.MutationFunction<ResetLessonProgressMutation, ResetLessonProgressMutationVariables>;

/**
 * __useResetLessonProgressMutation__
 *
 * To run a mutation, you first call `useResetLessonProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetLessonProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetLessonProgressMutation, { data, loading, error }] = useResetLessonProgressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetLessonProgressMutation(baseOptions?: Apollo.MutationHookOptions<ResetLessonProgressMutation, ResetLessonProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetLessonProgressMutation, ResetLessonProgressMutationVariables>(ResetLessonProgressDocument, options);
      }
export type ResetLessonProgressMutationHookResult = ReturnType<typeof useResetLessonProgressMutation>;
export type ResetLessonProgressMutationResult = Apollo.MutationResult<ResetLessonProgressMutation>;
export type ResetLessonProgressMutationOptions = Apollo.BaseMutationOptions<ResetLessonProgressMutation, ResetLessonProgressMutationVariables>;
export const SllGetBrainBreakLessonsDocument = gql`
    query sllGetBrainBreakLessons {
  sllGetBrainBreakLessons {
    ...SLLLesson
  }
}
    ${SllLessonFragmentDoc}`;

/**
 * __useSllGetBrainBreakLessonsQuery__
 *
 * To run a query within a React component, call `useSllGetBrainBreakLessonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSllGetBrainBreakLessonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSllGetBrainBreakLessonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSllGetBrainBreakLessonsQuery(baseOptions?: Apollo.QueryHookOptions<SllGetBrainBreakLessonsQuery, SllGetBrainBreakLessonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SllGetBrainBreakLessonsQuery, SllGetBrainBreakLessonsQueryVariables>(SllGetBrainBreakLessonsDocument, options);
      }
export function useSllGetBrainBreakLessonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SllGetBrainBreakLessonsQuery, SllGetBrainBreakLessonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SllGetBrainBreakLessonsQuery, SllGetBrainBreakLessonsQueryVariables>(SllGetBrainBreakLessonsDocument, options);
        }
export type SllGetBrainBreakLessonsQueryHookResult = ReturnType<typeof useSllGetBrainBreakLessonsQuery>;
export type SllGetBrainBreakLessonsLazyQueryHookResult = ReturnType<typeof useSllGetBrainBreakLessonsLazyQuery>;
export type SllGetBrainBreakLessonsQueryResult = Apollo.QueryResult<SllGetBrainBreakLessonsQuery, SllGetBrainBreakLessonsQueryVariables>;
export const GetPreProgramQuizUnitDocument = gql`
    query getPreProgramQuizUnit {
  getPreProgramQuizUnit {
    ...ExtendedUnit
  }
}
    ${ExtendedUnitFragmentDoc}`;

/**
 * __useGetPreProgramQuizUnitQuery__
 *
 * To run a query within a React component, call `useGetPreProgramQuizUnitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreProgramQuizUnitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreProgramQuizUnitQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPreProgramQuizUnitQuery(baseOptions?: Apollo.QueryHookOptions<GetPreProgramQuizUnitQuery, GetPreProgramQuizUnitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreProgramQuizUnitQuery, GetPreProgramQuizUnitQueryVariables>(GetPreProgramQuizUnitDocument, options);
      }
export function useGetPreProgramQuizUnitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreProgramQuizUnitQuery, GetPreProgramQuizUnitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreProgramQuizUnitQuery, GetPreProgramQuizUnitQueryVariables>(GetPreProgramQuizUnitDocument, options);
        }
export type GetPreProgramQuizUnitQueryHookResult = ReturnType<typeof useGetPreProgramQuizUnitQuery>;
export type GetPreProgramQuizUnitLazyQueryHookResult = ReturnType<typeof useGetPreProgramQuizUnitLazyQuery>;
export type GetPreProgramQuizUnitQueryResult = Apollo.QueryResult<GetPreProgramQuizUnitQuery, GetPreProgramQuizUnitQueryVariables>;
export const GenerateParentLinkForUserDocument = gql`
    mutation generateParentLinkForUser($input: ParentLinkInput) {
  generateParentLinkForUser(input: $input) {
    id
    resource
  }
}
    `;
export type GenerateParentLinkForUserMutationFn = Apollo.MutationFunction<GenerateParentLinkForUserMutation, GenerateParentLinkForUserMutationVariables>;

/**
 * __useGenerateParentLinkForUserMutation__
 *
 * To run a mutation, you first call `useGenerateParentLinkForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateParentLinkForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateParentLinkForUserMutation, { data, loading, error }] = useGenerateParentLinkForUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateParentLinkForUserMutation(baseOptions?: Apollo.MutationHookOptions<GenerateParentLinkForUserMutation, GenerateParentLinkForUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateParentLinkForUserMutation, GenerateParentLinkForUserMutationVariables>(GenerateParentLinkForUserDocument, options);
      }
export type GenerateParentLinkForUserMutationHookResult = ReturnType<typeof useGenerateParentLinkForUserMutation>;
export type GenerateParentLinkForUserMutationResult = Apollo.MutationResult<GenerateParentLinkForUserMutation>;
export type GenerateParentLinkForUserMutationOptions = Apollo.BaseMutationOptions<GenerateParentLinkForUserMutation, GenerateParentLinkForUserMutationVariables>;
export const GetUnitQuickInfoDocument = gql`
    query getUnitQuickInfo($input: IDInput!) {
  getUnitInfo(input: $input) {
    ...UnitContent
    teacherPreparationCount
    alternateMaterialsCount
    classPresentationCount
  }
}
    ${UnitContentFragmentDoc}`;

/**
 * __useGetUnitQuickInfoQuery__
 *
 * To run a query within a React component, call `useGetUnitQuickInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitQuickInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitQuickInfoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUnitQuickInfoQuery(baseOptions: Apollo.QueryHookOptions<GetUnitQuickInfoQuery, GetUnitQuickInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitQuickInfoQuery, GetUnitQuickInfoQueryVariables>(GetUnitQuickInfoDocument, options);
      }
export function useGetUnitQuickInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitQuickInfoQuery, GetUnitQuickInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitQuickInfoQuery, GetUnitQuickInfoQueryVariables>(GetUnitQuickInfoDocument, options);
        }
export type GetUnitQuickInfoQueryHookResult = ReturnType<typeof useGetUnitQuickInfoQuery>;
export type GetUnitQuickInfoLazyQueryHookResult = ReturnType<typeof useGetUnitQuickInfoLazyQuery>;
export type GetUnitQuickInfoQueryResult = Apollo.QueryResult<GetUnitQuickInfoQuery, GetUnitQuickInfoQueryVariables>;
export const GetAllVideosDocument = gql`
    query getAllVideos {
  allVideos {
    name
    data
    created
    meta
  }
}
    `;

/**
 * __useGetAllVideosQuery__
 *
 * To run a query within a React component, call `useGetAllVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllVideosQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllVideosQuery(baseOptions?: Apollo.QueryHookOptions<GetAllVideosQuery, GetAllVideosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllVideosQuery, GetAllVideosQueryVariables>(GetAllVideosDocument, options);
      }
export function useGetAllVideosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllVideosQuery, GetAllVideosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllVideosQuery, GetAllVideosQueryVariables>(GetAllVideosDocument, options);
        }
export type GetAllVideosQueryHookResult = ReturnType<typeof useGetAllVideosQuery>;
export type GetAllVideosLazyQueryHookResult = ReturnType<typeof useGetAllVideosLazyQuery>;
export type GetAllVideosQueryResult = Apollo.QueryResult<GetAllVideosQuery, GetAllVideosQueryVariables>;
export const GetAllCoverVideosDocument = gql`
    query getAllCoverVideos {
  allCoverVideos {
    name
    data
    created
    meta
  }
}
    `;

/**
 * __useGetAllCoverVideosQuery__
 *
 * To run a query within a React component, call `useGetAllCoverVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCoverVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCoverVideosQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCoverVideosQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCoverVideosQuery, GetAllCoverVideosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCoverVideosQuery, GetAllCoverVideosQueryVariables>(GetAllCoverVideosDocument, options);
      }
export function useGetAllCoverVideosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCoverVideosQuery, GetAllCoverVideosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCoverVideosQuery, GetAllCoverVideosQueryVariables>(GetAllCoverVideosDocument, options);
        }
export type GetAllCoverVideosQueryHookResult = ReturnType<typeof useGetAllCoverVideosQuery>;
export type GetAllCoverVideosLazyQueryHookResult = ReturnType<typeof useGetAllCoverVideosLazyQuery>;
export type GetAllCoverVideosQueryResult = Apollo.QueryResult<GetAllCoverVideosQuery, GetAllCoverVideosQueryVariables>;
export const UpdateUnitStudyReviewStatusDocument = gql`
    mutation updateUnitStudyReviewStatus($input: UpdateUnitStudyReviewStatusInput!) {
  updateUnitStudyReviewStatus(input: $input)
}
    `;
export type UpdateUnitStudyReviewStatusMutationFn = Apollo.MutationFunction<UpdateUnitStudyReviewStatusMutation, UpdateUnitStudyReviewStatusMutationVariables>;

/**
 * __useUpdateUnitStudyReviewStatusMutation__
 *
 * To run a mutation, you first call `useUpdateUnitStudyReviewStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUnitStudyReviewStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUnitStudyReviewStatusMutation, { data, loading, error }] = useUpdateUnitStudyReviewStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUnitStudyReviewStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUnitStudyReviewStatusMutation, UpdateUnitStudyReviewStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUnitStudyReviewStatusMutation, UpdateUnitStudyReviewStatusMutationVariables>(UpdateUnitStudyReviewStatusDocument, options);
      }
export type UpdateUnitStudyReviewStatusMutationHookResult = ReturnType<typeof useUpdateUnitStudyReviewStatusMutation>;
export type UpdateUnitStudyReviewStatusMutationResult = Apollo.MutationResult<UpdateUnitStudyReviewStatusMutation>;
export type UpdateUnitStudyReviewStatusMutationOptions = Apollo.BaseMutationOptions<UpdateUnitStudyReviewStatusMutation, UpdateUnitStudyReviewStatusMutationVariables>;
export const LastVisitedUnitStudyReviewDocument = gql`
    query lastVisitedUnitStudyReview($input: IDInput!) {
  lastVisitedUnitStudyReview(input: $input) {
    ...LastVisitedUnitStudyReviewContent
  }
}
    ${LastVisitedUnitStudyReviewContentFragmentDoc}`;

/**
 * __useLastVisitedUnitStudyReviewQuery__
 *
 * To run a query within a React component, call `useLastVisitedUnitStudyReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastVisitedUnitStudyReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLastVisitedUnitStudyReviewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLastVisitedUnitStudyReviewQuery(baseOptions: Apollo.QueryHookOptions<LastVisitedUnitStudyReviewQuery, LastVisitedUnitStudyReviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LastVisitedUnitStudyReviewQuery, LastVisitedUnitStudyReviewQueryVariables>(LastVisitedUnitStudyReviewDocument, options);
      }
export function useLastVisitedUnitStudyReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LastVisitedUnitStudyReviewQuery, LastVisitedUnitStudyReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LastVisitedUnitStudyReviewQuery, LastVisitedUnitStudyReviewQueryVariables>(LastVisitedUnitStudyReviewDocument, options);
        }
export type LastVisitedUnitStudyReviewQueryHookResult = ReturnType<typeof useLastVisitedUnitStudyReviewQuery>;
export type LastVisitedUnitStudyReviewLazyQueryHookResult = ReturnType<typeof useLastVisitedUnitStudyReviewLazyQuery>;
export type LastVisitedUnitStudyReviewQueryResult = Apollo.QueryResult<LastVisitedUnitStudyReviewQuery, LastVisitedUnitStudyReviewQueryVariables>;
export const UpdateLastVisitedUnitStudyReviewDocument = gql`
    mutation updateLastVisitedUnitStudyReview($input: LastVisitedUnitStudyReviewInput) {
  updateLastVisitedUnitStudyReview(input: $input) {
    ...LastVisitedUnitStudyReviewContent
  }
}
    ${LastVisitedUnitStudyReviewContentFragmentDoc}`;
export type UpdateLastVisitedUnitStudyReviewMutationFn = Apollo.MutationFunction<UpdateLastVisitedUnitStudyReviewMutation, UpdateLastVisitedUnitStudyReviewMutationVariables>;

/**
 * __useUpdateLastVisitedUnitStudyReviewMutation__
 *
 * To run a mutation, you first call `useUpdateLastVisitedUnitStudyReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLastVisitedUnitStudyReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLastVisitedUnitStudyReviewMutation, { data, loading, error }] = useUpdateLastVisitedUnitStudyReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLastVisitedUnitStudyReviewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLastVisitedUnitStudyReviewMutation, UpdateLastVisitedUnitStudyReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLastVisitedUnitStudyReviewMutation, UpdateLastVisitedUnitStudyReviewMutationVariables>(UpdateLastVisitedUnitStudyReviewDocument, options);
      }
export type UpdateLastVisitedUnitStudyReviewMutationHookResult = ReturnType<typeof useUpdateLastVisitedUnitStudyReviewMutation>;
export type UpdateLastVisitedUnitStudyReviewMutationResult = Apollo.MutationResult<UpdateLastVisitedUnitStudyReviewMutation>;
export type UpdateLastVisitedUnitStudyReviewMutationOptions = Apollo.BaseMutationOptions<UpdateLastVisitedUnitStudyReviewMutation, UpdateLastVisitedUnitStudyReviewMutationVariables>;
export const IsValidUnitUniqueNameDocument = gql`
    query isValidUnitUniqueName($input: UniqueNameInput!) {
  isValidUnitUniqueName(input: $input)
}
    `;

/**
 * __useIsValidUnitUniqueNameQuery__
 *
 * To run a query within a React component, call `useIsValidUnitUniqueNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsValidUnitUniqueNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsValidUnitUniqueNameQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIsValidUnitUniqueNameQuery(baseOptions: Apollo.QueryHookOptions<IsValidUnitUniqueNameQuery, IsValidUnitUniqueNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsValidUnitUniqueNameQuery, IsValidUnitUniqueNameQueryVariables>(IsValidUnitUniqueNameDocument, options);
      }
export function useIsValidUnitUniqueNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsValidUnitUniqueNameQuery, IsValidUnitUniqueNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsValidUnitUniqueNameQuery, IsValidUnitUniqueNameQueryVariables>(IsValidUnitUniqueNameDocument, options);
        }
export type IsValidUnitUniqueNameQueryHookResult = ReturnType<typeof useIsValidUnitUniqueNameQuery>;
export type IsValidUnitUniqueNameLazyQueryHookResult = ReturnType<typeof useIsValidUnitUniqueNameLazyQuery>;
export type IsValidUnitUniqueNameQueryResult = Apollo.QueryResult<IsValidUnitUniqueNameQuery, IsValidUnitUniqueNameQueryVariables>;
export const IsValidSllUniqueNameDocument = gql`
    query isValidSLLUniqueName($input: UniqueNameInput!) {
  isValidSLLUniqueName(input: $input)
}
    `;

/**
 * __useIsValidSllUniqueNameQuery__
 *
 * To run a query within a React component, call `useIsValidSllUniqueNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsValidSllUniqueNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsValidSllUniqueNameQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIsValidSllUniqueNameQuery(baseOptions: Apollo.QueryHookOptions<IsValidSllUniqueNameQuery, IsValidSllUniqueNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsValidSllUniqueNameQuery, IsValidSllUniqueNameQueryVariables>(IsValidSllUniqueNameDocument, options);
      }
export function useIsValidSllUniqueNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsValidSllUniqueNameQuery, IsValidSllUniqueNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsValidSllUniqueNameQuery, IsValidSllUniqueNameQueryVariables>(IsValidSllUniqueNameDocument, options);
        }
export type IsValidSllUniqueNameQueryHookResult = ReturnType<typeof useIsValidSllUniqueNameQuery>;
export type IsValidSllUniqueNameLazyQueryHookResult = ReturnType<typeof useIsValidSllUniqueNameLazyQuery>;
export type IsValidSllUniqueNameQueryResult = Apollo.QueryResult<IsValidSllUniqueNameQuery, IsValidSllUniqueNameQueryVariables>;
export const IsValidLessonUniqueNameDocument = gql`
    query isValidLessonUniqueName($input: UniqueNameInput!) {
  isValidLessonUniqueName(input: $input)
}
    `;

/**
 * __useIsValidLessonUniqueNameQuery__
 *
 * To run a query within a React component, call `useIsValidLessonUniqueNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsValidLessonUniqueNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsValidLessonUniqueNameQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIsValidLessonUniqueNameQuery(baseOptions: Apollo.QueryHookOptions<IsValidLessonUniqueNameQuery, IsValidLessonUniqueNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsValidLessonUniqueNameQuery, IsValidLessonUniqueNameQueryVariables>(IsValidLessonUniqueNameDocument, options);
      }
export function useIsValidLessonUniqueNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsValidLessonUniqueNameQuery, IsValidLessonUniqueNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsValidLessonUniqueNameQuery, IsValidLessonUniqueNameQueryVariables>(IsValidLessonUniqueNameDocument, options);
        }
export type IsValidLessonUniqueNameQueryHookResult = ReturnType<typeof useIsValidLessonUniqueNameQuery>;
export type IsValidLessonUniqueNameLazyQueryHookResult = ReturnType<typeof useIsValidLessonUniqueNameLazyQuery>;
export type IsValidLessonUniqueNameQueryResult = Apollo.QueryResult<IsValidLessonUniqueNameQuery, IsValidLessonUniqueNameQueryVariables>;
export const GetUnitInfoByUniqueNameDocument = gql`
    query getUnitInfoByUniqueName($input: UniqueNameInput!) {
  getUnitInfoByUniqueName(input: $input) {
    ...ExtendedUnitWithHEA
  }
}
    ${ExtendedUnitWithHeaFragmentDoc}`;

/**
 * __useGetUnitInfoByUniqueNameQuery__
 *
 * To run a query within a React component, call `useGetUnitInfoByUniqueNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitInfoByUniqueNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitInfoByUniqueNameQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUnitInfoByUniqueNameQuery(baseOptions: Apollo.QueryHookOptions<GetUnitInfoByUniqueNameQuery, GetUnitInfoByUniqueNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitInfoByUniqueNameQuery, GetUnitInfoByUniqueNameQueryVariables>(GetUnitInfoByUniqueNameDocument, options);
      }
export function useGetUnitInfoByUniqueNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitInfoByUniqueNameQuery, GetUnitInfoByUniqueNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitInfoByUniqueNameQuery, GetUnitInfoByUniqueNameQueryVariables>(GetUnitInfoByUniqueNameDocument, options);
        }
export type GetUnitInfoByUniqueNameQueryHookResult = ReturnType<typeof useGetUnitInfoByUniqueNameQuery>;
export type GetUnitInfoByUniqueNameLazyQueryHookResult = ReturnType<typeof useGetUnitInfoByUniqueNameLazyQuery>;
export type GetUnitInfoByUniqueNameQueryResult = Apollo.QueryResult<GetUnitInfoByUniqueNameQuery, GetUnitInfoByUniqueNameQueryVariables>;
export const SllGetLessonInfoByUniqueNameDocument = gql`
    query sllGetLessonInfoByUniqueName($input: UniqueNameInput!) {
  sllGetLessonInfoByUniqueName(input: $input) {
    ...SLLLesson
  }
}
    ${SllLessonFragmentDoc}`;

/**
 * __useSllGetLessonInfoByUniqueNameQuery__
 *
 * To run a query within a React component, call `useSllGetLessonInfoByUniqueNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useSllGetLessonInfoByUniqueNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSllGetLessonInfoByUniqueNameQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSllGetLessonInfoByUniqueNameQuery(baseOptions: Apollo.QueryHookOptions<SllGetLessonInfoByUniqueNameQuery, SllGetLessonInfoByUniqueNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SllGetLessonInfoByUniqueNameQuery, SllGetLessonInfoByUniqueNameQueryVariables>(SllGetLessonInfoByUniqueNameDocument, options);
      }
export function useSllGetLessonInfoByUniqueNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SllGetLessonInfoByUniqueNameQuery, SllGetLessonInfoByUniqueNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SllGetLessonInfoByUniqueNameQuery, SllGetLessonInfoByUniqueNameQueryVariables>(SllGetLessonInfoByUniqueNameDocument, options);
        }
export type SllGetLessonInfoByUniqueNameQueryHookResult = ReturnType<typeof useSllGetLessonInfoByUniqueNameQuery>;
export type SllGetLessonInfoByUniqueNameLazyQueryHookResult = ReturnType<typeof useSllGetLessonInfoByUniqueNameLazyQuery>;
export type SllGetLessonInfoByUniqueNameQueryResult = Apollo.QueryResult<SllGetLessonInfoByUniqueNameQuery, SllGetLessonInfoByUniqueNameQueryVariables>;
export const GetAllUnitsWithQuizDocument = gql`
    query getAllUnitsWithQuiz {
  getAllUnitsWithQuiz {
    id
    name
    units {
      ...UnitContent
    }
  }
}
    ${UnitContentFragmentDoc}`;

/**
 * __useGetAllUnitsWithQuizQuery__
 *
 * To run a query within a React component, call `useGetAllUnitsWithQuizQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUnitsWithQuizQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUnitsWithQuizQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllUnitsWithQuizQuery(baseOptions?: Apollo.QueryHookOptions<GetAllUnitsWithQuizQuery, GetAllUnitsWithQuizQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllUnitsWithQuizQuery, GetAllUnitsWithQuizQueryVariables>(GetAllUnitsWithQuizDocument, options);
      }
export function useGetAllUnitsWithQuizLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllUnitsWithQuizQuery, GetAllUnitsWithQuizQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllUnitsWithQuizQuery, GetAllUnitsWithQuizQueryVariables>(GetAllUnitsWithQuizDocument, options);
        }
export type GetAllUnitsWithQuizQueryHookResult = ReturnType<typeof useGetAllUnitsWithQuizQuery>;
export type GetAllUnitsWithQuizLazyQueryHookResult = ReturnType<typeof useGetAllUnitsWithQuizLazyQuery>;
export type GetAllUnitsWithQuizQueryResult = Apollo.QueryResult<GetAllUnitsWithQuizQuery, GetAllUnitsWithQuizQueryVariables>;
export const GetAllCollectionsDocument = gql`
    query getAllCollections($input: GetAllCollectionsInput!) {
  getAllCollections(input: $input) {
    ...Collection
  }
}
    ${CollectionFragmentDoc}`;

/**
 * __useGetAllCollectionsQuery__
 *
 * To run a query within a React component, call `useGetAllCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCollectionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllCollectionsQuery(baseOptions: Apollo.QueryHookOptions<GetAllCollectionsQuery, GetAllCollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCollectionsQuery, GetAllCollectionsQueryVariables>(GetAllCollectionsDocument, options);
      }
export function useGetAllCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCollectionsQuery, GetAllCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCollectionsQuery, GetAllCollectionsQueryVariables>(GetAllCollectionsDocument, options);
        }
export type GetAllCollectionsQueryHookResult = ReturnType<typeof useGetAllCollectionsQuery>;
export type GetAllCollectionsLazyQueryHookResult = ReturnType<typeof useGetAllCollectionsLazyQuery>;
export type GetAllCollectionsQueryResult = Apollo.QueryResult<GetAllCollectionsQuery, GetAllCollectionsQueryVariables>;
export const GetCollectionDocument = gql`
    query getCollection($input: IDInput!) {
  getCollection(input: $input) {
    ...CollectionWithPresentation
  }
}
    ${CollectionWithPresentationFragmentDoc}`;

/**
 * __useGetCollectionQuery__
 *
 * To run a query within a React component, call `useGetCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCollectionQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionQuery, GetCollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionQuery, GetCollectionQueryVariables>(GetCollectionDocument, options);
      }
export function useGetCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionQuery, GetCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionQuery, GetCollectionQueryVariables>(GetCollectionDocument, options);
        }
export type GetCollectionQueryHookResult = ReturnType<typeof useGetCollectionQuery>;
export type GetCollectionLazyQueryHookResult = ReturnType<typeof useGetCollectionLazyQuery>;
export type GetCollectionQueryResult = Apollo.QueryResult<GetCollectionQuery, GetCollectionQueryVariables>;
export const CreateCollectionDocument = gql`
    mutation createCollection($input: CreateCollectionInput!) {
  createCollection(input: $input) {
    ...Collection
  }
}
    ${CollectionFragmentDoc}`;
export type CreateCollectionMutationFn = Apollo.MutationFunction<CreateCollectionMutation, CreateCollectionMutationVariables>;

/**
 * __useCreateCollectionMutation__
 *
 * To run a mutation, you first call `useCreateCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCollectionMutation, { data, loading, error }] = useCreateCollectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCollectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateCollectionMutation, CreateCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCollectionMutation, CreateCollectionMutationVariables>(CreateCollectionDocument, options);
      }
export type CreateCollectionMutationHookResult = ReturnType<typeof useCreateCollectionMutation>;
export type CreateCollectionMutationResult = Apollo.MutationResult<CreateCollectionMutation>;
export type CreateCollectionMutationOptions = Apollo.BaseMutationOptions<CreateCollectionMutation, CreateCollectionMutationVariables>;
export const UpdateCollectionDocument = gql`
    mutation updateCollection($input: UpdateCollectionInput!) {
  updateCollection(input: $input) {
    ...Collection
  }
}
    ${CollectionFragmentDoc}`;
export type UpdateCollectionMutationFn = Apollo.MutationFunction<UpdateCollectionMutation, UpdateCollectionMutationVariables>;

/**
 * __useUpdateCollectionMutation__
 *
 * To run a mutation, you first call `useUpdateCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCollectionMutation, { data, loading, error }] = useUpdateCollectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCollectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCollectionMutation, UpdateCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCollectionMutation, UpdateCollectionMutationVariables>(UpdateCollectionDocument, options);
      }
export type UpdateCollectionMutationHookResult = ReturnType<typeof useUpdateCollectionMutation>;
export type UpdateCollectionMutationResult = Apollo.MutationResult<UpdateCollectionMutation>;
export type UpdateCollectionMutationOptions = Apollo.BaseMutationOptions<UpdateCollectionMutation, UpdateCollectionMutationVariables>;
export const DeleteCollectionDocument = gql`
    mutation deleteCollection($input: IDInput!) {
  deleteCollection(input: $input)
}
    `;
export type DeleteCollectionMutationFn = Apollo.MutationFunction<DeleteCollectionMutation, DeleteCollectionMutationVariables>;

/**
 * __useDeleteCollectionMutation__
 *
 * To run a mutation, you first call `useDeleteCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCollectionMutation, { data, loading, error }] = useDeleteCollectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCollectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCollectionMutation, DeleteCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCollectionMutation, DeleteCollectionMutationVariables>(DeleteCollectionDocument, options);
      }
export type DeleteCollectionMutationHookResult = ReturnType<typeof useDeleteCollectionMutation>;
export type DeleteCollectionMutationResult = Apollo.MutationResult<DeleteCollectionMutation>;
export type DeleteCollectionMutationOptions = Apollo.BaseMutationOptions<DeleteCollectionMutation, DeleteCollectionMutationVariables>;
export const SaveCollectionLessonsDocument = gql`
    mutation saveCollectionLessons($input: SaveCollectionLessonsInput!) {
  saveCollectionLessons(input: $input)
}
    `;
export type SaveCollectionLessonsMutationFn = Apollo.MutationFunction<SaveCollectionLessonsMutation, SaveCollectionLessonsMutationVariables>;

/**
 * __useSaveCollectionLessonsMutation__
 *
 * To run a mutation, you first call `useSaveCollectionLessonsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCollectionLessonsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCollectionLessonsMutation, { data, loading, error }] = useSaveCollectionLessonsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCollectionLessonsMutation(baseOptions?: Apollo.MutationHookOptions<SaveCollectionLessonsMutation, SaveCollectionLessonsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCollectionLessonsMutation, SaveCollectionLessonsMutationVariables>(SaveCollectionLessonsDocument, options);
      }
export type SaveCollectionLessonsMutationHookResult = ReturnType<typeof useSaveCollectionLessonsMutation>;
export type SaveCollectionLessonsMutationResult = Apollo.MutationResult<SaveCollectionLessonsMutation>;
export type SaveCollectionLessonsMutationOptions = Apollo.BaseMutationOptions<SaveCollectionLessonsMutation, SaveCollectionLessonsMutationVariables>;
export const GetMyQuizzesDocument = gql`
    query getMyQuizzes {
  myQuizzes {
    ...Quiz
  }
}
    ${QuizFragmentDoc}`;

/**
 * __useGetMyQuizzesQuery__
 *
 * To run a query within a React component, call `useGetMyQuizzesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyQuizzesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyQuizzesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyQuizzesQuery(baseOptions?: Apollo.QueryHookOptions<GetMyQuizzesQuery, GetMyQuizzesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyQuizzesQuery, GetMyQuizzesQueryVariables>(GetMyQuizzesDocument, options);
      }
export function useGetMyQuizzesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyQuizzesQuery, GetMyQuizzesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyQuizzesQuery, GetMyQuizzesQueryVariables>(GetMyQuizzesDocument, options);
        }
export type GetMyQuizzesQueryHookResult = ReturnType<typeof useGetMyQuizzesQuery>;
export type GetMyQuizzesLazyQueryHookResult = ReturnType<typeof useGetMyQuizzesLazyQuery>;
export type GetMyQuizzesQueryResult = Apollo.QueryResult<GetMyQuizzesQuery, GetMyQuizzesQueryVariables>;
export const CreateQuizDocument = gql`
    mutation createQuiz($input: CreateQuizInput!) {
  createQuiz(input: $input)
}
    `;
export type CreateQuizMutationFn = Apollo.MutationFunction<CreateQuizMutation, CreateQuizMutationVariables>;

/**
 * __useCreateQuizMutation__
 *
 * To run a mutation, you first call `useCreateQuizMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuizMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuizMutation, { data, loading, error }] = useCreateQuizMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateQuizMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuizMutation, CreateQuizMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuizMutation, CreateQuizMutationVariables>(CreateQuizDocument, options);
      }
export type CreateQuizMutationHookResult = ReturnType<typeof useCreateQuizMutation>;
export type CreateQuizMutationResult = Apollo.MutationResult<CreateQuizMutation>;
export type CreateQuizMutationOptions = Apollo.BaseMutationOptions<CreateQuizMutation, CreateQuizMutationVariables>;
export const UpdateQuizDocument = gql`
    mutation updateQuiz($input: UpdateQuizInput!) {
  updateQuiz(input: $input)
}
    `;
export type UpdateQuizMutationFn = Apollo.MutationFunction<UpdateQuizMutation, UpdateQuizMutationVariables>;

/**
 * __useUpdateQuizMutation__
 *
 * To run a mutation, you first call `useUpdateQuizMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuizMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuizMutation, { data, loading, error }] = useUpdateQuizMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuizMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuizMutation, UpdateQuizMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuizMutation, UpdateQuizMutationVariables>(UpdateQuizDocument, options);
      }
export type UpdateQuizMutationHookResult = ReturnType<typeof useUpdateQuizMutation>;
export type UpdateQuizMutationResult = Apollo.MutationResult<UpdateQuizMutation>;
export type UpdateQuizMutationOptions = Apollo.BaseMutationOptions<UpdateQuizMutation, UpdateQuizMutationVariables>;
export const UpdateQuizNameDocument = gql`
    mutation updateQuizName($input: UpdateQuizNameInput!) {
  updateQuizName(input: $input)
}
    `;
export type UpdateQuizNameMutationFn = Apollo.MutationFunction<UpdateQuizNameMutation, UpdateQuizNameMutationVariables>;

/**
 * __useUpdateQuizNameMutation__
 *
 * To run a mutation, you first call `useUpdateQuizNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuizNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuizNameMutation, { data, loading, error }] = useUpdateQuizNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuizNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuizNameMutation, UpdateQuizNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuizNameMutation, UpdateQuizNameMutationVariables>(UpdateQuizNameDocument, options);
      }
export type UpdateQuizNameMutationHookResult = ReturnType<typeof useUpdateQuizNameMutation>;
export type UpdateQuizNameMutationResult = Apollo.MutationResult<UpdateQuizNameMutation>;
export type UpdateQuizNameMutationOptions = Apollo.BaseMutationOptions<UpdateQuizNameMutation, UpdateQuizNameMutationVariables>;
export const DeleteQuizDocument = gql`
    mutation deleteQuiz($input: IDInput!) {
  deleteQuiz(input: $input)
}
    `;
export type DeleteQuizMutationFn = Apollo.MutationFunction<DeleteQuizMutation, DeleteQuizMutationVariables>;

/**
 * __useDeleteQuizMutation__
 *
 * To run a mutation, you first call `useDeleteQuizMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuizMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuizMutation, { data, loading, error }] = useDeleteQuizMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteQuizMutation(baseOptions?: Apollo.MutationHookOptions<DeleteQuizMutation, DeleteQuizMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteQuizMutation, DeleteQuizMutationVariables>(DeleteQuizDocument, options);
      }
export type DeleteQuizMutationHookResult = ReturnType<typeof useDeleteQuizMutation>;
export type DeleteQuizMutationResult = Apollo.MutationResult<DeleteQuizMutation>;
export type DeleteQuizMutationOptions = Apollo.BaseMutationOptions<DeleteQuizMutation, DeleteQuizMutationVariables>;
export const CreateQuizFeedbackFormDocument = gql`
    mutation createQuizFeedbackForm($input: QuizFeedbackFormInput!) {
  createQuizFeedbackForm(input: $input) {
    ...FeedbackFormContent
  }
}
    ${FeedbackFormContentFragmentDoc}`;
export type CreateQuizFeedbackFormMutationFn = Apollo.MutationFunction<CreateQuizFeedbackFormMutation, CreateQuizFeedbackFormMutationVariables>;

/**
 * __useCreateQuizFeedbackFormMutation__
 *
 * To run a mutation, you first call `useCreateQuizFeedbackFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuizFeedbackFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuizFeedbackFormMutation, { data, loading, error }] = useCreateQuizFeedbackFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateQuizFeedbackFormMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuizFeedbackFormMutation, CreateQuizFeedbackFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuizFeedbackFormMutation, CreateQuizFeedbackFormMutationVariables>(CreateQuizFeedbackFormDocument, options);
      }
export type CreateQuizFeedbackFormMutationHookResult = ReturnType<typeof useCreateQuizFeedbackFormMutation>;
export type CreateQuizFeedbackFormMutationResult = Apollo.MutationResult<CreateQuizFeedbackFormMutation>;
export type CreateQuizFeedbackFormMutationOptions = Apollo.BaseMutationOptions<CreateQuizFeedbackFormMutation, CreateQuizFeedbackFormMutationVariables>;
export const GetQuizDocument = gql`
    query getQuiz($input: IDInput!) {
  getQuiz(input: $input) {
    id
    name
    color
    darkColor
    contents {
      ...Content
    }
  }
}
    ${ContentFragmentDoc}`;

/**
 * __useGetQuizQuery__
 *
 * To run a query within a React component, call `useGetQuizQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuizQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuizQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetQuizQuery(baseOptions: Apollo.QueryHookOptions<GetQuizQuery, GetQuizQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuizQuery, GetQuizQueryVariables>(GetQuizDocument, options);
      }
export function useGetQuizLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuizQuery, GetQuizQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuizQuery, GetQuizQueryVariables>(GetQuizDocument, options);
        }
export type GetQuizQueryHookResult = ReturnType<typeof useGetQuizQuery>;
export type GetQuizLazyQueryHookResult = ReturnType<typeof useGetQuizLazyQuery>;
export type GetQuizQueryResult = Apollo.QueryResult<GetQuizQuery, GetQuizQueryVariables>;
export const GetStudyReviewUnitDocument = gql`
    query getStudyReviewUnit($input: IDInput!) {
  getUnitInfo(input: $input) {
    ...ShortenUnit
  }
}
    ${ShortenUnitFragmentDoc}`;

/**
 * __useGetStudyReviewUnitQuery__
 *
 * To run a query within a React component, call `useGetStudyReviewUnitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudyReviewUnitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudyReviewUnitQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetStudyReviewUnitQuery(baseOptions: Apollo.QueryHookOptions<GetStudyReviewUnitQuery, GetStudyReviewUnitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudyReviewUnitQuery, GetStudyReviewUnitQueryVariables>(GetStudyReviewUnitDocument, options);
      }
export function useGetStudyReviewUnitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudyReviewUnitQuery, GetStudyReviewUnitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudyReviewUnitQuery, GetStudyReviewUnitQueryVariables>(GetStudyReviewUnitDocument, options);
        }
export type GetStudyReviewUnitQueryHookResult = ReturnType<typeof useGetStudyReviewUnitQuery>;
export type GetStudyReviewUnitLazyQueryHookResult = ReturnType<typeof useGetStudyReviewUnitLazyQuery>;
export type GetStudyReviewUnitQueryResult = Apollo.QueryResult<GetStudyReviewUnitQuery, GetStudyReviewUnitQueryVariables>;
export const VideoSubtitlesDocument = gql`
    query videoSubtitles($assetId: String, $playbackId: String) {
  videoSubtitles(assetId: $assetId, playbackId: $playbackId) {
    id
    languageCode
    name
  }
}
    `;

/**
 * __useVideoSubtitlesQuery__
 *
 * To run a query within a React component, call `useVideoSubtitlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoSubtitlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoSubtitlesQuery({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      playbackId: // value for 'playbackId'
 *   },
 * });
 */
export function useVideoSubtitlesQuery(baseOptions?: Apollo.QueryHookOptions<VideoSubtitlesQuery, VideoSubtitlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VideoSubtitlesQuery, VideoSubtitlesQueryVariables>(VideoSubtitlesDocument, options);
      }
export function useVideoSubtitlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VideoSubtitlesQuery, VideoSubtitlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VideoSubtitlesQuery, VideoSubtitlesQueryVariables>(VideoSubtitlesDocument, options);
        }
export type VideoSubtitlesQueryHookResult = ReturnType<typeof useVideoSubtitlesQuery>;
export type VideoSubtitlesLazyQueryHookResult = ReturnType<typeof useVideoSubtitlesLazyQuery>;
export type VideoSubtitlesQueryResult = Apollo.QueryResult<VideoSubtitlesQuery, VideoSubtitlesQueryVariables>;
export const SllGetPreProgramInfoDocument = gql`
    query SllGetPreProgramInfo {
  sllGetPreProgramInfo {
    ...SLLLesson
  }
}
    ${SllLessonFragmentDoc}`;

/**
 * __useSllGetPreProgramInfoQuery__
 *
 * To run a query within a React component, call `useSllGetPreProgramInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useSllGetPreProgramInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSllGetPreProgramInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useSllGetPreProgramInfoQuery(baseOptions?: Apollo.QueryHookOptions<SllGetPreProgramInfoQuery, SllGetPreProgramInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SllGetPreProgramInfoQuery, SllGetPreProgramInfoQueryVariables>(SllGetPreProgramInfoDocument, options);
      }
export function useSllGetPreProgramInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SllGetPreProgramInfoQuery, SllGetPreProgramInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SllGetPreProgramInfoQuery, SllGetPreProgramInfoQueryVariables>(SllGetPreProgramInfoDocument, options);
        }
export type SllGetPreProgramInfoQueryHookResult = ReturnType<typeof useSllGetPreProgramInfoQuery>;
export type SllGetPreProgramInfoLazyQueryHookResult = ReturnType<typeof useSllGetPreProgramInfoLazyQuery>;
export type SllGetPreProgramInfoQueryResult = Apollo.QueryResult<SllGetPreProgramInfoQuery, SllGetPreProgramInfoQueryVariables>;
export const SllPreProgramQuizDocument = gql`
    query SllPreProgramQuiz($input: IDInput!) {
  sllPreProgramQuiz(input: $input) {
    ...Content
  }
}
    ${ContentFragmentDoc}`;

/**
 * __useSllPreProgramQuizQuery__
 *
 * To run a query within a React component, call `useSllPreProgramQuizQuery` and pass it any options that fit your needs.
 * When your component renders, `useSllPreProgramQuizQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSllPreProgramQuizQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSllPreProgramQuizQuery(baseOptions: Apollo.QueryHookOptions<SllPreProgramQuizQuery, SllPreProgramQuizQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SllPreProgramQuizQuery, SllPreProgramQuizQueryVariables>(SllPreProgramQuizDocument, options);
      }
export function useSllPreProgramQuizLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SllPreProgramQuizQuery, SllPreProgramQuizQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SllPreProgramQuizQuery, SllPreProgramQuizQueryVariables>(SllPreProgramQuizDocument, options);
        }
export type SllPreProgramQuizQueryHookResult = ReturnType<typeof useSllPreProgramQuizQuery>;
export type SllPreProgramQuizLazyQueryHookResult = ReturnType<typeof useSllPreProgramQuizLazyQuery>;
export type SllPreProgramQuizQueryResult = Apollo.QueryResult<SllPreProgramQuizQuery, SllPreProgramQuizQueryVariables>;
export const SslCreatePreProgramFeedbackFormDocument = gql`
    mutation SslCreatePreProgramFeedbackForm($input: SLLPreProgramQuizInput!) {
  sslCreatePreProgramFeedbackForm(input: $input) {
    unitName
    type
    programName
    link
    lessonName
    isCancelled
    id
    formData
    expirationAt
    exitTicketCount
    createdAt
    className
    grade
  }
}
    `;
export type SslCreatePreProgramFeedbackFormMutationFn = Apollo.MutationFunction<SslCreatePreProgramFeedbackFormMutation, SslCreatePreProgramFeedbackFormMutationVariables>;

/**
 * __useSslCreatePreProgramFeedbackFormMutation__
 *
 * To run a mutation, you first call `useSslCreatePreProgramFeedbackFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSslCreatePreProgramFeedbackFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sslCreatePreProgramFeedbackFormMutation, { data, loading, error }] = useSslCreatePreProgramFeedbackFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSslCreatePreProgramFeedbackFormMutation(baseOptions?: Apollo.MutationHookOptions<SslCreatePreProgramFeedbackFormMutation, SslCreatePreProgramFeedbackFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SslCreatePreProgramFeedbackFormMutation, SslCreatePreProgramFeedbackFormMutationVariables>(SslCreatePreProgramFeedbackFormDocument, options);
      }
export type SslCreatePreProgramFeedbackFormMutationHookResult = ReturnType<typeof useSslCreatePreProgramFeedbackFormMutation>;
export type SslCreatePreProgramFeedbackFormMutationResult = Apollo.MutationResult<SslCreatePreProgramFeedbackFormMutation>;
export type SslCreatePreProgramFeedbackFormMutationOptions = Apollo.BaseMutationOptions<SslCreatePreProgramFeedbackFormMutation, SslCreatePreProgramFeedbackFormMutationVariables>;
export const AllProgramsForSuperAdminDocument = gql`
    query allProgramsForSuperAdmin {
  allProgramsForSuperAdmin {
    ...Program
  }
}
    ${ProgramFragmentDoc}`;

/**
 * __useAllProgramsForSuperAdminQuery__
 *
 * To run a query within a React component, call `useAllProgramsForSuperAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllProgramsForSuperAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllProgramsForSuperAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllProgramsForSuperAdminQuery(baseOptions?: Apollo.QueryHookOptions<AllProgramsForSuperAdminQuery, AllProgramsForSuperAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllProgramsForSuperAdminQuery, AllProgramsForSuperAdminQueryVariables>(AllProgramsForSuperAdminDocument, options);
      }
export function useAllProgramsForSuperAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllProgramsForSuperAdminQuery, AllProgramsForSuperAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllProgramsForSuperAdminQuery, AllProgramsForSuperAdminQueryVariables>(AllProgramsForSuperAdminDocument, options);
        }
export type AllProgramsForSuperAdminQueryHookResult = ReturnType<typeof useAllProgramsForSuperAdminQuery>;
export type AllProgramsForSuperAdminLazyQueryHookResult = ReturnType<typeof useAllProgramsForSuperAdminLazyQuery>;
export type AllProgramsForSuperAdminQueryResult = Apollo.QueryResult<AllProgramsForSuperAdminQuery, AllProgramsForSuperAdminQueryVariables>;
export const GetAllUnitsAndSllLessonsDocument = gql`
    query getAllUnitsAndSLLLessons {
  getAllUnitsAndSLLLessons {
    sllLessons {
      ...SLLLesson
    }
    units {
      ...UnitContent
    }
  }
}
    ${SllLessonFragmentDoc}
${UnitContentFragmentDoc}`;

/**
 * __useGetAllUnitsAndSllLessonsQuery__
 *
 * To run a query within a React component, call `useGetAllUnitsAndSllLessonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUnitsAndSllLessonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUnitsAndSllLessonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllUnitsAndSllLessonsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllUnitsAndSllLessonsQuery, GetAllUnitsAndSllLessonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllUnitsAndSllLessonsQuery, GetAllUnitsAndSllLessonsQueryVariables>(GetAllUnitsAndSllLessonsDocument, options);
      }
export function useGetAllUnitsAndSllLessonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllUnitsAndSllLessonsQuery, GetAllUnitsAndSllLessonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllUnitsAndSllLessonsQuery, GetAllUnitsAndSllLessonsQueryVariables>(GetAllUnitsAndSllLessonsDocument, options);
        }
export type GetAllUnitsAndSllLessonsQueryHookResult = ReturnType<typeof useGetAllUnitsAndSllLessonsQuery>;
export type GetAllUnitsAndSllLessonsLazyQueryHookResult = ReturnType<typeof useGetAllUnitsAndSllLessonsLazyQuery>;
export type GetAllUnitsAndSllLessonsQueryResult = Apollo.QueryResult<GetAllUnitsAndSllLessonsQuery, GetAllUnitsAndSllLessonsQueryVariables>;
export const SaveReelsProgramDocument = gql`
    mutation saveReelsProgram($input: [SaveReelInput!]!) {
  saveReel(input: $input)
}
    `;
export type SaveReelsProgramMutationFn = Apollo.MutationFunction<SaveReelsProgramMutation, SaveReelsProgramMutationVariables>;

/**
 * __useSaveReelsProgramMutation__
 *
 * To run a mutation, you first call `useSaveReelsProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveReelsProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveReelsProgramMutation, { data, loading, error }] = useSaveReelsProgramMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveReelsProgramMutation(baseOptions?: Apollo.MutationHookOptions<SaveReelsProgramMutation, SaveReelsProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveReelsProgramMutation, SaveReelsProgramMutationVariables>(SaveReelsProgramDocument, options);
      }
export type SaveReelsProgramMutationHookResult = ReturnType<typeof useSaveReelsProgramMutation>;
export type SaveReelsProgramMutationResult = Apollo.MutationResult<SaveReelsProgramMutation>;
export type SaveReelsProgramMutationOptions = Apollo.BaseMutationOptions<SaveReelsProgramMutation, SaveReelsProgramMutationVariables>;
export const GetAusCourseDocument = gql`
    query getAUSCourse($input: IDInput!) {
  getAUSCourse(input: $input) {
    id
    country
    courseContents {
      ...AUSCourseContent
    }
    coverVideo
    description
    grade {
      id
      name
      position
    }
    image
    isCustomized
    isParentCourse
    isSpecial
    isTest
    name
    meta
  }
}
    ${AusCourseContentFragmentDoc}`;

/**
 * __useGetAusCourseQuery__
 *
 * To run a query within a React component, call `useGetAusCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAusCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAusCourseQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAusCourseQuery(baseOptions: Apollo.QueryHookOptions<GetAusCourseQuery, GetAusCourseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAusCourseQuery, GetAusCourseQueryVariables>(GetAusCourseDocument, options);
      }
export function useGetAusCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAusCourseQuery, GetAusCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAusCourseQuery, GetAusCourseQueryVariables>(GetAusCourseDocument, options);
        }
export type GetAusCourseQueryHookResult = ReturnType<typeof useGetAusCourseQuery>;
export type GetAusCourseLazyQueryHookResult = ReturnType<typeof useGetAusCourseLazyQuery>;
export type GetAusCourseQueryResult = Apollo.QueryResult<GetAusCourseQuery, GetAusCourseQueryVariables>;
export const GetCourseContentsDocument = gql`
    query getCourseContents($input: IDInput!) {
  getCourseContents(input: $input) {
    primary {
      ...UnitContent
    }
    additional {
      ...UnitContent
    }
  }
}
    ${UnitContentFragmentDoc}`;

/**
 * __useGetCourseContentsQuery__
 *
 * To run a query within a React component, call `useGetCourseContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseContentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCourseContentsQuery(baseOptions: Apollo.QueryHookOptions<GetCourseContentsQuery, GetCourseContentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseContentsQuery, GetCourseContentsQueryVariables>(GetCourseContentsDocument, options);
      }
export function useGetCourseContentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseContentsQuery, GetCourseContentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseContentsQuery, GetCourseContentsQueryVariables>(GetCourseContentsDocument, options);
        }
export type GetCourseContentsQueryHookResult = ReturnType<typeof useGetCourseContentsQuery>;
export type GetCourseContentsLazyQueryHookResult = ReturnType<typeof useGetCourseContentsLazyQuery>;
export type GetCourseContentsQueryResult = Apollo.QueryResult<GetCourseContentsQuery, GetCourseContentsQueryVariables>;
export const GetAusCourseContentsDocument = gql`
    query getAUSCourseContents($input: IDInput!) {
  getAUSCourseContents(input: $input) {
    ...AUSCourseContent
  }
}
    ${AusCourseContentFragmentDoc}`;

/**
 * __useGetAusCourseContentsQuery__
 *
 * To run a query within a React component, call `useGetAusCourseContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAusCourseContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAusCourseContentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAusCourseContentsQuery(baseOptions: Apollo.QueryHookOptions<GetAusCourseContentsQuery, GetAusCourseContentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAusCourseContentsQuery, GetAusCourseContentsQueryVariables>(GetAusCourseContentsDocument, options);
      }
export function useGetAusCourseContentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAusCourseContentsQuery, GetAusCourseContentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAusCourseContentsQuery, GetAusCourseContentsQueryVariables>(GetAusCourseContentsDocument, options);
        }
export type GetAusCourseContentsQueryHookResult = ReturnType<typeof useGetAusCourseContentsQuery>;
export type GetAusCourseContentsLazyQueryHookResult = ReturnType<typeof useGetAusCourseContentsLazyQuery>;
export type GetAusCourseContentsQueryResult = Apollo.QueryResult<GetAusCourseContentsQuery, GetAusCourseContentsQueryVariables>;
export const RegisteredUsersDocument = gql`
    query registeredUsers($input: AnalyticsInput!) {
  registeredUsers(input: $input) {
    items
    result
    total
  }
}
    `;

/**
 * __useRegisteredUsersQuery__
 *
 * To run a query within a React component, call `useRegisteredUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegisteredUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegisteredUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisteredUsersQuery(baseOptions: Apollo.QueryHookOptions<RegisteredUsersQuery, RegisteredUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegisteredUsersQuery, RegisteredUsersQueryVariables>(RegisteredUsersDocument, options);
      }
export function useRegisteredUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegisteredUsersQuery, RegisteredUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegisteredUsersQuery, RegisteredUsersQueryVariables>(RegisteredUsersDocument, options);
        }
export type RegisteredUsersQueryHookResult = ReturnType<typeof useRegisteredUsersQuery>;
export type RegisteredUsersLazyQueryHookResult = ReturnType<typeof useRegisteredUsersLazyQuery>;
export type RegisteredUsersQueryResult = Apollo.QueryResult<RegisteredUsersQuery, RegisteredUsersQueryVariables>;
export const LoginAnalyticsDocument = gql`
    query loginAnalytics($input: AnalyticsInput!) {
  loginAnalytics(input: $input) {
    total {
      items
      count
      data {
        count
        name
      }
    }
    unique {
      items
      count
    }
  }
}
    `;

/**
 * __useLoginAnalyticsQuery__
 *
 * To run a query within a React component, call `useLoginAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginAnalyticsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<LoginAnalyticsQuery, LoginAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoginAnalyticsQuery, LoginAnalyticsQueryVariables>(LoginAnalyticsDocument, options);
      }
export function useLoginAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoginAnalyticsQuery, LoginAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoginAnalyticsQuery, LoginAnalyticsQueryVariables>(LoginAnalyticsDocument, options);
        }
export type LoginAnalyticsQueryHookResult = ReturnType<typeof useLoginAnalyticsQuery>;
export type LoginAnalyticsLazyQueryHookResult = ReturnType<typeof useLoginAnalyticsLazyQuery>;
export type LoginAnalyticsQueryResult = Apollo.QueryResult<LoginAnalyticsQuery, LoginAnalyticsQueryVariables>;
export const LessonsByTeacherDocument = gql`
    query lessonsByTeacher($input: AnalyticsInput!) {
  lessonsByTeacher(input: $input) {
    data {
      teacherName
      schoolName
      engagement
      totalLogins
      totalSessions
      activeSessions
      completedLessons
      lastActiveAt
      lastSessionAt
      timeSpent
      items {
        completedAt
        grade
        lessonId
        lessonName
        lessonType
        lessonPosition
        type
        unitName
      }
    }
    total
    totalTimeSpent
  }
}
    `;

/**
 * __useLessonsByTeacherQuery__
 *
 * To run a query within a React component, call `useLessonsByTeacherQuery` and pass it any options that fit your needs.
 * When your component renders, `useLessonsByTeacherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLessonsByTeacherQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLessonsByTeacherQuery(baseOptions: Apollo.QueryHookOptions<LessonsByTeacherQuery, LessonsByTeacherQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LessonsByTeacherQuery, LessonsByTeacherQueryVariables>(LessonsByTeacherDocument, options);
      }
export function useLessonsByTeacherLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LessonsByTeacherQuery, LessonsByTeacherQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LessonsByTeacherQuery, LessonsByTeacherQueryVariables>(LessonsByTeacherDocument, options);
        }
export type LessonsByTeacherQueryHookResult = ReturnType<typeof useLessonsByTeacherQuery>;
export type LessonsByTeacherLazyQueryHookResult = ReturnType<typeof useLessonsByTeacherLazyQuery>;
export type LessonsByTeacherQueryResult = Apollo.QueryResult<LessonsByTeacherQuery, LessonsByTeacherQueryVariables>;
export const EducatorWellBeingByLessonsDocument = gql`
    query educatorWellBeingByLessons($input: AnalyticsInput!) {
  educatorWellBeingByLessons(input: $input) {
    lessonId
    lessonName
    lessons {
      completedAt
      schoolId
      schoolName
      teacherId
      teacherName
    }
    lessonsCompleted
    progress
  }
}
    `;

/**
 * __useEducatorWellBeingByLessonsQuery__
 *
 * To run a query within a React component, call `useEducatorWellBeingByLessonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEducatorWellBeingByLessonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEducatorWellBeingByLessonsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEducatorWellBeingByLessonsQuery(baseOptions: Apollo.QueryHookOptions<EducatorWellBeingByLessonsQuery, EducatorWellBeingByLessonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EducatorWellBeingByLessonsQuery, EducatorWellBeingByLessonsQueryVariables>(EducatorWellBeingByLessonsDocument, options);
      }
export function useEducatorWellBeingByLessonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EducatorWellBeingByLessonsQuery, EducatorWellBeingByLessonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EducatorWellBeingByLessonsQuery, EducatorWellBeingByLessonsQueryVariables>(EducatorWellBeingByLessonsDocument, options);
        }
export type EducatorWellBeingByLessonsQueryHookResult = ReturnType<typeof useEducatorWellBeingByLessonsQuery>;
export type EducatorWellBeingByLessonsLazyQueryHookResult = ReturnType<typeof useEducatorWellBeingByLessonsLazyQuery>;
export type EducatorWellBeingByLessonsQueryResult = Apollo.QueryResult<EducatorWellBeingByLessonsQuery, EducatorWellBeingByLessonsQueryVariables>;
export const GetPostProgramQuizUnitDocument = gql`
    query getPostProgramQuizUnit {
  getPostProgramQuizUnit {
    ...ExtendedUnit
  }
}
    ${ExtendedUnitFragmentDoc}`;

/**
 * __useGetPostProgramQuizUnitQuery__
 *
 * To run a query within a React component, call `useGetPostProgramQuizUnitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostProgramQuizUnitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostProgramQuizUnitQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPostProgramQuizUnitQuery(baseOptions?: Apollo.QueryHookOptions<GetPostProgramQuizUnitQuery, GetPostProgramQuizUnitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostProgramQuizUnitQuery, GetPostProgramQuizUnitQueryVariables>(GetPostProgramQuizUnitDocument, options);
      }
export function useGetPostProgramQuizUnitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostProgramQuizUnitQuery, GetPostProgramQuizUnitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostProgramQuizUnitQuery, GetPostProgramQuizUnitQueryVariables>(GetPostProgramQuizUnitDocument, options);
        }
export type GetPostProgramQuizUnitQueryHookResult = ReturnType<typeof useGetPostProgramQuizUnitQuery>;
export type GetPostProgramQuizUnitLazyQueryHookResult = ReturnType<typeof useGetPostProgramQuizUnitLazyQuery>;
export type GetPostProgramQuizUnitQueryResult = Apollo.QueryResult<GetPostProgramQuizUnitQuery, GetPostProgramQuizUnitQueryVariables>;
export const GetLessonsByGradeDocument = gql`
    query getLessonsByGrade($input: AnalyticsInput!) {
  lessonsByGrade(input: $input) {
    byCompetency {
      relationshipSkills
      responsibleDecisionMaking
      selfAwareness
      selfManagement
      socialAwareness
    }
    byGrade {
      data {
        ...LessonByCourse
      }
      total
    }
    summary {
      items
      result
      total
    }
  }
}
    ${LessonByCourseFragmentDoc}`;

/**
 * __useGetLessonsByGradeQuery__
 *
 * To run a query within a React component, call `useGetLessonsByGradeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLessonsByGradeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLessonsByGradeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetLessonsByGradeQuery(baseOptions: Apollo.QueryHookOptions<GetLessonsByGradeQuery, GetLessonsByGradeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLessonsByGradeQuery, GetLessonsByGradeQueryVariables>(GetLessonsByGradeDocument, options);
      }
export function useGetLessonsByGradeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLessonsByGradeQuery, GetLessonsByGradeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLessonsByGradeQuery, GetLessonsByGradeQueryVariables>(GetLessonsByGradeDocument, options);
        }
export type GetLessonsByGradeQueryHookResult = ReturnType<typeof useGetLessonsByGradeQuery>;
export type GetLessonsByGradeLazyQueryHookResult = ReturnType<typeof useGetLessonsByGradeLazyQuery>;
export type GetLessonsByGradeQueryResult = Apollo.QueryResult<GetLessonsByGradeQuery, GetLessonsByGradeQueryVariables>;
export const GetSurveySubmittedDocument = gql`
    query getSurveySubmitted($input: AnalyticsInput!) {
  surveySubmitted(input: $input) {
    exitTicket {
      items {
        dateCompleted
        educator
        grade
        lessonName
        responses
        score
      }
      result
      total
    }
    preProgramQuiz {
      items {
        dateCompleted
        educator
        grade
        responses
        score
      }
      result
      total
    }
  }
}
    `;

/**
 * __useGetSurveySubmittedQuery__
 *
 * To run a query within a React component, call `useGetSurveySubmittedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveySubmittedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveySubmittedQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSurveySubmittedQuery(baseOptions: Apollo.QueryHookOptions<GetSurveySubmittedQuery, GetSurveySubmittedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSurveySubmittedQuery, GetSurveySubmittedQueryVariables>(GetSurveySubmittedDocument, options);
      }
export function useGetSurveySubmittedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSurveySubmittedQuery, GetSurveySubmittedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSurveySubmittedQuery, GetSurveySubmittedQueryVariables>(GetSurveySubmittedDocument, options);
        }
export type GetSurveySubmittedQueryHookResult = ReturnType<typeof useGetSurveySubmittedQuery>;
export type GetSurveySubmittedLazyQueryHookResult = ReturnType<typeof useGetSurveySubmittedLazyQuery>;
export type GetSurveySubmittedQueryResult = Apollo.QueryResult<GetSurveySubmittedQuery, GetSurveySubmittedQueryVariables>;
export const DistrictCompetencyRatingDocument = gql`
    query districtCompetencyRating($input: AnalyticsInput!) {
  districtCompetencyRating(input: $input) {
    relationshipSkills
    responsibleDecisionMaking
    selfAwareness
    selfManagement
    socialAwareness
  }
}
    `;

/**
 * __useDistrictCompetencyRatingQuery__
 *
 * To run a query within a React component, call `useDistrictCompetencyRatingQuery` and pass it any options that fit your needs.
 * When your component renders, `useDistrictCompetencyRatingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDistrictCompetencyRatingQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDistrictCompetencyRatingQuery(baseOptions: Apollo.QueryHookOptions<DistrictCompetencyRatingQuery, DistrictCompetencyRatingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DistrictCompetencyRatingQuery, DistrictCompetencyRatingQueryVariables>(DistrictCompetencyRatingDocument, options);
      }
export function useDistrictCompetencyRatingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DistrictCompetencyRatingQuery, DistrictCompetencyRatingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DistrictCompetencyRatingQuery, DistrictCompetencyRatingQueryVariables>(DistrictCompetencyRatingDocument, options);
        }
export type DistrictCompetencyRatingQueryHookResult = ReturnType<typeof useDistrictCompetencyRatingQuery>;
export type DistrictCompetencyRatingLazyQueryHookResult = ReturnType<typeof useDistrictCompetencyRatingLazyQuery>;
export type DistrictCompetencyRatingQueryResult = Apollo.QueryResult<DistrictCompetencyRatingQuery, DistrictCompetencyRatingQueryVariables>;
export const SaveTimeSpentDocument = gql`
    mutation saveTimeSpent($input: TimeSpentInput!) {
  userTimeSpent(input: $input)
}
    `;
export type SaveTimeSpentMutationFn = Apollo.MutationFunction<SaveTimeSpentMutation, SaveTimeSpentMutationVariables>;

/**
 * __useSaveTimeSpentMutation__
 *
 * To run a mutation, you first call `useSaveTimeSpentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTimeSpentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTimeSpentMutation, { data, loading, error }] = useSaveTimeSpentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveTimeSpentMutation(baseOptions?: Apollo.MutationHookOptions<SaveTimeSpentMutation, SaveTimeSpentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTimeSpentMutation, SaveTimeSpentMutationVariables>(SaveTimeSpentDocument, options);
      }
export type SaveTimeSpentMutationHookResult = ReturnType<typeof useSaveTimeSpentMutation>;
export type SaveTimeSpentMutationResult = Apollo.MutationResult<SaveTimeSpentMutation>;
export type SaveTimeSpentMutationOptions = Apollo.BaseMutationOptions<SaveTimeSpentMutation, SaveTimeSpentMutationVariables>;
export const SllGetPopularLessonsDocument = gql`
    query SllGetPopularLessons($input: sllGetPopularLessonsInput) {
  sllGetPopularLessons(input: $input) {
    ...CollectionLesson
  }
}
    ${CollectionLessonFragmentDoc}`;

/**
 * __useSllGetPopularLessonsQuery__
 *
 * To run a query within a React component, call `useSllGetPopularLessonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSllGetPopularLessonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSllGetPopularLessonsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSllGetPopularLessonsQuery(baseOptions?: Apollo.QueryHookOptions<SllGetPopularLessonsQuery, SllGetPopularLessonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SllGetPopularLessonsQuery, SllGetPopularLessonsQueryVariables>(SllGetPopularLessonsDocument, options);
      }
export function useSllGetPopularLessonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SllGetPopularLessonsQuery, SllGetPopularLessonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SllGetPopularLessonsQuery, SllGetPopularLessonsQueryVariables>(SllGetPopularLessonsDocument, options);
        }
export type SllGetPopularLessonsQueryHookResult = ReturnType<typeof useSllGetPopularLessonsQuery>;
export type SllGetPopularLessonsLazyQueryHookResult = ReturnType<typeof useSllGetPopularLessonsLazyQuery>;
export type SllGetPopularLessonsQueryResult = Apollo.QueryResult<SllGetPopularLessonsQuery, SllGetPopularLessonsQueryVariables>;
export const GetAllMultiCollectionsDocument = gql`
    query GetAllMultiCollections($input: GetAllMultiCollectionsInput!) {
  getAllMultiCollections(input: $input) {
    country
    grade
    id
    isScopeAndSeq
    name
    scopeAndSeqId
    type
    collections {
      addlMatBox
      addlMatHeading
      bannerImage
      bannerVideo
      country
      grade
      id
      isSensitive
      name
      requirements
      subHeading
      tags
      unitOvwBox1
      unitOvwBox2
      unitOvwHeading1
      unitOvwHeading2
      sllLessons {
        ...CollectionLesson
      }
    }
  }
}
    ${CollectionLessonFragmentDoc}`;

/**
 * __useGetAllMultiCollectionsQuery__
 *
 * To run a query within a React component, call `useGetAllMultiCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMultiCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMultiCollectionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllMultiCollectionsQuery(baseOptions: Apollo.QueryHookOptions<GetAllMultiCollectionsQuery, GetAllMultiCollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllMultiCollectionsQuery, GetAllMultiCollectionsQueryVariables>(GetAllMultiCollectionsDocument, options);
      }
export function useGetAllMultiCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllMultiCollectionsQuery, GetAllMultiCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllMultiCollectionsQuery, GetAllMultiCollectionsQueryVariables>(GetAllMultiCollectionsDocument, options);
        }
export type GetAllMultiCollectionsQueryHookResult = ReturnType<typeof useGetAllMultiCollectionsQuery>;
export type GetAllMultiCollectionsLazyQueryHookResult = ReturnType<typeof useGetAllMultiCollectionsLazyQuery>;
export type GetAllMultiCollectionsQueryResult = Apollo.QueryResult<GetAllMultiCollectionsQuery, GetAllMultiCollectionsQueryVariables>;
export const GetListNormalMultiCollectionsDocument = gql`
    query GetListNormalMultiCollections($input: ListNormalMultiCollectionsInput!) {
  listNormalMultiCollections(input: $input) {
    ...DefaultMultiCollection
  }
}
    ${DefaultMultiCollectionFragmentDoc}`;

/**
 * __useGetListNormalMultiCollectionsQuery__
 *
 * To run a query within a React component, call `useGetListNormalMultiCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListNormalMultiCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListNormalMultiCollectionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetListNormalMultiCollectionsQuery(baseOptions: Apollo.QueryHookOptions<GetListNormalMultiCollectionsQuery, GetListNormalMultiCollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetListNormalMultiCollectionsQuery, GetListNormalMultiCollectionsQueryVariables>(GetListNormalMultiCollectionsDocument, options);
      }
export function useGetListNormalMultiCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListNormalMultiCollectionsQuery, GetListNormalMultiCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetListNormalMultiCollectionsQuery, GetListNormalMultiCollectionsQueryVariables>(GetListNormalMultiCollectionsDocument, options);
        }
export type GetListNormalMultiCollectionsQueryHookResult = ReturnType<typeof useGetListNormalMultiCollectionsQuery>;
export type GetListNormalMultiCollectionsLazyQueryHookResult = ReturnType<typeof useGetListNormalMultiCollectionsLazyQuery>;
export type GetListNormalMultiCollectionsQueryResult = Apollo.QueryResult<GetListNormalMultiCollectionsQuery, GetListNormalMultiCollectionsQueryVariables>;
export const CreateMultiCollectionDocument = gql`
    mutation CreateMultiCollection($input: CreateMultiCollectionInput!) {
  createMultiCollection(input: $input) {
    ...MultiCollection
  }
}
    ${MultiCollectionFragmentDoc}`;
export type CreateMultiCollectionMutationFn = Apollo.MutationFunction<CreateMultiCollectionMutation, CreateMultiCollectionMutationVariables>;

/**
 * __useCreateMultiCollectionMutation__
 *
 * To run a mutation, you first call `useCreateMultiCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMultiCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMultiCollectionMutation, { data, loading, error }] = useCreateMultiCollectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMultiCollectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateMultiCollectionMutation, CreateMultiCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMultiCollectionMutation, CreateMultiCollectionMutationVariables>(CreateMultiCollectionDocument, options);
      }
export type CreateMultiCollectionMutationHookResult = ReturnType<typeof useCreateMultiCollectionMutation>;
export type CreateMultiCollectionMutationResult = Apollo.MutationResult<CreateMultiCollectionMutation>;
export type CreateMultiCollectionMutationOptions = Apollo.BaseMutationOptions<CreateMultiCollectionMutation, CreateMultiCollectionMutationVariables>;
export const UpdateMultiCollectionDocument = gql`
    mutation UpdateMultiCollection($input: UpdateMultiCollectionInput!) {
  updateMultiCollection(input: $input) {
    ...MultiCollection
  }
}
    ${MultiCollectionFragmentDoc}`;
export type UpdateMultiCollectionMutationFn = Apollo.MutationFunction<UpdateMultiCollectionMutation, UpdateMultiCollectionMutationVariables>;

/**
 * __useUpdateMultiCollectionMutation__
 *
 * To run a mutation, you first call `useUpdateMultiCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMultiCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMultiCollectionMutation, { data, loading, error }] = useUpdateMultiCollectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMultiCollectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMultiCollectionMutation, UpdateMultiCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMultiCollectionMutation, UpdateMultiCollectionMutationVariables>(UpdateMultiCollectionDocument, options);
      }
export type UpdateMultiCollectionMutationHookResult = ReturnType<typeof useUpdateMultiCollectionMutation>;
export type UpdateMultiCollectionMutationResult = Apollo.MutationResult<UpdateMultiCollectionMutation>;
export type UpdateMultiCollectionMutationOptions = Apollo.BaseMutationOptions<UpdateMultiCollectionMutation, UpdateMultiCollectionMutationVariables>;
export const DeleteMultiCollectionDocument = gql`
    mutation DeleteMultiCollection($input: IDInput!) {
  deleteMultiCollection(input: $input)
}
    `;
export type DeleteMultiCollectionMutationFn = Apollo.MutationFunction<DeleteMultiCollectionMutation, DeleteMultiCollectionMutationVariables>;

/**
 * __useDeleteMultiCollectionMutation__
 *
 * To run a mutation, you first call `useDeleteMultiCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMultiCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMultiCollectionMutation, { data, loading, error }] = useDeleteMultiCollectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteMultiCollectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMultiCollectionMutation, DeleteMultiCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMultiCollectionMutation, DeleteMultiCollectionMutationVariables>(DeleteMultiCollectionDocument, options);
      }
export type DeleteMultiCollectionMutationHookResult = ReturnType<typeof useDeleteMultiCollectionMutation>;
export type DeleteMultiCollectionMutationResult = Apollo.MutationResult<DeleteMultiCollectionMutation>;
export type DeleteMultiCollectionMutationOptions = Apollo.BaseMutationOptions<DeleteMultiCollectionMutation, DeleteMultiCollectionMutationVariables>;
export const SaveMultiCollectionsDocument = gql`
    mutation SaveMultiCollections($input: [SaveMultiCollectionsInput!]!) {
  saveMultiCollections(input: $input)
}
    `;
export type SaveMultiCollectionsMutationFn = Apollo.MutationFunction<SaveMultiCollectionsMutation, SaveMultiCollectionsMutationVariables>;

/**
 * __useSaveMultiCollectionsMutation__
 *
 * To run a mutation, you first call `useSaveMultiCollectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMultiCollectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMultiCollectionsMutation, { data, loading, error }] = useSaveMultiCollectionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveMultiCollectionsMutation(baseOptions?: Apollo.MutationHookOptions<SaveMultiCollectionsMutation, SaveMultiCollectionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveMultiCollectionsMutation, SaveMultiCollectionsMutationVariables>(SaveMultiCollectionsDocument, options);
      }
export type SaveMultiCollectionsMutationHookResult = ReturnType<typeof useSaveMultiCollectionsMutation>;
export type SaveMultiCollectionsMutationResult = Apollo.MutationResult<SaveMultiCollectionsMutation>;
export type SaveMultiCollectionsMutationOptions = Apollo.BaseMutationOptions<SaveMultiCollectionsMutation, SaveMultiCollectionsMutationVariables>;
export const GetMultiCollectionDocument = gql`
    query GetMultiCollection($input: IDInput!) {
  getMultiCollection(input: $input) {
    ...NormalMultiCollection
  }
}
    ${NormalMultiCollectionFragmentDoc}`;

/**
 * __useGetMultiCollectionQuery__
 *
 * To run a query within a React component, call `useGetMultiCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMultiCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMultiCollectionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMultiCollectionQuery(baseOptions: Apollo.QueryHookOptions<GetMultiCollectionQuery, GetMultiCollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMultiCollectionQuery, GetMultiCollectionQueryVariables>(GetMultiCollectionDocument, options);
      }
export function useGetMultiCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMultiCollectionQuery, GetMultiCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMultiCollectionQuery, GetMultiCollectionQueryVariables>(GetMultiCollectionDocument, options);
        }
export type GetMultiCollectionQueryHookResult = ReturnType<typeof useGetMultiCollectionQuery>;
export type GetMultiCollectionLazyQueryHookResult = ReturnType<typeof useGetMultiCollectionLazyQuery>;
export type GetMultiCollectionQueryResult = Apollo.QueryResult<GetMultiCollectionQuery, GetMultiCollectionQueryVariables>;
export const GetMultiCollectionsDocument = gql`
    query GetMultiCollections($input: IDsInput!) {
  getMultiCollections(input: $input) {
    ...NormalMultiCollection
  }
}
    ${NormalMultiCollectionFragmentDoc}`;

/**
 * __useGetMultiCollectionsQuery__
 *
 * To run a query within a React component, call `useGetMultiCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMultiCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMultiCollectionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMultiCollectionsQuery(baseOptions: Apollo.QueryHookOptions<GetMultiCollectionsQuery, GetMultiCollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMultiCollectionsQuery, GetMultiCollectionsQueryVariables>(GetMultiCollectionsDocument, options);
      }
export function useGetMultiCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMultiCollectionsQuery, GetMultiCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMultiCollectionsQuery, GetMultiCollectionsQueryVariables>(GetMultiCollectionsDocument, options);
        }
export type GetMultiCollectionsQueryHookResult = ReturnType<typeof useGetMultiCollectionsQuery>;
export type GetMultiCollectionsLazyQueryHookResult = ReturnType<typeof useGetMultiCollectionsLazyQuery>;
export type GetMultiCollectionsQueryResult = Apollo.QueryResult<GetMultiCollectionsQuery, GetMultiCollectionsQueryVariables>;
export const SearchLessonLibraryDocument = gql`
    query SearchLessonLibrary($input: LessonLibrarySearchInput!) {
  searchLessonLibrary(input: $input) {
    mCollectionId
    mCollectionName
    mIsScopeandSeq
    mScopeAndSeqId
    position
    content {
      id
      name
      competency
      categories
      coverImage
      duration
      mainTopics
      isExtensionAvailable
      lessonType
    }
  }
}
    `;

/**
 * __useSearchLessonLibraryQuery__
 *
 * To run a query within a React component, call `useSearchLessonLibraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchLessonLibraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchLessonLibraryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchLessonLibraryQuery(baseOptions: Apollo.QueryHookOptions<SearchLessonLibraryQuery, SearchLessonLibraryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchLessonLibraryQuery, SearchLessonLibraryQueryVariables>(SearchLessonLibraryDocument, options);
      }
export function useSearchLessonLibraryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchLessonLibraryQuery, SearchLessonLibraryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchLessonLibraryQuery, SearchLessonLibraryQueryVariables>(SearchLessonLibraryDocument, options);
        }
export type SearchLessonLibraryQueryHookResult = ReturnType<typeof useSearchLessonLibraryQuery>;
export type SearchLessonLibraryLazyQueryHookResult = ReturnType<typeof useSearchLessonLibraryLazyQuery>;
export type SearchLessonLibraryQueryResult = Apollo.QueryResult<SearchLessonLibraryQuery, SearchLessonLibraryQueryVariables>;
export const CreateAbsentStudentLessonDocument = gql`
    mutation CreateAbsentStudentLesson($input: AbsentStudentLessonInput!) {
  createAbsentStudentLesson(input: $input) {
    ...AbsentStudentLesson
  }
}
    ${AbsentStudentLessonFragmentDoc}`;
export type CreateAbsentStudentLessonMutationFn = Apollo.MutationFunction<CreateAbsentStudentLessonMutation, CreateAbsentStudentLessonMutationVariables>;

/**
 * __useCreateAbsentStudentLessonMutation__
 *
 * To run a mutation, you first call `useCreateAbsentStudentLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAbsentStudentLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAbsentStudentLessonMutation, { data, loading, error }] = useCreateAbsentStudentLessonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAbsentStudentLessonMutation(baseOptions?: Apollo.MutationHookOptions<CreateAbsentStudentLessonMutation, CreateAbsentStudentLessonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAbsentStudentLessonMutation, CreateAbsentStudentLessonMutationVariables>(CreateAbsentStudentLessonDocument, options);
      }
export type CreateAbsentStudentLessonMutationHookResult = ReturnType<typeof useCreateAbsentStudentLessonMutation>;
export type CreateAbsentStudentLessonMutationResult = Apollo.MutationResult<CreateAbsentStudentLessonMutation>;
export type CreateAbsentStudentLessonMutationOptions = Apollo.BaseMutationOptions<CreateAbsentStudentLessonMutation, CreateAbsentStudentLessonMutationVariables>;
export const GetAbsentStudentLessonDocument = gql`
    query GetAbsentStudentLesson($input: IDInput!) {
  getAbsentStudentLesson(input: $input) {
    ...AbsentStudentLesson
  }
}
    ${AbsentStudentLessonFragmentDoc}`;

/**
 * __useGetAbsentStudentLessonQuery__
 *
 * To run a query within a React component, call `useGetAbsentStudentLessonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAbsentStudentLessonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAbsentStudentLessonQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAbsentStudentLessonQuery(baseOptions: Apollo.QueryHookOptions<GetAbsentStudentLessonQuery, GetAbsentStudentLessonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAbsentStudentLessonQuery, GetAbsentStudentLessonQueryVariables>(GetAbsentStudentLessonDocument, options);
      }
export function useGetAbsentStudentLessonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAbsentStudentLessonQuery, GetAbsentStudentLessonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAbsentStudentLessonQuery, GetAbsentStudentLessonQueryVariables>(GetAbsentStudentLessonDocument, options);
        }
export type GetAbsentStudentLessonQueryHookResult = ReturnType<typeof useGetAbsentStudentLessonQuery>;
export type GetAbsentStudentLessonLazyQueryHookResult = ReturnType<typeof useGetAbsentStudentLessonLazyQuery>;
export type GetAbsentStudentLessonQueryResult = Apollo.QueryResult<GetAbsentStudentLessonQuery, GetAbsentStudentLessonQueryVariables>;
export const CancelAbsentStudentLessonDocument = gql`
    mutation CancelAbsentStudentLesson($input: IDInput!) {
  cancelAbsentStudentLesson(input: $input)
}
    `;
export type CancelAbsentStudentLessonMutationFn = Apollo.MutationFunction<CancelAbsentStudentLessonMutation, CancelAbsentStudentLessonMutationVariables>;

/**
 * __useCancelAbsentStudentLessonMutation__
 *
 * To run a mutation, you first call `useCancelAbsentStudentLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelAbsentStudentLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelAbsentStudentLessonMutation, { data, loading, error }] = useCancelAbsentStudentLessonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelAbsentStudentLessonMutation(baseOptions?: Apollo.MutationHookOptions<CancelAbsentStudentLessonMutation, CancelAbsentStudentLessonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelAbsentStudentLessonMutation, CancelAbsentStudentLessonMutationVariables>(CancelAbsentStudentLessonDocument, options);
      }
export type CancelAbsentStudentLessonMutationHookResult = ReturnType<typeof useCancelAbsentStudentLessonMutation>;
export type CancelAbsentStudentLessonMutationResult = Apollo.MutationResult<CancelAbsentStudentLessonMutation>;
export type CancelAbsentStudentLessonMutationOptions = Apollo.BaseMutationOptions<CancelAbsentStudentLessonMutation, CancelAbsentStudentLessonMutationVariables>;
export const GetLessonInfoByLinkDocument = gql`
    query getLessonInfoByLink($input: AbsentStudentLessonByLinkInput!) {
  getLessonInfoByLink(input: $input) {
    ...Lesson
  }
}
    ${LessonFragmentDoc}`;

/**
 * __useGetLessonInfoByLinkQuery__
 *
 * To run a query within a React component, call `useGetLessonInfoByLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLessonInfoByLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLessonInfoByLinkQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetLessonInfoByLinkQuery(baseOptions: Apollo.QueryHookOptions<GetLessonInfoByLinkQuery, GetLessonInfoByLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLessonInfoByLinkQuery, GetLessonInfoByLinkQueryVariables>(GetLessonInfoByLinkDocument, options);
      }
export function useGetLessonInfoByLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLessonInfoByLinkQuery, GetLessonInfoByLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLessonInfoByLinkQuery, GetLessonInfoByLinkQueryVariables>(GetLessonInfoByLinkDocument, options);
        }
export type GetLessonInfoByLinkQueryHookResult = ReturnType<typeof useGetLessonInfoByLinkQuery>;
export type GetLessonInfoByLinkLazyQueryHookResult = ReturnType<typeof useGetLessonInfoByLinkLazyQuery>;
export type GetLessonInfoByLinkQueryResult = Apollo.QueryResult<GetLessonInfoByLinkQuery, GetLessonInfoByLinkQueryVariables>;
export const GetSllLessonInfoByLinkDocument = gql`
    query getSllLessonInfoByLink($input: AbsentStudentLessonByLinkInput!) {
  getSllLessonInfoByLink(input: $input) {
    ...SLLLesson
  }
}
    ${SllLessonFragmentDoc}`;

/**
 * __useGetSllLessonInfoByLinkQuery__
 *
 * To run a query within a React component, call `useGetSllLessonInfoByLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSllLessonInfoByLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSllLessonInfoByLinkQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSllLessonInfoByLinkQuery(baseOptions: Apollo.QueryHookOptions<GetSllLessonInfoByLinkQuery, GetSllLessonInfoByLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSllLessonInfoByLinkQuery, GetSllLessonInfoByLinkQueryVariables>(GetSllLessonInfoByLinkDocument, options);
      }
export function useGetSllLessonInfoByLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSllLessonInfoByLinkQuery, GetSllLessonInfoByLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSllLessonInfoByLinkQuery, GetSllLessonInfoByLinkQueryVariables>(GetSllLessonInfoByLinkDocument, options);
        }
export type GetSllLessonInfoByLinkQueryHookResult = ReturnType<typeof useGetSllLessonInfoByLinkQuery>;
export type GetSllLessonInfoByLinkLazyQueryHookResult = ReturnType<typeof useGetSllLessonInfoByLinkLazyQuery>;
export type GetSllLessonInfoByLinkQueryResult = Apollo.QueryResult<GetSllLessonInfoByLinkQuery, GetSllLessonInfoByLinkQueryVariables>;
export const UpdateMeDocument = gql`
    mutation UpdateMe($input: UserUpdateInput!) {
  updateMe(userInput: $input)
}
    `;
export type UpdateMeMutationFn = Apollo.MutationFunction<UpdateMeMutation, UpdateMeMutationVariables>;

/**
 * __useUpdateMeMutation__
 *
 * To run a mutation, you first call `useUpdateMeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeMutation, { data, loading, error }] = useUpdateMeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMeMutation, UpdateMeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMeMutation, UpdateMeMutationVariables>(UpdateMeDocument, options);
      }
export type UpdateMeMutationHookResult = ReturnType<typeof useUpdateMeMutation>;
export type UpdateMeMutationResult = Apollo.MutationResult<UpdateMeMutation>;
export type UpdateMeMutationOptions = Apollo.BaseMutationOptions<UpdateMeMutation, UpdateMeMutationVariables>;
export const EducatorResilientClassroomByLessonsDocument = gql`
    query educatorResilientClassroomByLessons($input: AnalyticsInput!) {
  educatorResilientClassroomByLessons(input: $input) {
    lessonId
    lessonName
    lessons {
      completedAt
      schoolId
      schoolName
      teacherId
      teacherName
    }
    lessonsCompleted
    progress
  }
}
    `;

/**
 * __useEducatorResilientClassroomByLessonsQuery__
 *
 * To run a query within a React component, call `useEducatorResilientClassroomByLessonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEducatorResilientClassroomByLessonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEducatorResilientClassroomByLessonsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEducatorResilientClassroomByLessonsQuery(baseOptions: Apollo.QueryHookOptions<EducatorResilientClassroomByLessonsQuery, EducatorResilientClassroomByLessonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EducatorResilientClassroomByLessonsQuery, EducatorResilientClassroomByLessonsQueryVariables>(EducatorResilientClassroomByLessonsDocument, options);
      }
export function useEducatorResilientClassroomByLessonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EducatorResilientClassroomByLessonsQuery, EducatorResilientClassroomByLessonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EducatorResilientClassroomByLessonsQuery, EducatorResilientClassroomByLessonsQueryVariables>(EducatorResilientClassroomByLessonsDocument, options);
        }
export type EducatorResilientClassroomByLessonsQueryHookResult = ReturnType<typeof useEducatorResilientClassroomByLessonsQuery>;
export type EducatorResilientClassroomByLessonsLazyQueryHookResult = ReturnType<typeof useEducatorResilientClassroomByLessonsLazyQuery>;
export type EducatorResilientClassroomByLessonsQueryResult = Apollo.QueryResult<EducatorResilientClassroomByLessonsQuery, EducatorResilientClassroomByLessonsQueryVariables>;
export const SubmitFeedbackFormAnswerForAbsentDocument = gql`
    mutation submitFeedbackFormAnswerForAbsent($input: FeedbackFormAnswerForAbsentInput!) {
  submitFeedbackFormAnswerForAbsent(input: $input) {
    id
    formId
    formData
    createdAt
  }
}
    `;
export type SubmitFeedbackFormAnswerForAbsentMutationFn = Apollo.MutationFunction<SubmitFeedbackFormAnswerForAbsentMutation, SubmitFeedbackFormAnswerForAbsentMutationVariables>;

/**
 * __useSubmitFeedbackFormAnswerForAbsentMutation__
 *
 * To run a mutation, you first call `useSubmitFeedbackFormAnswerForAbsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitFeedbackFormAnswerForAbsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitFeedbackFormAnswerForAbsentMutation, { data, loading, error }] = useSubmitFeedbackFormAnswerForAbsentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitFeedbackFormAnswerForAbsentMutation(baseOptions?: Apollo.MutationHookOptions<SubmitFeedbackFormAnswerForAbsentMutation, SubmitFeedbackFormAnswerForAbsentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitFeedbackFormAnswerForAbsentMutation, SubmitFeedbackFormAnswerForAbsentMutationVariables>(SubmitFeedbackFormAnswerForAbsentDocument, options);
      }
export type SubmitFeedbackFormAnswerForAbsentMutationHookResult = ReturnType<typeof useSubmitFeedbackFormAnswerForAbsentMutation>;
export type SubmitFeedbackFormAnswerForAbsentMutationResult = Apollo.MutationResult<SubmitFeedbackFormAnswerForAbsentMutation>;
export type SubmitFeedbackFormAnswerForAbsentMutationOptions = Apollo.BaseMutationOptions<SubmitFeedbackFormAnswerForAbsentMutation, SubmitFeedbackFormAnswerForAbsentMutationVariables>;
export const DistrictAdminInviteUsersDocument = gql`
    mutation districtAdminInviteUsers($input: [DistrictAdminBulkInviteUserInput]) {
  districtAdminInviteUsers(input: $input) {
    id
    firstName
    lastName
    email
  }
}
    `;
export type DistrictAdminInviteUsersMutationFn = Apollo.MutationFunction<DistrictAdminInviteUsersMutation, DistrictAdminInviteUsersMutationVariables>;

/**
 * __useDistrictAdminInviteUsersMutation__
 *
 * To run a mutation, you first call `useDistrictAdminInviteUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDistrictAdminInviteUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [districtAdminInviteUsersMutation, { data, loading, error }] = useDistrictAdminInviteUsersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDistrictAdminInviteUsersMutation(baseOptions?: Apollo.MutationHookOptions<DistrictAdminInviteUsersMutation, DistrictAdminInviteUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DistrictAdminInviteUsersMutation, DistrictAdminInviteUsersMutationVariables>(DistrictAdminInviteUsersDocument, options);
      }
export type DistrictAdminInviteUsersMutationHookResult = ReturnType<typeof useDistrictAdminInviteUsersMutation>;
export type DistrictAdminInviteUsersMutationResult = Apollo.MutationResult<DistrictAdminInviteUsersMutation>;
export type DistrictAdminInviteUsersMutationOptions = Apollo.BaseMutationOptions<DistrictAdminInviteUsersMutation, DistrictAdminInviteUsersMutationVariables>;
export const ConvertTextToAudioDocument = gql`
    mutation convertTextToAudio($text: String!, $isAU: Boolean) {
  convertTextToAudio(text: $text, isAU: $isAU)
}
    `;
export type ConvertTextToAudioMutationFn = Apollo.MutationFunction<ConvertTextToAudioMutation, ConvertTextToAudioMutationVariables>;

/**
 * __useConvertTextToAudioMutation__
 *
 * To run a mutation, you first call `useConvertTextToAudioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConvertTextToAudioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [convertTextToAudioMutation, { data, loading, error }] = useConvertTextToAudioMutation({
 *   variables: {
 *      text: // value for 'text'
 *      isAU: // value for 'isAU'
 *   },
 * });
 */
export function useConvertTextToAudioMutation(baseOptions?: Apollo.MutationHookOptions<ConvertTextToAudioMutation, ConvertTextToAudioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConvertTextToAudioMutation, ConvertTextToAudioMutationVariables>(ConvertTextToAudioDocument, options);
      }
export type ConvertTextToAudioMutationHookResult = ReturnType<typeof useConvertTextToAudioMutation>;
export type ConvertTextToAudioMutationResult = Apollo.MutationResult<ConvertTextToAudioMutation>;
export type ConvertTextToAudioMutationOptions = Apollo.BaseMutationOptions<ConvertTextToAudioMutation, ConvertTextToAudioMutationVariables>;
export const GetProgramsDocument = gql`
    query getPrograms {
  getPrograms {
    ...SLLProgram
  }
}
    ${SllProgramFragmentDoc}`;

/**
 * __useGetProgramsQuery__
 *
 * To run a query within a React component, call `useGetProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProgramsQuery(baseOptions?: Apollo.QueryHookOptions<GetProgramsQuery, GetProgramsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProgramsQuery, GetProgramsQueryVariables>(GetProgramsDocument, options);
      }
export function useGetProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProgramsQuery, GetProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProgramsQuery, GetProgramsQueryVariables>(GetProgramsDocument, options);
        }
export type GetProgramsQueryHookResult = ReturnType<typeof useGetProgramsQuery>;
export type GetProgramsLazyQueryHookResult = ReturnType<typeof useGetProgramsLazyQuery>;
export type GetProgramsQueryResult = Apollo.QueryResult<GetProgramsQuery, GetProgramsQueryVariables>;
export const CreateSllProgramDocument = gql`
    mutation CreateSllProgram($input: SLLCreateProgramInput!) {
  sllCreateProgram(input: $input) {
    ...SLLProgram
  }
}
    ${SllProgramFragmentDoc}`;
export type CreateSllProgramMutationFn = Apollo.MutationFunction<CreateSllProgramMutation, CreateSllProgramMutationVariables>;

/**
 * __useCreateSllProgramMutation__
 *
 * To run a mutation, you first call `useCreateSllProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSllProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSllProgramMutation, { data, loading, error }] = useCreateSllProgramMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSllProgramMutation(baseOptions?: Apollo.MutationHookOptions<CreateSllProgramMutation, CreateSllProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSllProgramMutation, CreateSllProgramMutationVariables>(CreateSllProgramDocument, options);
      }
export type CreateSllProgramMutationHookResult = ReturnType<typeof useCreateSllProgramMutation>;
export type CreateSllProgramMutationResult = Apollo.MutationResult<CreateSllProgramMutation>;
export type CreateSllProgramMutationOptions = Apollo.BaseMutationOptions<CreateSllProgramMutation, CreateSllProgramMutationVariables>;
export const UpdateSllProgramDocument = gql`
    mutation UpdateSllProgram($input: SLLUpdateProgramInput!) {
  sllUpdateProgram(input: $input) {
    ...SLLProgram
  }
}
    ${SllProgramFragmentDoc}`;
export type UpdateSllProgramMutationFn = Apollo.MutationFunction<UpdateSllProgramMutation, UpdateSllProgramMutationVariables>;

/**
 * __useUpdateSllProgramMutation__
 *
 * To run a mutation, you first call `useUpdateSllProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSllProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSllProgramMutation, { data, loading, error }] = useUpdateSllProgramMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSllProgramMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSllProgramMutation, UpdateSllProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSllProgramMutation, UpdateSllProgramMutationVariables>(UpdateSllProgramDocument, options);
      }
export type UpdateSllProgramMutationHookResult = ReturnType<typeof useUpdateSllProgramMutation>;
export type UpdateSllProgramMutationResult = Apollo.MutationResult<UpdateSllProgramMutation>;
export type UpdateSllProgramMutationOptions = Apollo.BaseMutationOptions<UpdateSllProgramMutation, UpdateSllProgramMutationVariables>;
export const DeleteSllProgramDocument = gql`
    mutation DeleteSllProgram($input: IDInput!) {
  sllDeleteProgram(input: $input)
}
    `;
export type DeleteSllProgramMutationFn = Apollo.MutationFunction<DeleteSllProgramMutation, DeleteSllProgramMutationVariables>;

/**
 * __useDeleteSllProgramMutation__
 *
 * To run a mutation, you first call `useDeleteSllProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSllProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSllProgramMutation, { data, loading, error }] = useDeleteSllProgramMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSllProgramMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSllProgramMutation, DeleteSllProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSllProgramMutation, DeleteSllProgramMutationVariables>(DeleteSllProgramDocument, options);
      }
export type DeleteSllProgramMutationHookResult = ReturnType<typeof useDeleteSllProgramMutation>;
export type DeleteSllProgramMutationResult = Apollo.MutationResult<DeleteSllProgramMutation>;
export type DeleteSllProgramMutationOptions = Apollo.BaseMutationOptions<DeleteSllProgramMutation, DeleteSllProgramMutationVariables>;
export const AddMcToProgramDocument = gql`
    mutation AddMCToProgram($input: AddMCToProgramInput!) {
  addMCToProgram(input: $input)
}
    `;
export type AddMcToProgramMutationFn = Apollo.MutationFunction<AddMcToProgramMutation, AddMcToProgramMutationVariables>;

/**
 * __useAddMcToProgramMutation__
 *
 * To run a mutation, you first call `useAddMcToProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMcToProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMcToProgramMutation, { data, loading, error }] = useAddMcToProgramMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMcToProgramMutation(baseOptions?: Apollo.MutationHookOptions<AddMcToProgramMutation, AddMcToProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMcToProgramMutation, AddMcToProgramMutationVariables>(AddMcToProgramDocument, options);
      }
export type AddMcToProgramMutationHookResult = ReturnType<typeof useAddMcToProgramMutation>;
export type AddMcToProgramMutationResult = Apollo.MutationResult<AddMcToProgramMutation>;
export type AddMcToProgramMutationOptions = Apollo.BaseMutationOptions<AddMcToProgramMutation, AddMcToProgramMutationVariables>;
export const RemoveMcFromProgramDocument = gql`
    mutation RemoveMCFromProgram($input: RemoveMCFromProgramInput!) {
  removeMCFromProgram(input: $input)
}
    `;
export type RemoveMcFromProgramMutationFn = Apollo.MutationFunction<RemoveMcFromProgramMutation, RemoveMcFromProgramMutationVariables>;

/**
 * __useRemoveMcFromProgramMutation__
 *
 * To run a mutation, you first call `useRemoveMcFromProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMcFromProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMcFromProgramMutation, { data, loading, error }] = useRemoveMcFromProgramMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveMcFromProgramMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMcFromProgramMutation, RemoveMcFromProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMcFromProgramMutation, RemoveMcFromProgramMutationVariables>(RemoveMcFromProgramDocument, options);
      }
export type RemoveMcFromProgramMutationHookResult = ReturnType<typeof useRemoveMcFromProgramMutation>;
export type RemoveMcFromProgramMutationResult = Apollo.MutationResult<RemoveMcFromProgramMutation>;
export type RemoveMcFromProgramMutationOptions = Apollo.BaseMutationOptions<RemoveMcFromProgramMutation, RemoveMcFromProgramMutationVariables>;
export const GetListMultiCollectionsDocument = gql`
    query GetListMultiCollections($input: ListNormalMultiCollectionsInput!) {
  listNormalMultiCollections(input: $input) {
    ...SimpleMultiCollection
  }
}
    ${SimpleMultiCollectionFragmentDoc}`;

/**
 * __useGetListMultiCollectionsQuery__
 *
 * To run a query within a React component, call `useGetListMultiCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListMultiCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListMultiCollectionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetListMultiCollectionsQuery(baseOptions: Apollo.QueryHookOptions<GetListMultiCollectionsQuery, GetListMultiCollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetListMultiCollectionsQuery, GetListMultiCollectionsQueryVariables>(GetListMultiCollectionsDocument, options);
      }
export function useGetListMultiCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListMultiCollectionsQuery, GetListMultiCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetListMultiCollectionsQuery, GetListMultiCollectionsQueryVariables>(GetListMultiCollectionsDocument, options);
        }
export type GetListMultiCollectionsQueryHookResult = ReturnType<typeof useGetListMultiCollectionsQuery>;
export type GetListMultiCollectionsLazyQueryHookResult = ReturnType<typeof useGetListMultiCollectionsLazyQuery>;
export type GetListMultiCollectionsQueryResult = Apollo.QueryResult<GetListMultiCollectionsQuery, GetListMultiCollectionsQueryVariables>;
export const GetProgramDocument = gql`
    query getProgram($input: IDInput!) {
  getProgram(input: $input) {
    ...SLLProgram
  }
}
    ${SllProgramFragmentDoc}`;

/**
 * __useGetProgramQuery__
 *
 * To run a query within a React component, call `useGetProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetProgramQuery(baseOptions: Apollo.QueryHookOptions<GetProgramQuery, GetProgramQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProgramQuery, GetProgramQueryVariables>(GetProgramDocument, options);
      }
export function useGetProgramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProgramQuery, GetProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProgramQuery, GetProgramQueryVariables>(GetProgramDocument, options);
        }
export type GetProgramQueryHookResult = ReturnType<typeof useGetProgramQuery>;
export type GetProgramLazyQueryHookResult = ReturnType<typeof useGetProgramLazyQuery>;
export type GetProgramQueryResult = Apollo.QueryResult<GetProgramQuery, GetProgramQueryVariables>;
export const UploadZipSlideDocument = gql`
    mutation uploadZIPSlide($input: UploadZIPSlideInput!) {
  uploadZIPSlide(input: $input)
}
    `;
export type UploadZipSlideMutationFn = Apollo.MutationFunction<UploadZipSlideMutation, UploadZipSlideMutationVariables>;

/**
 * __useUploadZipSlideMutation__
 *
 * To run a mutation, you first call `useUploadZipSlideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadZipSlideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadZipSlideMutation, { data, loading, error }] = useUploadZipSlideMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadZipSlideMutation(baseOptions?: Apollo.MutationHookOptions<UploadZipSlideMutation, UploadZipSlideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadZipSlideMutation, UploadZipSlideMutationVariables>(UploadZipSlideDocument, options);
      }
export type UploadZipSlideMutationHookResult = ReturnType<typeof useUploadZipSlideMutation>;
export type UploadZipSlideMutationResult = Apollo.MutationResult<UploadZipSlideMutation>;
export type UploadZipSlideMutationOptions = Apollo.BaseMutationOptions<UploadZipSlideMutation, UploadZipSlideMutationVariables>;
export const GetZipSlideUrlDocument = gql`
    query getZIPSlideUrl($id: ID!, $isCourse: Boolean, $isHomeEd: Boolean, $groupId: ID) {
  getZIPSlideUrl(
    id: $id
    isCourse: $isCourse
    isHomeEd: $isHomeEd
    groupId: $groupId
  )
}
    `;

/**
 * __useGetZipSlideUrlQuery__
 *
 * To run a query within a React component, call `useGetZipSlideUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetZipSlideUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetZipSlideUrlQuery({
 *   variables: {
 *      id: // value for 'id'
 *      isCourse: // value for 'isCourse'
 *      isHomeEd: // value for 'isHomeEd'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetZipSlideUrlQuery(baseOptions: Apollo.QueryHookOptions<GetZipSlideUrlQuery, GetZipSlideUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetZipSlideUrlQuery, GetZipSlideUrlQueryVariables>(GetZipSlideUrlDocument, options);
      }
export function useGetZipSlideUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetZipSlideUrlQuery, GetZipSlideUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetZipSlideUrlQuery, GetZipSlideUrlQueryVariables>(GetZipSlideUrlDocument, options);
        }
export type GetZipSlideUrlQueryHookResult = ReturnType<typeof useGetZipSlideUrlQuery>;
export type GetZipSlideUrlLazyQueryHookResult = ReturnType<typeof useGetZipSlideUrlLazyQuery>;
export type GetZipSlideUrlQueryResult = Apollo.QueryResult<GetZipSlideUrlQuery, GetZipSlideUrlQueryVariables>;
export const DeleteAccountDocument = gql`
    mutation deleteAccount($input: UserIDInput!) {
  deleteAccount(input: $input)
}
    `;
export type DeleteAccountMutationFn = Apollo.MutationFunction<DeleteAccountMutation, DeleteAccountMutationVariables>;

/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountMutation, { data, loading, error }] = useDeleteAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccountMutation, DeleteAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccountMutation, DeleteAccountMutationVariables>(DeleteAccountDocument, options);
      }
export type DeleteAccountMutationHookResult = ReturnType<typeof useDeleteAccountMutation>;
export type DeleteAccountMutationResult = Apollo.MutationResult<DeleteAccountMutation>;
export type DeleteAccountMutationOptions = Apollo.BaseMutationOptions<DeleteAccountMutation, DeleteAccountMutationVariables>;
export const DeleteSchoolDocument = gql`
    mutation deleteSchool($input: UserIDInput!) {
  deleteSchool(input: $input)
}
    `;
export type DeleteSchoolMutationFn = Apollo.MutationFunction<DeleteSchoolMutation, DeleteSchoolMutationVariables>;

/**
 * __useDeleteSchoolMutation__
 *
 * To run a mutation, you first call `useDeleteSchoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSchoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSchoolMutation, { data, loading, error }] = useDeleteSchoolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSchoolMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSchoolMutation, DeleteSchoolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSchoolMutation, DeleteSchoolMutationVariables>(DeleteSchoolDocument, options);
      }
export type DeleteSchoolMutationHookResult = ReturnType<typeof useDeleteSchoolMutation>;
export type DeleteSchoolMutationResult = Apollo.MutationResult<DeleteSchoolMutation>;
export type DeleteSchoolMutationOptions = Apollo.BaseMutationOptions<DeleteSchoolMutation, DeleteSchoolMutationVariables>;
export const GenerateAwsKeysDocument = gql`
    mutation generateAWSKeys {
  generateAWSKeys {
    AccessKeyId
    SecretKey
    SessionToken
    Expiration
  }
}
    `;
export type GenerateAwsKeysMutationFn = Apollo.MutationFunction<GenerateAwsKeysMutation, GenerateAwsKeysMutationVariables>;

/**
 * __useGenerateAwsKeysMutation__
 *
 * To run a mutation, you first call `useGenerateAwsKeysMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAwsKeysMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateAwsKeysMutation, { data, loading, error }] = useGenerateAwsKeysMutation({
 *   variables: {
 *   },
 * });
 */
export function useGenerateAwsKeysMutation(baseOptions?: Apollo.MutationHookOptions<GenerateAwsKeysMutation, GenerateAwsKeysMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateAwsKeysMutation, GenerateAwsKeysMutationVariables>(GenerateAwsKeysDocument, options);
      }
export type GenerateAwsKeysMutationHookResult = ReturnType<typeof useGenerateAwsKeysMutation>;
export type GenerateAwsKeysMutationResult = Apollo.MutationResult<GenerateAwsKeysMutation>;
export type GenerateAwsKeysMutationOptions = Apollo.BaseMutationOptions<GenerateAwsKeysMutation, GenerateAwsKeysMutationVariables>;
export const AddUrlToAirtableDocument = gql`
    mutation AddUrlToAirtable($urls: [String!]!) {
  addUrlToAirtable(urls: $urls)
}
    `;
export type AddUrlToAirtableMutationFn = Apollo.MutationFunction<AddUrlToAirtableMutation, AddUrlToAirtableMutationVariables>;

/**
 * __useAddUrlToAirtableMutation__
 *
 * To run a mutation, you first call `useAddUrlToAirtableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUrlToAirtableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUrlToAirtableMutation, { data, loading, error }] = useAddUrlToAirtableMutation({
 *   variables: {
 *      urls: // value for 'urls'
 *   },
 * });
 */
export function useAddUrlToAirtableMutation(baseOptions?: Apollo.MutationHookOptions<AddUrlToAirtableMutation, AddUrlToAirtableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUrlToAirtableMutation, AddUrlToAirtableMutationVariables>(AddUrlToAirtableDocument, options);
      }
export type AddUrlToAirtableMutationHookResult = ReturnType<typeof useAddUrlToAirtableMutation>;
export type AddUrlToAirtableMutationResult = Apollo.MutationResult<AddUrlToAirtableMutation>;
export type AddUrlToAirtableMutationOptions = Apollo.BaseMutationOptions<AddUrlToAirtableMutation, AddUrlToAirtableMutationVariables>;
export const AiSearchLessonLibraryDocument = gql`
    query AiSearchLessonLibrary($input: AiLessonLibrarySearchInput!) {
  aiSearchLessonLibrary(input: $input) {
    mCollectionId
    mCollectionName
    mIsScopeandSeq
    mScopeAndSeqId
    position
    content {
      id
      name
      competency
      categories
      coverImage
      duration
      mainTopics
      isExtensionAvailable
      lessonType
    }
  }
}
    `;

/**
 * __useAiSearchLessonLibraryQuery__
 *
 * To run a query within a React component, call `useAiSearchLessonLibraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiSearchLessonLibraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiSearchLessonLibraryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAiSearchLessonLibraryQuery(baseOptions: Apollo.QueryHookOptions<AiSearchLessonLibraryQuery, AiSearchLessonLibraryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AiSearchLessonLibraryQuery, AiSearchLessonLibraryQueryVariables>(AiSearchLessonLibraryDocument, options);
      }
export function useAiSearchLessonLibraryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AiSearchLessonLibraryQuery, AiSearchLessonLibraryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AiSearchLessonLibraryQuery, AiSearchLessonLibraryQueryVariables>(AiSearchLessonLibraryDocument, options);
        }
export type AiSearchLessonLibraryQueryHookResult = ReturnType<typeof useAiSearchLessonLibraryQuery>;
export type AiSearchLessonLibraryLazyQueryHookResult = ReturnType<typeof useAiSearchLessonLibraryLazyQuery>;
export type AiSearchLessonLibraryQueryResult = Apollo.QueryResult<AiSearchLessonLibraryQuery, AiSearchLessonLibraryQueryVariables>;
export const AiLessonChatDocument = gql`
    mutation AiLessonChat($input: AiLessonChatInput!) {
  aiLessonChat(input: $input) {
    answer
    sources {
      namespace
      name
    }
    lessons {
      ...AiSearchLessonCard
    }
  }
}
    ${AiSearchLessonCardFragmentDoc}`;
export type AiLessonChatMutationFn = Apollo.MutationFunction<AiLessonChatMutation, AiLessonChatMutationVariables>;

/**
 * __useAiLessonChatMutation__
 *
 * To run a mutation, you first call `useAiLessonChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiLessonChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiLessonChatMutation, { data, loading, error }] = useAiLessonChatMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAiLessonChatMutation(baseOptions?: Apollo.MutationHookOptions<AiLessonChatMutation, AiLessonChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AiLessonChatMutation, AiLessonChatMutationVariables>(AiLessonChatDocument, options);
      }
export type AiLessonChatMutationHookResult = ReturnType<typeof useAiLessonChatMutation>;
export type AiLessonChatMutationResult = Apollo.MutationResult<AiLessonChatMutation>;
export type AiLessonChatMutationOptions = Apollo.BaseMutationOptions<AiLessonChatMutation, AiLessonChatMutationVariables>;
export const GetSupportedLanguagesDocument = gql`
    query GetSupportedLanguages {
  supportedLanguages
}
    `;

/**
 * __useGetSupportedLanguagesQuery__
 *
 * To run a query within a React component, call `useGetSupportedLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupportedLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupportedLanguagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSupportedLanguagesQuery(baseOptions?: Apollo.QueryHookOptions<GetSupportedLanguagesQuery, GetSupportedLanguagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSupportedLanguagesQuery, GetSupportedLanguagesQueryVariables>(GetSupportedLanguagesDocument, options);
      }
export function useGetSupportedLanguagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSupportedLanguagesQuery, GetSupportedLanguagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSupportedLanguagesQuery, GetSupportedLanguagesQueryVariables>(GetSupportedLanguagesDocument, options);
        }
export type GetSupportedLanguagesQueryHookResult = ReturnType<typeof useGetSupportedLanguagesQuery>;
export type GetSupportedLanguagesLazyQueryHookResult = ReturnType<typeof useGetSupportedLanguagesLazyQuery>;
export type GetSupportedLanguagesQueryResult = Apollo.QueryResult<GetSupportedLanguagesQuery, GetSupportedLanguagesQueryVariables>;
export const TranslateTextDocument = gql`
    mutation TranslateText($input: TranslateTextInput!) {
  translateText(input: $input) {
    translatedText
    targetLanguage
  }
}
    `;
export type TranslateTextMutationFn = Apollo.MutationFunction<TranslateTextMutation, TranslateTextMutationVariables>;

/**
 * __useTranslateTextMutation__
 *
 * To run a mutation, you first call `useTranslateTextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTranslateTextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [translateTextMutation, { data, loading, error }] = useTranslateTextMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTranslateTextMutation(baseOptions?: Apollo.MutationHookOptions<TranslateTextMutation, TranslateTextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TranslateTextMutation, TranslateTextMutationVariables>(TranslateTextDocument, options);
      }
export type TranslateTextMutationHookResult = ReturnType<typeof useTranslateTextMutation>;
export type TranslateTextMutationResult = Apollo.MutationResult<TranslateTextMutation>;
export type TranslateTextMutationOptions = Apollo.BaseMutationOptions<TranslateTextMutation, TranslateTextMutationVariables>;
export const TranslateTextsDocument = gql`
    mutation TranslateTexts($input: TranslateTextsInput!) {
  translateTexts(input: $input) {
    translatedTexts
    targetLanguage
  }
}
    `;
export type TranslateTextsMutationFn = Apollo.MutationFunction<TranslateTextsMutation, TranslateTextsMutationVariables>;

/**
 * __useTranslateTextsMutation__
 *
 * To run a mutation, you first call `useTranslateTextsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTranslateTextsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [translateTextsMutation, { data, loading, error }] = useTranslateTextsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTranslateTextsMutation(baseOptions?: Apollo.MutationHookOptions<TranslateTextsMutation, TranslateTextsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TranslateTextsMutation, TranslateTextsMutationVariables>(TranslateTextsDocument, options);
      }
export type TranslateTextsMutationHookResult = ReturnType<typeof useTranslateTextsMutation>;
export type TranslateTextsMutationResult = Apollo.MutationResult<TranslateTextsMutation>;
export type TranslateTextsMutationOptions = Apollo.BaseMutationOptions<TranslateTextsMutation, TranslateTextsMutationVariables>;
export const GenerateEnglishCaptionsDocument = gql`
    mutation GenerateEnglishCaptions($input: GenerateEnglishCaptionsInput!) {
  generateEnglishCaptions(input: $input) {
    id
    userId
    videoUrl
    status
    progressPercentage
    subtitleUrl
    errorMessage
    createdAt
    updatedAt
    completedAt
  }
}
    `;
export type GenerateEnglishCaptionsMutationFn = Apollo.MutationFunction<GenerateEnglishCaptionsMutation, GenerateEnglishCaptionsMutationVariables>;

/**
 * __useGenerateEnglishCaptionsMutation__
 *
 * To run a mutation, you first call `useGenerateEnglishCaptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateEnglishCaptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateEnglishCaptionsMutation, { data, loading, error }] = useGenerateEnglishCaptionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateEnglishCaptionsMutation(baseOptions?: Apollo.MutationHookOptions<GenerateEnglishCaptionsMutation, GenerateEnglishCaptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateEnglishCaptionsMutation, GenerateEnglishCaptionsMutationVariables>(GenerateEnglishCaptionsDocument, options);
      }
export type GenerateEnglishCaptionsMutationHookResult = ReturnType<typeof useGenerateEnglishCaptionsMutation>;
export type GenerateEnglishCaptionsMutationResult = Apollo.MutationResult<GenerateEnglishCaptionsMutation>;
export type GenerateEnglishCaptionsMutationOptions = Apollo.BaseMutationOptions<GenerateEnglishCaptionsMutation, GenerateEnglishCaptionsMutationVariables>;
export const GetEnglishCaptionJobDocument = gql`
    query GetEnglishCaptionJob($id: String!) {
  englishCaptionJob(id: $id) {
    id
    userId
    videoUrl
    status
    progressPercentage
    subtitleUrl
    errorMessage
    createdAt
    updatedAt
    completedAt
  }
}
    `;

/**
 * __useGetEnglishCaptionJobQuery__
 *
 * To run a query within a React component, call `useGetEnglishCaptionJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnglishCaptionJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnglishCaptionJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEnglishCaptionJobQuery(baseOptions: Apollo.QueryHookOptions<GetEnglishCaptionJobQuery, GetEnglishCaptionJobQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEnglishCaptionJobQuery, GetEnglishCaptionJobQueryVariables>(GetEnglishCaptionJobDocument, options);
      }
export function useGetEnglishCaptionJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEnglishCaptionJobQuery, GetEnglishCaptionJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEnglishCaptionJobQuery, GetEnglishCaptionJobQueryVariables>(GetEnglishCaptionJobDocument, options);
        }
export type GetEnglishCaptionJobQueryHookResult = ReturnType<typeof useGetEnglishCaptionJobQuery>;
export type GetEnglishCaptionJobLazyQueryHookResult = ReturnType<typeof useGetEnglishCaptionJobLazyQuery>;
export type GetEnglishCaptionJobQueryResult = Apollo.QueryResult<GetEnglishCaptionJobQuery, GetEnglishCaptionJobQueryVariables>;
export const CreateTranslationJobDocument = gql`
    mutation CreateTranslationJob($input: CreateTranslationJobInput!) {
  createTranslationJob(input: $input) {
    id
    userId
    videoUrl
    targetLanguages
    status
    progressPercentage
    translationResults
    errorMessage
    externalJobId
    createdAt
    updatedAt
    completedAt
    englishSubtitleUrl
    languageJobs {
      id
      parentJobId
      languageCode
      status
      subtitleUrl
      errorMessage
      retryCount
      maxRetries
      createdAt
      updatedAt
      completedAt
    }
  }
}
    `;
export type CreateTranslationJobMutationFn = Apollo.MutationFunction<CreateTranslationJobMutation, CreateTranslationJobMutationVariables>;

/**
 * __useCreateTranslationJobMutation__
 *
 * To run a mutation, you first call `useCreateTranslationJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTranslationJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTranslationJobMutation, { data, loading, error }] = useCreateTranslationJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTranslationJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateTranslationJobMutation, CreateTranslationJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTranslationJobMutation, CreateTranslationJobMutationVariables>(CreateTranslationJobDocument, options);
      }
export type CreateTranslationJobMutationHookResult = ReturnType<typeof useCreateTranslationJobMutation>;
export type CreateTranslationJobMutationResult = Apollo.MutationResult<CreateTranslationJobMutation>;
export type CreateTranslationJobMutationOptions = Apollo.BaseMutationOptions<CreateTranslationJobMutation, CreateTranslationJobMutationVariables>;
export const GetTranslationJobDocument = gql`
    query GetTranslationJob($id: String!) {
  translationJob(id: $id) {
    id
    userId
    videoUrl
    targetLanguages
    status
    progressPercentage
    translationResults
    errorMessage
    externalJobId
    createdAt
    updatedAt
    completedAt
    englishSubtitleUrl
    languageJobs {
      id
      parentJobId
      languageCode
      status
      subtitleUrl
      errorMessage
      retryCount
      maxRetries
      createdAt
      updatedAt
      completedAt
    }
  }
}
    `;

/**
 * __useGetTranslationJobQuery__
 *
 * To run a query within a React component, call `useGetTranslationJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranslationJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTranslationJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTranslationJobQuery(baseOptions: Apollo.QueryHookOptions<GetTranslationJobQuery, GetTranslationJobQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTranslationJobQuery, GetTranslationJobQueryVariables>(GetTranslationJobDocument, options);
      }
export function useGetTranslationJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTranslationJobQuery, GetTranslationJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTranslationJobQuery, GetTranslationJobQueryVariables>(GetTranslationJobDocument, options);
        }
export type GetTranslationJobQueryHookResult = ReturnType<typeof useGetTranslationJobQuery>;
export type GetTranslationJobLazyQueryHookResult = ReturnType<typeof useGetTranslationJobLazyQuery>;
export type GetTranslationJobQueryResult = Apollo.QueryResult<GetTranslationJobQuery, GetTranslationJobQueryVariables>;